import { jsx as g, jsxs as G, Fragment as Pe } from "react/jsx-runtime";
import * as f from "react";
import ne, { isValidElement as Ur, useState as de, useEffect as ie, useRef as Se, createContext as Kt, useContext as Ae, Children as tn, useLayoutEffect as gl, useId as cn, useInsertionEffect as Xf, useMemo as Lt, useCallback as Dt, forwardRef as Yt, Fragment as Zf, createElement as yb, Component as bb, useImperativeHandle as wb, cloneElement as xb } from "react";
import * as Ps from "react-dom";
import Cb, { createPortal as vl } from "react-dom";
function Eb(t, e) {
  const n = f.createContext(e), r = (s) => {
    const { children: i, ...a } = s, l = f.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ g(n.Provider, { value: l, children: i });
  };
  r.displayName = t + "Provider";
  function o(s) {
    const i = f.useContext(n);
    if (i) return i;
    if (e !== void 0) return e;
    throw new Error(`\`${s}\` must be used within \`${t}\``);
  }
  return [r, o];
}
function je(t, e = []) {
  let n = [];
  function r(s, i) {
    const a = f.createContext(i), l = n.length;
    n = [...n, i];
    const c = (d) => {
      var b;
      const { scope: p, children: h, ...v } = d, m = ((b = p == null ? void 0 : p[t]) == null ? void 0 : b[l]) || a, y = f.useMemo(() => v, Object.values(v));
      return /* @__PURE__ */ g(m.Provider, { value: y, children: h });
    };
    c.displayName = s + "Provider";
    function u(d, p) {
      var m;
      const h = ((m = p == null ? void 0 : p[t]) == null ? void 0 : m[l]) || a, v = f.useContext(h);
      if (v) return v;
      if (i !== void 0) return i;
      throw new Error(`\`${d}\` must be used within \`${s}\``);
    }
    return [c, u];
  }
  const o = () => {
    const s = n.map((i) => f.createContext(i));
    return function(a) {
      const l = (a == null ? void 0 : a[t]) || s;
      return f.useMemo(
        () => ({ [`__scope${t}`]: { ...a, [t]: l } }),
        [a, l]
      );
    };
  };
  return o.scopeName = t, [r, Sb(o, ...e)];
}
function Sb(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const n = () => {
    const r = t.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(s) {
      const i = r.reduce((a, { useScope: l, scopeName: c }) => {
        const d = l(s)[`__scope${c}`];
        return { ...a, ...d };
      }, {});
      return f.useMemo(() => ({ [`__scope${e.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
function mu(t, e) {
  if (typeof t == "function")
    return t(e);
  t != null && (t.current = e);
}
function Ab(...t) {
  return (e) => {
    let n = !1;
    const r = t.map((o) => {
      const s = mu(o, e);
      return !n && typeof s == "function" && (n = !0), s;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const s = r[o];
          typeof s == "function" ? s() : mu(t[o], null);
        }
      };
  };
}
function te(...t) {
  return f.useCallback(Ab(...t), t);
}
// @__NO_SIDE_EFFECTS__
function gu(t) {
  const e = /* @__PURE__ */ Tb(t), n = f.forwardRef((r, o) => {
    const { children: s, ...i } = r, a = f.Children.toArray(s), l = a.find(_b);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ g(e, { ...i, ref: o, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ g(e, { ...i, ref: o, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function Tb(t) {
  const e = f.forwardRef((n, r) => {
    const { children: o, ...s } = n, i = f.isValidElement(o) ? kb(o) : void 0, a = te(i, r);
    if (f.isValidElement(o)) {
      const l = Pb(s, o.props);
      return o.type !== f.Fragment && (l.ref = a), f.cloneElement(o, l);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var Rb = Symbol("radix.slottable");
function _b(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === Rb;
}
function Pb(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const l = s(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function kb(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
function ks(t) {
  const e = t + "CollectionProvider", [n, r] = je(e), [o, s] = n(
    e,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (m) => {
    const { scope: y, children: b } = m, w = ne.useRef(null), x = ne.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ g(o, { scope: y, itemMap: x, collectionRef: w, children: b });
  };
  i.displayName = e;
  const a = t + "CollectionSlot", l = /* @__PURE__ */ gu(a), c = ne.forwardRef(
    (m, y) => {
      const { scope: b, children: w } = m, x = s(a, b), E = te(y, x.collectionRef);
      return /* @__PURE__ */ g(l, { ref: E, children: w });
    }
  );
  c.displayName = a;
  const u = t + "CollectionItemSlot", d = "data-radix-collection-item", p = /* @__PURE__ */ gu(u), h = ne.forwardRef(
    (m, y) => {
      const { scope: b, children: w, ...x } = m, E = ne.useRef(null), C = te(y, E), A = s(u, b);
      return ne.useEffect(() => (A.itemMap.set(E, { ref: E, ...x }), () => void A.itemMap.delete(E))), /* @__PURE__ */ g(p, { [d]: "", ref: C, children: w });
    }
  );
  h.displayName = u;
  function v(m) {
    const y = s(t + "CollectionConsumer", m);
    return ne.useCallback(() => {
      const w = y.collectionRef.current;
      if (!w) return [];
      const x = Array.from(w.querySelectorAll(`[${d}]`));
      return Array.from(y.itemMap.values()).sort(
        (A, S) => x.indexOf(A.ref.current) - x.indexOf(S.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: i, Slot: c, ItemSlot: h },
    v,
    r
  ];
}
function J(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (t == null || t(o), n === !1 || !o.defaultPrevented)
      return e == null ? void 0 : e(o);
  };
}
var ke = globalThis != null && globalThis.document ? f.useLayoutEffect : () => {
}, Ib = f[" useInsertionEffect ".trim().toString()] || ke;
function tt({
  prop: t,
  defaultProp: e,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, s, i] = Db({
    defaultProp: e,
    onChange: n
  }), a = t !== void 0, l = a ? t : o;
  {
    const u = f.useRef(t !== void 0);
    f.useEffect(() => {
      const d = u.current;
      d !== a && console.warn(
        `${r} is changing from ${d ? "controlled" : "uncontrolled"} to ${a ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = a;
    }, [a, r]);
  }
  const c = f.useCallback(
    (u) => {
      var d;
      if (a) {
        const p = Mb(u) ? u(t) : u;
        p !== t && ((d = i.current) == null || d.call(i, p));
      } else
        s(u);
    },
    [a, t, s, i]
  );
  return [l, c];
}
function Db({
  defaultProp: t,
  onChange: e
}) {
  const [n, r] = f.useState(t), o = f.useRef(n), s = f.useRef(e);
  return Ib(() => {
    s.current = e;
  }, [e]), f.useEffect(() => {
    var i;
    o.current !== n && ((i = s.current) == null || i.call(s, n), o.current = n);
  }, [n, o]), [n, r, s];
}
function Mb(t) {
  return typeof t == "function";
}
// @__NO_SIDE_EFFECTS__
function Nb(t) {
  const e = /* @__PURE__ */ Ob(t), n = f.forwardRef((r, o) => {
    const { children: s, ...i } = r, a = f.Children.toArray(s), l = a.find(Fb);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ g(e, { ...i, ref: o, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ g(e, { ...i, ref: o, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function Ob(t) {
  const e = f.forwardRef((n, r) => {
    const { children: o, ...s } = n, i = f.isValidElement(o) ? Bb(o) : void 0, a = te(i, r);
    if (f.isValidElement(o)) {
      const l = Lb(s, o.props);
      return o.type !== f.Fragment && (l.ref = a), f.cloneElement(o, l);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var Vb = Symbol("radix.slottable");
function Fb(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === Vb;
}
function Lb(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const l = s(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function Bb(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var $b = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Jf = $b.reduce((t, e) => {
  const n = /* @__PURE__ */ Nb(`Primitive.${e}`), r = f.forwardRef((o, s) => {
    const { asChild: i, ...a } = o, l = i ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {});
// @__NO_SIDE_EFFECTS__
function Wb(t) {
  const e = /* @__PURE__ */ jb(t), n = f.forwardRef((r, o) => {
    const { children: s, ...i } = r, a = f.Children.toArray(s), l = a.find(Hb);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ g(e, { ...i, ref: o, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ g(e, { ...i, ref: o, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function jb(t) {
  const e = f.forwardRef((n, r) => {
    const { children: o, ...s } = n, i = f.isValidElement(o) ? Gb(o) : void 0, a = te(i, r);
    if (f.isValidElement(o)) {
      const l = zb(s, o.props);
      return o.type !== f.Fragment && (l.ref = a), f.cloneElement(o, l);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var Ub = Symbol("radix.slottable");
function Hb(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === Ub;
}
function zb(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const l = s(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function Gb(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var Kb = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], yl = Kb.reduce((t, e) => {
  const n = /* @__PURE__ */ Wb(`Primitive.${e}`), r = f.forwardRef((o, s) => {
    const { asChild: i, ...a } = o, l = i ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {});
function Yb(t, e) {
  return f.useReducer((n, r) => e[n][r] ?? n, t);
}
var Ge = (t) => {
  const { present: e, children: n } = t, r = qb(e), o = typeof n == "function" ? n({ present: r.isPresent }) : f.Children.only(n), s = te(r.ref, Xb(o));
  return typeof n == "function" || r.isPresent ? f.cloneElement(o, { ref: s }) : null;
};
Ge.displayName = "Presence";
function qb(t) {
  const [e, n] = f.useState(), r = f.useRef(null), o = f.useRef(t), s = f.useRef("none"), i = t ? "mounted" : "unmounted", [a, l] = Yb(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return f.useEffect(() => {
    const c = Do(r.current);
    s.current = a === "mounted" ? c : "none";
  }, [a]), ke(() => {
    const c = r.current, u = o.current;
    if (u !== t) {
      const p = s.current, h = Do(c);
      t ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && p !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = t;
    }
  }, [t, l]), ke(() => {
    if (e) {
      let c;
      const u = e.ownerDocument.defaultView ?? window, d = (h) => {
        const m = Do(r.current).includes(h.animationName);
        if (h.target === e && m && (l("ANIMATION_END"), !o.current)) {
          const y = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = y);
          });
        }
      }, p = (h) => {
        h.target === e && (s.current = Do(r.current));
      };
      return e.addEventListener("animationstart", p), e.addEventListener("animationcancel", d), e.addEventListener("animationend", d), () => {
        u.clearTimeout(c), e.removeEventListener("animationstart", p), e.removeEventListener("animationcancel", d), e.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [e, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: f.useCallback((c) => {
      r.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function Do(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function Xb(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var Zb = f[" useId ".trim().toString()] || (() => {
}), Jb = 0;
function Je(t) {
  const [e, n] = f.useState(Zb());
  return ke(() => {
    n((r) => r ?? String(Jb++));
  }, [t]), e ? `radix-${e}` : "";
}
var Is = "Collapsible", [Qb, Qf] = je(Is), [e0, bl] = Qb(Is), ep = f.forwardRef(
  (t, e) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: o,
      disabled: s,
      onOpenChange: i,
      ...a
    } = t, [l, c] = tt({
      prop: r,
      defaultProp: o ?? !1,
      onChange: i,
      caller: Is
    });
    return /* @__PURE__ */ g(
      e0,
      {
        scope: n,
        disabled: s,
        contentId: Je(),
        open: l,
        onOpenToggle: f.useCallback(() => c((u) => !u), [c]),
        children: /* @__PURE__ */ g(
          yl.div,
          {
            "data-state": xl(l),
            "data-disabled": s ? "" : void 0,
            ...a,
            ref: e
          }
        )
      }
    );
  }
);
ep.displayName = Is;
var tp = "CollapsibleTrigger", np = f.forwardRef(
  (t, e) => {
    const { __scopeCollapsible: n, ...r } = t, o = bl(tp, n);
    return /* @__PURE__ */ g(
      yl.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": xl(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...r,
        ref: e,
        onClick: J(t.onClick, o.onOpenToggle)
      }
    );
  }
);
np.displayName = tp;
var wl = "CollapsibleContent", rp = f.forwardRef(
  (t, e) => {
    const { forceMount: n, ...r } = t, o = bl(wl, t.__scopeCollapsible);
    return /* @__PURE__ */ g(Ge, { present: n || o.open, children: ({ present: s }) => /* @__PURE__ */ g(t0, { ...r, ref: e, present: s }) });
  }
);
rp.displayName = wl;
var t0 = f.forwardRef((t, e) => {
  const { __scopeCollapsible: n, present: r, children: o, ...s } = t, i = bl(wl, n), [a, l] = f.useState(r), c = f.useRef(null), u = te(e, c), d = f.useRef(0), p = d.current, h = f.useRef(0), v = h.current, m = i.open || a, y = f.useRef(m), b = f.useRef(void 0);
  return f.useEffect(() => {
    const w = requestAnimationFrame(() => y.current = !1);
    return () => cancelAnimationFrame(w);
  }, []), ke(() => {
    const w = c.current;
    if (w) {
      b.current = b.current || {
        transitionDuration: w.style.transitionDuration,
        animationName: w.style.animationName
      }, w.style.transitionDuration = "0s", w.style.animationName = "none";
      const x = w.getBoundingClientRect();
      d.current = x.height, h.current = x.width, y.current || (w.style.transitionDuration = b.current.transitionDuration, w.style.animationName = b.current.animationName), l(r);
    }
  }, [i.open, r]), /* @__PURE__ */ g(
    yl.div,
    {
      "data-state": xl(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !m,
      ...s,
      ref: u,
      style: {
        "--radix-collapsible-content-height": p ? `${p}px` : void 0,
        "--radix-collapsible-content-width": v ? `${v}px` : void 0,
        ...t.style
      },
      children: m && o
    }
  );
});
function xl(t) {
  return t ? "open" : "closed";
}
var op = ep, sp = np, ip = rp, n0 = f.createContext(void 0);
function r0(t) {
  const e = f.useContext(n0);
  return t || e || "ltr";
}
var ft = "Accordion", o0 = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Cl, s0, i0] = ks(ft), [Ds, RN] = je(ft, [
  i0,
  Qf
]), El = Qf(), ap = ne.forwardRef(
  (t, e) => {
    const { type: n, ...r } = t, o = r, s = r;
    return /* @__PURE__ */ g(Cl.Provider, { scope: t.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ g(u0, { ...s, ref: e }) : /* @__PURE__ */ g(c0, { ...o, ref: e }) });
  }
);
ap.displayName = ft;
var [lp, a0] = Ds(ft), [cp, l0] = Ds(
  ft,
  { collapsible: !1 }
), c0 = ne.forwardRef(
  (t, e) => {
    const {
      value: n,
      defaultValue: r,
      onValueChange: o = () => {
      },
      collapsible: s = !1,
      ...i
    } = t, [a, l] = tt({
      prop: n,
      defaultProp: r ?? "",
      onChange: o,
      caller: ft
    });
    return /* @__PURE__ */ g(
      lp,
      {
        scope: t.__scopeAccordion,
        value: ne.useMemo(() => a ? [a] : [], [a]),
        onItemOpen: l,
        onItemClose: ne.useCallback(() => s && l(""), [s, l]),
        children: /* @__PURE__ */ g(cp, { scope: t.__scopeAccordion, collapsible: s, children: /* @__PURE__ */ g(up, { ...i, ref: e }) })
      }
    );
  }
), u0 = ne.forwardRef((t, e) => {
  const {
    value: n,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...s
  } = t, [i, a] = tt({
    prop: n,
    defaultProp: r ?? [],
    onChange: o,
    caller: ft
  }), l = ne.useCallback(
    (u) => a((d = []) => [...d, u]),
    [a]
  ), c = ne.useCallback(
    (u) => a((d = []) => d.filter((p) => p !== u)),
    [a]
  );
  return /* @__PURE__ */ g(
    lp,
    {
      scope: t.__scopeAccordion,
      value: i,
      onItemOpen: l,
      onItemClose: c,
      children: /* @__PURE__ */ g(cp, { scope: t.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ g(up, { ...s, ref: e }) })
    }
  );
}), [d0, Ms] = Ds(ft), up = ne.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, disabled: r, dir: o, orientation: s = "vertical", ...i } = t, a = ne.useRef(null), l = te(a, e), c = s0(n), d = r0(o) === "ltr", p = J(t.onKeyDown, (h) => {
      var R;
      if (!o0.includes(h.key)) return;
      const v = h.target, m = c().filter((P) => {
        var k;
        return !((k = P.ref.current) != null && k.disabled);
      }), y = m.findIndex((P) => P.ref.current === v), b = m.length;
      if (y === -1) return;
      h.preventDefault();
      let w = y;
      const x = 0, E = b - 1, C = () => {
        w = y + 1, w > E && (w = x);
      }, A = () => {
        w = y - 1, w < x && (w = E);
      };
      switch (h.key) {
        case "Home":
          w = x;
          break;
        case "End":
          w = E;
          break;
        case "ArrowRight":
          s === "horizontal" && (d ? C() : A());
          break;
        case "ArrowDown":
          s === "vertical" && C();
          break;
        case "ArrowLeft":
          s === "horizontal" && (d ? A() : C());
          break;
        case "ArrowUp":
          s === "vertical" && A();
          break;
      }
      const S = w % b;
      (R = m[S].ref.current) == null || R.focus();
    });
    return /* @__PURE__ */ g(
      d0,
      {
        scope: n,
        disabled: r,
        direction: o,
        orientation: s,
        children: /* @__PURE__ */ g(Cl.Slot, { scope: n, children: /* @__PURE__ */ g(
          Jf.div,
          {
            ...i,
            "data-orientation": s,
            ref: l,
            onKeyDown: r ? void 0 : p
          }
        ) })
      }
    );
  }
), is = "AccordionItem", [f0, Sl] = Ds(is), p0 = ne.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, value: r, ...o } = t, s = Ms(is, n), i = a0(is, n), a = El(n), l = Je(), c = r && i.value.includes(r) || !1, u = s.disabled || t.disabled;
    return /* @__PURE__ */ g(
      f0,
      {
        scope: n,
        open: c,
        disabled: u,
        triggerId: l,
        children: /* @__PURE__ */ g(
          op,
          {
            "data-orientation": s.orientation,
            "data-state": pp(c),
            ...a,
            ...o,
            ref: e,
            disabled: u,
            open: c,
            onOpenChange: (d) => {
              d ? i.onItemOpen(r) : i.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
p0.displayName = is;
var dp = "AccordionHeader", h0 = ne.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, ...r } = t, o = Ms(ft, n), s = Sl(dp, n);
    return /* @__PURE__ */ g(
      Jf.h3,
      {
        "data-orientation": o.orientation,
        "data-state": pp(s.open),
        "data-disabled": s.disabled ? "" : void 0,
        ...r,
        ref: e
      }
    );
  }
);
h0.displayName = dp;
var ga = "AccordionTrigger", m0 = ne.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, ...r } = t, o = Ms(ft, n), s = Sl(ga, n), i = l0(ga, n), a = El(n);
    return /* @__PURE__ */ g(Cl.ItemSlot, { scope: n, children: /* @__PURE__ */ g(
      sp,
      {
        "aria-disabled": s.open && !i.collapsible || void 0,
        "data-orientation": o.orientation,
        id: s.triggerId,
        ...a,
        ...r,
        ref: e
      }
    ) });
  }
);
m0.displayName = ga;
var fp = "AccordionContent", g0 = ne.forwardRef(
  (t, e) => {
    const { __scopeAccordion: n, ...r } = t, o = Ms(ft, n), s = Sl(fp, n), i = El(n);
    return /* @__PURE__ */ g(
      ip,
      {
        role: "region",
        "aria-labelledby": s.triggerId,
        "data-orientation": o.orientation,
        ...i,
        ...r,
        ref: e,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...t.style
        }
      }
    );
  }
);
g0.displayName = fp;
function pp(t) {
  return t ? "open" : "closed";
}
var v0 = ap;
const pt = (t) => {
  const e = (o) => "type" in o ? [o] : o, n = (o, s) => o.displayName !== void 0 && s.type.displayName === o.displayName, r = e(t).filter((o) => Ur(o));
  return {
    getSubcomponents: () => r.reduce(
      (o, s) => ({ ...o, [s.type.displayName]: s }),
      {}
    ),
    getChildrenFromSubcomponent: (o, s) => r.filter((l) => n(o, l)).map((l, c) => ({
      ...l,
      props: { ...l.props, ...s, index: c }
    })),
    getSingleChildFromSubcomponent: (o, s, i) => Ur(s) && n(o, s) ? { ...s, props: { ...s.props, ...i } } : null,
    printBadConstructionMessage: (o) => console.error(
      `The ${o} component is not being rendered because it was not constructed properly. Check out the documentation for more`
    )
  };
}, y0 = (t) => {
  const [e, n] = de(t);
  return ie(() => {
    t && n(!0);
  }, [t]), { shouldRender: e, handleAnimationEnd: () => {
    t || n(!1);
  } };
};
function b0(t, e, n) {
  if (t instanceof EventTarget)
    return [t];
  if (typeof t == "string") {
    const o = document.querySelectorAll(t);
    return o ? Array.from(o) : [];
  }
  return Array.from(t);
}
const w0 = {
  some: 0,
  all: 1
};
function x0(t, e, { root: n, margin: r, amount: o = "some" } = {}) {
  const s = b0(t), i = /* @__PURE__ */ new WeakMap(), a = (c) => {
    c.forEach((u) => {
      const d = i.get(u.target);
      if (u.isIntersecting !== !!d)
        if (u.isIntersecting) {
          const p = e(u.target, u);
          typeof p == "function" ? i.set(u.target, p) : l.unobserve(u.target);
        } else typeof d == "function" && (d(u), i.delete(u.target));
    });
  }, l = new IntersectionObserver(a, {
    root: n,
    rootMargin: r,
    threshold: typeof o == "number" ? o : w0[o]
  });
  return s.forEach((c) => l.observe(c)), () => l.disconnect();
}
function C0(t, { root: e, margin: n, amount: r, once: o = !1, initial: s = !1 } = {}) {
  const [i, a] = de(s);
  return ie(() => {
    if (!t.current || o && i)
      return;
    const l = () => (a(!0), o ? void 0 : () => a(!1)), c = {
      root: e && e.current || void 0,
      margin: n,
      amount: r
    };
    return x0(t.current, l, c);
  }, [e, t, n, o, r]), i;
}
const E0 = (t, e) => {
  const n = Se(null), r = C0(t || n, { once: !0 });
  return ie(() => {
    e && r && e();
  }, [r, e]), t || n;
}, S0 = (t) => {
  const [e, n] = de("transparent");
  return ie(() => {
    if (t.current) {
      const r = A0(t.current);
      n(r);
    }
  }, [t]), e;
}, A0 = (t) => {
  if (t === document.body)
    return getComputedStyle(t).backgroundColor;
  for (; t.parentElement; ) {
    const e = getComputedStyle(t.parentElement).backgroundColor;
    if (e && e !== "rgba(0, 0, 0, 0)" && e !== "transparent")
      return e;
    t = t.parentElement;
  }
  return "transparent";
}, Al = Kt(0), T0 = () => Ae(Al);
function hp(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var R0 = function(t) {
  return t.replace(/[A-Z]/g, function(e) {
    return "-" + e.toLowerCase();
  }).toLowerCase();
}, _0 = R0, P0 = _0, k0 = function(t) {
  var e = /[height|width]$/;
  return e.test(t);
}, vu = function(t) {
  var e = "", n = Object.keys(t);
  return n.forEach(function(r, o) {
    var s = t[r];
    r = P0(r), k0(r) && typeof s == "number" && (s = s + "px"), s === !0 ? e += r : s === !1 ? e += "not " + r : e += "(" + r + ": " + s + ")", o < n.length - 1 && (e += " and ");
  }), e;
}, I0 = function(t) {
  var e = "";
  return typeof t == "string" ? t : t instanceof Array ? (t.forEach(function(n, r) {
    e += vu(n), r < t.length - 1 && (e += ", ");
  }), e) : vu(t);
}, D0 = I0;
const Re = /* @__PURE__ */ hp(D0), pe = {
  s: 0,
  m: 480,
  l: 768,
  xl: 992,
  xxl: 1280,
  xxxl: 1600
}, _N = () => {
  const t = window.matchMedia(Re({ maxWidth: pe.m - 1 })), e = window.matchMedia(Re({ minWidth: pe.m, maxWidth: pe.l - 1 })), n = window.matchMedia(Re({ minWidth: pe.l, maxWidth: pe.xl - 1 })), r = window.matchMedia(Re({ minWidth: pe.xl, maxWidth: pe.xxl - 1 })), o = window.matchMedia(Re({ minWidth: pe.xxl, maxWidth: pe.xxxl - 1 })), s = window.matchMedia(Re({ minWidth: pe.xxxl }));
  let i = "xxxl";
  t.matches ? i = "s" : e.matches ? i = "m" : n.matches ? i = "l" : r.matches ? i = "xl" : o.matches && (i = "xxl");
  const [a, l] = de(i);
  return ie(() => {
    const c = (u) => {
      u.matches && l("s");
    };
    return t == null || t.addEventListener("change", c), () => t == null ? void 0 : t.removeEventListener("change", c);
  }, []), ie(() => {
    const c = (u) => {
      u.matches && l("m");
    };
    return e == null || e.addEventListener("change", c), () => e == null ? void 0 : e.removeEventListener("change", c);
  }, []), ie(() => {
    const c = (u) => {
      u.matches && l("l");
    };
    return n == null || n.addEventListener("change", c), () => n == null ? void 0 : n.removeEventListener("change", c);
  }, []), ie(() => {
    const c = (u) => {
      u.matches && l("xl");
    };
    return r == null || r.addEventListener("change", c), () => r == null ? void 0 : r.removeEventListener("change", c);
  }, []), ie(() => {
    const c = (u) => {
      u.matches && l("xxl");
    };
    return o == null || o.addEventListener("change", c), () => o == null ? void 0 : o.removeEventListener("change", c);
  }, []), ie(() => {
    const c = (u) => {
      u.matches && l("xxxl");
    };
    return s == null || s.addEventListener("change", c), () => s == null ? void 0 : s.removeEventListener("change", c);
  }, []), a;
}, M0 = (t) => {
  const e = window.matchMedia(Re({ minWidth: pe[t] })), [n, r] = de(e.matches);
  return ie(() => {
    const o = (s) => r(s.matches);
    return e.addEventListener("change", o), () => e.removeEventListener("change", o);
  }, [t]), n;
}, N0 = (t) => {
  const e = window.matchMedia(Re({ maxWidth: pe[t] - 1 })), [n, r] = de(e.matches);
  return ie(() => {
    const o = (s) => r(s.matches);
    return e.addEventListener("change", o), () => e.removeEventListener("change", o);
  }, [t]), n;
}, Tl = (t, e) => {
  const n = window.matchMedia(Re({ minWidth: pe[t], maxWidth: pe[e] })), [r, o] = de(n.matches);
  return ie(() => {
    const s = (i) => o(i.matches);
    return n.addEventListener("change", s), () => n.removeEventListener("change", s);
  }, [t, e]), r;
}, PN = (t) => {
  const e = window.matchMedia(Re({ minWidth: pe[t] })), [n, r] = de(e.matches);
  return ie(() => {
    const o = (s) => r(s.matches);
    return e.addEventListener("change", o), () => e.removeEventListener("change", o);
  }, [t]), n;
}, kN = (t) => {
  const [e, n] = de(), [r, o] = de();
  return ie(() => {
    const s = window.matchMedia(Re({ minWidth: pe[t] }));
    n(s);
  }, []), ie(() => {
    const s = (i) => o(i.matches);
    return e == null || e.addEventListener("change", s), () => e == null ? void 0 : e.removeEventListener("change", s);
  }, [t, e]), r;
}, IN = (t, e) => {
  const [n, r] = de(), [o, s] = de();
  return ie(() => {
    const i = window.matchMedia(Re({ minWidth: pe[t], maxWidth: pe[e] }));
    r(i);
  }, []), ie(() => {
    const i = (a) => s(a.matches);
    return n == null || n.addEventListener("change", i), () => n == null ? void 0 : n.removeEventListener("change", i);
  }, [t, e, n]), o;
}, DN = () => {
  const [t, e] = de(void 0), [n, r] = de(), [o, s] = de(), [i, a] = de(), [l, c] = de(), [u, d] = de(), [p, h] = de();
  return ie(() => {
    const v = window.matchMedia(Re({ maxWidth: pe.m - 1 })), m = window.matchMedia(Re({ minWidth: pe.m, maxWidth: pe.l - 1 })), y = window.matchMedia(Re({ minWidth: pe.l, maxWidth: pe.xl - 1 })), b = window.matchMedia(Re({ minWidth: pe.xl, maxWidth: pe.xxl - 1 })), w = window.matchMedia(Re({ minWidth: pe.xxl, maxWidth: pe.xxxl - 1 })), x = window.matchMedia(Re({ minWidth: pe.xxxl }));
    r(v), s(m), a(y), c(b), d(w), h(x);
  }, []), ie(() => {
    const v = (m) => {
      m.matches && e("s");
    };
    return n == null || n.addEventListener("change", v), () => n == null ? void 0 : n.removeEventListener("change", v);
  }, [n]), ie(() => {
    const v = (m) => {
      m.matches && e("m");
    };
    return o == null || o.addEventListener("change", v), () => o == null ? void 0 : o.removeEventListener("change", v);
  }, [o]), ie(() => {
    const v = (m) => {
      m.matches && e("l");
    };
    return i == null || i.addEventListener("change", v), () => i == null ? void 0 : i.removeEventListener("change", v);
  }, [i]), ie(() => {
    const v = (m) => {
      m.matches && e("xl");
    };
    return l == null || l.addEventListener("change", v), () => l == null ? void 0 : l.removeEventListener("change", v);
  }, [l]), ie(() => {
    const v = (m) => {
      m.matches && e("xxl");
    };
    return u == null || u.addEventListener("change", v), () => u == null ? void 0 : u.removeEventListener("change", v);
  }, [u]), ie(() => {
    const v = (m) => {
      m.matches && e("xxxl");
    };
    return p == null || p.addEventListener("change", v), () => p == null ? void 0 : p.removeEventListener("change", v);
  }, [p]), t;
};
var yu = (t) => typeof t == "boolean" ? `${t}` : t === 0 ? "0" : t, Be = (t) => !t || typeof t != "object" || Object.keys(t).length === 0, O0 = (t, e) => JSON.stringify(t) === JSON.stringify(e);
function mp(t, e) {
  t.forEach(function(n) {
    Array.isArray(n) ? mp(n, e) : e.push(n);
  });
}
function gp(t) {
  let e = [];
  return mp(t, e), e;
}
var vp = (...t) => gp(t).filter(Boolean), yp = (t, e) => {
  let n = {}, r = Object.keys(t), o = Object.keys(e);
  for (let s of r) if (o.includes(s)) {
    let i = t[s], a = e[s];
    Array.isArray(i) || Array.isArray(a) ? n[s] = vp(a, i) : typeof i == "object" && typeof a == "object" ? n[s] = yp(i, a) : n[s] = a + " " + i;
  } else n[s] = t[s];
  for (let s of o) r.includes(s) || (n[s] = e[s]);
  return n;
}, bu = (t) => !t || typeof t != "string" ? t : t.replace(/\s+/g, " ").trim();
const Rl = "-", V0 = (t) => {
  const e = L0(t), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = t;
  return {
    getClassGroupId: (i) => {
      const a = i.split(Rl);
      return a[0] === "" && a.length !== 1 && a.shift(), bp(a, e) || F0(i);
    },
    getConflictingClassGroupIds: (i, a) => {
      const l = n[i] || [];
      return a && r[i] ? [...l, ...r[i]] : l;
    }
  };
}, bp = (t, e) => {
  var i;
  if (t.length === 0)
    return e.classGroupId;
  const n = t[0], r = e.nextPart.get(n), o = r ? bp(t.slice(1), r) : void 0;
  if (o)
    return o;
  if (e.validators.length === 0)
    return;
  const s = t.join(Rl);
  return (i = e.validators.find(({
    validator: a
  }) => a(s))) == null ? void 0 : i.classGroupId;
}, wu = /^\[(.+)\]$/, F0 = (t) => {
  if (wu.test(t)) {
    const e = wu.exec(t)[1], n = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, L0 = (t) => {
  const {
    theme: e,
    prefix: n
  } = t, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return $0(Object.entries(t.classGroups), n).forEach(([s, i]) => {
    va(i, r, s, e);
  }), r;
}, va = (t, e, n, r) => {
  t.forEach((o) => {
    if (typeof o == "string") {
      const s = o === "" ? e : xu(e, o);
      s.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (B0(o)) {
        va(o(r), e, n, r);
        return;
      }
      e.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([s, i]) => {
      va(i, xu(e, s), n, r);
    });
  });
}, xu = (t, e) => {
  let n = t;
  return e.split(Rl).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, B0 = (t) => t.isThemeGetter, $0 = (t, e) => e ? t.map(([n, r]) => {
  const o = r.map((s) => typeof s == "string" ? e + s : typeof s == "object" ? Object.fromEntries(Object.entries(s).map(([i, a]) => [e + i, a])) : s);
  return [n, o];
}) : t, W0 = (t) => {
  if (t < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (s, i) => {
    n.set(s, i), e++, e > t && (e = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(s) {
      let i = n.get(s);
      if (i !== void 0)
        return i;
      if ((i = r.get(s)) !== void 0)
        return o(s, i), i;
    },
    set(s, i) {
      n.has(s) ? n.set(s, i) : o(s, i);
    }
  };
}, wp = "!", j0 = (t) => {
  const {
    separator: e,
    experimentalParseClassName: n
  } = t, r = e.length === 1, o = e[0], s = e.length, i = (a) => {
    const l = [];
    let c = 0, u = 0, d;
    for (let y = 0; y < a.length; y++) {
      let b = a[y];
      if (c === 0) {
        if (b === o && (r || a.slice(y, y + s) === e)) {
          l.push(a.slice(u, y)), u = y + s;
          continue;
        }
        if (b === "/") {
          d = y;
          continue;
        }
      }
      b === "[" ? c++ : b === "]" && c--;
    }
    const p = l.length === 0 ? a : a.substring(u), h = p.startsWith(wp), v = h ? p.substring(1) : p, m = d && d > u ? d - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: h,
      baseClassName: v,
      maybePostfixModifierPosition: m
    };
  };
  return n ? (a) => n({
    className: a,
    parseClassName: i
  }) : i;
}, U0 = (t) => {
  if (t.length <= 1)
    return t;
  const e = [];
  let n = [];
  return t.forEach((r) => {
    r[0] === "[" ? (e.push(...n.sort(), r), n = []) : n.push(r);
  }), e.push(...n.sort()), e;
}, H0 = (t) => ({
  cache: W0(t.cacheSize),
  parseClassName: j0(t),
  ...V0(t)
}), z0 = /\s+/, G0 = (t, e) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = e, s = [], i = t.trim().split(z0);
  let a = "";
  for (let l = i.length - 1; l >= 0; l -= 1) {
    const c = i[l], {
      modifiers: u,
      hasImportantModifier: d,
      baseClassName: p,
      maybePostfixModifierPosition: h
    } = n(c);
    let v = !!h, m = r(v ? p.substring(0, h) : p);
    if (!m) {
      if (!v) {
        a = c + (a.length > 0 ? " " + a : a);
        continue;
      }
      if (m = r(p), !m) {
        a = c + (a.length > 0 ? " " + a : a);
        continue;
      }
      v = !1;
    }
    const y = U0(u).join(":"), b = d ? y + wp : y, w = b + m;
    if (s.includes(w))
      continue;
    s.push(w);
    const x = o(m, v);
    for (let E = 0; E < x.length; ++E) {
      const C = x[E];
      s.push(b + C);
    }
    a = c + (a.length > 0 ? " " + a : a);
  }
  return a;
};
function K0() {
  let t = 0, e, n, r = "";
  for (; t < arguments.length; )
    (e = arguments[t++]) && (n = xp(e)) && (r && (r += " "), r += n);
  return r;
}
const xp = (t) => {
  if (typeof t == "string")
    return t;
  let e, n = "";
  for (let r = 0; r < t.length; r++)
    t[r] && (e = xp(t[r])) && (n && (n += " "), n += e);
  return n;
};
function ya(t, ...e) {
  let n, r, o, s = i;
  function i(l) {
    const c = e.reduce((u, d) => d(u), t());
    return n = H0(c), r = n.cache.get, o = n.cache.set, s = a, a(l);
  }
  function a(l) {
    const c = r(l);
    if (c)
      return c;
    const u = G0(l, n);
    return o(l, u), u;
  }
  return function() {
    return s(K0.apply(null, arguments));
  };
}
const ye = (t) => {
  const e = (n) => n[t] || [];
  return e.isThemeGetter = !0, e;
}, Cp = /^\[(?:([a-z-]+):)?(.+)\]$/i, Y0 = /^\d+\/\d+$/, q0 = /* @__PURE__ */ new Set(["px", "full", "screen"]), X0 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Z0 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, J0 = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Q0 = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, ew = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Rt = (t) => Kn(t) || q0.has(t) || Y0.test(t), qt = (t) => dr(t, "length", lw), Kn = (t) => !!t && !Number.isNaN(Number(t)), _i = (t) => dr(t, "number", Kn), Sr = (t) => !!t && Number.isInteger(Number(t)), tw = (t) => t.endsWith("%") && Kn(t.slice(0, -1)), ce = (t) => Cp.test(t), Xt = (t) => X0.test(t), nw = /* @__PURE__ */ new Set(["length", "size", "percentage"]), rw = (t) => dr(t, nw, Ep), ow = (t) => dr(t, "position", Ep), sw = /* @__PURE__ */ new Set(["image", "url"]), iw = (t) => dr(t, sw, uw), aw = (t) => dr(t, "", cw), Ar = () => !0, dr = (t, e, n) => {
  const r = Cp.exec(t);
  return r ? r[1] ? typeof e == "string" ? r[1] === e : e.has(r[1]) : n(r[2]) : !1;
}, lw = (t) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Z0.test(t) && !J0.test(t)
), Ep = () => !1, cw = (t) => Q0.test(t), uw = (t) => ew.test(t), ba = () => {
  const t = ye("colors"), e = ye("spacing"), n = ye("blur"), r = ye("brightness"), o = ye("borderColor"), s = ye("borderRadius"), i = ye("borderSpacing"), a = ye("borderWidth"), l = ye("contrast"), c = ye("grayscale"), u = ye("hueRotate"), d = ye("invert"), p = ye("gap"), h = ye("gradientColorStops"), v = ye("gradientColorStopPositions"), m = ye("inset"), y = ye("margin"), b = ye("opacity"), w = ye("padding"), x = ye("saturate"), E = ye("scale"), C = ye("sepia"), A = ye("skew"), S = ye("space"), R = ye("translate"), P = () => ["auto", "contain", "none"], k = () => ["auto", "hidden", "clip", "visible", "scroll"], I = () => ["auto", ce, e], _ = () => [ce, e], D = () => ["", Rt, qt], N = () => ["auto", Kn, ce], W = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], L = () => ["solid", "dashed", "dotted", "double", "none"], B = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], V = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], $ = () => ["", "0", ce], T = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], M = () => [Kn, ce];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Ar],
      spacing: [Rt, qt],
      blur: ["none", "", Xt, ce],
      brightness: M(),
      borderColor: [t],
      borderRadius: ["none", "", "full", Xt, ce],
      borderSpacing: _(),
      borderWidth: D(),
      contrast: M(),
      grayscale: $(),
      hueRotate: M(),
      invert: $(),
      gap: _(),
      gradientColorStops: [t],
      gradientColorStopPositions: [tw, qt],
      inset: I(),
      margin: I(),
      opacity: M(),
      padding: _(),
      saturate: M(),
      scale: M(),
      sepia: $(),
      skew: M(),
      space: _(),
      translate: _()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", ce]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Xt]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": T()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": T()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...W(), ce]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: k()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": k()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": k()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: P()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": P()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": P()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [m]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [m]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [m]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [m]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [m]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [m]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [m]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [m]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [m]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Sr, ce]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: I()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", ce]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: $()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: $()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Sr, ce]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Ar]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Sr, ce]
        }, ce]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": N()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": N()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Ar]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Sr, ce]
        }, ce]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": N()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": N()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", ce]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", ce]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...V()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...V(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...V(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [w]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [w]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [w]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [w]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [w]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [w]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [w]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [w]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [w]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [y]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [y]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [y]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [y]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [y]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [y]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [y]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [y]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [y]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [S]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [S]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", ce, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [ce, e, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [ce, e, "none", "full", "min", "max", "fit", "prose", {
          screen: [Xt]
        }, Xt]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [ce, e, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [ce, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [ce, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [ce, e, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Xt, qt]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", _i]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Ar]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", ce]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Kn, _i]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Rt, ce]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ce]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", ce]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [t]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [t]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...L(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Rt, qt]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Rt, ce]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [t]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: _()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ce]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ce]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...W(), ow]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", rw]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, iw]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [t]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [v]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [s]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [s]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [s]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [s]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [s]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [s]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [s]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [s]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [s]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [s]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [s]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [s]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [s]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [s]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [s]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...L(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: L()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...L()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Rt, ce]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Rt, qt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [t]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: D()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [t]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Rt, qt]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [t]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Xt, aw]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Ar]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...B(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": B()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Xt, ce]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [C]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [C]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", ce]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: M()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", ce]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: M()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", ce]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [E]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [E]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [E]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Sr, ce]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [R]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [R]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [A]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [A]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", ce]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", t]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ce]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [t]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": _()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": _()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": _()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": _()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": _()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": _()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": _()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": _()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": _()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": _()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": _()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": _()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": _()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": _()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": _()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": _()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": _()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": _()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ce]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [t, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Rt, qt, _i]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [t, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, dw = (t, {
  cacheSize: e,
  prefix: n,
  separator: r,
  experimentalParseClassName: o,
  extend: s = {},
  override: i = {}
}) => {
  kr(t, "cacheSize", e), kr(t, "prefix", n), kr(t, "separator", r), kr(t, "experimentalParseClassName", o);
  for (const a in i)
    fw(t[a], i[a]);
  for (const a in s)
    pw(t[a], s[a]);
  return t;
}, kr = (t, e, n) => {
  n !== void 0 && (t[e] = n);
}, fw = (t, e) => {
  if (e)
    for (const n in e)
      kr(t, n, e[n]);
}, pw = (t, e) => {
  if (e)
    for (const n in e) {
      const r = e[n];
      r !== void 0 && (t[n] = (t[n] || []).concat(r));
    }
}, hw = (t, ...e) => typeof t == "function" ? ya(ba, t, ...e) : ya(() => dw(ba(), t), ...e), Jn = /* @__PURE__ */ ya(ba);
var mw = { twMerge: !0, twMergeConfig: {}, responsiveVariants: !1 }, Sp = (t) => t || void 0, Hr = (...t) => Sp(gp(t).filter(Boolean).join(" ")), Pi = null, Pt = {}, wa = !1, Tr = (...t) => (e) => e.twMerge ? ((!Pi || wa) && (wa = !1, Pi = Be(Pt) ? Jn : hw({ ...Pt, extend: { theme: Pt.theme, classGroups: Pt.classGroups, conflictingClassGroupModifiers: Pt.conflictingClassGroupModifiers, conflictingClassGroups: Pt.conflictingClassGroups, ...Pt.extend } })), Sp(Pi(Hr(t)))) : Hr(t), Cu = (t, e) => {
  for (let n in e) t.hasOwnProperty(n) ? t[n] = Hr(t[n], e[n]) : t[n] = e[n];
  return t;
}, ae = (t, e) => {
  let { extend: n = null, slots: r = {}, variants: o = {}, compoundVariants: s = [], compoundSlots: i = [], defaultVariants: a = {} } = t, l = { ...mw, ...e }, c = n != null && n.base ? Hr(n.base, t == null ? void 0 : t.base) : t == null ? void 0 : t.base, u = n != null && n.variants && !Be(n.variants) ? yp(o, n.variants) : o, d = n != null && n.defaultVariants && !Be(n.defaultVariants) ? { ...n.defaultVariants, ...a } : a;
  !Be(l.twMergeConfig) && !O0(l.twMergeConfig, Pt) && (wa = !0, Pt = l.twMergeConfig);
  let p = Be(n == null ? void 0 : n.slots), h = Be(r) ? {} : { base: Hr(t == null ? void 0 : t.base, p && (n == null ? void 0 : n.base)), ...r }, v = p ? h : Cu({ ...n == null ? void 0 : n.slots }, Be(h) ? { base: t == null ? void 0 : t.base } : h), m = Be(n == null ? void 0 : n.compoundVariants) ? s : vp(n == null ? void 0 : n.compoundVariants, s), y = (w) => {
    if (Be(u) && Be(r) && p) return Tr(c, w == null ? void 0 : w.class, w == null ? void 0 : w.className)(l);
    if (m && !Array.isArray(m)) throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof m}`);
    if (i && !Array.isArray(i)) throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof i}`);
    let x = (_, D, N = [], W) => {
      let L = N;
      if (typeof D == "string") L = L.concat(bu(D).split(" ").map((B) => `${_}:${B}`));
      else if (Array.isArray(D)) L = L.concat(D.reduce((B, V) => B.concat(`${_}:${V}`), []));
      else if (typeof D == "object" && typeof W == "string") {
        for (let B in D) if (D.hasOwnProperty(B) && B === W) {
          let V = D[B];
          if (V && typeof V == "string") {
            let $ = bu(V);
            L[W] ? L[W] = L[W].concat($.split(" ").map((T) => `${_}:${T}`)) : L[W] = $.split(" ").map((T) => `${_}:${T}`);
          } else Array.isArray(V) && V.length > 0 && (L[W] = V.reduce(($, T) => $.concat(`${_}:${T}`), []));
        }
      }
      return L;
    }, E = (_, D = u, N = null, W = null) => {
      var L;
      let B = D[_];
      if (!B || Be(B)) return null;
      let V = (L = W == null ? void 0 : W[_]) != null ? L : w == null ? void 0 : w[_];
      if (V === null) return null;
      let $ = yu(V), T = Array.isArray(l.responsiveVariants) && l.responsiveVariants.length > 0 || l.responsiveVariants === !0, M = d == null ? void 0 : d[_], H = [];
      if (typeof $ == "object" && T) for (let [X, O] of Object.entries($)) {
        let F = B[O];
        if (X === "initial") {
          M = O;
          continue;
        }
        Array.isArray(l.responsiveVariants) && !l.responsiveVariants.includes(X) || (H = x(X, F, H, N));
      }
      let Z = $ != null && typeof $ != "object" ? $ : yu(M), U = B[Z || "false"];
      return typeof H == "object" && typeof N == "string" && H[N] ? Cu(H, U) : H.length > 0 ? (H.push(U), N === "base" ? H.join(" ") : H) : U;
    }, C = () => u ? Object.keys(u).map((_) => E(_, u)) : null, A = (_, D) => {
      if (!u || typeof u != "object") return null;
      let N = new Array();
      for (let W in u) {
        let L = E(W, u, _, D), B = _ === "base" && typeof L == "string" ? L : L && L[_];
        B && (N[N.length] = B);
      }
      return N;
    }, S = {};
    for (let _ in w) w[_] !== void 0 && (S[_] = w[_]);
    let R = (_, D) => {
      var N;
      let W = typeof (w == null ? void 0 : w[_]) == "object" ? { [_]: (N = w[_]) == null ? void 0 : N.initial } : {};
      return { ...d, ...S, ...W, ...D };
    }, P = (_ = [], D) => {
      let N = [];
      for (let { class: W, className: L, ...B } of _) {
        let V = !0;
        for (let [$, T] of Object.entries(B)) {
          let M = R($, D)[$];
          if (Array.isArray(T)) {
            if (!T.includes(M)) {
              V = !1;
              break;
            }
          } else {
            let H = (Z) => Z == null || Z === !1;
            if (H(T) && H(M)) continue;
            if (M !== T) {
              V = !1;
              break;
            }
          }
        }
        V && (W && N.push(W), L && N.push(L));
      }
      return N;
    }, k = (_) => {
      let D = P(m, _);
      if (!Array.isArray(D)) return D;
      let N = {};
      for (let W of D) if (typeof W == "string" && (N.base = Tr(N.base, W)(l)), typeof W == "object") for (let [L, B] of Object.entries(W)) N[L] = Tr(N[L], B)(l);
      return N;
    }, I = (_) => {
      if (i.length < 1) return null;
      let D = {};
      for (let { slots: N = [], class: W, className: L, ...B } of i) {
        if (!Be(B)) {
          let V = !0;
          for (let $ of Object.keys(B)) {
            let T = R($, _)[$];
            if (T === void 0 || (Array.isArray(B[$]) ? !B[$].includes(T) : B[$] !== T)) {
              V = !1;
              break;
            }
          }
          if (!V) continue;
        }
        for (let V of N) D[V] = D[V] || [], D[V].push([W, L]);
      }
      return D;
    };
    if (!Be(r) || !p) {
      let _ = {};
      if (typeof v == "object" && !Be(v)) for (let D of Object.keys(v)) _[D] = (N) => {
        var W, L;
        return Tr(v[D], A(D, N), ((W = k(N)) != null ? W : [])[D], ((L = I(N)) != null ? L : [])[D], N == null ? void 0 : N.class, N == null ? void 0 : N.className)(l);
      };
      return _;
    }
    return Tr(c, C(), P(m), w == null ? void 0 : w.class, w == null ? void 0 : w.className)(l);
  }, b = () => {
    if (!(!u || typeof u != "object")) return Object.keys(u);
  };
  return y.variantKeys = b(), y.extend = n, y.base = c, y.slots = v, y.variants = u, y.defaultVariants = d, y.compoundSlots = i, y.compoundVariants = m, y;
};
const Ap = ae({
  base: "data-[state=open]:animate-fadeIn data-[state=closed]:animate-fadeOut"
}), gw = ae({
  base: "data-[state=open]:animate-slideLeft data-[state=closed]:animate-slideRight"
}), Ns = ae({
  base: ["fixed top-0 left-0 h-full w-full flex bg-clr-on-bg-high/[.50] justify-center items-center", Ap()]
}), vw = ae({
  base: "preflight border-b border-b-clr-on-bg-low group",
  variants: {
    disabled: {
      true: "",
      false: "hover:border-b-clr-on-bg-high"
    }
  }
}), yw = ae({
  base: [
    "typography-body1 text-clr-on-bg-high pb-5 group-data-[state=closed]:h-0 group-data-[state=closed]:invisible group-data-[state=closed]:py-0",
    "transition-height group-data-[state=closed]:overflow-hidden ease-out duration-300"
  ]
}), Tp = (t, e, n) => {
  const r = t[e];
  return r ? typeof r == "function" ? r() : Promise.resolve(r) : new Promise((o, s) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      s.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + e + (e.split("/").length !== n ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
function ge({ variant: t, className: e }) {
  const [n, r] = de(null);
  ie(() => {
    (async () => {
      try {
        const i = await Tp(/* @__PURE__ */ Object.assign({ "../../assets/icons/account-balanced-icon.svg": () => import("./account-balanced-icon-zMTWOxZv.js"), "../../assets/icons/address-book-icon.svg": () => import("./address-book-icon-BWM3tv8b.js"), "../../assets/icons/alarm-clock-icon.svg": () => import("./alarm-clock-icon-Ci4PW-35.js"), "../../assets/icons/alert-icon.svg": () => import("./alert-icon-D110gXHn.js"), "../../assets/icons/app-icon.svg": () => import("./app-icon-ngqw7ROO.js"), "../../assets/icons/apple-icon.svg": () => import("./apple-icon-BTIs_wBP.js"), "../../assets/icons/armchair-icon.svg": () => import("./armchair-icon-Dbq4WGMg.js"), "../../assets/icons/arrow-down-icon.svg": () => import("./arrow-down-icon-I1CFs7g_.js"), "../../assets/icons/arrow-left-icon.svg": () => import("./arrow-left-icon-YsKs7mXw.js"), "../../assets/icons/arrow-right-icon.svg": () => import("./arrow-right-icon-A-nZ6g7O.js"), "../../assets/icons/arrow-up-icon.svg": () => import("./arrow-up-icon-CAzBEIpL.js"), "../../assets/icons/back-icon.svg": () => import("./back-icon-C6DDMlcB.js"), "../../assets/icons/bell-icon.svg": () => import("./bell-icon-CRpsAkxX.js"), "../../assets/icons/bra-icon.svg": () => import("./bra-icon-CC9uOqlL.js"), "../../assets/icons/briefcase-icon.svg": () => import("./briefcase-icon-BuwuCNbO.js"), "../../assets/icons/cake-piece-full-icon.svg": () => import("./cake-piece-full-icon-CkCLeIwV.js"), "../../assets/icons/cake-piece-icon.svg": () => import("./cake-piece-icon-Bz--FXNJ.js"), "../../assets/icons/calendar-icon.svg": () => import("./calendar-icon-CZ-w7y9t.js"), "../../assets/icons/cart-icon.svg": () => import("./cart-icon-vUUp3K-6.js"), "../../assets/icons/catalog-icon.svg": () => import("./catalog-icon-YGZwlG4e.js"), "../../assets/icons/chat-icon.svg": () => import("./chat-icon-0aaDqvaR.js"), "../../assets/icons/check-bold-icon.svg": () => import("./check-bold-icon-CJurDNu0.js"), "../../assets/icons/check-icon.svg": () => import("./check-icon-BmaA_JZx.js"), "../../assets/icons/child-icon.svg": () => import("./child-icon-DYjUsYFC.js"), "../../assets/icons/closer-icon.svg": () => import("./closer-icon-Bx8glUHF.js"), "../../assets/icons/clothing-icon.svg": () => import("./clothing-icon-CwNFJBnc.js"), "../../assets/icons/clothing-size-icon.svg": () => import("./clothing-size-icon-C_2yM5Cn.js"), "../../assets/icons/communication-icon.svg": () => import("./communication-icon-BQ-j9wpo.js"), "../../assets/icons/connection-icon.svg": () => import("./connection-icon-BkWfA5Ai.js"), "../../assets/icons/control-panel-icon.svg": () => import("./control-panel-icon-C5P0GiWd.js"), "../../assets/icons/cookie-icon.svg": () => import("./cookie-icon-DsSRMAq2.js"), "../../assets/icons/copy-icon.svg": () => import("./copy-icon-Bpfwd1RL.js"), "../../assets/icons/credit-card-icon.svg": () => import("./credit-card-icon-CBcJ9T2q.js"), "../../assets/icons/crown-icon.svg": () => import("./crown-icon-C4dNxvDx.js"), "../../assets/icons/culture-icon.svg": () => import("./culture-icon-0sve4N-p.js"), "../../assets/icons/curtain-almost-dark-icon.svg": () => import("./curtain-almost-dark-icon-BRmc3I_w.js"), "../../assets/icons/curtain-dark-icon.svg": () => import("./curtain-dark-icon-BaQ599GQ.js"), "../../assets/icons/curtain-opaque-icon.svg": () => import("./curtain-opaque-icon-DEUTfKVC.js"), "../../assets/icons/curtain-semi-transparent-icon.svg": () => import("./curtain-semi-transparent-icon-Bb8oaofi.js"), "../../assets/icons/curtain-transparent-icon.svg": () => import("./curtain-transparent-icon-dn7faJK3.js"), "../../assets/icons/customer-icon.svg": () => import("./customer-icon-DbQ2ch5B.js"), "../../assets/icons/delivery-icon.svg": () => import("./delivery-icon-Dmm6FuKb.js"), "../../assets/icons/denied-icon.svg": () => import("./denied-icon-Dw8rhbVP.js"), "../../assets/icons/desktop-icon.svg": () => import("./desktop-icon-CL2saCrX.js"), "../../assets/icons/diamond-icon.svg": () => import("./diamond-icon-BFw4aH6o.js"), "../../assets/icons/discount-icon.svg": () => import("./discount-icon-C1u9uhgm.js"), "../../assets/icons/dots-icon.svg": () => import("./dots-icon-DwAaH14u.js"), "../../assets/icons/download-icon.svg": () => import("./download-icon-Cma1AKJ3.js"), "../../assets/icons/edit-icon.svg": () => import("./edit-icon-WQjldlaQ.js"), "../../assets/icons/education-icon.svg": () => import("./education-icon-RDopC-Cq.js"), "../../assets/icons/email-icon.svg": () => import("./email-icon-mDyxUKZL.js"), "../../assets/icons/error-icon.svg": () => import("./error-icon-BZAB6_T2.js"), "../../assets/icons/family-icon.svg": () => import("./family-icon-js6b_288.js"), "../../assets/icons/faq-icon.svg": () => import("./faq-icon-CtfsUkbI.js"), "../../assets/icons/fast-delivery-icon.svg": () => import("./fast-delivery-icon-B4n-3hMl.js"), "../../assets/icons/feedback-negative-icon.svg": () => import("./feedback-negative-icon-DyMd9BR6.js"), "../../assets/icons/feedback-positive-icon.svg": () => import("./feedback-positive-icon-BAXGosYw.js"), "../../assets/icons/first-aid-icon.svg": () => import("./first-aid-icon-BrcJpjT0.js"), "../../assets/icons/fitness-icon.svg": () => import("./fitness-icon-KaNV7fs5.js"), "../../assets/icons/fossil-fuel-icon.svg": () => import("./fossil-fuel-icon-a-puzuvu.js"), "../../assets/icons/free-delivery-icon.svg": () => import("./free-delivery-icon-DMjzrB2n.js"), "../../assets/icons/friendship-icon.svg": () => import("./friendship-icon-DYVys10C.js"), "../../assets/icons/global-warming-icon.svg": () => import("./global-warming-icon-DEjDcox8.js"), "../../assets/icons/glossary-icon.svg": () => import("./glossary-icon-D4OVHejy.js"), "../../assets/icons/handshake-icon.svg": () => import("./handshake-icon-CDFSn9ku.js"), "../../assets/icons/hanger-icon.svg": () => import("./hanger-icon-DynYEwON.js"), "../../assets/icons/hashtag-icon.svg": () => import("./hashtag-icon-D2GYoIG6.js"), "../../assets/icons/health-icon.svg": () => import("./health-icon-CaTk4DKT.js"), "../../assets/icons/heart-eyes-emoji-icon.svg": () => import("./heart-eyes-emoji-icon-9qipgzma.js"), "../../assets/icons/heart-full-icon.svg": () => import("./heart-full-icon-DvOrbL8v.js"), "../../assets/icons/heart-icon.svg": () => import("./heart-icon-BpkxSSXq.js"), "../../assets/icons/help-icon.svg": () => import("./help-icon-CArmCB1w.js"), "../../assets/icons/hint-icon.svg": () => import("./hint-icon-BvSyjn-_.js"), "../../assets/icons/home-icon.svg": () => import("./home-icon-tNyoWo86.js"), "../../assets/icons/home2-icon.svg": () => import("./home2-icon-CAUiRC2u.js"), "../../assets/icons/image-placeholder-icon.svg": () => import("./image-placeholder-icon-aqP1m7cy.js"), "../../assets/icons/info-icon.svg": () => import("./info-icon-CV3CCeRD.js"), "../../assets/icons/invoice-icon.svg": () => import("./invoice-icon-Qmlair3V.js"), "../../assets/icons/light-bulb-heart-icon.svg": () => import("./light-bulb-heart-icon-DWsQcS9E.js"), "../../assets/icons/light-bulb-icon.svg": () => import("./light-bulb-icon-B-r9IrmC.js"), "../../assets/icons/lightning-icon.svg": () => import("./lightning-icon---t48G3x.js"), "../../assets/icons/location-icon.svg": () => import("./location-icon-BysfMNAg.js"), "../../assets/icons/locations-icon.svg": () => import("./locations-icon-DMIyzCnV.js"), "../../assets/icons/lock-icon.svg": () => import("./lock-icon-BknRwb2U.js"), "../../assets/icons/lock-open-icon.svg": () => import("./lock-open-icon-DfnVWX-S.js"), "../../assets/icons/logged-in-icon.svg": () => import("./logged-in-icon-CPZ9A3Kh.js"), "../../assets/icons/logout-icon.svg": () => import("./logout-icon-J5-spMlN.js"), "../../assets/icons/mail-icon.svg": () => import("./mail-icon-DMCIT9fP.js"), "../../assets/icons/menu-icon.svg": () => import("./menu-icon-DKowfNna.js"), "../../assets/icons/minus-icon.svg": () => import("./minus-icon-DXc0WOO-.js"), "../../assets/icons/newsletter-icon.svg": () => import("./newsletter-icon-DYTFgi3S.js"), "../../assets/icons/not-yet-available-icon.svg": () => import("./not-yet-available-icon-Bp8f3lYU.js"), "../../assets/icons/order-icon.svg": () => import("./order-icon-CxelxU0V.js"), "../../assets/icons/order2-icon.svg": () => import("./order2-icon-BU4gXoTn.js"), "../../assets/icons/out-of-stock-icon.svg": () => import("./out-of-stock-icon-BNZSx21I.js"), "../../assets/icons/pause-icon.svg": () => import("./pause-icon-DKmrDCbu.js"), "../../assets/icons/personal-data-icon.svg": () => import("./personal-data-icon-CE2zdcia.js"), "../../assets/icons/phone-icon.svg": () => import("./phone-icon-SUeBHyPb.js"), "../../assets/icons/pin-icon.svg": () => import("./pin-icon-DtpZU9D8.js"), "../../assets/icons/pinch-zoom-icon.svg": () => import("./pinch-zoom-icon-BnJZHHdv.js"), "../../assets/icons/plane-icon.svg": () => import("./plane-icon-BR8Jk3E4.js"), "../../assets/icons/play-icon.svg": () => import("./play-icon-nlrZoMKj.js"), "../../assets/icons/plus-icon.svg": () => import("./plus-icon-CMb50u-N.js"), "../../assets/icons/prepaid-icon.svg": () => import("./prepaid-icon-D0txIt4a.js"), "../../assets/icons/print-icon.svg": () => import("./print-icon-B4z4SRJ9.js"), "../../assets/icons/process-icon.svg": () => import("./process-icon-DQ5SNtfW.js"), "../../assets/icons/production-site-icon.svg": () => import("./production-site-icon-D-Tx-Di2.js"), "../../assets/icons/puzzle-icon.svg": () => import("./puzzle-icon-0N0NRFaI.js"), "../../assets/icons/qr-code-icon.svg": () => import("./qr-code-icon-BJVKbyAS.js"), "../../assets/icons/quality-icon.svg": () => import("./quality-icon-UTwSEFyd.js"), "../../assets/icons/question-icon.svg": () => import("./question-icon-D5IAIujI.js"), "../../assets/icons/radio-icon.svg": () => import("./radio-icon-nfG3ZREo.js"), "../../assets/icons/recently-viewed-icon.svg": () => import("./recently-viewed-icon-BvckzMHz.js"), "../../assets/icons/recycling-icon.svg": () => import("./recycling-icon-B9bq7uQv.js"), "../../assets/icons/religion-icon.svg": () => import("./religion-icon-BN7U-Nh7.js"), "../../assets/icons/return-icon.svg": () => import("./return-icon-DmwVg-YL.js"), "../../assets/icons/review-full-icon.svg": () => import("./review-full-icon-0ltgqBjM.js"), "../../assets/icons/review-icon.svg": () => import("./review-icon-dH-QQTTV.js"), "../../assets/icons/rocket-icon.svg": () => import("./rocket-icon-Du14mYzc.js"), "../../assets/icons/roots-icon.svg": () => import("./roots-icon-DOdzp87Y.js"), "../../assets/icons/scale-icon.svg": () => import("./scale-icon-ClAHqETG.js"), "../../assets/icons/search-categories-icon.svg": () => import("./search-categories-icon-BHqfBs4K.js"), "../../assets/icons/search-form-arrow-icon.svg": () => import("./search-form-arrow-icon-DrwazoiZ.js"), "../../assets/icons/search-icon.svg": () => import("./search-icon-vDsiFO-G.js"), "../../assets/icons/sepa-icon.svg": () => import("./sepa-icon-vZAJ6Ahn.js"), "../../assets/icons/service-icon.svg": () => import("./service-icon-xRmNR2Nl.js"), "../../assets/icons/share-icon.svg": () => import("./share-icon-Zt4PXBUH.js"), "../../assets/icons/shopping-bag-icon.svg": () => import("./shopping-bag-icon-C23f9bvk.js"), "../../assets/icons/signpost-icon.svg": () => import("./signpost-icon-GLMQoDiF.js"), "../../assets/icons/signpost-single-icon.svg": () => import("./signpost-single-icon-CBPhup5_.js"), "../../assets/icons/similar-products-icon.svg": () => import("./similar-products-icon-DLdiWKSO.js"), "../../assets/icons/size-icon.svg": () => import("./size-icon-Dcy0dygE.js"), "../../assets/icons/social-icon.svg": () => import("./social-icon-CP_4i3Oa.js"), "../../assets/icons/sold-out-icon.svg": () => import("./sold-out-icon-D--d5J7S.js"), "../../assets/icons/sort-icon.svg": () => import("./sort-icon-DC9t7b7J.js"), "../../assets/icons/spark-icon.svg": () => import("./spark-icon-Llzmp6pE.js"), "../../assets/icons/store-icon.svg": () => import("./store-icon-iQI7KbUQ.js"), "../../assets/icons/success-icon.svg": () => import("./success-icon-Ck0a67sm.js"), "../../assets/icons/suitcase-icon.svg": () => import("./suitcase-icon-o-K8t_DG.js"), "../../assets/icons/sustainable-animal-welfare-icon.svg": () => import("./sustainable-animal-welfare-icon-j3O9G9bu.js"), "../../assets/icons/sustainable-energy-efficient-icon.svg": () => import("./sustainable-energy-efficient-icon-ZqrV0HED.js"), "../../assets/icons/sustainable-natural-cosmetics-icon.svg": () => import("./sustainable-natural-cosmetics-icon-CKr3dG8-.js"), "../../assets/icons/sustainable-organic-materials-icon.svg": () => import("./sustainable-organic-materials-icon-C2DhpBkc.js"), "../../assets/icons/sustainable-production-icon.svg": () => import("./sustainable-production-icon-BlE58kS8.js"), "../../assets/icons/sustainable-recyclable-design-icon.svg": () => import("./sustainable-recyclable-design-icon-BaVFWkv8.js"), "../../assets/icons/sustainable-recycling-icon.svg": () => import("./sustainable-recycling-icon-DfQjOB8A.js"), "../../assets/icons/sustainable-resource-icon.svg": () => import("./sustainable-resource-icon-BZ8vYUWo.js"), "../../assets/icons/sustainable-social-initiatives-icon.svg": () => import("./sustainable-social-initiatives-icon-B7tz-UVU.js"), "../../assets/icons/swords-icon.svg": () => import("./swords-icon-BU3gDrG9.js"), "../../assets/icons/tablet-icon.svg": () => import("./tablet-icon-DCdSORFn.js"), "../../assets/icons/teacup-icon.svg": () => import("./teacup-icon-C4W141Y7.js"), "../../assets/icons/thumb-down-full-icon.svg": () => import("./thumb-down-full-icon-L_UCqoHT.js"), "../../assets/icons/thumb-down-icon.svg": () => import("./thumb-down-icon-VI5SZ3Jw.js"), "../../assets/icons/thumb-up-full-icon.svg": () => import("./thumb-up-full-icon-ft9PdyiY.js"), "../../assets/icons/thumb-up-icon.svg": () => import("./thumb-up-icon-DVRjfP3k.js"), "../../assets/icons/trash-bin-icon.svg": () => import("./trash-bin-icon-BC8xZbTZ.js"), "../../assets/icons/tv-icon.svg": () => import("./tv-icon-DYE6KvBv.js"), "../../assets/icons/user-icon.svg": () => import("./user-icon-oq9x9V4F.js"), "../../assets/icons/visibility-icon.svg": () => import("./visibility-icon-u0MX3TxC.js"), "../../assets/icons/visibility-off-icon.svg": () => import("./visibility-off-icon-BGgb544w.js"), "../../assets/icons/wallet-icon.svg": () => import("./wallet-icon-By4Xib1G.js"), "../../assets/icons/water-pollution-icon.svg": () => import("./water-pollution-icon-BpqEDbO6.js"), "../../assets/icons/water-usage-icon.svg": () => import("./water-usage-icon-xiMOUyov.js"), "../../assets/icons/whatsapp-bell-icon.svg": () => import("./whatsapp-bell-icon-C2Fg3x3c.js"), "../../assets/icons/whatsapp-phone-icon.svg": () => import("./whatsapp-phone-icon-C-jSnsOL.js") }), `../../assets/icons/${t}-icon.svg`, 5);
        r(() => i.default);
      } catch (i) {
        console.error("Error during the dynamic import of the svg icon:", i);
      }
    })();
  }, [t]);
  let o = "fill-clr-primary";
  t.startsWith("sustainable-") && (o = "fill-clr-sustainable");
  const s = Jn("shrink-0 w-6 h-6", o, e);
  return n ? /* @__PURE__ */ g(n, { className: s, "aria-hidden": "true", focusable: "false" }) : /* @__PURE__ */ g("div", { className: s });
}
const bw = ae({
  base: "inline-flex relative fill-clr-on-bg-high w-min",
  slots: {
    icons: "flex",
    iconsFull: "flex absolute top-0 left-0 overflow-hidden",
    icon: "shrink-0"
  },
  variants: {
    size: {
      small: {
        icon: "w-3 h-3"
      },
      large: {
        icon: "w-4 h-4"
      }
    }
  }
}), ww = ({ rating: t, size: e = "small" }) => {
  const { base: n, icons: r, iconsFull: o, icon: s } = bw({ size: e }), i = t < 0 ? 0 : t, a = Math.min(i, 5) / 5 * 100 + "%";
  return /* @__PURE__ */ G("span", { className: n(), children: [
    /* @__PURE__ */ G("span", { className: `${r()} ${o()}`, style: { width: a }, children: [
      /* @__PURE__ */ g(ge, { variant: "review-full", className: s() }),
      /* @__PURE__ */ g(ge, { variant: "review-full", className: s() }),
      /* @__PURE__ */ g(ge, { variant: "review-full", className: s() }),
      /* @__PURE__ */ g(ge, { variant: "review-full", className: s() }),
      /* @__PURE__ */ g(ge, { variant: "review-full", className: s() })
    ] }),
    /* @__PURE__ */ G("span", { className: r(), children: [
      /* @__PURE__ */ g(ge, { variant: "review", className: s() }),
      /* @__PURE__ */ g(ge, { variant: "review", className: s() }),
      /* @__PURE__ */ g(ge, { variant: "review", className: s() }),
      /* @__PURE__ */ g(ge, { variant: "review", className: s() }),
      /* @__PURE__ */ g(ge, { variant: "review", className: s() })
    ] })
  ] });
}, xw = ({ value: t, quantity: e }) => /* @__PURE__ */ G("span", { className: "flex gap-1.25 items-center typography-body1", children: [
  /* @__PURE__ */ g(ww, { rating: t }),
  `(${e})`
] }), Cw = ({ features: t }) => {
  const e = "w-6 h-6 fill-clr-sustainable";
  return /* @__PURE__ */ G("span", { className: "flex gap-2", children: [
    t[0] ? /* @__PURE__ */ g(ge, { variant: `sustainable-${t[0]}`, className: e }) : null,
    t[1] ? /* @__PURE__ */ g(ge, { variant: `sustainable-${t[1]}`, className: e }) : null,
    t[2] ? /* @__PURE__ */ g(ge, { variant: `sustainable-${t[2]}`, className: e }) : null
  ] });
}, Ew = ae({
  base: "preflight typography-h5 text-clr-on-bg-high flex gap-6.5 justify-between items-start py-5 w-full outline-none group",
  slots: {
    header: "flex items-center gap-2 flex-wrap",
    title: "rounded-sm text-left group-focus-visible:px-1 group-focus-visible:outline group-focus-visible:outline-1 break-all",
    icon: "w-6 h-full py-0.5 shrink-0 transition [button[data-state='open']>&]:rotate-180 ease-out duration-300"
  },
  variants: {
    disabled: {
      true: {
        base: "text-clr-on-bg-disabled",
        icon: "fill-clr-on-bg-disabled"
      },
      false: {
        base: "text-clr-on-bg-high",
        icon: "fill-clr-primary"
      }
    }
  }
}), Sw = (t) => {
  const { children: e, component: n = sp, disabled: r = !1, id: o } = t, { base: s, header: i, title: a, icon: l } = Ew({ disabled: r });
  let c = null;
  if (t.type === "rating")
    c = /* @__PURE__ */ g(xw, { value: t.rating, quantity: t.ratingQuantity });
  else if (t.type === "sustainable") {
    t.features.length === 0 && console.error("Sustainable collapsible should have at least one feature");
    const u = [...new Set(t.features)];
    c = /* @__PURE__ */ g(Cw, { features: u });
  }
  return /* @__PURE__ */ G(n, { className: s(), id: o, children: [
    /* @__PURE__ */ G("div", { className: i(), children: [
      /* @__PURE__ */ g("span", { className: a(), children: e }),
      c && /* @__PURE__ */ g("span", { children: c })
    ] }),
    /* @__PURE__ */ g(ge, { variant: "arrow-down", className: l() })
  ] });
}, _l = (t) => {
  const { title: e, children: n, disabled: r = !1, initiallyOpened: o = !1, ...s } = t, i = E0(t.rootRef, t.onInitialInView), [a, l] = de(o), c = () => {
    a ? t.onClose && t.onClose() : t.onOpen && t.onOpen(), l(!a);
  }, u = vw({ disabled: r }), d = yw();
  return /* @__PURE__ */ G(
    op,
    {
      className: u,
      open: r ? !1 : a,
      onOpenChange: c,
      disabled: r,
      ref: i,
      children: [
        /* @__PURE__ */ g(Sw, { disabled: r, ...s, children: e }),
        /* @__PURE__ */ g(ip, { className: d, forceMount: !0, children: n })
      ]
    }
  );
};
_l.displayName = "Collapsible";
const Aw = ({ children: t }) => {
  const { getSingleChildFromSubcomponent: e, printBadConstructionMessage: n } = pt(t);
  return t ? /* @__PURE__ */ g(v0, { type: "multiple", children: tn.map(t, (r, o) => {
    const i = { value: "item-" + o + 1 };
    return e(_l, r, i);
  }) }) : (n("Accordion"), null);
};
Aw.Item = _l;
const Tw = ({ edgeLength: t = "16px" }) => /* @__PURE__ */ G("span", { role: "status", children: [
  /* @__PURE__ */ G(
    "svg",
    {
      "aria-hidden": "true",
      "data-chromatic": "ignore",
      className: "text-clr-on-bg-mid animate-spin fill-clr-bg",
      style: { width: t, height: t },
      viewBox: "0 0 100 101",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ g(
          "path",
          {
            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ g(
          "path",
          {
            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
            fill: "currentFill"
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ g("span", { className: "sr-only", children: "Lade..." })
] }), Rw = ae({
  base: [
    "preflight rounded typography-button relative flex items-center justify-center gap-2 border border-transparent group",
    "focus-visible:outline outline-1 outline-offset-1 outline-clr-primary"
  ],
  slots: {
    icon: "",
    loader: "absolute",
    contentWrapper: "flex items-center justify-center gap-2"
  },
  variants: {
    variant: {
      primary: {
        base: "bg-clr-primary text-clr-on-primary-high hover:enabled:bg-clr-on-bg-low active:bg-clr-on-bg-low",
        icon: "fill-clr-on-primary-high"
      },
      secondary: {
        base: [
          "text-clr-primary border-clr-primary",
          "hover:enabled:text-clr-on-bg-low hover:enabled:border-clr-on-bg-low",
          "active:bg-clr-bg-light active:text-clr-on-bg-low active:border-clr-on-bg-low"
        ],
        icon: "fill-clr-primary group-hover:group-enabled:fill-clr-on-bg-low"
      },
      tertiary: {
        base: [
          "text-clr-primary hover:enabled:text-clr-on-bg-low active:text-clr-on-bg-low",
          "focus-visible:outline outline-1 outline-offset-1 outline-clr-primary"
        ],
        icon: "fill-clr-primary group-hover:group-enabled:fill-clr-on-bg-low active:fill-clr-on-bg-low"
      }
    },
    disabled: {
      true: "",
      false: ""
    },
    small: {
      true: "",
      false: ""
    },
    contentWidth: {
      true: "",
      false: ""
    },
    link: {
      true: "",
      false: ""
    },
    iconPosition: {
      start: "",
      end: "flex-row-reverse"
    },
    loading: {
      true: {
        contentWrapper: "invisible"
      },
      false: ""
    },
    iconButton: {
      true: "",
      false: "py-[7px]"
    }
  },
  compoundVariants: [
    {
      variant: "primary",
      disabled: !0,
      class: "bg-clr-on-bg-disabled"
    },
    {
      contentWidth: !1,
      iconButton: !1,
      class: "w-full"
    },
    {
      contentWidth: !0,
      link: !0,
      class: "w-fit"
    },
    {
      variant: "secondary",
      disabled: !0,
      class: {
        base: "text-clr-on-bg-disabled border-clr-on-bg-disabled",
        icon: "fill-clr-on-bg-disabled"
      }
    },
    {
      variant: "tertiary",
      disabled: !0,
      class: {
        base: "text-clr-on-bg-disabled",
        icon: "fill-clr-on-bg-disabled"
      }
    },
    {
      iconButton: !1,
      small: !1,
      class: {
        icon: "w-4 h-4"
      }
    },
    {
      iconButton: !0,
      small: !1,
      variant: ["primary", "secondary"],
      class: {
        base: "p-[7px]",
        icon: "w-4 h-4"
        // we currently predefine the fill color in the icon, so we cannot inherit the fill from base and instead have to set it directly
      }
    },
    {
      iconButton: !1,
      variant: ["primary", "secondary"],
      class: "px-7"
    },
    {
      iconButton: !0,
      small: !0,
      class: {
        base: "p-[3px]",
        icon: "w-4 h-4"
      }
    },
    {
      iconButton: !0,
      small: !1,
      variant: "tertiary",
      class: {
        base: "p-[3px]",
        icon: "w-6 h-6"
      }
    }
  ]
}), Qn = ({
  id: t,
  children: e,
  small: n = !1,
  disabled: r = !1,
  variant: o = "primary",
  onClick: s,
  contentWidth: i = !1,
  loading: a = !1,
  type: l = "button",
  icon: c,
  iconPosition: u = "start",
  iconButton: d = !1,
  link: p = !1,
  rel: h,
  href: v = "#",
  target: m,
  tabIndex: y,
  className: b = ""
}) => {
  const w = r || a, {
    base: x,
    icon: E,
    contentWrapper: C,
    loader: A
  } = Rw({
    small: n,
    contentWidth: i,
    disabled: w,
    iconPosition: u,
    variant: o,
    loading: a,
    iconButton: d,
    link: p
  }), S = /* @__PURE__ */ G(Pe, { children: [
    c && /* @__PURE__ */ g(ge, { variant: c, className: E() }),
    d ? void 0 : e
  ] });
  let R = S;
  a && (R = /* @__PURE__ */ G(Pe, { children: [
    /* @__PURE__ */ g("span", { className: C(), children: S }),
    /* @__PURE__ */ g("span", { className: A(), children: /* @__PURE__ */ g(Tw, { edgeLength: d ? "20px" : "16px" }) })
  ] }));
  let P;
  return d && (e ? P = e : P = "Icon"), p ? /* @__PURE__ */ g(
    "a",
    {
      className: Jn(x(), b),
      href: v,
      rel: h,
      target: m,
      onClick: s,
      tabIndex: y,
      "aria-label": P,
      children: R
    }
  ) : /* @__PURE__ */ g(
    "button",
    {
      id: t,
      type: l,
      className: Jn(x(), b),
      disabled: w,
      onClick: s,
      tabIndex: y,
      "aria-label": P,
      children: R
    }
  );
}, Pl = ({
  children: t,
  icon: e,
  iconPosition: n = "start",
  contentWidth: r = !1,
  id: o,
  variant: s = "primary",
  tabIndex: i,
  ...a
}) => {
  const l = { children: t, icon: e, iconPosition: n, contentWidth: r, id: o, variant: s, tabIndex: i };
  if (a.link) {
    const { href: c, rel: u, target: d, onClick: p } = a;
    return /* @__PURE__ */ g(Qn, { ...l, link: !0, href: c, rel: u, target: d, onClick: p, children: t });
  } else {
    const { disabled: c, loading: u, onClick: d, type: p } = a;
    return /* @__PURE__ */ g(Qn, { ...l, loading: u, disabled: c, onClick: d, type: p, children: t });
  }
}, Tn = ({ id: t, icon: e, label: n, small: r = !1, variant: o = "primary", tabIndex: s, ...i }) => {
  const a = { id: t, icon: e, label: n, small: r, variant: o, tabIndex: s };
  if (i.link) {
    const { href: l, rel: c, target: u, onClick: d } = i;
    return /* @__PURE__ */ g(Qn, { ...a, link: !0, href: l, rel: c, target: u, onClick: d, iconButton: !0, contentWidth: !0, children: n });
  } else {
    const { disabled: l = !1, loading: c = !1, onClick: u, type: d = "button" } = i;
    return /* @__PURE__ */ g(Qn, { ...a, disabled: l, loading: c, type: d, onClick: u, iconButton: !0, contentWidth: !0, children: n });
  }
}, MN = ({
  children: t,
  icon: e,
  iconPosition: n = "start",
  disabled: r = !1,
  contentWidth: o = !1,
  onClick: s,
  small: i = !1,
  loading: a = !1,
  type: l = "button",
  tabIndex: c
}) => /* @__PURE__ */ g(
  Qn,
  {
    disabled: r,
    loading: a,
    type: l,
    small: i,
    icon: e,
    contentWidth: o,
    iconPosition: n,
    variant: "tertiary",
    onClick: s,
    tabIndex: c,
    children: t
  }
), _w = ae({
  base: "my-0",
  variants: {
    variant: {
      h1: "typography-h1",
      h2: "typography-h2",
      h3: "typography-h3",
      h4: "typography-h4",
      h5: "typography-h5",
      h6: "typography-h6",
      "bonprix-h1": "typography-bonprix-h1",
      "bonprix-h2": "typography-bonprix-h2",
      "bonprix-h3": "typography-bonprix-h3",
      "bonprix-h4": "typography-bonprix-h4",
      "bonprix-h5": "typography-bonprix-h5",
      "bonprix-h6": "typography-bonprix-h6",
      subtitle1: "typography-subtitle1",
      subtitle2: "typography-subtitle2",
      body1: "typography-body1",
      "body1-bold": "typography-body1-bold",
      body2: "typography-body2",
      "body2-bold": "typography-body2-bold",
      caption: "typography-caption",
      overline: "typography-overline"
    },
    color: {
      primary: "text-clr-primary",
      "on-primary-high": "text-clr-on-primary-high",
      "on-primary-low": "text-clr-on-primary-low",
      "on-bg-high": "text-clr-on-bg-high",
      "on-bg-mid": "text-clr-on-bg-mid",
      "on-bg-low": "text-clr-on-bg-low",
      "on-bg-disabled": "text-clr-on-bg-disabled",
      error: "text-clr-error",
      alert: "text-clr-alert",
      success: "text-clr-success",
      info: "text-clr-info",
      sale: "text-clr-sale",
      sustainable: "text-clr-sustainable",
      black: "text-clr-black",
      white: "text-clr-white",
      inherit: "text-inherit"
    },
    bold: {
      true: "font-bold"
    },
    strikeThrough: {
      true: "line-through"
    },
    align: {
      left: "text-left",
      center: "text-center",
      right: "text-right"
    }
  }
}), er = ({
  children: t,
  variant: e = "body1",
  component: n,
  bold: r = !1,
  strikeThrough: o = !1,
  color: s = "on-bg-high",
  align: i = "left"
}) => {
  const l = n ?? {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    "bonprix-h1": "h1",
    "bonprix-h2": "h2",
    "bonprix-h3": "h3",
    "bonprix-h4": "h4",
    "bonprix-h5": "h5",
    "bonprix-h6": "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    "body1-bold": "p",
    body2: "p",
    "body2-bold": "p",
    caption: "span",
    overline: "span"
  }[e];
  return /* @__PURE__ */ g(l, { className: _w({ variant: e, bold: r, strikeThrough: o, color: s, align: i }), children: t });
}, Pw = ae({
  slots: {
    root: "preflight m-0 flex justify-between items-start p-5 rounded gap-4",
    iconAndContent: "flex gap-2",
    content: "flex-col text-clr-on-bg-high gap-0.5 pt-0.5",
    title: "",
    icon: ""
  },
  variants: {
    severity: {
      success: {
        root: "bg-clr-success-bg",
        title: "text-clr-success",
        icon: "fill-clr-success"
      },
      info: {
        root: "bg-clr-info-bg",
        title: "text-clr-info",
        icon: "fill-clr-info"
      },
      warning: {
        root: "bg-clr-alert-bg",
        title: "text-clr-alert",
        icon: "fill-clr-alert"
      },
      error: {
        root: "bg-clr-error-bg",
        title: "text-clr-error",
        icon: "fill-clr-error"
      }
    },
    alertVariant: {
      primary: {
        title: "text-clr-on-bg-high"
      },
      secondary: {
        root: "p-0 rounded-none bg-transparent"
      }
    }
  }
}), Eu = {
  warning: {
    icon: "alert",
    label: "warnung"
  },
  info: {
    icon: "hint",
    label: "hinweis"
  },
  success: {
    icon: "success",
    label: "erfolg"
  },
  error: {
    icon: "error",
    label: "fehler"
  }
}, NN = ({
  isOpen: t,
  variant: e = "primary",
  severity: n,
  title: r,
  children: o,
  showCloseIcon: s = !0,
  onClose: i = () => null,
  nonCritical: a = !1,
  titleTag: l = "h2"
}) => {
  const { root: c, content: u, title: d, iconAndContent: p, icon: h } = Pw({ severity: n, alertVariant: e });
  if (!t) return null;
  const v = Eu[n].icon, m = Eu[n].label;
  return /* @__PURE__ */ G("div", { className: c(), role: a ? void 0 : "alert", "aria-label": m, children: [
    /* @__PURE__ */ G("div", { className: p(), children: [
      /* @__PURE__ */ g(ge, { variant: v, className: h() }),
      /* @__PURE__ */ G("div", { className: u(), children: [
        r !== void 0 && /* @__PURE__ */ g("div", { className: d(), children: /* @__PURE__ */ g(er, { variant: "h6", color: "inherit", component: l, children: r }) }),
        /* @__PURE__ */ g(er, { variant: "body1", children: o })
      ] })
    ] }),
    s && /* @__PURE__ */ g(Tn, { variant: "tertiary", icon: "closer", small: !0, label: "Schließen", onClick: i })
  ] });
}, kw = ae({
  base: "preflight flex gap-2 py-1",
  slots: {
    icon: "h-2.5 w-2.5 rounded-full shrink-0 mt-1.25",
    text: "typography-body1 text-clr-primary",
    stack: "flex flex-col gap-y-1"
  },
  variants: {
    delivery: {
      available: { icon: "bg-clr-success" },
      "available-soon": { icon: "bg-clr-alert" },
      "sold-out": { icon: "bg-clr-error" }
    },
    almostSoldOut: {
      false: {
        stack: "pb-6"
      }
    }
  }
}), ON = ({ delivery: t, children: e, almostSoldOut: n = !1 }) => {
  const { base: r, icon: o, text: s, stack: i } = kw({ delivery: t, almostSoldOut: n });
  return /* @__PURE__ */ G("div", { className: r(), children: [
    /* @__PURE__ */ g("div", { className: o() }),
    /* @__PURE__ */ G("div", { className: i(), children: [
      /* @__PURE__ */ g("p", { className: s(), children: e }),
      n && /* @__PURE__ */ g(er, { variant: "body1", color: "alert", children: /* @__PURE__ */ g("span", { className: "bg-clr-alert-bg", children: "Fast ausverkauft" }) })
    ] })
  ] });
}, Iw = ae({
  base: "preflight inline-block px-0.5 rounded-sm",
  variants: {
    variant: {
      product: "text-clr-white bg-clr-black",
      price: "text-clr-white bg-clr-sale",
      social: "text-clr-on-bg-mid bg-clr-bg-disabled"
    },
    size: {
      small: "typography-flag-small-text",
      large: "typography-flag-large-text"
    }
  }
}), VN = ({ children: t, variant: e = "product", size: n = "large" }) => /* @__PURE__ */ g("p", { className: Iw({ variant: e, size: n }), children: t }), kl = Kt({});
function uo(t) {
  const e = Se(null);
  return e.current === null && (e.current = t()), e.current;
}
const Il = typeof window < "u", Dl = Il ? gl : ie, Os = /* @__PURE__ */ Kt(null), Vs = Kt({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
});
function Rp(t) {
  return typeof t == "object" && t !== null;
}
function Ml(t) {
  return Rp(t) && "offsetHeight" in t;
}
class Dw extends f.Component {
  getSnapshotBeforeUpdate(e) {
    const n = this.props.childRef.current;
    if (n && e.isPresent && !this.props.isPresent) {
      const r = n.offsetParent, o = Ml(r) && r.offsetWidth || 0, s = this.props.sizeRef.current;
      s.height = n.offsetHeight || 0, s.width = n.offsetWidth || 0, s.top = n.offsetTop, s.left = n.offsetLeft, s.right = o - s.width - s.left;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function Mw({ children: t, isPresent: e, anchorX: n }) {
  const r = cn(), o = Se(null), s = Se({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    right: 0
  }), { nonce: i } = Ae(Vs);
  return Xf(() => {
    const { width: a, height: l, top: c, left: u, right: d } = s.current;
    if (e || !o.current || !a || !l)
      return;
    const p = n === "left" ? `left: ${u}` : `right: ${d}`;
    o.current.dataset.motionPopId = r;
    const h = document.createElement("style");
    return i && (h.nonce = i), document.head.appendChild(h), h.sheet && h.sheet.insertRule(`
          [data-motion-pop-id="${r}"] {
            position: absolute !important;
            width: ${a}px !important;
            height: ${l}px !important;
            ${p}px !important;
            top: ${c}px !important;
          }
        `), () => {
      document.head.contains(h) && document.head.removeChild(h);
    };
  }, [e]), g(Dw, { isPresent: e, childRef: o, sizeRef: s, children: f.cloneElement(t, { ref: o }) });
}
const Nw = ({ children: t, initial: e, isPresent: n, onExitComplete: r, custom: o, presenceAffectsLayout: s, mode: i, anchorX: a }) => {
  const l = uo(Ow), c = cn();
  let u = !0, d = Lt(() => (u = !1, {
    id: c,
    initial: e,
    isPresent: n,
    custom: o,
    onExitComplete: (p) => {
      l.set(p, !0);
      for (const h of l.values())
        if (!h)
          return;
      r && r();
    },
    register: (p) => (l.set(p, !1), () => l.delete(p))
  }), [n, l, r]);
  return s && u && (d = { ...d }), Lt(() => {
    l.forEach((p, h) => l.set(h, !1));
  }, [n]), f.useEffect(() => {
    !n && !l.size && r && r();
  }, [n]), i === "popLayout" && (t = g(Mw, { isPresent: n, anchorX: a, children: t })), g(Os.Provider, { value: d, children: t });
};
function Ow() {
  return /* @__PURE__ */ new Map();
}
function _p(t = !0) {
  const e = Ae(Os);
  if (e === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: r, register: o } = e, s = cn();
  ie(() => {
    if (t)
      return o(s);
  }, [t]);
  const i = Dt(() => t && r && r(s), [s, r, t]);
  return !n && r ? [!1, i] : [!0];
}
const Mo = (t) => t.key || "";
function Su(t) {
  const e = [];
  return tn.forEach(t, (n) => {
    Ur(n) && e.push(n);
  }), e;
}
const Vw = ({ children: t, custom: e, initial: n = !0, onExitComplete: r, presenceAffectsLayout: o = !0, mode: s = "sync", propagate: i = !1, anchorX: a = "left" }) => {
  const [l, c] = _p(i), u = Lt(() => Su(t), [t]), d = i && !l ? [] : u.map(Mo), p = Se(!0), h = Se(u), v = uo(() => /* @__PURE__ */ new Map()), [m, y] = de(u), [b, w] = de(u);
  Dl(() => {
    p.current = !1, h.current = u;
    for (let C = 0; C < b.length; C++) {
      const A = Mo(b[C]);
      d.includes(A) ? v.delete(A) : v.get(A) !== !0 && v.set(A, !1);
    }
  }, [b, d.length, d.join("-")]);
  const x = [];
  if (u !== m) {
    let C = [...u];
    for (let A = 0; A < b.length; A++) {
      const S = b[A], R = Mo(S);
      d.includes(R) || (C.splice(A, 0, S), x.push(S));
    }
    return s === "wait" && x.length && (C = x), w(Su(C)), y(u), null;
  }
  process.env.NODE_ENV !== "production" && s === "wait" && b.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: E } = Ae(kl);
  return g(Pe, { children: b.map((C) => {
    const A = Mo(C), S = i && !l ? !1 : u === b || d.includes(A), R = () => {
      if (v.has(A))
        v.set(A, !0);
      else
        return;
      let P = !0;
      v.forEach((k) => {
        k || (P = !1);
      }), P && (E == null || E(), w(h.current), i && (c == null || c()), r && r());
    };
    return g(Nw, { isPresent: S, initial: !p.current || n ? void 0 : !1, custom: e, presenceAffectsLayout: o, mode: s, onExitComplete: S ? void 0 : R, anchorX: a, children: C }, A);
  }) });
}, No = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], Au = {
  value: null,
  addProjectionMetrics: null
};
function Fw(t, e) {
  let n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), o = !1, s = !1;
  const i = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, l = 0;
  function c(d) {
    i.has(d) && (u.schedule(d), t()), l++, d(a);
  }
  const u = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (d, p = !1, h = !1) => {
      const m = h && o ? n : r;
      return p && i.add(d), m.has(d) || m.add(d), d;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (d) => {
      r.delete(d), i.delete(d);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (d) => {
      if (a = d, o) {
        s = !0;
        return;
      }
      o = !0, [n, r] = [r, n], n.forEach(c), e && Au.value && Au.value.frameloop[e].push(l), l = 0, n.clear(), o = !1, s && (s = !1, u.process(d));
    }
  };
  return u;
}
const Bt = {}, Lw = 40;
function Pp(t, e) {
  let n = !1, r = !0;
  const o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, s = () => n = !0, i = No.reduce((x, E) => (x[E] = Fw(s, e ? E : void 0), x), {}), { setup: a, read: l, resolveKeyframes: c, preUpdate: u, update: d, preRender: p, render: h, postRender: v } = i, m = () => {
    const x = Bt.useManualTiming ? o.timestamp : performance.now();
    n = !1, Bt.useManualTiming || (o.delta = r ? 1e3 / 60 : Math.max(Math.min(x - o.timestamp, Lw), 1)), o.timestamp = x, o.isProcessing = !0, a.process(o), l.process(o), c.process(o), u.process(o), d.process(o), p.process(o), h.process(o), v.process(o), o.isProcessing = !1, n && e && (r = !1, t(m));
  }, y = () => {
    n = !0, r = !0, o.isProcessing || t(m);
  };
  return { schedule: No.reduce((x, E) => {
    const C = i[E];
    return x[E] = (A, S = !1, R = !1) => (n || y(), C.schedule(A, S, R)), x;
  }, {}), cancel: (x) => {
    for (let E = 0; E < No.length; E++)
      i[No[E]].cancel(x);
  }, state: o, steps: i };
}
const Qe = /* @__NO_SIDE_EFFECTS__ */ (t) => t, { schedule: we, cancel: $t, state: Ie, steps: ki } = /* @__PURE__ */ Pp(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Qe, !0), kp = Kt({ strict: !1 }), Tu = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, tr = {};
for (const t in Tu)
  tr[t] = {
    isEnabled: (e) => Tu[t].some((n) => !!e[n])
  };
function Bw(t) {
  for (const e in t)
    tr[e] = {
      ...tr[e],
      ...t[e]
    };
}
const $w = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function as(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || $w.has(t);
}
let Ip = (t) => !as(t);
function Ww(t) {
  t && (Ip = (e) => e.startsWith("on") ? !as(e) : t(e));
}
try {
  Ww(require("@emotion/is-prop-valid").default);
} catch {
}
function jw(t, e, n) {
  const r = {};
  for (const o in t)
    o === "values" && typeof t.values == "object" || (Ip(o) || n === !0 && as(o) || !e && !as(o) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && o.startsWith("onDrag")) && (r[o] = t[o]);
  return r;
}
const Ru = /* @__PURE__ */ new Set();
function Fs(t, e, n) {
  t || Ru.has(e) || (console.warn(e), Ru.add(e));
}
function Uw(t) {
  if (typeof Proxy > "u")
    return t;
  const e = /* @__PURE__ */ new Map(), n = (...r) => (process.env.NODE_ENV !== "production" && Fs(!1, "motion() is deprecated. Use motion.create() instead."), t(...r));
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, o) => o === "create" ? t : (e.has(o) || e.set(o, t(o)), e.get(o))
  });
}
const Ls = /* @__PURE__ */ Kt({});
function Bs(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
function zr(t) {
  return typeof t == "string" || Array.isArray(t);
}
const Nl = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Ol = ["initial", ...Nl];
function $s(t) {
  return Bs(t.animate) || Ol.some((e) => zr(t[e]));
}
function Dp(t) {
  return !!($s(t) || t.variants);
}
function Hw(t, e) {
  if ($s(t)) {
    const { initial: n, animate: r } = t;
    return {
      initial: n === !1 || zr(n) ? n : void 0,
      animate: zr(r) ? r : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function zw(t) {
  const { initial: e, animate: n } = Hw(t, Ae(Ls));
  return Lt(() => ({ initial: e, animate: n }), [_u(e), _u(n)]);
}
function _u(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const Gw = Symbol.for("motionComponentSymbol");
function $n(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function Kw(t, e, n) {
  return Dt(
    (r) => {
      r && t.onMount && t.onMount(r), e && (r ? e.mount(r) : e.unmount()), n && (typeof n == "function" ? n(r) : $n(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
const Vl = (t) => t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), Yw = "framerAppearId", Mp = "data-" + Vl(Yw), Np = Kt({}), { schedule: Fl, cancel: FN } = /* @__PURE__ */ Pp(queueMicrotask, !1);
function qw(t, e, n, r, o) {
  var m, y;
  const { visualElement: s } = Ae(Ls), i = Ae(kp), a = Ae(Os), l = Ae(Vs).reducedMotion, c = Se(null);
  r = r || i.renderer, !c.current && r && (c.current = r(t, {
    visualState: e,
    parent: s,
    props: n,
    presenceContext: a,
    blockInitialAnimation: a ? a.initial === !1 : !1,
    reducedMotionConfig: l
  }));
  const u = c.current, d = Ae(Np);
  u && !u.projection && o && (u.type === "html" || u.type === "svg") && Xw(c.current, n, o, d);
  const p = Se(!1);
  Xf(() => {
    u && p.current && u.update(n, a);
  });
  const h = n[Mp], v = Se(!!h && !((m = window.MotionHandoffIsComplete) != null && m.call(window, h)) && ((y = window.MotionHasOptimisedAnimation) == null ? void 0 : y.call(window, h)));
  return Dl(() => {
    u && (p.current = !0, window.MotionIsMounted = !0, u.updateFeatures(), Fl.render(u.render), v.current && u.animationState && u.animationState.animateChanges());
  }), ie(() => {
    u && (!v.current && u.animationState && u.animationState.animateChanges(), v.current && (queueMicrotask(() => {
      var b;
      (b = window.MotionHandoffMarkAsComplete) == null || b.call(window, h);
    }), v.current = !1));
  }), u;
}
function Xw(t, e, n, r) {
  const { layoutId: o, layout: s, drag: i, dragConstraints: a, layoutScroll: l, layoutRoot: c, layoutCrossfade: u } = e;
  t.projection = new n(t.latestValues, e["data-framer-portal-id"] ? void 0 : Op(t.parent)), t.projection.setOptions({
    layoutId: o,
    layout: s,
    alwaysMeasureLayout: !!i || a && $n(a),
    visualElement: t,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof s == "string" ? s : "both",
    initialPromotionConfig: r,
    crossfade: u,
    layoutScroll: l,
    layoutRoot: c
  });
}
function Op(t) {
  if (t)
    return t.options.allowProjection !== !1 ? t.projection : Op(t.parent);
}
let fr = () => {
}, ct = () => {
};
process.env.NODE_ENV !== "production" && (fr = (t, e) => {
  !t && typeof console < "u" && console.warn(e);
}, ct = (t, e) => {
  if (!t)
    throw new Error(e);
});
function Zw({ preloadedFeatures: t, createVisualElement: e, useRender: n, useVisualState: r, Component: o }) {
  t && Bw(t);
  function s(a, l) {
    let c;
    const u = {
      ...Ae(Vs),
      ...a,
      layoutId: Jw(a)
    }, { isStatic: d } = u, p = zw(a), h = r(a, d);
    if (!d && Il) {
      Qw(u, t);
      const v = ex(u);
      c = v.MeasureLayout, p.visualElement = qw(o, h, u, e, v.ProjectionNode);
    }
    return G(Ls.Provider, { value: p, children: [c && p.visualElement ? g(c, { visualElement: p.visualElement, ...u }) : null, n(o, a, Kw(h, p.visualElement, l), h, d, p.visualElement)] });
  }
  s.displayName = `motion.${typeof o == "string" ? o : `create(${o.displayName ?? o.name ?? ""})`}`;
  const i = Yt(s);
  return i[Gw] = o, i;
}
function Jw({ layoutId: t }) {
  const e = Ae(kl).id;
  return e && t !== void 0 ? e + "-" + t : t;
}
function Qw(t, e) {
  const n = Ae(kp).strict;
  if (process.env.NODE_ENV !== "production" && e && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    t.ignoreStrict ? fr(!1, r) : ct(!1, r);
  }
}
function ex(t) {
  const { drag: e, layout: n } = tr;
  if (!e && !n)
    return {};
  const r = { ...e, ...n };
  return {
    MeasureLayout: e != null && e.isEnabled(t) || n != null && n.isEnabled(t) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
const Vp = (t) => (e) => typeof e == "string" && e.startsWith(t), Ll = /* @__PURE__ */ Vp("--"), tx = /* @__PURE__ */ Vp("var(--"), Bl = (t) => tx(t) ? nx.test(t.split("/*")[0].trim()) : !1, nx = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, Gr = {};
function rx(t) {
  for (const e in t)
    Gr[e] = t[e], Ll(e) && (Gr[e].isCSSVariable = !0);
}
const pr = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], hr = new Set(pr);
function Fp(t, { layout: e, layoutId: n }) {
  return hr.has(t) || t.startsWith("origin") || (e || n !== void 0) && (!!Gr[t] || t === "opacity");
}
const Lp = (t, e) => e && typeof t == "number" ? e.transform(t) : t, Wt = (t, e, n) => n > e ? e : n < t ? t : n, mr = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, Kr = {
  ...mr,
  transform: (t) => Wt(0, 1, t)
}, Oo = {
  ...mr,
  default: 1
}, Pu = {
  ...mr,
  transform: Math.round
}, fo = /* @__NO_SIDE_EFFECTS__ */ (t) => ({
  test: (e) => typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), Zt = /* @__PURE__ */ fo("deg"), yt = /* @__PURE__ */ fo("%"), oe = /* @__PURE__ */ fo("px"), ox = /* @__PURE__ */ fo("vh"), sx = /* @__PURE__ */ fo("vw"), ku = {
  ...yt,
  parse: (t) => yt.parse(t) / 100,
  transform: (t) => yt.transform(t * 100)
}, ix = {
  rotate: Zt,
  rotateX: Zt,
  rotateY: Zt,
  rotateZ: Zt,
  scale: Oo,
  scaleX: Oo,
  scaleY: Oo,
  scaleZ: Oo,
  skew: Zt,
  skewX: Zt,
  skewY: Zt,
  distance: oe,
  translateX: oe,
  translateY: oe,
  translateZ: oe,
  x: oe,
  y: oe,
  z: oe,
  perspective: oe,
  transformPerspective: oe,
  opacity: Kr,
  originX: ku,
  originY: ku,
  originZ: oe
}, $l = {
  // Border props
  borderWidth: oe,
  borderTopWidth: oe,
  borderRightWidth: oe,
  borderBottomWidth: oe,
  borderLeftWidth: oe,
  borderRadius: oe,
  radius: oe,
  borderTopLeftRadius: oe,
  borderTopRightRadius: oe,
  borderBottomRightRadius: oe,
  borderBottomLeftRadius: oe,
  // Positioning props
  width: oe,
  maxWidth: oe,
  height: oe,
  maxHeight: oe,
  top: oe,
  right: oe,
  bottom: oe,
  left: oe,
  // Spacing props
  padding: oe,
  paddingTop: oe,
  paddingRight: oe,
  paddingBottom: oe,
  paddingLeft: oe,
  margin: oe,
  marginTop: oe,
  marginRight: oe,
  marginBottom: oe,
  marginLeft: oe,
  // Misc
  backgroundPositionX: oe,
  backgroundPositionY: oe,
  ...ix,
  zIndex: Pu,
  // SVG
  fillOpacity: Kr,
  strokeOpacity: Kr,
  numOctaves: Pu
}, ax = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, lx = pr.length;
function cx(t, e, n) {
  let r = "", o = !0;
  for (let s = 0; s < lx; s++) {
    const i = pr[s], a = t[i];
    if (a === void 0)
      continue;
    let l = !0;
    if (typeof a == "number" ? l = a === (i.startsWith("scale") ? 1 : 0) : l = parseFloat(a) === 0, !l || n) {
      const c = Lp(a, $l[i]);
      if (!l) {
        o = !1;
        const u = ax[i] || i;
        r += `${u}(${c}) `;
      }
      n && (e[i] = c);
    }
  }
  return r = r.trim(), n ? r = n(e, o ? "" : r) : o && (r = "none"), r;
}
function Wl(t, e, n) {
  const { style: r, vars: o, transformOrigin: s } = t;
  let i = !1, a = !1;
  for (const l in e) {
    const c = e[l];
    if (hr.has(l)) {
      i = !0;
      continue;
    } else if (Ll(l)) {
      o[l] = c;
      continue;
    } else {
      const u = Lp(c, $l[l]);
      l.startsWith("origin") ? (a = !0, s[l] = u) : r[l] = u;
    }
  }
  if (e.transform || (i || n ? r.transform = cx(e, t.transform, n) : r.transform && (r.transform = "none")), a) {
    const { originX: l = "50%", originY: c = "50%", originZ: u = 0 } = s;
    r.transformOrigin = `${l} ${c} ${u}`;
  }
}
const jl = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), _e = (t) => !!(t && t.getVelocity);
function Bp(t, e, n) {
  for (const r in e)
    !_e(e[r]) && !Fp(r, n) && (t[r] = e[r]);
}
function ux({ transformTemplate: t }, e) {
  return Lt(() => {
    const n = jl();
    return Wl(n, e, t), Object.assign({}, n.vars, n.style);
  }, [e]);
}
function dx(t, e) {
  const n = t.style || {}, r = {};
  return Bp(r, n, t), Object.assign(r, ux(t, e)), r;
}
function fx(t, e) {
  const n = {}, r = dx(t, e);
  return t.drag && t.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const px = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, hx = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function mx(t, e, n = 1, r = 0, o = !0) {
  t.pathLength = 1;
  const s = o ? px : hx;
  t[s.offset] = oe.transform(-r);
  const i = oe.transform(e), a = oe.transform(n);
  t[s.array] = `${i} ${a}`;
}
function $p(t, {
  attrX: e,
  attrY: n,
  attrScale: r,
  pathLength: o,
  pathSpacing: s = 1,
  pathOffset: i = 0,
  // This is object creation, which we try to avoid per-frame.
  ...a
}, l, c, u) {
  if (Wl(t, a, c), l) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: d, style: p } = t;
  d.transform && (p.transform = d.transform, delete d.transform), (p.transform || d.transformOrigin) && (p.transformOrigin = d.transformOrigin ?? "50% 50%", delete d.transformOrigin), p.transform && (p.transformBox = (u == null ? void 0 : u.transformBox) ?? "fill-box", delete d.transformBox), e !== void 0 && (d.x = e), n !== void 0 && (d.y = n), r !== void 0 && (d.scale = r), o !== void 0 && mx(d, o, s, i, !1);
}
const Wp = () => ({
  ...jl(),
  attrs: {}
}), jp = (t) => typeof t == "string" && t.toLowerCase() === "svg";
function gx(t, e, n, r) {
  const o = Lt(() => {
    const s = Wp();
    return $p(s, e, jp(r), t.transformTemplate, t.style), {
      ...s.attrs,
      style: { ...s.style }
    };
  }, [e]);
  if (t.style) {
    const s = {};
    Bp(s, t.style, t), o.style = { ...s, ...o.style };
  }
  return o;
}
const vx = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Ul(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(vx.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(t))
    )
  );
}
function yx(t = !1) {
  return (n, r, o, { latestValues: s }, i) => {
    const l = (Ul(n) ? gx : fx)(r, s, i, n), c = jw(r, typeof n == "string", t), u = n !== Zf ? { ...c, ...l, ref: o } : {}, { children: d } = r, p = Lt(() => _e(d) ? d.get() : d, [d]);
    return yb(n, {
      ...u,
      children: p
    });
  };
}
function Iu(t) {
  const e = [{}, {}];
  return t == null || t.values.forEach((n, r) => {
    e[0][r] = n.get(), e[1][r] = n.getVelocity();
  }), e;
}
function Hl(t, e, n, r) {
  if (typeof e == "function") {
    const [o, s] = Iu(r);
    e = e(n !== void 0 ? n : t.custom, o, s);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [o, s] = Iu(r);
    e = e(n !== void 0 ? n : t.custom, o, s);
  }
  return e;
}
function Ko(t) {
  return _e(t) ? t.get() : t;
}
function bx({ scrapeMotionValuesFromProps: t, createRenderState: e }, n, r, o) {
  return {
    latestValues: wx(n, r, o, t),
    renderState: e()
  };
}
const Up = (t) => (e, n) => {
  const r = Ae(Ls), o = Ae(Os), s = () => bx(t, e, r, o);
  return n ? s() : uo(s);
};
function wx(t, e, n, r) {
  const o = {}, s = r(t, {});
  for (const p in s)
    o[p] = Ko(s[p]);
  let { initial: i, animate: a } = t;
  const l = $s(t), c = Dp(t);
  e && c && !l && t.inherit !== !1 && (i === void 0 && (i = e.initial), a === void 0 && (a = e.animate));
  let u = n ? n.initial === !1 : !1;
  u = u || i === !1;
  const d = u ? a : i;
  if (d && typeof d != "boolean" && !Bs(d)) {
    const p = Array.isArray(d) ? d : [d];
    for (let h = 0; h < p.length; h++) {
      const v = Hl(t, p[h]);
      if (v) {
        const { transitionEnd: m, transition: y, ...b } = v;
        for (const w in b) {
          let x = b[w];
          if (Array.isArray(x)) {
            const E = u ? x.length - 1 : 0;
            x = x[E];
          }
          x !== null && (o[w] = x);
        }
        for (const w in m)
          o[w] = m[w];
      }
    }
  }
  return o;
}
function zl(t, e, n) {
  var s;
  const { style: r } = t, o = {};
  for (const i in r)
    (_e(r[i]) || e.style && _e(e.style[i]) || Fp(i, t) || ((s = n == null ? void 0 : n.getValue(i)) == null ? void 0 : s.liveStyle) !== void 0) && (o[i] = r[i]);
  return o;
}
const xx = {
  useVisualState: Up({
    scrapeMotionValuesFromProps: zl,
    createRenderState: jl
  })
};
function Hp(t, e, n) {
  const r = zl(t, e, n);
  for (const o in t)
    if (_e(t[o]) || _e(e[o])) {
      const s = pr.indexOf(o) !== -1 ? "attr" + o.charAt(0).toUpperCase() + o.substring(1) : o;
      r[s] = t[o];
    }
  return r;
}
const Cx = {
  useVisualState: Up({
    scrapeMotionValuesFromProps: Hp,
    createRenderState: Wp
  })
};
function Ex(t, e) {
  return function(r, { forwardMotionProps: o } = { forwardMotionProps: !1 }) {
    const i = {
      ...Ul(r) ? Cx : xx,
      preloadedFeatures: t,
      useRender: yx(o),
      createVisualElement: e,
      Component: r
    };
    return Zw(i);
  };
}
function Yr(t, e, n) {
  const r = t.getProps();
  return Hl(r, e, n !== void 0 ? n : r.custom, t);
}
const xa = (t) => Array.isArray(t);
let Yo;
function Sx() {
  Yo = void 0;
}
const $e = {
  now: () => (Yo === void 0 && $e.set(Ie.isProcessing || Bt.useManualTiming ? Ie.timestamp : performance.now()), Yo),
  set: (t) => {
    Yo = t, queueMicrotask(Sx);
  }
};
function Gl(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function Ws(t, e) {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
class Kl {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return Gl(this.subscriptions, e), () => Ws(this.subscriptions, e);
  }
  notify(e, n, r) {
    const o = this.subscriptions.length;
    if (o)
      if (o === 1)
        this.subscriptions[0](e, n, r);
      else
        for (let s = 0; s < o; s++) {
          const i = this.subscriptions[s];
          i && i(e, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
function zp(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const Du = 30, Ax = (t) => !isNaN(parseFloat(t)), Or = {
  current: void 0
};
class Tx {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(e, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r, o = !0) => {
      var i, a;
      const s = $e.now();
      if (this.updatedAt !== s && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && ((i = this.events.change) == null || i.notify(this.current), this.dependents))
        for (const l of this.dependents)
          l.dirty();
      o && ((a = this.events.renderRequest) == null || a.notify(this.current));
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = n.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = $e.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = Ax(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && Fs(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, n) {
    this.events[e] || (this.events[e] = new Kl());
    const r = this.events[e].add(n);
    return e === "change" ? () => {
      r(), we.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(e, n) {
    this.passiveEffect = e, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(e, n) : this.passiveEffect(e, this.updateAndNotify);
  }
  setWithVelocity(e, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, n = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var e;
    (e = this.events.change) == null || e.notify(this.current);
  }
  addDependent(e) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(e);
  }
  removeDependent(e) {
    this.dependents && this.dependents.delete(e);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return Or.current && Or.current.push(this), this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = $e.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > Du)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, Du);
    return zp(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(e) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = e(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var e, n;
    (e = this.dependents) == null || e.clear(), (n = this.events.destroy) == null || n.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function Rn(t, e) {
  return new Tx(t, e);
}
function Rx(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, Rn(n));
}
function _x(t) {
  return xa(t) ? t[t.length - 1] || 0 : t;
}
function Px(t, e) {
  const n = Yr(t, e);
  let { transitionEnd: r = {}, transition: o = {}, ...s } = n || {};
  s = { ...s, ...r };
  for (const i in s) {
    const a = _x(s[i]);
    Rx(t, i, a);
  }
}
function kx(t) {
  return !!(_e(t) && t.add);
}
function Ca(t, e) {
  const n = t.getValue("willChange");
  if (kx(n))
    return n.add(e);
  if (!n && Bt.WillChange) {
    const r = new Bt.WillChange("auto");
    t.addValue("willChange", r), r.add(e);
  }
}
function Gp(t) {
  return t.props[Mp];
}
const Ix = (t) => t !== null;
function Dx(t, { repeat: e, repeatType: n = "loop" }, r) {
  const o = t.filter(Ix), s = e && n !== "loop" && e % 2 === 1 ? 0 : o.length - 1;
  return !s || r === void 0 ? o[s] : r;
}
const Mx = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Nx = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), Ox = {
  type: "keyframes",
  duration: 0.8
}, Vx = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, Fx = (t, { keyframes: e }) => e.length > 2 ? Ox : hr.has(t) ? t.startsWith("scale") ? Nx(e[1]) : Mx : Vx;
function Lx({ when: t, delay: e, delayChildren: n, staggerChildren: r, staggerDirection: o, repeat: s, repeatType: i, repeatDelay: a, from: l, elapsed: c, ...u }) {
  return !!Object.keys(u).length;
}
function Yl(t, e) {
  return (t == null ? void 0 : t[e]) ?? (t == null ? void 0 : t.default) ?? t;
}
const et = /* @__NO_SIDE_EFFECTS__ */ (t) => t * 1e3, bt = /* @__NO_SIDE_EFFECTS__ */ (t) => t / 1e3, Vr = (t) => Math.round(t * 1e5) / 1e5, ql = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function Bx(t) {
  return t == null;
}
const $x = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Xl = (t, e) => (n) => !!(typeof n == "string" && $x.test(n) && n.startsWith(t) || e && !Bx(n) && Object.prototype.hasOwnProperty.call(n, e)), Kp = (t, e, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [o, s, i, a] = r.match(ql);
  return {
    [t]: parseFloat(o),
    [e]: parseFloat(s),
    [n]: parseFloat(i),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, Wx = (t) => Wt(0, 255, t), Ii = {
  ...mr,
  transform: (t) => Math.round(Wx(t))
}, wn = {
  test: /* @__PURE__ */ Xl("rgb", "red"),
  parse: /* @__PURE__ */ Kp("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: r = 1 }) => "rgba(" + Ii.transform(t) + ", " + Ii.transform(e) + ", " + Ii.transform(n) + ", " + Vr(Kr.transform(r)) + ")"
};
function jx(t) {
  let e = "", n = "", r = "", o = "";
  return t.length > 5 ? (e = t.substring(1, 3), n = t.substring(3, 5), r = t.substring(5, 7), o = t.substring(7, 9)) : (e = t.substring(1, 2), n = t.substring(2, 3), r = t.substring(3, 4), o = t.substring(4, 5), e += e, n += n, r += r, o += o), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const Ea = {
  test: /* @__PURE__ */ Xl("#"),
  parse: jx,
  transform: wn.transform
}, Wn = {
  test: /* @__PURE__ */ Xl("hsl", "hue"),
  parse: /* @__PURE__ */ Kp("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(t) + ", " + yt.transform(Vr(e)) + ", " + yt.transform(Vr(n)) + ", " + Vr(Kr.transform(r)) + ")"
}, Me = {
  test: (t) => wn.test(t) || Ea.test(t) || Wn.test(t),
  parse: (t) => wn.test(t) ? wn.parse(t) : Wn.test(t) ? Wn.parse(t) : Ea.parse(t),
  transform: (t) => typeof t == "string" ? t : t.hasOwnProperty("red") ? wn.transform(t) : Wn.transform(t)
}, Ux = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Hx(t) {
  var e, n;
  return isNaN(t) && typeof t == "string" && (((e = t.match(ql)) == null ? void 0 : e.length) || 0) + (((n = t.match(Ux)) == null ? void 0 : n.length) || 0) > 0;
}
const Yp = "number", qp = "color", zx = "var", Gx = "var(", Mu = "${}", Kx = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function qr(t) {
  const e = t.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, o = [];
  let s = 0;
  const a = e.replace(Kx, (l) => (Me.test(l) ? (r.color.push(s), o.push(qp), n.push(Me.parse(l))) : l.startsWith(Gx) ? (r.var.push(s), o.push(zx), n.push(l)) : (r.number.push(s), o.push(Yp), n.push(parseFloat(l))), ++s, Mu)).split(Mu);
  return { values: n, split: a, indexes: r, types: o };
}
function Xp(t) {
  return qr(t).values;
}
function Zp(t) {
  const { split: e, types: n } = qr(t), r = e.length;
  return (o) => {
    let s = "";
    for (let i = 0; i < r; i++)
      if (s += e[i], o[i] !== void 0) {
        const a = n[i];
        a === Yp ? s += Vr(o[i]) : a === qp ? s += Me.transform(o[i]) : s += o[i];
      }
    return s;
  };
}
const Yx = (t) => typeof t == "number" ? 0 : t;
function qx(t) {
  const e = Xp(t);
  return Zp(t)(e.map(Yx));
}
const nn = {
  test: Hx,
  parse: Xp,
  createTransformer: Zp,
  getAnimatableNone: qx
};
function Di(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function Xx({ hue: t, saturation: e, lightness: n, alpha: r }) {
  t /= 360, e /= 100, n /= 100;
  let o = 0, s = 0, i = 0;
  if (!e)
    o = s = i = n;
  else {
    const a = n < 0.5 ? n * (1 + e) : n + e - n * e, l = 2 * n - a;
    o = Di(l, a, t + 1 / 3), s = Di(l, a, t), i = Di(l, a, t - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(s * 255),
    blue: Math.round(i * 255),
    alpha: r
  };
}
function ls(t, e) {
  return (n) => n > 0 ? e : t;
}
const be = (t, e, n) => t + (e - t) * n, Mi = (t, e, n) => {
  const r = t * t, o = n * (e * e - r) + r;
  return o < 0 ? 0 : Math.sqrt(o);
}, Zx = [Ea, wn, Wn], Jx = (t) => Zx.find((e) => e.test(t));
function Nu(t) {
  const e = Jx(t);
  if (fr(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`), !e)
    return !1;
  let n = e.parse(t);
  return e === Wn && (n = Xx(n)), n;
}
const Ou = (t, e) => {
  const n = Nu(t), r = Nu(e);
  if (!n || !r)
    return ls(t, e);
  const o = { ...n };
  return (s) => (o.red = Mi(n.red, r.red, s), o.green = Mi(n.green, r.green, s), o.blue = Mi(n.blue, r.blue, s), o.alpha = be(n.alpha, r.alpha, s), wn.transform(o));
}, Sa = /* @__PURE__ */ new Set(["none", "hidden"]);
function Qx(t, e) {
  return Sa.has(t) ? (n) => n <= 0 ? t : e : (n) => n >= 1 ? e : t;
}
const eC = (t, e) => (n) => e(t(n)), po = (...t) => t.reduce(eC);
function tC(t, e) {
  return (n) => be(t, e, n);
}
function Zl(t) {
  return typeof t == "number" ? tC : typeof t == "string" ? Bl(t) ? ls : Me.test(t) ? Ou : oC : Array.isArray(t) ? Jp : typeof t == "object" ? Me.test(t) ? Ou : nC : ls;
}
function Jp(t, e) {
  const n = [...t], r = n.length, o = t.map((s, i) => Zl(s)(s, e[i]));
  return (s) => {
    for (let i = 0; i < r; i++)
      n[i] = o[i](s);
    return n;
  };
}
function nC(t, e) {
  const n = { ...t, ...e }, r = {};
  for (const o in n)
    t[o] !== void 0 && e[o] !== void 0 && (r[o] = Zl(t[o])(t[o], e[o]));
  return (o) => {
    for (const s in r)
      n[s] = r[s](o);
    return n;
  };
}
function rC(t, e) {
  const n = [], r = { color: 0, var: 0, number: 0 };
  for (let o = 0; o < e.values.length; o++) {
    const s = e.types[o], i = t.indexes[s][r[s]], a = t.values[i] ?? 0;
    n[o] = a, r[s]++;
  }
  return n;
}
const oC = (t, e) => {
  const n = nn.createTransformer(e), r = qr(t), o = qr(e);
  return r.indexes.var.length === o.indexes.var.length && r.indexes.color.length === o.indexes.color.length && r.indexes.number.length >= o.indexes.number.length ? Sa.has(t) && !o.values.length || Sa.has(e) && !r.values.length ? Qx(t, e) : po(Jp(rC(r, o), o.values), n) : (fr(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), ls(t, e));
};
function Qp(t, e, n) {
  return typeof t == "number" && typeof e == "number" && typeof n == "number" ? be(t, e, n) : Zl(t)(t, e);
}
const sC = (t) => {
  const e = ({ timestamp: n }) => t(n);
  return {
    start: (n = !0) => we.update(e, n),
    stop: () => $t(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Ie.isProcessing ? Ie.timestamp : $e.now()
  };
}, eh = (t, e, n = 10) => {
  let r = "";
  const o = Math.max(Math.round(e / n), 2);
  for (let s = 0; s < o; s++)
    r += t(s / (o - 1)) + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, cs = 2e4;
function Jl(t) {
  let e = 0;
  const n = 50;
  let r = t.next(e);
  for (; !r.done && e < cs; )
    e += n, r = t.next(e);
  return e >= cs ? 1 / 0 : e;
}
function th(t, e = 100, n) {
  const r = n({ ...t, keyframes: [0, e] }), o = Math.min(Jl(r), cs);
  return {
    type: "keyframes",
    ease: (s) => r.next(o * s).value / e,
    duration: /* @__PURE__ */ bt(o)
  };
}
const iC = 5;
function nh(t, e, n) {
  const r = Math.max(e - iC, 0);
  return zp(n - t(r), e - r);
}
const xe = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, Ni = 1e-3;
function aC({ duration: t = xe.duration, bounce: e = xe.bounce, velocity: n = xe.velocity, mass: r = xe.mass }) {
  let o, s;
  fr(t <= /* @__PURE__ */ et(xe.maxDuration), "Spring duration must be 10 seconds or less");
  let i = 1 - e;
  i = Wt(xe.minDamping, xe.maxDamping, i), t = Wt(xe.minDuration, xe.maxDuration, /* @__PURE__ */ bt(t)), i < 1 ? (o = (c) => {
    const u = c * i, d = u * t, p = u - n, h = Aa(c, i), v = Math.exp(-d);
    return Ni - p / h * v;
  }, s = (c) => {
    const d = c * i * t, p = d * n + n, h = Math.pow(i, 2) * Math.pow(c, 2) * t, v = Math.exp(-d), m = Aa(Math.pow(c, 2), i);
    return (-o(c) + Ni > 0 ? -1 : 1) * ((p - h) * v) / m;
  }) : (o = (c) => {
    const u = Math.exp(-c * t), d = (c - n) * t + 1;
    return -Ni + u * d;
  }, s = (c) => {
    const u = Math.exp(-c * t), d = (n - c) * (t * t);
    return u * d;
  });
  const a = 5 / t, l = cC(o, s, a);
  if (t = /* @__PURE__ */ et(t), isNaN(l))
    return {
      stiffness: xe.stiffness,
      damping: xe.damping,
      duration: t
    };
  {
    const c = Math.pow(l, 2) * r;
    return {
      stiffness: c,
      damping: i * 2 * Math.sqrt(r * c),
      duration: t
    };
  }
}
const lC = 12;
function cC(t, e, n) {
  let r = n;
  for (let o = 1; o < lC; o++)
    r = r - t(r) / e(r);
  return r;
}
function Aa(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const uC = ["duration", "bounce"], dC = ["stiffness", "damping", "mass"];
function Vu(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function fC(t) {
  let e = {
    velocity: xe.velocity,
    stiffness: xe.stiffness,
    damping: xe.damping,
    mass: xe.mass,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!Vu(t, dC) && Vu(t, uC))
    if (t.visualDuration) {
      const n = t.visualDuration, r = 2 * Math.PI / (n * 1.2), o = r * r, s = 2 * Wt(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(o);
      e = {
        ...e,
        mass: xe.mass,
        stiffness: o,
        damping: s
      };
    } else {
      const n = aC(t);
      e = {
        ...e,
        ...n,
        mass: xe.mass
      }, e.isResolvedFromDuration = !0;
    }
  return e;
}
function Xr(t = xe.visualDuration, e = xe.bounce) {
  const n = typeof t != "object" ? {
    visualDuration: t,
    keyframes: [0, 1],
    bounce: e
  } : t;
  let { restSpeed: r, restDelta: o } = n;
  const s = n.keyframes[0], i = n.keyframes[n.keyframes.length - 1], a = { done: !1, value: s }, { stiffness: l, damping: c, mass: u, duration: d, velocity: p, isResolvedFromDuration: h } = fC({
    ...n,
    velocity: -/* @__PURE__ */ bt(n.velocity || 0)
  }), v = p || 0, m = c / (2 * Math.sqrt(l * u)), y = i - s, b = /* @__PURE__ */ bt(Math.sqrt(l / u)), w = Math.abs(y) < 5;
  r || (r = w ? xe.restSpeed.granular : xe.restSpeed.default), o || (o = w ? xe.restDelta.granular : xe.restDelta.default);
  let x;
  if (m < 1) {
    const C = Aa(b, m);
    x = (A) => {
      const S = Math.exp(-m * b * A);
      return i - S * ((v + m * b * y) / C * Math.sin(C * A) + y * Math.cos(C * A));
    };
  } else if (m === 1)
    x = (C) => i - Math.exp(-b * C) * (y + (v + b * y) * C);
  else {
    const C = b * Math.sqrt(m * m - 1);
    x = (A) => {
      const S = Math.exp(-m * b * A), R = Math.min(C * A, 300);
      return i - S * ((v + m * b * y) * Math.sinh(R) + C * y * Math.cosh(R)) / C;
    };
  }
  const E = {
    calculatedDuration: h && d || null,
    next: (C) => {
      const A = x(C);
      if (h)
        a.done = C >= d;
      else {
        let S = C === 0 ? v : 0;
        m < 1 && (S = C === 0 ? /* @__PURE__ */ et(v) : nh(x, C, A));
        const R = Math.abs(S) <= r, P = Math.abs(i - A) <= o;
        a.done = R && P;
      }
      return a.value = a.done ? i : A, a;
    },
    toString: () => {
      const C = Math.min(Jl(E), cs), A = eh((S) => E.next(C * S).value, C, 30);
      return C + "ms " + A;
    },
    toTransition: () => {
    }
  };
  return E;
}
Xr.applyToOptions = (t) => {
  const e = th(t, 100, Xr);
  return t.ease = e.ease, t.duration = /* @__PURE__ */ et(e.duration), t.type = "keyframes", t;
};
function Ta({ keyframes: t, velocity: e = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: o = 10, bounceStiffness: s = 500, modifyTarget: i, min: a, max: l, restDelta: c = 0.5, restSpeed: u }) {
  const d = t[0], p = {
    done: !1,
    value: d
  }, h = (R) => a !== void 0 && R < a || l !== void 0 && R > l, v = (R) => a === void 0 ? l : l === void 0 || Math.abs(a - R) < Math.abs(l - R) ? a : l;
  let m = n * e;
  const y = d + m, b = i === void 0 ? y : i(y);
  b !== y && (m = b - d);
  const w = (R) => -m * Math.exp(-R / r), x = (R) => b + w(R), E = (R) => {
    const P = w(R), k = x(R);
    p.done = Math.abs(P) <= c, p.value = p.done ? b : k;
  };
  let C, A;
  const S = (R) => {
    h(p.value) && (C = R, A = Xr({
      keyframes: [p.value, v(p.value)],
      velocity: nh(x, R, p.value),
      // TODO: This should be passing * 1000
      damping: o,
      stiffness: s,
      restDelta: c,
      restSpeed: u
    }));
  };
  return S(0), {
    calculatedDuration: null,
    next: (R) => {
      let P = !1;
      return !A && C === void 0 && (P = !0, E(R), S(R)), C !== void 0 && R >= C ? A.next(R - C) : (!P && E(R), p);
    }
  };
}
const nr = /* @__NO_SIDE_EFFECTS__ */ (t, e, n) => {
  const r = e - t;
  return r === 0 ? 1 : (n - t) / r;
};
function pC(t, e, n) {
  const r = [], o = n || Bt.mix || Qp, s = t.length - 1;
  for (let i = 0; i < s; i++) {
    let a = o(t[i], t[i + 1]);
    if (e) {
      const l = Array.isArray(e) ? e[i] || Qe : e;
      a = po(l, a);
    }
    r.push(a);
  }
  return r;
}
function rh(t, e, { clamp: n = !0, ease: r, mixer: o } = {}) {
  const s = t.length;
  if (ct(s === e.length, "Both input and output ranges must be the same length"), s === 1)
    return () => e[0];
  if (s === 2 && e[0] === e[1])
    return () => e[1];
  const i = t[0] === t[1];
  t[0] > t[s - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const a = pC(e, r, o), l = a.length, c = (u) => {
    if (i && u < t[0])
      return e[0];
    let d = 0;
    if (l > 1)
      for (; d < t.length - 2 && !(u < t[d + 1]); d++)
        ;
    const p = /* @__PURE__ */ nr(t[d], t[d + 1], u);
    return a[d](p);
  };
  return n ? (u) => c(Wt(t[0], t[s - 1], u)) : c;
}
function oh(t, e) {
  const n = t[t.length - 1];
  for (let r = 1; r <= e; r++) {
    const o = /* @__PURE__ */ nr(0, e, r);
    t.push(be(n, 1, o));
  }
}
function sh(t) {
  const e = [0];
  return oh(e, t.length - 1), e;
}
function hC(t, e) {
  return t.map((n) => n * e);
}
const ih = (t, e, n) => (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t, mC = 1e-7, gC = 12;
function vC(t, e, n, r, o) {
  let s, i, a = 0;
  do
    i = e + (n - e) / 2, s = ih(i, r, o) - t, s > 0 ? n = i : e = i;
  while (Math.abs(s) > mC && ++a < gC);
  return i;
}
function ho(t, e, n, r) {
  if (t === e && n === r)
    return Qe;
  const o = (s) => vC(s, 0, 1, t, n);
  return (s) => s === 0 || s === 1 ? s : ih(o(s), e, r);
}
const yC = /* @__PURE__ */ ho(0.42, 0, 1, 1), bC = /* @__PURE__ */ ho(0, 0, 0.58, 1), ah = /* @__PURE__ */ ho(0.42, 0, 0.58, 1), lh = (t) => Array.isArray(t) && typeof t[0] != "number", ch = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, uh = (t) => (e) => 1 - t(1 - e), dh = /* @__PURE__ */ ho(0.33, 1.53, 0.69, 0.99), Ql = /* @__PURE__ */ uh(dh), fh = /* @__PURE__ */ ch(Ql), ph = (t) => (t *= 2) < 1 ? 0.5 * Ql(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), ec = (t) => 1 - Math.sin(Math.acos(t)), hh = uh(ec), mh = ch(ec), gh = (t) => Array.isArray(t) && typeof t[0] == "number", Fu = {
  linear: Qe,
  easeIn: yC,
  easeInOut: ah,
  easeOut: bC,
  circIn: ec,
  circInOut: mh,
  circOut: hh,
  backIn: Ql,
  backInOut: fh,
  backOut: dh,
  anticipate: ph
}, wC = (t) => typeof t == "string", Lu = (t) => {
  if (gh(t)) {
    ct(t.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [e, n, r, o] = t;
    return ho(e, n, r, o);
  } else if (wC(t))
    return ct(Fu[t] !== void 0, `Invalid easing type '${t}'`), Fu[t];
  return t;
};
function xC(t, e) {
  return t.map(() => e || ah).splice(0, t.length - 1);
}
function jn({ duration: t = 300, keyframes: e, times: n, ease: r = "easeInOut" }) {
  const o = lh(r) ? r.map(Lu) : Lu(r), s = {
    done: !1,
    value: e[0]
  }, i = hC(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === e.length ? n : sh(e),
    t
  ), a = rh(i, e, {
    ease: Array.isArray(o) ? o : xC(e, o)
  });
  return {
    calculatedDuration: t,
    next: (l) => (s.value = a(l), s.done = l >= t, s)
  };
}
const CC = (t) => t !== null;
function tc(t, { repeat: e, repeatType: n = "loop" }, r, o = 1) {
  const s = t.filter(CC), a = o < 0 || e && n !== "loop" && e % 2 === 1 ? 0 : s.length - 1;
  return !a || r === void 0 ? s[a] : r;
}
const EC = {
  decay: Ta,
  inertia: Ta,
  tween: jn,
  keyframes: jn,
  spring: Xr
};
function vh(t) {
  typeof t.type == "string" && (t.type = EC[t.type]);
}
class nc {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((e) => {
      this.resolve = e;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(e, n) {
    return this.finished.then(e, n);
  }
}
const SC = (t) => t / 100;
class rc extends nc {
  constructor(e) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = (n = !0) => {
      var r, o;
      if (n) {
        const { motionValue: s } = this.options;
        s && s.updatedAt !== $e.now() && this.tick($e.now());
      }
      this.isStopped = !0, this.state !== "idle" && (this.teardown(), (o = (r = this.options).onStop) == null || o.call(r));
    }, this.options = e, this.initAnimation(), this.play(), e.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: e } = this;
    vh(e);
    const { type: n = jn, repeat: r = 0, repeatDelay: o = 0, repeatType: s, velocity: i = 0 } = e;
    let { keyframes: a } = e;
    const l = n || jn;
    process.env.NODE_ENV !== "production" && l !== jn && ct(a.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${a}`), l !== jn && typeof a[0] != "number" && (this.mixKeyframes = po(SC, Qp(a[0], a[1])), a = [0, 100]);
    const c = l({ ...e, keyframes: a });
    s === "mirror" && (this.mirroredGenerator = l({
      ...e,
      keyframes: [...a].reverse(),
      velocity: -i
    })), c.calculatedDuration === null && (c.calculatedDuration = Jl(c));
    const { calculatedDuration: u } = c;
    this.calculatedDuration = u, this.resolvedDuration = u + o, this.totalDuration = this.resolvedDuration * (r + 1) - o, this.generator = c;
  }
  updateTime(e) {
    const n = Math.round(e - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(e, n = !1) {
    const { generator: r, totalDuration: o, mixKeyframes: s, mirroredGenerator: i, resolvedDuration: a, calculatedDuration: l } = this;
    if (this.startTime === null)
      return r.next(0);
    const { delay: c = 0, keyframes: u, repeat: d, repeatType: p, repeatDelay: h, type: v, onUpdate: m, finalKeyframe: y } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - o / this.speed, this.startTime)), n ? this.currentTime = e : this.updateTime(e);
    const b = this.currentTime - c * (this.playbackSpeed >= 0 ? 1 : -1), w = this.playbackSpeed >= 0 ? b < 0 : b > o;
    this.currentTime = Math.max(b, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = o);
    let x = this.currentTime, E = r;
    if (d) {
      const R = Math.min(this.currentTime, o) / a;
      let P = Math.floor(R), k = R % 1;
      !k && R >= 1 && (k = 1), k === 1 && P--, P = Math.min(P, d + 1), !!(P % 2) && (p === "reverse" ? (k = 1 - k, h && (k -= h / a)) : p === "mirror" && (E = i)), x = Wt(0, 1, k) * a;
    }
    const C = w ? { done: !1, value: u[0] } : E.next(x);
    s && (C.value = s(C.value));
    let { done: A } = C;
    !w && l !== null && (A = this.playbackSpeed >= 0 ? this.currentTime >= o : this.currentTime <= 0);
    const S = this.holdTime === null && (this.state === "finished" || this.state === "running" && A);
    return S && v !== Ta && (C.value = tc(u, this.options, y, this.speed)), m && m(C.value), S && this.finish(), C;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, n) {
    return this.finished.then(e, n);
  }
  get duration() {
    return /* @__PURE__ */ bt(this.calculatedDuration);
  }
  get time() {
    return /* @__PURE__ */ bt(this.currentTime);
  }
  set time(e) {
    var n;
    e = /* @__PURE__ */ et(e), this.currentTime = e, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.playbackSpeed), (n = this.driver) == null || n.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    this.updateTime($e.now());
    const n = this.playbackSpeed !== e;
    this.playbackSpeed = e, n && (this.time = /* @__PURE__ */ bt(this.currentTime));
  }
  play() {
    var o, s;
    if (this.isStopped)
      return;
    const { driver: e = sC, startTime: n } = this.options;
    this.driver || (this.driver = e((i) => this.tick(i))), (s = (o = this.options).onPlay) == null || s.call(o);
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = n ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime($e.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var e, n;
    this.notifyFinished(), this.teardown(), this.state = "finished", (n = (e = this.options).onComplete) == null || n.call(e);
  }
  cancel() {
    var e, n;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (n = (e = this.options).onCancel) == null || n.call(e);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
  attachTimeline(e) {
    var n;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (n = this.driver) == null || n.stop(), e.observe(this);
  }
}
function AC(t) {
  for (let e = 1; e < t.length; e++)
    t[e] ?? (t[e] = t[e - 1]);
}
const xn = (t) => t * 180 / Math.PI, Ra = (t) => {
  const e = xn(Math.atan2(t[1], t[0]));
  return _a(e);
}, TC = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (t) => (Math.abs(t[0]) + Math.abs(t[3])) / 2,
  rotate: Ra,
  rotateZ: Ra,
  skewX: (t) => xn(Math.atan(t[1])),
  skewY: (t) => xn(Math.atan(t[2])),
  skew: (t) => (Math.abs(t[1]) + Math.abs(t[2])) / 2
}, _a = (t) => (t = t % 360, t < 0 && (t += 360), t), Bu = Ra, $u = (t) => Math.sqrt(t[0] * t[0] + t[1] * t[1]), Wu = (t) => Math.sqrt(t[4] * t[4] + t[5] * t[5]), RC = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: $u,
  scaleY: Wu,
  scale: (t) => ($u(t) + Wu(t)) / 2,
  rotateX: (t) => _a(xn(Math.atan2(t[6], t[5]))),
  rotateY: (t) => _a(xn(Math.atan2(-t[2], t[0]))),
  rotateZ: Bu,
  rotate: Bu,
  skewX: (t) => xn(Math.atan(t[4])),
  skewY: (t) => xn(Math.atan(t[1])),
  skew: (t) => (Math.abs(t[1]) + Math.abs(t[4])) / 2
};
function Pa(t) {
  return t.includes("scale") ? 1 : 0;
}
function ka(t, e) {
  if (!t || t === "none")
    return Pa(e);
  const n = t.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, o;
  if (n)
    r = RC, o = n;
  else {
    const a = t.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = TC, o = a;
  }
  if (!o)
    return Pa(e);
  const s = r[e], i = o[1].split(",").map(PC);
  return typeof s == "function" ? s(i) : i[s];
}
const _C = (t, e) => {
  const { transform: n = "none" } = getComputedStyle(t);
  return ka(n, e);
};
function PC(t) {
  return parseFloat(t.trim());
}
const ju = (t) => t === mr || t === oe, kC = /* @__PURE__ */ new Set(["x", "y", "z"]), IC = pr.filter((t) => !kC.has(t));
function DC(t) {
  const e = [];
  return IC.forEach((n) => {
    const r = t.getValue(n);
    r !== void 0 && (e.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), e;
}
const En = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: n = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(n),
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: (t, { transform: e }) => ka(e, "x"),
  y: (t, { transform: e }) => ka(e, "y")
};
En.translateX = En.x;
En.translateY = En.y;
const Sn = /* @__PURE__ */ new Set();
let Ia = !1, Da = !1, Ma = !1;
function yh() {
  if (Da) {
    const t = Array.from(Sn).filter((r) => r.needsMeasurement), e = new Set(t.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    e.forEach((r) => {
      const o = DC(r);
      o.length && (n.set(r, o), r.render());
    }), t.forEach((r) => r.measureInitialState()), e.forEach((r) => {
      r.render();
      const o = n.get(r);
      o && o.forEach(([s, i]) => {
        var a;
        (a = r.getValue(s)) == null || a.set(i);
      });
    }), t.forEach((r) => r.measureEndState()), t.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  Da = !1, Ia = !1, Sn.forEach((t) => t.complete(Ma)), Sn.clear();
}
function bh() {
  Sn.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (Da = !0);
  });
}
function MC() {
  Ma = !0, bh(), yh(), Ma = !1;
}
class oc {
  constructor(e, n, r, o, s, i = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...e], this.onComplete = n, this.name = r, this.motionValue = o, this.element = s, this.isAsync = i;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (Sn.add(this), Ia || (Ia = !0, we.read(bh), we.resolveKeyframes(yh))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: n, element: r, motionValue: o } = this;
    if (e[0] === null) {
      const s = o == null ? void 0 : o.get(), i = e[e.length - 1];
      if (s !== void 0)
        e[0] = s;
      else if (r && n) {
        const a = r.readValue(n, i);
        a != null && (e[0] = a);
      }
      e[0] === void 0 && (e[0] = i), o && s === void 0 && o.set(e[0]);
    }
    AC(e);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(e = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, e), Sn.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (Sn.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const NC = (t) => t.startsWith("--");
function OC(t, e, n) {
  NC(e) ? t.style.setProperty(e, n) : t.style[e] = n;
}
// @__NO_SIDE_EFFECTS__
function sc(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const VC = /* @__PURE__ */ sc(() => window.ScrollTimeline !== void 0), FC = {};
function LC(t, e) {
  const n = /* @__PURE__ */ sc(t);
  return () => FC[e] ?? n();
}
const wh = /* @__PURE__ */ LC(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Ir = ([t, e, n, r]) => `cubic-bezier(${t}, ${e}, ${n}, ${r})`, Uu = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Ir([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Ir([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Ir([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Ir([0.33, 1.53, 0.69, 0.99])
};
function xh(t, e) {
  if (t)
    return typeof t == "function" ? wh() ? eh(t, e) : "ease-out" : gh(t) ? Ir(t) : Array.isArray(t) ? t.map((n) => xh(n, e) || Uu.easeOut) : Uu[t];
}
function BC(t, e, n, { delay: r = 0, duration: o = 300, repeat: s = 0, repeatType: i = "loop", ease: a = "easeOut", times: l } = {}, c = void 0) {
  const u = {
    [e]: n
  };
  l && (u.offset = l);
  const d = xh(a, o);
  Array.isArray(d) && (u.easing = d);
  const p = {
    delay: r,
    duration: o,
    easing: Array.isArray(d) ? "linear" : d,
    fill: "both",
    iterations: s + 1,
    direction: i === "reverse" ? "alternate" : "normal"
  };
  return c && (p.pseudoElement = c), t.animate(u, p);
}
function ic(t) {
  return typeof t == "function" && "applyToOptions" in t;
}
function $C({ type: t, ...e }) {
  return ic(t) && wh() ? t.applyToOptions(e) : (e.duration ?? (e.duration = 300), e.ease ?? (e.ease = "easeOut"), e);
}
class WC extends nc {
  constructor(e) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !e)
      return;
    const { element: n, name: r, keyframes: o, pseudoElement: s, allowFlatten: i = !1, finalKeyframe: a, onComplete: l } = e;
    this.isPseudoElement = !!s, this.allowFlatten = i, this.options = e, ct(typeof e.type != "string", `animateMini doesn't support "type" as a string. Did you mean to import { spring } from "motion"?`);
    const c = $C(e);
    this.animation = BC(n, r, o, c, s), c.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !s) {
        const u = tc(o, this.options, a, this.speed);
        this.updateMotionValue ? this.updateMotionValue(u) : OC(n, r, u), this.animation.cancel();
      }
      l == null || l(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var e, n;
    (n = (e = this.animation).finish) == null || n.call(e);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: e } = this;
    e === "idle" || e === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var e, n;
    this.isPseudoElement || (n = (e = this.animation).commitStyles) == null || n.call(e);
  }
  get duration() {
    var n, r;
    const e = ((r = (n = this.animation.effect) == null ? void 0 : n.getComputedTiming) == null ? void 0 : r.call(n).duration) || 0;
    return /* @__PURE__ */ bt(Number(e));
  }
  get time() {
    return /* @__PURE__ */ bt(Number(this.animation.currentTime) || 0);
  }
  set time(e) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ et(e);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(e) {
    e < 0 && (this.finishedTime = null), this.animation.playbackRate = e;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(e) {
    this.animation.startTime = e;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: e, observe: n }) {
    var r;
    return this.allowFlatten && ((r = this.animation.effect) == null || r.updateTiming({ easing: "linear" })), this.animation.onfinish = null, e && VC() ? (this.animation.timeline = e, Qe) : n(this);
  }
}
const Ch = {
  anticipate: ph,
  backInOut: fh,
  circInOut: mh
};
function jC(t) {
  return t in Ch;
}
function UC(t) {
  typeof t.ease == "string" && jC(t.ease) && (t.ease = Ch[t.ease]);
}
const Hu = 10;
class HC extends WC {
  constructor(e) {
    UC(e), vh(e), super(e), e.startTime && (this.startTime = e.startTime), this.options = e;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(e) {
    const { motionValue: n, onUpdate: r, onComplete: o, element: s, ...i } = this.options;
    if (!n)
      return;
    if (e !== void 0) {
      n.set(e);
      return;
    }
    const a = new rc({
      ...i,
      autoplay: !1
    }), l = /* @__PURE__ */ et(this.finishedTime ?? this.time);
    n.setWithVelocity(a.sample(l - Hu).value, a.sample(l).value, Hu), a.stop();
  }
}
const zu = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(nn.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url("));
function zC(t) {
  const e = t[0];
  if (t.length === 1)
    return !0;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e)
      return !0;
}
function GC(t, e, n, r) {
  const o = t[0];
  if (o === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const s = t[t.length - 1], i = zu(o, e), a = zu(s, e);
  return fr(i === a, `You are trying to animate ${e} from "${o}" to "${s}". ${o} is not an animatable value - to enable this animation set ${o} to a value animatable to ${s} via the \`style\` property.`), !i || !a ? !1 : zC(t) || (n === "spring" || ic(n)) && r;
}
const KC = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), YC = /* @__PURE__ */ sc(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function qC(t) {
  var c;
  const { motionValue: e, name: n, repeatDelay: r, repeatType: o, damping: s, type: i } = t;
  if (!Ml((c = e == null ? void 0 : e.owner) == null ? void 0 : c.current))
    return !1;
  const { onUpdate: a, transformTemplate: l } = e.owner.getProps();
  return YC() && n && KC.has(n) && (n !== "transform" || !l) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !a && !r && o !== "mirror" && s !== 0 && i !== "inertia";
}
const XC = 40;
class ZC extends nc {
  constructor({ autoplay: e = !0, delay: n = 0, type: r = "keyframes", repeat: o = 0, repeatDelay: s = 0, repeatType: i = "loop", keyframes: a, name: l, motionValue: c, element: u, ...d }) {
    var v;
    super(), this.stop = () => {
      var m, y;
      this._animation && (this._animation.stop(), (m = this.stopTimeline) == null || m.call(this)), (y = this.keyframeResolver) == null || y.cancel();
    }, this.createdAt = $e.now();
    const p = {
      autoplay: e,
      delay: n,
      type: r,
      repeat: o,
      repeatDelay: s,
      repeatType: i,
      name: l,
      motionValue: c,
      element: u,
      ...d
    }, h = (u == null ? void 0 : u.KeyframeResolver) || oc;
    this.keyframeResolver = new h(a, (m, y, b) => this.onKeyframesResolved(m, y, p, !b), l, c, u), (v = this.keyframeResolver) == null || v.scheduleResolve();
  }
  onKeyframesResolved(e, n, r, o) {
    this.keyframeResolver = void 0;
    const { name: s, type: i, velocity: a, delay: l, isHandoff: c, onUpdate: u } = r;
    this.resolvedAt = $e.now(), GC(e, s, i, a) || ((Bt.instantAnimations || !l) && (u == null || u(tc(e, r, n))), e[0] = e[e.length - 1], r.duration = 0, r.repeat = 0);
    const p = {
      startTime: o ? this.resolvedAt ? this.resolvedAt - this.createdAt > XC ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...r,
      keyframes: e
    }, h = !c && qC(p) ? new HC({
      ...p,
      element: p.motionValue.owner.current
    }) : new rc(p);
    h.finished.then(() => this.notifyFinished()).catch(Qe), this.pendingTimeline && (this.stopTimeline = h.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = h;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(e, n) {
    return this.finished.finally(e).then(() => {
    });
  }
  get animation() {
    var e;
    return this._animation || ((e = this.keyframeResolver) == null || e.resume(), MC()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get time() {
    return this.animation.time;
  }
  set time(e) {
    this.animation.time = e;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(e) {
    this.animation.speed = e;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(e) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(e) : this.pendingTimeline = e, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var e;
    this._animation && this.animation.cancel(), (e = this.keyframeResolver) == null || e.cancel();
  }
}
const ac = (t, e, n, r = {}, o, s) => (i) => {
  const a = Yl(r, t) || {}, l = a.delay || r.delay || 0;
  let { elapsed: c = 0 } = r;
  c = c - /* @__PURE__ */ et(l);
  const u = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...a,
    delay: -c,
    onUpdate: (p) => {
      e.set(p), a.onUpdate && a.onUpdate(p);
    },
    onComplete: () => {
      i(), a.onComplete && a.onComplete();
    },
    name: t,
    motionValue: e,
    element: s ? void 0 : o
  };
  Lx(a) || Object.assign(u, Fx(t, u)), u.duration && (u.duration = /* @__PURE__ */ et(u.duration)), u.repeatDelay && (u.repeatDelay = /* @__PURE__ */ et(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let d = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (u.duration = 0, u.delay === 0 && (d = !0)), (Bt.instantAnimations || Bt.skipAnimations) && (d = !0, u.duration = 0, u.delay = 0), u.allowFlatten = !a.type && !a.ease, d && !s && e.get() !== void 0) {
    const p = Dx(u.keyframes, a);
    if (p !== void 0) {
      we.update(() => {
        u.onUpdate(p), u.onComplete();
      });
      return;
    }
  }
  return a.isSync ? new rc(u) : new ZC(u);
}, Eh = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...pr
]);
function JC({ protectedKeys: t, needsAnimating: e }, n) {
  const r = t.hasOwnProperty(n) && e[n] !== !0;
  return e[n] = !1, r;
}
function lc(t, e, { delay: n = 0, transitionOverride: r, type: o } = {}) {
  let { transition: s = t.getDefaultTransition(), transitionEnd: i, ...a } = e;
  r && (s = r);
  const l = [], c = o && t.animationState && t.animationState.getState()[o];
  for (const u in a) {
    const d = t.getValue(u, t.latestValues[u] ?? null), p = a[u];
    if (p === void 0 || c && JC(c, u))
      continue;
    const h = {
      delay: n,
      ...Yl(s || {}, u)
    }, v = d.get();
    if (v !== void 0 && !d.isAnimating && !Array.isArray(p) && p === v && !h.velocity)
      continue;
    let m = !1;
    if (window.MotionHandoffAnimation) {
      const b = Gp(t);
      if (b) {
        const w = window.MotionHandoffAnimation(b, u, we);
        w !== null && (h.startTime = w, m = !0);
      }
    }
    Ca(t, u), d.start(ac(u, d, p, t.shouldReduceMotion && Eh.has(u) ? { type: !1 } : h, t, m));
    const y = d.animation;
    y && l.push(y);
  }
  return i && Promise.all(l).then(() => {
    we.update(() => {
      i && Px(t, i);
    });
  }), l;
}
function Na(t, e, n = {}) {
  var l;
  const r = Yr(t, e, n.type === "exit" ? (l = t.presenceContext) == null ? void 0 : l.custom : void 0);
  let { transition: o = t.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (o = n.transitionOverride);
  const s = r ? () => Promise.all(lc(t, r, n)) : () => Promise.resolve(), i = t.variantChildren && t.variantChildren.size ? (c = 0) => {
    const { delayChildren: u = 0, staggerChildren: d, staggerDirection: p } = o;
    return QC(t, e, u + c, d, p, n);
  } : () => Promise.resolve(), { when: a } = o;
  if (a) {
    const [c, u] = a === "beforeChildren" ? [s, i] : [i, s];
    return c().then(() => u());
  } else
    return Promise.all([s(), i(n.delay)]);
}
function QC(t, e, n = 0, r = 0, o = 1, s) {
  const i = [], a = (t.variantChildren.size - 1) * r, l = o === 1 ? (c = 0) => c * r : (c = 0) => a - c * r;
  return Array.from(t.variantChildren).sort(eE).forEach((c, u) => {
    c.notify("AnimationStart", e), i.push(Na(c, e, {
      ...s,
      delay: n + l(u)
    }).then(() => c.notify("AnimationComplete", e)));
  }), Promise.all(i);
}
function eE(t, e) {
  return t.sortNodePosition(e);
}
function tE(t, e, n = {}) {
  t.notify("AnimationStart", e);
  let r;
  if (Array.isArray(e)) {
    const o = e.map((s) => Na(t, s, n));
    r = Promise.all(o);
  } else if (typeof e == "string")
    r = Na(t, e, n);
  else {
    const o = typeof e == "function" ? Yr(t, e, n.custom) : e;
    r = Promise.all(lc(t, o, n));
  }
  return r.then(() => {
    t.notify("AnimationComplete", e);
  });
}
function Sh(t, e) {
  if (!Array.isArray(e))
    return !1;
  const n = e.length;
  if (n !== t.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
const nE = Ol.length;
function Ah(t) {
  if (!t)
    return;
  if (!t.isControllingVariants) {
    const n = t.parent ? Ah(t.parent) || {} : {};
    return t.props.initial !== void 0 && (n.initial = t.props.initial), n;
  }
  const e = {};
  for (let n = 0; n < nE; n++) {
    const r = Ol[n], o = t.props[r];
    (zr(o) || o === !1) && (e[r] = o);
  }
  return e;
}
const rE = [...Nl].reverse(), oE = Nl.length;
function sE(t) {
  return (e) => Promise.all(e.map(({ animation: n, options: r }) => tE(t, n, r)));
}
function iE(t) {
  let e = sE(t), n = Gu(), r = !0;
  const o = (l) => (c, u) => {
    var p;
    const d = Yr(t, u, l === "exit" ? (p = t.presenceContext) == null ? void 0 : p.custom : void 0);
    if (d) {
      const { transition: h, transitionEnd: v, ...m } = d;
      c = { ...c, ...m, ...v };
    }
    return c;
  };
  function s(l) {
    e = l(t);
  }
  function i(l) {
    const { props: c } = t, u = Ah(t.parent) || {}, d = [], p = /* @__PURE__ */ new Set();
    let h = {}, v = 1 / 0;
    for (let y = 0; y < oE; y++) {
      const b = rE[y], w = n[b], x = c[b] !== void 0 ? c[b] : u[b], E = zr(x), C = b === l ? w.isActive : null;
      C === !1 && (v = y);
      let A = x === u[b] && x !== c[b] && E;
      if (A && r && t.manuallyAnimateOnMount && (A = !1), w.protectedKeys = { ...h }, // If it isn't active and hasn't *just* been set as inactive
      !w.isActive && C === null || // If we didn't and don't have any defined prop for this animation type
      !x && !w.prevProp || // Or if the prop doesn't define an animation
      Bs(x) || typeof x == "boolean")
        continue;
      const S = aE(w.prevProp, x);
      let R = S || // If we're making this variant active, we want to always make it active
      b === l && w.isActive && !A && E || // If we removed a higher-priority variant (i is in reverse order)
      y > v && E, P = !1;
      const k = Array.isArray(x) ? x : [x];
      let I = k.reduce(o(b), {});
      C === !1 && (I = {});
      const { prevResolvedValues: _ = {} } = w, D = {
        ..._,
        ...I
      }, N = (B) => {
        R = !0, p.has(B) && (P = !0, p.delete(B)), w.needsAnimating[B] = !0;
        const V = t.getValue(B);
        V && (V.liveStyle = !1);
      };
      for (const B in D) {
        const V = I[B], $ = _[B];
        if (h.hasOwnProperty(B))
          continue;
        let T = !1;
        xa(V) && xa($) ? T = !Sh(V, $) : T = V !== $, T ? V != null ? N(B) : p.add(B) : V !== void 0 && p.has(B) ? N(B) : w.protectedKeys[B] = !0;
      }
      w.prevProp = x, w.prevResolvedValues = I, w.isActive && (h = { ...h, ...I }), r && t.blockInitialAnimation && (R = !1), R && (!(A && S) || P) && d.push(...k.map((B) => ({
        animation: B,
        options: { type: b }
      })));
    }
    if (p.size) {
      const y = {};
      if (typeof c.initial != "boolean") {
        const b = Yr(t, Array.isArray(c.initial) ? c.initial[0] : c.initial);
        b && b.transition && (y.transition = b.transition);
      }
      p.forEach((b) => {
        const w = t.getBaseTarget(b), x = t.getValue(b);
        x && (x.liveStyle = !0), y[b] = w ?? null;
      }), d.push({ animation: y });
    }
    let m = !!d.length;
    return r && (c.initial === !1 || c.initial === c.animate) && !t.manuallyAnimateOnMount && (m = !1), r = !1, m ? e(d) : Promise.resolve();
  }
  function a(l, c) {
    var d;
    if (n[l].isActive === c)
      return Promise.resolve();
    (d = t.variantChildren) == null || d.forEach((p) => {
      var h;
      return (h = p.animationState) == null ? void 0 : h.setActive(l, c);
    }), n[l].isActive = c;
    const u = i(l);
    for (const p in n)
      n[p].protectedKeys = {};
    return u;
  }
  return {
    animateChanges: i,
    setActive: a,
    setAnimateFunction: s,
    getState: () => n,
    reset: () => {
      n = Gu(), r = !0;
    }
  };
}
function aE(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !Sh(e, t) : !1;
}
function vn(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Gu() {
  return {
    animate: vn(!0),
    whileInView: vn(),
    whileHover: vn(),
    whileTap: vn(),
    whileDrag: vn(),
    whileFocus: vn(),
    exit: vn()
  };
}
class un {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
class lE extends un {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = iE(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    Bs(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    e !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var e;
    this.node.animationState.reset(), (e = this.unmountControls) == null || e.call(this);
  }
}
let cE = 0;
class uE extends un {
  constructor() {
    super(...arguments), this.id = cE++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === r)
      return;
    const o = this.node.animationState.setActive("exit", !e);
    n && !e && o.then(() => {
      n(this.id);
    });
  }
  mount() {
    const { register: e, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const dE = {
  animation: {
    Feature: lE
  },
  exit: {
    Feature: uE
  }
};
function Zr(t, e, n, r = { passive: !0 }) {
  return t.addEventListener(e, n, r), () => t.removeEventListener(e, n);
}
const cc = (t) => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1;
function mo(t) {
  return {
    point: {
      x: t.pageX,
      y: t.pageY
    }
  };
}
const fE = (t) => (e) => cc(e) && t(e, mo(e));
function Fr(t, e, n, r) {
  return Zr(t, e, fE(n), r);
}
function Th({ top: t, left: e, right: n, bottom: r }) {
  return {
    x: { min: e, max: n },
    y: { min: t, max: r }
  };
}
function pE({ x: t, y: e }) {
  return { top: e.min, right: t.max, bottom: e.max, left: t.min };
}
function hE(t, e) {
  if (!e)
    return t;
  const n = e({ x: t.left, y: t.top }), r = e({ x: t.right, y: t.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
const Rh = 1e-4, mE = 1 - Rh, gE = 1 + Rh, _h = 0.01, vE = 0 - _h, yE = 0 + _h;
function Fe(t) {
  return t.max - t.min;
}
function bE(t, e, n) {
  return Math.abs(t - e) <= n;
}
function Ku(t, e, n, r = 0.5) {
  t.origin = r, t.originPoint = be(e.min, e.max, t.origin), t.scale = Fe(n) / Fe(e), t.translate = be(n.min, n.max, t.origin) - t.originPoint, (t.scale >= mE && t.scale <= gE || isNaN(t.scale)) && (t.scale = 1), (t.translate >= vE && t.translate <= yE || isNaN(t.translate)) && (t.translate = 0);
}
function Lr(t, e, n, r) {
  Ku(t.x, e.x, n.x, r ? r.originX : void 0), Ku(t.y, e.y, n.y, r ? r.originY : void 0);
}
function Yu(t, e, n) {
  t.min = n.min + e.min, t.max = t.min + Fe(e);
}
function wE(t, e, n) {
  Yu(t.x, e.x, n.x), Yu(t.y, e.y, n.y);
}
function qu(t, e, n) {
  t.min = e.min - n.min, t.max = t.min + Fe(e);
}
function Br(t, e, n) {
  qu(t.x, e.x, n.x), qu(t.y, e.y, n.y);
}
const Xu = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), Un = () => ({
  x: Xu(),
  y: Xu()
}), Zu = () => ({ min: 0, max: 0 }), Ee = () => ({
  x: Zu(),
  y: Zu()
});
function qe(t) {
  return [t("x"), t("y")];
}
function Oi(t) {
  return t === void 0 || t === 1;
}
function Oa({ scale: t, scaleX: e, scaleY: n }) {
  return !Oi(t) || !Oi(e) || !Oi(n);
}
function bn(t) {
  return Oa(t) || Ph(t) || t.z || t.rotate || t.rotateX || t.rotateY || t.skewX || t.skewY;
}
function Ph(t) {
  return Ju(t.x) || Ju(t.y);
}
function Ju(t) {
  return t && t !== "0%";
}
function us(t, e, n) {
  const r = t - n, o = e * r;
  return n + o;
}
function Qu(t, e, n, r, o) {
  return o !== void 0 && (t = us(t, o, r)), us(t, n, r) + e;
}
function Va(t, e = 0, n = 1, r, o) {
  t.min = Qu(t.min, e, n, r, o), t.max = Qu(t.max, e, n, r, o);
}
function kh(t, { x: e, y: n }) {
  Va(t.x, e.translate, e.scale, e.originPoint), Va(t.y, n.translate, n.scale, n.originPoint);
}
const ed = 0.999999999999, td = 1.0000000000001;
function xE(t, e, n, r = !1) {
  const o = n.length;
  if (!o)
    return;
  e.x = e.y = 1;
  let s, i;
  for (let a = 0; a < o; a++) {
    s = n[a], i = s.projectionDelta;
    const { visualElement: l } = s.options;
    l && l.props.style && l.props.style.display === "contents" || (r && s.options.layoutScroll && s.scroll && s !== s.root && zn(t, {
      x: -s.scroll.offset.x,
      y: -s.scroll.offset.y
    }), i && (e.x *= i.x.scale, e.y *= i.y.scale, kh(t, i)), r && bn(s.latestValues) && zn(t, s.latestValues));
  }
  e.x < td && e.x > ed && (e.x = 1), e.y < td && e.y > ed && (e.y = 1);
}
function Hn(t, e) {
  t.min = t.min + e, t.max = t.max + e;
}
function nd(t, e, n, r, o = 0.5) {
  const s = be(t.min, t.max, o);
  Va(t, e, n, s, r);
}
function zn(t, e) {
  nd(t.x, e.x, e.scaleX, e.scale, e.originX), nd(t.y, e.y, e.scaleY, e.scale, e.originY);
}
function Ih(t, e) {
  return Th(hE(t.getBoundingClientRect(), e));
}
function CE(t, e, n) {
  const r = Ih(t, n), { scroll: o } = e;
  return o && (Hn(r.x, o.offset.x), Hn(r.y, o.offset.y)), r;
}
const Dh = ({ current: t }) => t ? t.ownerDocument.defaultView : null, rd = (t, e) => Math.abs(t - e);
function EE(t, e) {
  const n = rd(t.x, e.x), r = rd(t.y, e.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class Mh {
  constructor(e, n, { transformPagePoint: r, contextWindow: o, dragSnapToOrigin: s = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const d = Fi(this.lastMoveEventInfo, this.history), p = this.startEvent !== null, h = EE(d.offset, { x: 0, y: 0 }) >= 3;
      if (!p && !h)
        return;
      const { point: v } = d, { timestamp: m } = Ie;
      this.history.push({ ...v, timestamp: m });
      const { onStart: y, onMove: b } = this.handlers;
      p || (y && y(this.lastMoveEvent, d), this.startEvent = this.lastMoveEvent), b && b(this.lastMoveEvent, d);
    }, this.handlePointerMove = (d, p) => {
      this.lastMoveEvent = d, this.lastMoveEventInfo = Vi(p, this.transformPagePoint), we.update(this.updatePoint, !0);
    }, this.handlePointerUp = (d, p) => {
      this.end();
      const { onEnd: h, onSessionEnd: v, resumeAnimation: m } = this.handlers;
      if (this.dragSnapToOrigin && m && m(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const y = Fi(d.type === "pointercancel" ? this.lastMoveEventInfo : Vi(p, this.transformPagePoint), this.history);
      this.startEvent && h && h(d, y), v && v(d, y);
    }, !cc(e))
      return;
    this.dragSnapToOrigin = s, this.handlers = n, this.transformPagePoint = r, this.contextWindow = o || window;
    const i = mo(e), a = Vi(i, this.transformPagePoint), { point: l } = a, { timestamp: c } = Ie;
    this.history = [{ ...l, timestamp: c }];
    const { onSessionStart: u } = n;
    u && u(e, Fi(a, this.history)), this.removeListeners = po(Fr(this.contextWindow, "pointermove", this.handlePointerMove), Fr(this.contextWindow, "pointerup", this.handlePointerUp), Fr(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), $t(this.updatePoint);
  }
}
function Vi(t, e) {
  return e ? { point: e(t.point) } : t;
}
function od(t, e) {
  return { x: t.x - e.x, y: t.y - e.y };
}
function Fi({ point: t }, e) {
  return {
    point: t,
    delta: od(t, Nh(e)),
    offset: od(t, SE(e)),
    velocity: AE(e, 0.1)
  };
}
function SE(t) {
  return t[0];
}
function Nh(t) {
  return t[t.length - 1];
}
function AE(t, e) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  let n = t.length - 1, r = null;
  const o = Nh(t);
  for (; n >= 0 && (r = t[n], !(o.timestamp - r.timestamp > /* @__PURE__ */ et(e))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const s = /* @__PURE__ */ bt(o.timestamp - r.timestamp);
  if (s === 0)
    return { x: 0, y: 0 };
  const i = {
    x: (o.x - r.x) / s,
    y: (o.y - r.y) / s
  };
  return i.x === 1 / 0 && (i.x = 0), i.y === 1 / 0 && (i.y = 0), i;
}
function TE(t, { min: e, max: n }, r) {
  return e !== void 0 && t < e ? t = r ? be(e, t, r.min) : Math.max(t, e) : n !== void 0 && t > n && (t = r ? be(n, t, r.max) : Math.min(t, n)), t;
}
function sd(t, e, n) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: n !== void 0 ? t.max + n - (t.max - t.min) : void 0
  };
}
function RE(t, { top: e, left: n, bottom: r, right: o }) {
  return {
    x: sd(t.x, n, o),
    y: sd(t.y, e, r)
  };
}
function id(t, e) {
  let n = e.min - t.min, r = e.max - t.max;
  return e.max - e.min < t.max - t.min && ([n, r] = [r, n]), { min: n, max: r };
}
function _E(t, e) {
  return {
    x: id(t.x, e.x),
    y: id(t.y, e.y)
  };
}
function PE(t, e) {
  let n = 0.5;
  const r = Fe(t), o = Fe(e);
  return o > r ? n = /* @__PURE__ */ nr(e.min, e.max - r, t.min) : r > o && (n = /* @__PURE__ */ nr(t.min, t.max - o, e.min)), Wt(0, 1, n);
}
function kE(t, e) {
  const n = {};
  return e.min !== void 0 && (n.min = e.min - t.min), e.max !== void 0 && (n.max = e.max - t.min), n;
}
const Fa = 0.35;
function IE(t = Fa) {
  return t === !1 ? t = 0 : t === !0 && (t = Fa), {
    x: ad(t, "left", "right"),
    y: ad(t, "top", "bottom")
  };
}
function ad(t, e, n) {
  return {
    min: ld(t, e),
    max: ld(t, n)
  };
}
function ld(t, e) {
  return typeof t == "number" ? t : t[e] || 0;
}
const st = {
  x: !1,
  y: !1
};
function Oh() {
  return st.x || st.y;
}
function DE(t) {
  return t === "x" || t === "y" ? st[t] ? null : (st[t] = !0, () => {
    st[t] = !1;
  }) : st.x || st.y ? null : (st.x = st.y = !0, () => {
    st.x = st.y = !1;
  });
}
const ME = /* @__PURE__ */ new WeakMap();
class NE {
  constructor(e) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = Ee(), this.visualElement = e;
  }
  start(e, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const o = (u) => {
      const { dragSnapToOrigin: d } = this.getProps();
      d ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(mo(u).point);
    }, s = (u, d) => {
      const { drag: p, dragPropagation: h, onDragStart: v } = this.getProps();
      if (p && !h && (this.openDragLock && this.openDragLock(), this.openDragLock = DE(p), !this.openDragLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), qe((y) => {
        let b = this.getAxisMotionValue(y).get() || 0;
        if (yt.test(b)) {
          const { projection: w } = this.visualElement;
          if (w && w.layout) {
            const x = w.layout.layoutBox[y];
            x && (b = Fe(x) * (parseFloat(b) / 100));
          }
        }
        this.originPoint[y] = b;
      }), v && we.postRender(() => v(u, d)), Ca(this.visualElement, "transform");
      const { animationState: m } = this.visualElement;
      m && m.setActive("whileDrag", !0);
    }, i = (u, d) => {
      const { dragPropagation: p, dragDirectionLock: h, onDirectionLock: v, onDrag: m } = this.getProps();
      if (!p && !this.openDragLock)
        return;
      const { offset: y } = d;
      if (h && this.currentDirection === null) {
        this.currentDirection = OE(y), this.currentDirection !== null && v && v(this.currentDirection);
        return;
      }
      this.updateAxis("x", d.point, y), this.updateAxis("y", d.point, y), this.visualElement.render(), m && m(u, d);
    }, a = (u, d) => this.stop(u, d), l = () => qe((u) => {
      var d;
      return this.getAnimationState(u) === "paused" && ((d = this.getAxisMotionValue(u).animation) == null ? void 0 : d.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new Mh(e, {
      onSessionStart: o,
      onStart: s,
      onMove: i,
      onSessionEnd: a,
      resumeAnimation: l
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      contextWindow: Dh(this.visualElement)
    });
  }
  stop(e, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: o } = n;
    this.startAnimation(o);
    const { onDragEnd: s } = this.getProps();
    s && we.postRender(() => s(e, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: n } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(e, n, r) {
    const { drag: o } = this.getProps();
    if (!r || !Vo(e, o, this.currentDirection))
      return;
    const s = this.getAxisMotionValue(e);
    let i = this.originPoint[e] + r[e];
    this.constraints && this.constraints[e] && (i = TE(i, this.constraints[e], this.elastic[e])), s.set(i);
  }
  resolveConstraints() {
    var s;
    const { dragConstraints: e, dragElastic: n } = this.getProps(), r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (s = this.visualElement.projection) == null ? void 0 : s.layout, o = this.constraints;
    e && $n(e) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : e && r ? this.constraints = RE(r.layoutBox, e) : this.constraints = !1, this.elastic = IE(n), o !== this.constraints && r && this.constraints && !this.hasMutatedConstraints && qe((i) => {
      this.constraints !== !1 && this.getAxisMotionValue(i) && (this.constraints[i] = kE(r.layoutBox[i], this.constraints[i]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: n } = this.getProps();
    if (!e || !$n(e))
      return !1;
    const r = e.current;
    ct(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: o } = this.visualElement;
    if (!o || !o.layout)
      return !1;
    const s = CE(r, o.root, this.visualElement.getTransformPagePoint());
    let i = _E(o.layout.layoutBox, s);
    if (n) {
      const a = n(pE(i));
      this.hasMutatedConstraints = !!a, a && (i = Th(a));
    }
    return i;
  }
  startAnimation(e) {
    const { drag: n, dragMomentum: r, dragElastic: o, dragTransition: s, dragSnapToOrigin: i, onDragTransitionEnd: a } = this.getProps(), l = this.constraints || {}, c = qe((u) => {
      if (!Vo(u, n, this.currentDirection))
        return;
      let d = l && l[u] || {};
      i && (d = { min: 0, max: 0 });
      const p = o ? 200 : 1e6, h = o ? 40 : 1e7, v = {
        type: "inertia",
        velocity: r ? e[u] : 0,
        bounceStiffness: p,
        bounceDamping: h,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...s,
        ...d
      };
      return this.startAxisValueAnimation(u, v);
    });
    return Promise.all(c).then(a);
  }
  startAxisValueAnimation(e, n) {
    const r = this.getAxisMotionValue(e);
    return Ca(this.visualElement, e), r.start(ac(e, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    qe((e) => this.getAxisMotionValue(e).stop());
  }
  pauseAnimation() {
    qe((e) => {
      var n;
      return (n = this.getAxisMotionValue(e).animation) == null ? void 0 : n.pause();
    });
  }
  getAnimationState(e) {
    var n;
    return (n = this.getAxisMotionValue(e).animation) == null ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const n = `_drag${e.toUpperCase()}`, r = this.visualElement.getProps(), o = r[n];
    return o || this.visualElement.getValue(e, (r.initial ? r.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    qe((n) => {
      const { drag: r } = this.getProps();
      if (!Vo(n, r, this.currentDirection))
        return;
      const { projection: o } = this.visualElement, s = this.getAxisMotionValue(n);
      if (o && o.layout) {
        const { min: i, max: a } = o.layout.layoutBox[n];
        s.set(e[n] - be(i, a, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!$n(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const o = { x: 0, y: 0 };
    qe((i) => {
      const a = this.getAxisMotionValue(i);
      if (a && this.constraints !== !1) {
        const l = a.get();
        o[i] = PE({ min: l, max: l }, this.constraints[i]);
      }
    });
    const { transformTemplate: s } = this.visualElement.getProps();
    this.visualElement.current.style.transform = s ? s({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), qe((i) => {
      if (!Vo(i, e, null))
        return;
      const a = this.getAxisMotionValue(i), { min: l, max: c } = this.constraints[i];
      a.set(be(l, c, o[i]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    ME.set(this.visualElement, this);
    const e = this.visualElement.current, n = Fr(e, "pointerdown", (l) => {
      const { drag: c, dragListener: u = !0 } = this.getProps();
      c && u && this.start(l);
    }), r = () => {
      const { dragConstraints: l } = this.getProps();
      $n(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: o } = this.visualElement, s = o.addEventListener("measure", r);
    o && !o.layout && (o.root && o.root.updateScroll(), o.updateLayout()), we.read(r);
    const i = Zr(window, "resize", () => this.scalePositionWithinConstraints()), a = o.addEventListener("didUpdate", ({ delta: l, hasLayoutChanged: c }) => {
      this.isDragging && c && (qe((u) => {
        const d = this.getAxisMotionValue(u);
        d && (this.originPoint[u] += l[u].translate, d.set(d.get() + l[u].translate));
      }), this.visualElement.render());
    });
    return () => {
      i(), n(), s(), a && a();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: o = !1, dragConstraints: s = !1, dragElastic: i = Fa, dragMomentum: a = !0 } = e;
    return {
      ...e,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: o,
      dragConstraints: s,
      dragElastic: i,
      dragMomentum: a
    };
  }
}
function Vo(t, e, n) {
  return (e === !0 || e === t) && (n === null || n === t);
}
function OE(t, e = 10) {
  let n = null;
  return Math.abs(t.y) > e ? n = "y" : Math.abs(t.x) > e && (n = "x"), n;
}
class VE extends un {
  constructor(e) {
    super(e), this.removeGroupControls = Qe, this.removeListeners = Qe, this.controls = new NE(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Qe;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const cd = (t) => (e, n) => {
  t && we.postRender(() => t(e, n));
};
class FE extends un {
  constructor() {
    super(...arguments), this.removePointerDownListener = Qe;
  }
  onPointerDown(e) {
    this.session = new Mh(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Dh(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: n, onPan: r, onPanEnd: o } = this.node.getProps();
    return {
      onSessionStart: cd(e),
      onStart: cd(n),
      onMove: r,
      onEnd: (s, i) => {
        delete this.session, o && we.postRender(() => o(s, i));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Fr(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const qo = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function ud(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
const Rr = {
  correct: (t, e) => {
    if (!e.target)
      return t;
    if (typeof t == "string")
      if (oe.test(t))
        t = parseFloat(t);
      else
        return t;
    const n = ud(t, e.target.x), r = ud(t, e.target.y);
    return `${n}% ${r}%`;
  }
}, LE = {
  correct: (t, { treeScale: e, projectionDelta: n }) => {
    const r = t, o = nn.parse(t);
    if (o.length > 5)
      return r;
    const s = nn.createTransformer(t), i = typeof o[0] != "number" ? 1 : 0, a = n.x.scale * e.x, l = n.y.scale * e.y;
    o[0 + i] /= a, o[1 + i] /= l;
    const c = be(a, l, 0.5);
    return typeof o[2 + i] == "number" && (o[2 + i] /= c), typeof o[3 + i] == "number" && (o[3 + i] /= c), s(o);
  }
};
class BE extends bb {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: r, layoutId: o } = this.props, { projection: s } = e;
    rx($E), s && (n.group && n.group.add(s), r && r.register && o && r.register(s), s.root.didUpdate(), s.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), s.setOptions({
      ...s.options,
      onExitComplete: () => this.safeToRemove()
    })), qo.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: n, visualElement: r, drag: o, isPresent: s } = this.props, { projection: i } = r;
    return i && (i.isPresent = s, o || e.layoutDependency !== n || n === void 0 || e.isPresent !== s ? i.willUpdate() : this.safeToRemove(), e.isPresent !== s && (s ? i.promote() : i.relegate() || we.postRender(() => {
      const a = i.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: e } = this.props.visualElement;
    e && (e.root.didUpdate(), Fl.postRender(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: o } = e;
    o && (o.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(o), r && r.deregister && r.deregister(o));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function Vh(t) {
  const [e, n] = _p(), r = Ae(kl);
  return g(BE, { ...t, layoutGroup: r, switchLayoutGroup: Ae(Np), isPresent: e, safeToRemove: n });
}
const $E = {
  borderRadius: {
    ...Rr,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Rr,
  borderTopRightRadius: Rr,
  borderBottomLeftRadius: Rr,
  borderBottomRightRadius: Rr,
  boxShadow: LE
};
function Fh(t, e, n) {
  const r = _e(t) ? t : Rn(t);
  return r.start(ac("", r, e, n)), r.animation;
}
const WE = (t, e) => t.depth - e.depth;
class jE {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    Gl(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    Ws(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(WE), this.isDirty = !1, this.children.forEach(e);
  }
}
function UE(t, e) {
  const n = $e.now(), r = ({ timestamp: o }) => {
    const s = o - n;
    s >= e && ($t(r), t(s - e));
  };
  return we.setup(r, !0), () => $t(r);
}
const Lh = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], HE = Lh.length, dd = (t) => typeof t == "string" ? parseFloat(t) : t, fd = (t) => typeof t == "number" || oe.test(t);
function zE(t, e, n, r, o, s) {
  o ? (t.opacity = be(0, n.opacity ?? 1, GE(r)), t.opacityExit = be(e.opacity ?? 1, 0, KE(r))) : s && (t.opacity = be(e.opacity ?? 1, n.opacity ?? 1, r));
  for (let i = 0; i < HE; i++) {
    const a = `border${Lh[i]}Radius`;
    let l = pd(e, a), c = pd(n, a);
    if (l === void 0 && c === void 0)
      continue;
    l || (l = 0), c || (c = 0), l === 0 || c === 0 || fd(l) === fd(c) ? (t[a] = Math.max(be(dd(l), dd(c), r), 0), (yt.test(c) || yt.test(l)) && (t[a] += "%")) : t[a] = c;
  }
  (e.rotate || n.rotate) && (t.rotate = be(e.rotate || 0, n.rotate || 0, r));
}
function pd(t, e) {
  return t[e] !== void 0 ? t[e] : t.borderRadius;
}
const GE = /* @__PURE__ */ Bh(0, 0.5, hh), KE = /* @__PURE__ */ Bh(0.5, 0.95, Qe);
function Bh(t, e, n) {
  return (r) => r < t ? 0 : r > e ? 1 : n(/* @__PURE__ */ nr(t, e, r));
}
function hd(t, e) {
  t.min = e.min, t.max = e.max;
}
function Ye(t, e) {
  hd(t.x, e.x), hd(t.y, e.y);
}
function md(t, e) {
  t.translate = e.translate, t.scale = e.scale, t.originPoint = e.originPoint, t.origin = e.origin;
}
function gd(t, e, n, r, o) {
  return t -= e, t = us(t, 1 / n, r), o !== void 0 && (t = us(t, 1 / o, r)), t;
}
function YE(t, e = 0, n = 1, r = 0.5, o, s = t, i = t) {
  if (yt.test(e) && (e = parseFloat(e), e = be(i.min, i.max, e / 100) - i.min), typeof e != "number")
    return;
  let a = be(s.min, s.max, r);
  t === s && (a -= e), t.min = gd(t.min, e, n, a, o), t.max = gd(t.max, e, n, a, o);
}
function vd(t, e, [n, r, o], s, i) {
  YE(t, e[n], e[r], e[o], e.scale, s, i);
}
const qE = ["x", "scaleX", "originX"], XE = ["y", "scaleY", "originY"];
function yd(t, e, n, r) {
  vd(t.x, e, qE, n ? n.x : void 0, r ? r.x : void 0), vd(t.y, e, XE, n ? n.y : void 0, r ? r.y : void 0);
}
function bd(t) {
  return t.translate === 0 && t.scale === 1;
}
function $h(t) {
  return bd(t.x) && bd(t.y);
}
function wd(t, e) {
  return t.min === e.min && t.max === e.max;
}
function ZE(t, e) {
  return wd(t.x, e.x) && wd(t.y, e.y);
}
function xd(t, e) {
  return Math.round(t.min) === Math.round(e.min) && Math.round(t.max) === Math.round(e.max);
}
function Wh(t, e) {
  return xd(t.x, e.x) && xd(t.y, e.y);
}
function Cd(t) {
  return Fe(t.x) / Fe(t.y);
}
function Ed(t, e) {
  return t.translate === e.translate && t.scale === e.scale && t.originPoint === e.originPoint;
}
class JE {
  constructor() {
    this.members = [];
  }
  add(e) {
    Gl(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (Ws(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(e) {
    const n = this.members.findIndex((o) => e === o);
    if (n === 0)
      return !1;
    let r;
    for (let o = n; o >= 0; o--) {
      const s = this.members[o];
      if (s.isPresent !== !1) {
        r = s;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(e, n) {
    const r = this.lead;
    if (e !== r && (this.prevLead = r, this.lead = e, e.show(), r)) {
      r.instance && r.scheduleRender(), e.scheduleRender(), e.resumeFrom = r, n && (e.resumeFrom.preserveOpacity = !0), r.snapshot && (e.snapshot = r.snapshot, e.snapshot.latestValues = r.animationValues || r.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
      const { crossfade: o } = e.options;
      o === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      const { options: n, resumingFrom: r } = e;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((e) => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function QE(t, e, n) {
  let r = "";
  const o = t.x.translate / e.x, s = t.y.translate / e.y, i = (n == null ? void 0 : n.z) || 0;
  if ((o || s || i) && (r = `translate3d(${o}px, ${s}px, ${i}px) `), (e.x !== 1 || e.y !== 1) && (r += `scale(${1 / e.x}, ${1 / e.y}) `), n) {
    const { transformPerspective: c, rotate: u, rotateX: d, rotateY: p, skewX: h, skewY: v } = n;
    c && (r = `perspective(${c}px) ${r}`), u && (r += `rotate(${u}deg) `), d && (r += `rotateX(${d}deg) `), p && (r += `rotateY(${p}deg) `), h && (r += `skewX(${h}deg) `), v && (r += `skewY(${v}deg) `);
  }
  const a = t.x.scale * e.x, l = t.y.scale * e.y;
  return (a !== 1 || l !== 1) && (r += `scale(${a}, ${l})`), r || "none";
}
function uc(t) {
  return Rp(t) && "ownerSVGElement" in t;
}
function jh(t) {
  return uc(t) && t.tagName === "svg";
}
const Li = ["", "X", "Y", "Z"], eS = { visibility: "hidden" }, tS = 1e3;
let nS = 0;
function Bi(t, e, n, r) {
  const { latestValues: o } = e;
  o[t] && (n[t] = o[t], e.setStaticValue(t, 0), r && (r[t] = 0));
}
function Uh(t) {
  if (t.hasCheckedOptimisedAppear = !0, t.root === t)
    return;
  const { visualElement: e } = t.options;
  if (!e)
    return;
  const n = Gp(e);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: o, layoutId: s } = t.options;
    window.MotionCancelOptimisedAnimation(n, "transform", we, !(o || s));
  }
  const { parent: r } = t;
  r && !r.hasCheckedOptimisedAppear && Uh(r);
}
function Hh({ attachResizeListener: t, defaultParent: e, measureScroll: n, checkIsScrollRoot: r, resetTransform: o }) {
  return class {
    constructor(i = {}, a = e == null ? void 0 : e()) {
      this.id = nS++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(sS), this.nodes.forEach(uS), this.nodes.forEach(dS), this.nodes.forEach(iS);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = i, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new jE());
    }
    addEventListener(i, a) {
      return this.eventHandlers.has(i) || this.eventHandlers.set(i, new Kl()), this.eventHandlers.get(i).add(a);
    }
    notifyListeners(i, ...a) {
      const l = this.eventHandlers.get(i);
      l && l.notify(...a);
    }
    hasListeners(i) {
      return this.eventHandlers.has(i);
    }
    /**
     * Lifecycles
     */
    mount(i) {
      if (this.instance)
        return;
      this.isSVG = uc(i) && !jh(i), this.instance = i;
      const { layoutId: a, layout: l, visualElement: c } = this.options;
      if (c && !c.current && c.mount(i), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (l || a) && (this.isLayoutDirty = !0), t) {
        let u;
        const d = () => this.root.updateBlockedByResize = !1;
        t(i, () => {
          this.root.updateBlockedByResize = !0, u && u(), u = UE(d, 250), qo.hasAnimatedSinceResize && (qo.hasAnimatedSinceResize = !1, this.nodes.forEach(Ad));
        });
      }
      a && this.root.registerSharedNode(a, this), this.options.animate !== !1 && c && (a || l) && this.addEventListener("didUpdate", ({ delta: u, hasLayoutChanged: d, hasRelativeLayoutChanged: p, layout: h }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const v = this.options.transition || c.getDefaultTransition() || gS, { onLayoutAnimationStart: m, onLayoutAnimationComplete: y } = c.getProps(), b = !this.targetLayout || !Wh(this.targetLayout, h), w = !d && p;
        if (this.options.layoutRoot || this.resumeFrom || w || d && (b || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(u, w);
          const x = {
            ...Yl(v, "layout"),
            onPlay: m,
            onComplete: y
          };
          (c.shouldReduceMotion || this.options.layoutRoot) && (x.delay = 0, x.type = !1), this.startAnimation(x);
        } else
          d || Ad(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = h;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const i = this.getStack();
      i && i.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), $t(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(fS), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: i } = this.options;
      return i && i.getProps().transformTemplate;
    }
    willUpdate(i = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && Uh(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u];
        d.shouldResetTransform = !0, d.updateScroll("snapshot"), d.options.layoutRoot && d.willUpdate(!1);
      }
      const { layoutId: a, layout: l } = this.options;
      if (a === void 0 && !l)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), i && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Sd);
        return;
      }
      this.isUpdating || this.nodes.forEach(lS), this.isUpdating = !1, this.nodes.forEach(cS), this.nodes.forEach(rS), this.nodes.forEach(oS), this.clearAllSnapshots();
      const a = $e.now();
      Ie.delta = Wt(0, 1e3 / 60, a - Ie.timestamp), Ie.timestamp = a, Ie.isProcessing = !0, ki.update.process(Ie), ki.preRender.process(Ie), ki.render.process(Ie), Ie.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, Fl.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(aS), this.sharedNodes.forEach(pS);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, we.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      we.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !Fe(this.snapshot.measuredBox.x) && !Fe(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const i = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = Ee(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, i ? i.layoutBox : void 0);
    }
    updateScroll(i = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === i && (a = !1), a && this.instance) {
        const l = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: i,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!o)
        return;
      const i = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, a = this.projectionDelta && !$h(this.projectionDelta), l = this.getTransformTemplate(), c = l ? l(this.latestValues, "") : void 0, u = c !== this.prevTransformTemplateValue;
      i && this.instance && (a || bn(this.latestValues) || u) && (o(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(i = !0) {
      const a = this.measurePageBox();
      let l = this.removeElementScroll(a);
      return i && (l = this.removeTransform(l)), vS(l), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var c;
      const { visualElement: i } = this.options;
      if (!i)
        return Ee();
      const a = i.measureViewportBox();
      if (!(((c = this.scroll) == null ? void 0 : c.wasRoot) || this.path.some(yS))) {
        const { scroll: u } = this.root;
        u && (Hn(a.x, u.offset.x), Hn(a.y, u.offset.y));
      }
      return a;
    }
    removeElementScroll(i) {
      var l;
      const a = Ee();
      if (Ye(a, i), (l = this.scroll) != null && l.wasRoot)
        return a;
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c], { scroll: d, options: p } = u;
        u !== this.root && d && p.layoutScroll && (d.wasRoot && Ye(a, i), Hn(a.x, d.offset.x), Hn(a.y, d.offset.y));
      }
      return a;
    }
    applyTransform(i, a = !1) {
      const l = Ee();
      Ye(l, i);
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c];
        !a && u.options.layoutScroll && u.scroll && u !== u.root && zn(l, {
          x: -u.scroll.offset.x,
          y: -u.scroll.offset.y
        }), bn(u.latestValues) && zn(l, u.latestValues);
      }
      return bn(this.latestValues) && zn(l, this.latestValues), l;
    }
    removeTransform(i) {
      const a = Ee();
      Ye(a, i);
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l];
        if (!c.instance || !bn(c.latestValues))
          continue;
        Oa(c.latestValues) && c.updateSnapshot();
        const u = Ee(), d = c.measurePageBox();
        Ye(u, d), yd(a, c.latestValues, c.snapshot ? c.snapshot.layoutBox : void 0, u);
      }
      return bn(this.latestValues) && yd(a, this.latestValues), a;
    }
    setTargetDelta(i) {
      this.targetDelta = i, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(i) {
      this.options = {
        ...this.options,
        ...i,
        crossfade: i.crossfade !== void 0 ? i.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Ie.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(i = !1) {
      var p;
      const a = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = a.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = a.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = a.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== a;
      if (!(i || l && this.isSharedProjectionDirty || this.isProjectionDirty || (p = this.parent) != null && p.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: u, layoutId: d } = this.options;
      if (!(!this.layout || !(u || d))) {
        if (this.resolvedRelativeTargetAt = Ie.timestamp, !this.targetDelta && !this.relativeTarget) {
          const h = this.getClosestProjectingParent();
          h && h.layout && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Ee(), this.relativeTargetOrigin = Ee(), Br(this.relativeTargetOrigin, this.layout.layoutBox, h.layout.layoutBox), Ye(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = Ee(), this.targetWithTransforms = Ee()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), wE(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Ye(this.target, this.layout.layoutBox), kh(this.target, this.targetDelta)) : Ye(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget)) {
          this.attemptToResolveRelativeTarget = !1;
          const h = this.getClosestProjectingParent();
          h && !!h.resumingFrom == !!this.resumingFrom && !h.options.layoutScroll && h.target && this.animationProgress !== 1 ? (this.relativeParent = h, this.forceRelativeParentToResolveTarget(), this.relativeTarget = Ee(), this.relativeTargetOrigin = Ee(), Br(this.relativeTargetOrigin, this.target, h.target), Ye(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Oa(this.parent.latestValues) || Ph(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var v;
      const i = this.getLead(), a = !!this.resumingFrom || this !== i;
      let l = !0;
      if ((this.isProjectionDirty || (v = this.parent) != null && v.isProjectionDirty) && (l = !1), a && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === Ie.timestamp && (l = !1), l)
        return;
      const { layout: c, layoutId: u } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(c || u))
        return;
      Ye(this.layoutCorrected, this.layout.layoutBox);
      const d = this.treeScale.x, p = this.treeScale.y;
      xE(this.layoutCorrected, this.treeScale, this.path, a), i.layout && !i.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (i.target = i.layout.layoutBox, i.targetWithTransforms = Ee());
      const { target: h } = i;
      if (!h) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (md(this.prevProjectionDelta.x, this.projectionDelta.x), md(this.prevProjectionDelta.y, this.projectionDelta.y)), Lr(this.projectionDelta, this.layoutCorrected, h, this.latestValues), (this.treeScale.x !== d || this.treeScale.y !== p || !Ed(this.projectionDelta.x, this.prevProjectionDelta.x) || !Ed(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", h));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(i = !0) {
      var a;
      if ((a = this.options.visualElement) == null || a.scheduleRender(), i) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = Un(), this.projectionDelta = Un(), this.projectionDeltaWithTransform = Un();
    }
    setAnimationOrigin(i, a = !1) {
      const l = this.snapshot, c = l ? l.latestValues : {}, u = { ...this.latestValues }, d = Un();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const p = Ee(), h = l ? l.source : void 0, v = this.layout ? this.layout.source : void 0, m = h !== v, y = this.getStack(), b = !y || y.members.length <= 1, w = !!(m && !b && this.options.crossfade === !0 && !this.path.some(mS));
      this.animationProgress = 0;
      let x;
      this.mixTargetDelta = (E) => {
        const C = E / 1e3;
        Td(d.x, i.x, C), Td(d.y, i.y, C), this.setTargetDelta(d), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (Br(p, this.layout.layoutBox, this.relativeParent.layout.layoutBox), hS(this.relativeTarget, this.relativeTargetOrigin, p, C), x && ZE(this.relativeTarget, x) && (this.isProjectionDirty = !1), x || (x = Ee()), Ye(x, this.relativeTarget)), m && (this.animationValues = u, zE(u, c, this.latestValues, C, w, b)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = C;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(i) {
      var a, l, c;
      this.notifyListeners("animationStart"), (a = this.currentAnimation) == null || a.stop(!1), (c = (l = this.resumingFrom) == null ? void 0 : l.currentAnimation) == null || c.stop(!1), this.pendingAnimation && ($t(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = we.update(() => {
        qo.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = Rn(0)), this.currentAnimation = Fh(this.motionValue, [0, 1e3], {
          ...i,
          isSync: !0,
          onUpdate: (u) => {
            this.mixTargetDelta(u), i.onUpdate && i.onUpdate(u);
          },
          onStop: () => {
          },
          onComplete: () => {
            i.onComplete && i.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const i = this.getStack();
      i && i.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(tS), this.currentAnimation.stop(!1)), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const i = this.getLead();
      let { targetWithTransforms: a, target: l, layout: c, latestValues: u } = i;
      if (!(!a || !l || !c)) {
        if (this !== i && this.layout && c && zh(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          l = this.target || Ee();
          const d = Fe(this.layout.layoutBox.x);
          l.x.min = i.target.x.min, l.x.max = l.x.min + d;
          const p = Fe(this.layout.layoutBox.y);
          l.y.min = i.target.y.min, l.y.max = l.y.min + p;
        }
        Ye(a, l), zn(a, u), Lr(this.projectionDeltaWithTransform, this.layoutCorrected, a, u);
      }
    }
    registerSharedNode(i, a) {
      this.sharedNodes.has(i) || this.sharedNodes.set(i, new JE()), this.sharedNodes.get(i).add(a);
      const c = a.options.initialPromotionConfig;
      a.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const i = this.getStack();
      return i ? i.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: i } = this.options;
      return i ? ((a = this.getStack()) == null ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: i } = this.options;
      return i ? (a = this.getStack()) == null ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: i } = this.options;
      if (i)
        return this.root.sharedNodes.get(i);
    }
    promote({ needsReset: i, transition: a, preserveFollowOpacity: l } = {}) {
      const c = this.getStack();
      c && c.promote(this, l), i && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const i = this.getStack();
      return i ? i.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: i } = this.options;
      if (!i)
        return;
      let a = !1;
      const { latestValues: l } = i;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (a = !0), !a)
        return;
      const c = {};
      l.z && Bi("z", i, c, this.animationValues);
      for (let u = 0; u < Li.length; u++)
        Bi(`rotate${Li[u]}`, i, c, this.animationValues), Bi(`skew${Li[u]}`, i, c, this.animationValues);
      i.render();
      for (const u in c)
        i.setStaticValue(u, c[u]), this.animationValues && (this.animationValues[u] = c[u]);
      i.scheduleRender();
    }
    getProjectionStyles(i) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return eS;
      const a = {
        visibility: ""
      }, l = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, a.opacity = "", a.pointerEvents = Ko(i == null ? void 0 : i.pointerEvents) || "", a.transform = l ? l(this.latestValues, "") : "none", a;
      const c = this.getLead();
      if (!this.projectionDelta || !this.layout || !c.target) {
        const h = {};
        return this.options.layoutId && (h.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, h.pointerEvents = Ko(i == null ? void 0 : i.pointerEvents) || ""), this.hasProjected && !bn(this.latestValues) && (h.transform = l ? l({}, "") : "none", this.hasProjected = !1), h;
      }
      const u = c.animationValues || c.latestValues;
      this.applyTransformsToTarget(), a.transform = QE(this.projectionDeltaWithTransform, this.treeScale, u), l && (a.transform = l(u, a.transform));
      const { x: d, y: p } = this.projectionDelta;
      a.transformOrigin = `${d.origin * 100}% ${p.origin * 100}% 0`, c.animationValues ? a.opacity = c === this ? u.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : u.opacityExit : a.opacity = c === this ? u.opacity !== void 0 ? u.opacity : "" : u.opacityExit !== void 0 ? u.opacityExit : 0;
      for (const h in Gr) {
        if (u[h] === void 0)
          continue;
        const { correct: v, applyTo: m, isCSSVariable: y } = Gr[h], b = a.transform === "none" ? u[h] : v(u[h], c);
        if (m) {
          const w = m.length;
          for (let x = 0; x < w; x++)
            a[m[x]] = b;
        } else
          y ? this.options.visualElement.renderState.vars[h] = b : a[h] = b;
      }
      return this.options.layoutId && (a.pointerEvents = c === this ? Ko(i == null ? void 0 : i.pointerEvents) || "" : "none"), a;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((i) => {
        var a;
        return (a = i.currentAnimation) == null ? void 0 : a.stop(!1);
      }), this.root.nodes.forEach(Sd), this.root.sharedNodes.clear();
    }
  };
}
function rS(t) {
  t.updateLayout();
}
function oS(t) {
  var n;
  const e = ((n = t.resumeFrom) == null ? void 0 : n.snapshot) || t.snapshot;
  if (t.isLead() && t.layout && e && t.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: o } = t.layout, { animationType: s } = t.options, i = e.source !== t.layout.source;
    s === "size" ? qe((d) => {
      const p = i ? e.measuredBox[d] : e.layoutBox[d], h = Fe(p);
      p.min = r[d].min, p.max = p.min + h;
    }) : zh(s, e.layoutBox, r) && qe((d) => {
      const p = i ? e.measuredBox[d] : e.layoutBox[d], h = Fe(r[d]);
      p.max = p.min + h, t.relativeTarget && !t.currentAnimation && (t.isProjectionDirty = !0, t.relativeTarget[d].max = t.relativeTarget[d].min + h);
    });
    const a = Un();
    Lr(a, r, e.layoutBox);
    const l = Un();
    i ? Lr(l, t.applyTransform(o, !0), e.measuredBox) : Lr(l, r, e.layoutBox);
    const c = !$h(a);
    let u = !1;
    if (!t.resumeFrom) {
      const d = t.getClosestProjectingParent();
      if (d && !d.resumeFrom) {
        const { snapshot: p, layout: h } = d;
        if (p && h) {
          const v = Ee();
          Br(v, e.layoutBox, p.layoutBox);
          const m = Ee();
          Br(m, r, h.layoutBox), Wh(v, m) || (u = !0), d.options.layoutRoot && (t.relativeTarget = m, t.relativeTargetOrigin = v, t.relativeParent = d);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: r,
      snapshot: e,
      delta: l,
      layoutDelta: a,
      hasLayoutChanged: c,
      hasRelativeLayoutChanged: u
    });
  } else if (t.isLead()) {
    const { onExitComplete: r } = t.options;
    r && r();
  }
  t.options.transition = void 0;
}
function sS(t) {
  t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function iS(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function aS(t) {
  t.clearSnapshot();
}
function Sd(t) {
  t.clearMeasurements();
}
function lS(t) {
  t.isLayoutDirty = !1;
}
function cS(t) {
  const { visualElement: e } = t.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function Ad(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0, t.isProjectionDirty = !0;
}
function uS(t) {
  t.resolveTargetDelta();
}
function dS(t) {
  t.calcProjection();
}
function fS(t) {
  t.resetSkewAndRotation();
}
function pS(t) {
  t.removeLeadSnapshot();
}
function Td(t, e, n) {
  t.translate = be(e.translate, 0, n), t.scale = be(e.scale, 1, n), t.origin = e.origin, t.originPoint = e.originPoint;
}
function Rd(t, e, n, r) {
  t.min = be(e.min, n.min, r), t.max = be(e.max, n.max, r);
}
function hS(t, e, n, r) {
  Rd(t.x, e.x, n.x, r), Rd(t.y, e.y, n.y, r);
}
function mS(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const gS = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, _d = (t) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(t), Pd = _d("applewebkit/") && !_d("chrome/") ? Math.round : Qe;
function kd(t) {
  t.min = Pd(t.min), t.max = Pd(t.max);
}
function vS(t) {
  kd(t.x), kd(t.y);
}
function zh(t, e, n) {
  return t === "position" || t === "preserve-aspect" && !bE(Cd(e), Cd(n), 0.2);
}
function yS(t) {
  var e;
  return t !== t.root && ((e = t.scroll) == null ? void 0 : e.wasRoot);
}
const bS = Hh({
  attachResizeListener: (t, e) => Zr(t, "resize", e),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), $i = {
  current: void 0
}, Gh = Hh({
  measureScroll: (t) => ({
    x: t.scrollLeft,
    y: t.scrollTop
  }),
  defaultParent: () => {
    if (!$i.current) {
      const t = new bS({});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), $i.current = t;
    }
    return $i.current;
  },
  resetTransform: (t, e) => {
    t.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (t) => window.getComputedStyle(t).position === "fixed"
}), wS = {
  pan: {
    Feature: FE
  },
  drag: {
    Feature: VE,
    ProjectionNode: Gh,
    MeasureLayout: Vh
  }
};
function Kh(t, e, n) {
  if (t instanceof EventTarget)
    return [t];
  if (typeof t == "string") {
    let r = document;
    const o = (n == null ? void 0 : n[t]) ?? r.querySelectorAll(t);
    return o ? Array.from(o) : [];
  }
  return Array.from(t);
}
function Yh(t, e) {
  const n = Kh(t), r = new AbortController(), o = {
    passive: !0,
    ...e,
    signal: r.signal
  };
  return [n, o, () => r.abort()];
}
function Id(t) {
  return !(t.pointerType === "touch" || Oh());
}
function xS(t, e, n = {}) {
  const [r, o, s] = Yh(t, n), i = (a) => {
    if (!Id(a))
      return;
    const { target: l } = a, c = e(l, a);
    if (typeof c != "function" || !l)
      return;
    const u = (d) => {
      Id(d) && (c(d), l.removeEventListener("pointerleave", u));
    };
    l.addEventListener("pointerleave", u, o);
  };
  return r.forEach((a) => {
    a.addEventListener("pointerenter", i, o);
  }), s;
}
function Dd(t, e, n) {
  const { props: r } = t;
  t.animationState && r.whileHover && t.animationState.setActive("whileHover", n === "Start");
  const o = "onHover" + n, s = r[o];
  s && we.postRender(() => s(e, mo(e)));
}
class CS extends un {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = xS(e, (n, r) => (Dd(this.node, r, "Start"), (o) => Dd(this.node, o, "End"))));
  }
  unmount() {
  }
}
class ES extends un {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = po(Zr(this.node.current, "focus", () => this.onFocus()), Zr(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const qh = (t, e) => e ? t === e ? !0 : qh(t, e.parentElement) : !1, SS = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function AS(t) {
  return SS.has(t.tagName) || t.tabIndex !== -1;
}
const Xo = /* @__PURE__ */ new WeakSet();
function Md(t) {
  return (e) => {
    e.key === "Enter" && t(e);
  };
}
function Wi(t, e) {
  t.dispatchEvent(new PointerEvent("pointer" + e, { isPrimary: !0, bubbles: !0 }));
}
const TS = (t, e) => {
  const n = t.currentTarget;
  if (!n)
    return;
  const r = Md(() => {
    if (Xo.has(n))
      return;
    Wi(n, "down");
    const o = Md(() => {
      Wi(n, "up");
    }), s = () => Wi(n, "cancel");
    n.addEventListener("keyup", o, e), n.addEventListener("blur", s, e);
  });
  n.addEventListener("keydown", r, e), n.addEventListener("blur", () => n.removeEventListener("keydown", r), e);
};
function Nd(t) {
  return cc(t) && !Oh();
}
function RS(t, e, n = {}) {
  const [r, o, s] = Yh(t, n), i = (a) => {
    const l = a.currentTarget;
    if (!Nd(a))
      return;
    Xo.add(l);
    const c = e(l, a), u = (h, v) => {
      window.removeEventListener("pointerup", d), window.removeEventListener("pointercancel", p), Xo.has(l) && Xo.delete(l), Nd(h) && typeof c == "function" && c(h, { success: v });
    }, d = (h) => {
      u(h, l === window || l === document || n.useGlobalTarget || qh(l, h.target));
    }, p = (h) => {
      u(h, !1);
    };
    window.addEventListener("pointerup", d, o), window.addEventListener("pointercancel", p, o);
  };
  return r.forEach((a) => {
    (n.useGlobalTarget ? window : a).addEventListener("pointerdown", i, o), Ml(a) && (a.addEventListener("focus", (c) => TS(c, o)), !AS(a) && !a.hasAttribute("tabindex") && (a.tabIndex = 0));
  }), s;
}
function Od(t, e, n) {
  const { props: r } = t;
  if (t.current instanceof HTMLButtonElement && t.current.disabled)
    return;
  t.animationState && r.whileTap && t.animationState.setActive("whileTap", n === "Start");
  const o = "onTap" + (n === "End" ? "" : n), s = r[o];
  s && we.postRender(() => s(e, mo(e)));
}
class _S extends un {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = RS(e, (n, r) => (Od(this.node, r, "Start"), (o, { success: s }) => Od(this.node, o, s ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const La = /* @__PURE__ */ new WeakMap(), ji = /* @__PURE__ */ new WeakMap(), PS = (t) => {
  const e = La.get(t.target);
  e && e(t);
}, kS = (t) => {
  t.forEach(PS);
};
function IS({ root: t, ...e }) {
  const n = t || document;
  ji.has(n) || ji.set(n, {});
  const r = ji.get(n), o = JSON.stringify(e);
  return r[o] || (r[o] = new IntersectionObserver(kS, { root: t, ...e })), r[o];
}
function DS(t, e, n) {
  const r = IS(e);
  return La.set(t, n), r.observe(t), () => {
    La.delete(t), r.unobserve(t);
  };
}
const MS = {
  some: 0,
  all: 1
};
class NS extends un {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: e = {} } = this.node.getProps(), { root: n, margin: r, amount: o = "some", once: s } = e, i = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof o == "number" ? o : MS[o]
    }, a = (l) => {
      const { isIntersecting: c } = l;
      if (this.isInView === c || (this.isInView = c, s && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: u, onViewportLeave: d } = this.node.getProps(), p = c ? u : d;
      p && p(l);
    };
    return DS(this.node.current, i, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(OS(e, n)) && this.startObserver();
  }
  unmount() {
  }
}
function OS({ viewport: t = {} }, { viewport: e = {} } = {}) {
  return (n) => t[n] !== e[n];
}
const VS = {
  inView: {
    Feature: NS
  },
  tap: {
    Feature: _S
  },
  focus: {
    Feature: ES
  },
  hover: {
    Feature: CS
  }
}, FS = {
  layout: {
    ProjectionNode: Gh,
    MeasureLayout: Vh
  }
}, ds = { current: null }, dc = { current: !1 };
function Xh() {
  if (dc.current = !0, !!Il)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), e = () => ds.current = t.matches;
      t.addListener(e), e();
    } else
      ds.current = !1;
}
const Jr = /* @__PURE__ */ new WeakMap();
function LS(t, e, n) {
  for (const r in e) {
    const o = e[r], s = n[r];
    if (_e(o))
      t.addValue(r, o);
    else if (_e(s))
      t.addValue(r, Rn(o, { owner: t }));
    else if (s !== o)
      if (t.hasValue(r)) {
        const i = t.getValue(r);
        i.liveStyle === !0 ? i.jump(o) : i.hasAnimated || i.set(o);
      } else {
        const i = t.getStaticValue(r);
        t.addValue(r, Rn(i !== void 0 ? i : o, { owner: t }));
      }
  }
  for (const r in n)
    e[r] === void 0 && t.removeValue(r);
  return e;
}
const Zh = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t), Jh = (t) => /^0[^.\s]+$/u.test(t), BS = {
  test: (t) => t === "auto",
  parse: (t) => t
}, Qh = (t) => (e) => e.test(t), em = [mr, oe, yt, Zt, sx, ox, BS], Vd = (t) => em.find(Qh(t)), $S = [...em, Me, nn], WS = (t) => $S.find(Qh(t)), jS = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function US(t) {
  const [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [r] = n.match(ql) || [];
  if (!r)
    return t;
  const o = n.replace(r, "");
  let s = jS.has(e) ? 1 : 0;
  return r !== n && (s *= 100), e + "(" + s + o + ")";
}
const HS = /\b([a-z-]*)\(.*?\)/gu, Ba = {
  ...nn,
  getAnimatableNone: (t) => {
    const e = t.match(HS);
    return e ? e.map(US).join(" ") : t;
  }
}, zS = {
  ...$l,
  // Color props
  color: Me,
  backgroundColor: Me,
  outlineColor: Me,
  fill: Me,
  stroke: Me,
  // Border props
  borderColor: Me,
  borderTopColor: Me,
  borderRightColor: Me,
  borderBottomColor: Me,
  borderLeftColor: Me,
  filter: Ba,
  WebkitFilter: Ba
}, tm = (t) => zS[t];
function nm(t, e) {
  let n = tm(t);
  return n !== Ba && (n = nn), n.getAnimatableNone ? n.getAnimatableNone(e) : void 0;
}
const Fd = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class rm {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, n, r) {
    return {};
  }
  constructor({ parent: e, props: n, presenceContext: r, reducedMotionConfig: o, blockInitialAnimation: s, visualState: i }, a = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = oc, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const p = $e.now();
      this.renderScheduledAt < p && (this.renderScheduledAt = p, we.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: c } = i;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = c, this.parent = e, this.props = n, this.presenceContext = r, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = o, this.options = a, this.blockInitialAnimation = !!s, this.isControllingVariants = $s(n), this.isVariantNode = Dp(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: u, ...d } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const p in d) {
      const h = d[p];
      l[p] !== void 0 && _e(h) && h.set(l[p], !1);
    }
  }
  mount(e) {
    this.current = e, Jr.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), dc.current || Xh(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : ds.current, process.env.NODE_ENV !== "production" && Fs(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    this.projection && this.projection.unmount(), $t(this.notifyUpdate), $t(this.render), this.valueSubscriptions.forEach((e) => e()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const e in this.events)
      this.events[e].clear();
    for (const e in this.features) {
      const n = this.features[e];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(e, n) {
    this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
    const r = hr.has(e);
    r && this.onBindTransform && this.onBindTransform();
    const o = n.on("change", (a) => {
      this.latestValues[e] = a, this.props.onUpdate && we.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0);
    }), s = n.on("renderRequest", this.scheduleRender);
    let i;
    window.MotionCheckAppearSync && (i = window.MotionCheckAppearSync(this, e, n)), this.valueSubscriptions.set(e, () => {
      o(), s(), i && i(), n.owner && n.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in tr) {
      const n = tr[e];
      if (!n)
        continue;
      const { isEnabled: r, Feature: o } = n;
      if (!this.features[e] && o && r(this.props) && (this.features[e] = new o(this)), this.features[e]) {
        const s = this.features[e];
        s.isMounted ? s.update() : (s.mount(), s.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : Ee();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, n) {
    this.latestValues[e] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, n) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < Fd.length; r++) {
      const o = Fd[r];
      this.propEventSubscriptions[o] && (this.propEventSubscriptions[o](), delete this.propEventSubscriptions[o]);
      const s = "on" + o, i = e[s];
      i && (this.propEventSubscriptions[o] = this.on(o, i));
    }
    this.prevMotionValues = LS(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(e), () => n.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, n) {
    const r = this.values.get(e);
    n !== r && (r && this.removeValue(e), this.bindToMotionValue(e, n), this.values.set(e, n), this.latestValues[e] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const n = this.valueSubscriptions.get(e);
    n && (n(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, n) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let r = this.values.get(e);
    return r === void 0 && n !== void 0 && (r = Rn(n === null ? void 0 : n, { owner: this }), this.addValue(e, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, n) {
    let r = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : this.getBaseTargetFromProps(this.props, e) ?? this.readValueFromInstance(this.current, e, this.options);
    return r != null && (typeof r == "string" && (Zh(r) || Jh(r)) ? r = parseFloat(r) : !WS(r) && nn.test(n) && (r = nm(e, n)), this.setBaseTarget(e, _e(r) ? r.get() : r)), _e(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, n) {
    this.baseTarget[e] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var s;
    const { initial: n } = this.props;
    let r;
    if (typeof n == "string" || typeof n == "object") {
      const i = Hl(this.props, n, (s = this.presenceContext) == null ? void 0 : s.custom);
      i && (r = i[e]);
    }
    if (n && r !== void 0)
      return r;
    const o = this.getBaseTargetFromProps(this.props, e);
    return o !== void 0 && !_e(o) ? o : this.initialValues[e] !== void 0 && r === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, n) {
    return this.events[e] || (this.events[e] = new Kl()), this.events[e].add(n);
  }
  notify(e, ...n) {
    this.events[e] && this.events[e].notify(...n);
  }
}
const GS = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function KS(t) {
  const e = GS.exec(t);
  if (!e)
    return [,];
  const [, n, r, o] = e;
  return [`--${n ?? r}`, o];
}
const YS = 4;
function om(t, e, n = 1) {
  ct(n <= YS, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`);
  const [r, o] = KS(t);
  if (!r)
    return;
  const s = window.getComputedStyle(e).getPropertyValue(r);
  if (s) {
    const i = s.trim();
    return Zh(i) ? parseFloat(i) : i;
  }
  return Bl(o) ? om(o, e, n + 1) : o;
}
function qS(t) {
  return typeof t == "number" ? t === 0 : t !== null ? t === "none" || t === "0" || Jh(t) : !0;
}
const XS = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function ZS(t, e, n) {
  let r = 0, o;
  for (; r < t.length && !o; ) {
    const s = t[r];
    typeof s == "string" && !XS.has(s) && qr(s).values.length && (o = t[r]), r++;
  }
  if (o && n)
    for (const s of e)
      t[s] = nm(n, o);
}
class JS extends oc {
  constructor(e, n, r, o, s) {
    super(e, n, r, o, s, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < e.length; l++) {
      let c = e[l];
      if (typeof c == "string" && (c = c.trim(), Bl(c))) {
        const u = om(c, n.current);
        u !== void 0 && (e[l] = u), l === e.length - 1 && (this.finalKeyframe = c);
      }
    }
    if (this.resolveNoneKeyframes(), !Eh.has(r) || e.length !== 2)
      return;
    const [o, s] = e, i = Vd(o), a = Vd(s);
    if (i !== a)
      if (ju(i) && ju(a))
        for (let l = 0; l < e.length; l++) {
          const c = e[l];
          typeof c == "string" && (e[l] = parseFloat(c));
        }
      else En[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: n } = this, r = [];
    for (let o = 0; o < e.length; o++)
      (e[o] === null || qS(e[o])) && r.push(o);
    r.length && ZS(e, r, n);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: n, name: r } = this;
    if (!e || !e.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = En[r](e.measureViewportBox(), window.getComputedStyle(e.current)), n[0] = this.measuredOrigin;
    const o = n[n.length - 1];
    o !== void 0 && e.getValue(r, o).jump(o, !1);
  }
  measureEndState() {
    var a;
    const { element: e, name: n, unresolvedKeyframes: r } = this;
    if (!e || !e.current)
      return;
    const o = e.getValue(n);
    o && o.jump(this.measuredOrigin, !1);
    const s = r.length - 1, i = r[s];
    r[s] = En[n](e.measureViewportBox(), window.getComputedStyle(e.current)), i !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = i), (a = this.removedTransforms) != null && a.length && this.removedTransforms.forEach(([l, c]) => {
      e.getValue(l).set(c);
    }), this.resolveNoneKeyframes();
  }
}
class sm extends rm {
  constructor() {
    super(...arguments), this.KeyframeResolver = JS;
  }
  sortInstanceNodePosition(e, n) {
    return e.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, n) {
    return e.style ? e.style[n] : void 0;
  }
  removeValueFromRenderState(e, { vars: n, style: r }) {
    delete n[e], delete r[e];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    _e(e) && (this.childSubscription = e.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function im(t, { style: e, vars: n }, r, o) {
  Object.assign(t.style, e, o && o.getProjectionStyles(r));
  for (const s in n)
    t.style.setProperty(s, n[s]);
}
function QS(t) {
  return window.getComputedStyle(t);
}
class am extends sm {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = im;
  }
  readValueFromInstance(e, n) {
    var r;
    if (hr.has(n))
      return (r = this.projection) != null && r.isProjecting ? Pa(n) : _C(e, n);
    {
      const o = QS(e), s = (Ll(n) ? o.getPropertyValue(n) : o[n]) || 0;
      return typeof s == "string" ? s.trim() : s;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: n }) {
    return Ih(e, n);
  }
  build(e, n, r) {
    Wl(e, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, n, r) {
    return zl(e, n, r);
  }
}
const lm = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function eA(t, e, n, r) {
  im(t, e, void 0, r);
  for (const o in e.attrs)
    t.setAttribute(lm.has(o) ? o : Vl(o), e.attrs[o]);
}
class cm extends sm {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = Ee;
  }
  getBaseTargetFromProps(e, n) {
    return e[n];
  }
  readValueFromInstance(e, n) {
    if (hr.has(n)) {
      const r = tm(n);
      return r && r.default || 0;
    }
    return n = lm.has(n) ? n : Vl(n), e.getAttribute(n);
  }
  scrapeMotionValuesFromProps(e, n, r) {
    return Hp(e, n, r);
  }
  build(e, n, r) {
    $p(e, n, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(e, n, r, o) {
    eA(e, n, r, o);
  }
  mount(e) {
    this.isSVGTag = jp(e.tagName), super.mount(e);
  }
}
const tA = (t, e) => Ul(t) ? new cm(e) : new am(e, {
  allowProjection: t !== Zf
}), nA = /* @__PURE__ */ Ex({
  ...dE,
  ...VS,
  ...wS,
  ...FS
}, tA), Vt = /* @__PURE__ */ Uw(nA);
function $a(t) {
  const e = uo(() => Rn(t)), { isStatic: n } = Ae(Vs);
  if (n) {
    const [, r] = de(t);
    ie(() => e.on("change", r), []);
  }
  return e;
}
function um(t, e) {
  const n = $a(e()), r = () => n.set(e());
  return r(), Dl(() => {
    const o = () => we.preRender(r, !1, !0), s = t.map((i) => i.on("change", o));
    return () => {
      s.forEach((i) => i()), $t(r);
    };
  }), n;
}
function rA(t) {
  Or.current = [], t();
  const e = um(Or.current, t);
  return Or.current = void 0, e;
}
function Zo(...t) {
  const e = !Array.isArray(t[0]), n = e ? 0 : -1, r = t[0 + n], o = t[1 + n], s = t[2 + n], i = t[3 + n], a = rh(o, s, i);
  return e ? a(r) : a;
}
function fs(t, e, n, r) {
  if (typeof t == "function")
    return rA(t);
  const o = typeof e == "function" ? e : Zo(e, n, r);
  return Array.isArray(t) ? Ld(t, o) : Ld([t], ([s]) => o(s));
}
function Ld(t, e) {
  const n = uo(() => []);
  return um(t, () => {
    n.length = 0;
    const r = t.length;
    for (let o = 0; o < r; o++)
      n[o] = t[o].get();
    return e(n);
  });
}
function oA() {
  !dc.current && Xh();
  const [t] = de(ds.current);
  return process.env.NODE_ENV !== "production" && Fs(t !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), t;
}
function fc(t) {
  return typeof t == "object" && !Array.isArray(t);
}
function dm(t, e, n, r) {
  return typeof t == "string" && fc(e) ? Kh(t, n, r) : t instanceof NodeList ? Array.from(t) : Array.isArray(t) ? t : [t];
}
function sA(t, e, n) {
  return t * (e + 1);
}
function Bd(t, e, n, r) {
  return typeof e == "number" ? e : e.startsWith("-") || e.startsWith("+") ? Math.max(0, t + parseFloat(e)) : e === "<" ? n : r.get(e) ?? t;
}
const iA = (t, e, n) => {
  const r = e - t;
  return ((n - t) % r + r) % r + t;
};
function fm(t, e) {
  return lh(t) ? t[iA(0, t.length, e)] : t;
}
function aA(t, e, n) {
  for (let r = 0; r < t.length; r++) {
    const o = t[r];
    o.at > e && o.at < n && (Ws(t, o), r--);
  }
}
function lA(t, e, n, r, o, s) {
  aA(t, o, s);
  for (let i = 0; i < e.length; i++)
    t.push({
      value: e[i],
      at: be(o, s, r[i]),
      easing: fm(n, i)
    });
}
function cA(t, e) {
  for (let n = 0; n < t.length; n++)
    t[n] = t[n] / (e + 1);
}
function uA(t, e) {
  return t.at === e.at ? t.value === null ? 1 : e.value === null ? -1 : 0 : t.at - e.at;
}
const dA = "easeInOut", fA = 20;
function pA(t, { defaultTransition: e = {}, ...n } = {}, r, o) {
  const s = e.duration || 0.3, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), l = {}, c = /* @__PURE__ */ new Map();
  let u = 0, d = 0, p = 0;
  for (let h = 0; h < t.length; h++) {
    const v = t[h];
    if (typeof v == "string") {
      c.set(v, d);
      continue;
    } else if (!Array.isArray(v)) {
      c.set(v.name, Bd(d, v.at, u, c));
      continue;
    }
    let [m, y, b = {}] = v;
    b.at !== void 0 && (d = Bd(d, b.at, u, c));
    let w = 0;
    const x = (E, C, A, S = 0, R = 0) => {
      const P = hA(E), { delay: k = 0, times: I = sh(P), type: _ = "keyframes", repeat: D, repeatType: N, repeatDelay: W = 0, ...L } = C;
      let { ease: B = e.ease || "easeOut", duration: V } = C;
      const $ = typeof k == "function" ? k(S, R) : k, T = P.length, M = ic(_) ? _ : o == null ? void 0 : o[_];
      if (T <= 2 && M) {
        let X = 100;
        if (T === 2 && vA(P)) {
          const z = P[1] - P[0];
          X = Math.abs(z);
        }
        const O = { ...L };
        V !== void 0 && (O.duration = /* @__PURE__ */ et(V));
        const F = th(O, X, M);
        B = F.ease, V = F.duration;
      }
      V ?? (V = s);
      const H = d + $;
      I.length === 1 && I[0] === 0 && (I[1] = 1);
      const Z = I.length - P.length;
      if (Z > 0 && oh(I, Z), P.length === 1 && P.unshift(null), D) {
        ct(D < fA, "Repeat count too high, must be less than 20"), V = sA(V, D);
        const X = [...P], O = [...I];
        B = Array.isArray(B) ? [...B] : [B];
        const F = [...B];
        for (let z = 0; z < D; z++) {
          P.push(...X);
          for (let q = 0; q < X.length; q++)
            I.push(O[q] + (z + 1)), B.push(q === 0 ? "linear" : fm(F, q - 1));
        }
        cA(I, D);
      }
      const U = H + V;
      lA(A, P, B, I, H, U), w = Math.max($ + V, w), p = Math.max(U, p);
    };
    if (_e(m)) {
      const E = $d(m, a);
      x(y, b, Wd("default", E));
    } else {
      const E = dm(m, y, r, l), C = E.length;
      for (let A = 0; A < C; A++) {
        y = y, b = b;
        const S = E[A], R = $d(S, a);
        for (const P in y)
          x(y[P], mA(b, P), Wd(P, R), A, C);
      }
    }
    u = d, d += w;
  }
  return a.forEach((h, v) => {
    for (const m in h) {
      const y = h[m];
      y.sort(uA);
      const b = [], w = [], x = [];
      for (let C = 0; C < y.length; C++) {
        const { at: A, value: S, easing: R } = y[C];
        b.push(S), w.push(/* @__PURE__ */ nr(0, p, A)), x.push(R || "easeOut");
      }
      w[0] !== 0 && (w.unshift(0), b.unshift(b[0]), x.unshift(dA)), w[w.length - 1] !== 1 && (w.push(1), b.push(null)), i.has(v) || i.set(v, {
        keyframes: {},
        transition: {}
      });
      const E = i.get(v);
      E.keyframes[m] = b, E.transition[m] = {
        ...e,
        duration: p,
        ease: x,
        times: w,
        ...n
      };
    }
  }), i;
}
function $d(t, e) {
  return !e.has(t) && e.set(t, {}), e.get(t);
}
function Wd(t, e) {
  return e[t] || (e[t] = []), e[t];
}
function hA(t) {
  return Array.isArray(t) ? t : [t];
}
function mA(t, e) {
  return t && t[e] ? {
    ...t,
    ...t[e]
  } : { ...t };
}
const gA = (t) => typeof t == "number", vA = (t) => t.every(gA);
function yA(t, e) {
  return t in e;
}
class bA extends rm {
  constructor() {
    super(...arguments), this.type = "object";
  }
  readValueFromInstance(e, n) {
    if (yA(n, e)) {
      const r = e[n];
      if (typeof r == "string" || typeof r == "number")
        return r;
    }
  }
  getBaseTargetFromProps() {
  }
  removeValueFromRenderState(e, n) {
    delete n.output[e];
  }
  measureInstanceViewportBox() {
    return Ee();
  }
  build(e, n) {
    Object.assign(e.output, n);
  }
  renderInstance(e, { output: n }) {
    Object.assign(e, n);
  }
  sortInstanceNodePosition() {
    return 0;
  }
}
function wA(t) {
  const e = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  }, n = uc(t) && !jh(t) ? new cm(e) : new am(e);
  n.mount(t), Jr.set(t, n);
}
function xA(t) {
  const e = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        output: {}
      },
      latestValues: {}
    }
  }, n = new bA(e);
  n.mount(t), Jr.set(t, n);
}
function CA(t, e) {
  return _e(t) || typeof t == "number" || typeof t == "string" && !fc(e);
}
function pm(t, e, n, r) {
  const o = [];
  if (CA(t, e))
    o.push(Fh(t, fc(e) && e.default || e, n && (n.default || n)));
  else {
    const s = dm(t, e, r), i = s.length;
    ct(!!i, "No valid elements provided.");
    for (let a = 0; a < i; a++) {
      const l = s[a], c = l instanceof Element ? wA : xA;
      Jr.has(l) || c(l);
      const u = Jr.get(l), d = { ...n };
      "delay" in d && typeof d.delay == "function" && (d.delay = d.delay(a, i)), o.push(...lc(u, { ...e, transition: d }, {}));
    }
  }
  return o;
}
function EA(t, e, n) {
  const r = [];
  return pA(t, e, n, { spring: Xr }).forEach(({ keyframes: s, transition: i }, a) => {
    r.push(...pm(a, s, i));
  }), r;
}
class SA {
  constructor(e) {
    this.stop = () => this.runAll("stop"), this.animations = e.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((e) => e.finished));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(e) {
    return this.animations[0][e];
  }
  setAll(e, n) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][e] = n;
  }
  attachTimeline(e) {
    const n = this.animations.map((r) => r.attachTimeline(e));
    return () => {
      n.forEach((r, o) => {
        r && r(), this.animations[o].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(e) {
    this.setAll("time", e);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(e) {
    this.setAll("speed", e);
  }
  get state() {
    return this.getAll("state");
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let e = 0;
    for (let n = 0; n < this.animations.length; n++)
      e = Math.max(e, this.animations[n].duration);
    return e;
  }
  runAll(e) {
    this.animations.forEach((n) => n[e]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
class AA extends SA {
  then(e, n) {
    return this.finished.finally(e).then(() => {
    });
  }
}
function TA(t) {
  return Array.isArray(t) && t.some(Array.isArray);
}
function RA(t) {
  function e(n, r, o) {
    let s = [];
    return TA(n) ? s = EA(n, r, t) : s = pm(n, r, o, t), new AA(s);
  }
  return e;
}
const Ui = RA();
var jd = "calc(100% - env(safe-area-inset-top) - 34px)", rr = typeof window > "u", _A = {
  ease: "easeOut",
  duration: 0.2
}, PA = {
  ease: "linear",
  duration: 0.01
}, kA = 0.6, IA = 500;
function Dr(t) {
  const e = t.current;
  return e ? Math.round(e.getBoundingClientRect().height) : (console.warn(
    "Sheet height is not available because the sheet element is not mounted yet."
  ), 0);
}
function Mr({
  snapPointsProp: t,
  sheetHeight: e
}) {
  const n = t.map((r) => r > 0 && r <= 1 ? Math.round(r * e) : r < 0 ? e + r : r);
  return console.assert(
    MA(n) || e === 0,
    `Snap points need to be in descending order got: [${t.join(", ")}]`
  ), n;
}
function DA({
  snapPoints: t,
  currentY: e,
  sheetHeight: n,
  detent: r
}) {
  const o = t.map(
    (l) => n - Math.min(l, n)
  );
  r === "content-height" && !o.includes(0) && o.unshift(0);
  const s = Ud(o, e), i = o.indexOf(s);
  return { snapY: hm({
    snapTo: Ud(o, e),
    sheetHeight: n
  }), snapIndex: i };
}
function Ud(t, e) {
  let n = t[0], r = Math.abs(t[0] - e);
  for (let o = 1; o < t.length; o++) {
    const s = Math.abs(t[o] - e);
    s < r && (n = t[o], r = s);
  }
  return n;
}
function MA(t) {
  for (let e = 0; e < t.length; e++)
    if (t[e + 1] > t[e]) return !1;
  return !0;
}
function Hd({
  sheetHeight: t,
  snapPoints: e,
  snapIndex: n
}) {
  const r = e[n];
  return r === void 0 ? (console.warn(
    `Invalid snap index ${n}. Snap points are: [${e.join(", ")}]`
  ), null) : hm({ snapTo: t - r, sheetHeight: t });
}
function hm({
  snapTo: t,
  sheetHeight: e
}) {
  return t < 0 && console.warn(
    `Snap point is out of bounds. Sheet height is ${e} but snap point is ${e + Math.abs(t)}.`
  ), Math.max(Math.round(t), 0);
}
function pc(t) {
  return (e) => {
    t.forEach((n) => {
      typeof n == "function" ? n(e) : n && (n.current = e);
    });
  };
}
function NA() {
  return rr ? !1 : "ontouchstart" in window || navigator.maxTouchPoints > 0;
}
function hc(t) {
  var e;
  return typeof window < "u" && window.navigator != null ? t.test(
    // @ts-expect-error
    ((e = window.navigator.userAgentData) == null ? void 0 : e.platform) || window.navigator.platform
  ) : !1;
}
function js(t) {
  let e = null;
  return () => (e == null && (e = t()), e);
}
var OA = js(function() {
  return hc(/^Mac/i);
}), VA = js(function() {
  return hc(/^iPhone/i);
}), FA = js(function() {
  return hc(/^iPad/i) || OA() && navigator.maxTouchPoints > 1;
}), LA = js(function() {
  return VA() || FA();
}), mm = Kt(
  void 0
);
function go() {
  const t = Ae(mm);
  if (!t) throw new Error("Sheet context error");
  return t;
}
var gm = Kt(void 0);
function BA({
  children: t
}) {
  const e = go(), [n, r] = de(!!e.disableDrag);
  function o() {
    e.disableDrag || r(!1);
  }
  function s() {
    n || r(!0);
  }
  return /* @__PURE__ */ ne.createElement(
    gm.Provider,
    {
      value: { disableDrag: n, setDragEnabled: o, setDragDisabled: s }
    },
    t
  );
}
function vm() {
  const t = Ae(gm);
  if (!t) throw new Error("Sheet scroller context error");
  return t;
}
var Mt = {
  wrapper: {
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    overflow: "hidden",
    pointerEvents: "none"
  },
  backdrop: {
    zIndex: 1,
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    touchAction: "none",
    border: "none",
    userSelect: "none",
    WebkitTapHighlightColor: "transparent"
  },
  container: {
    zIndex: 2,
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    backgroundColor: "#fff",
    borderTopRightRadius: "8px",
    borderTopLeftRadius: "8px",
    boxShadow: "0px -2px 16px rgba(0, 0, 0, 0.3)",
    display: "flex",
    flexDirection: "column",
    pointerEvents: "auto"
  },
  headerWrapper: {
    width: "100%"
  },
  header: {
    height: "40px",
    width: "100%",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  indicator: {
    width: "18px",
    height: "4px",
    borderRadius: "99px",
    backgroundColor: "#ddd"
  },
  content: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: "0px",
    position: "relative"
  },
  scroller: {
    height: "100%",
    overflowY: "auto",
    overscrollBehaviorY: "none"
  }
}, or = rr ? ie : gl;
function $A() {
  const [t] = de(() => {
    const e = { top: 0, left: 0, right: 0, bottom: 0 };
    if (rr) return e;
    const n = document.querySelector(":root");
    if (!n) return e;
    n.style.setProperty("--rms-sat", "env(safe-area-inset-top)"), n.style.setProperty("--rms-sal", "env(safe-area-inset-left)"), n.style.setProperty("--rms-sar", "env(safe-area-inset-right)"), n.style.setProperty("--rms-sab", "env(safe-area-inset-bottom)");
    const r = getComputedStyle(n), o = Fo(r, "--rms-sat"), s = Fo(r, "--rms-sal"), i = Fo(r, "--rms-sar"), a = Fo(r, "--rms-sab");
    return n.style.removeProperty("--rms-sat"), n.style.removeProperty("--rms-sal"), n.style.removeProperty("--rms-sar"), n.style.removeProperty("--rms-sab"), { top: o, left: s, right: i, bottom: a };
  });
  return t;
}
function Fo(t, e) {
  const n = t.getPropertyValue(e).replace("px", "").trim();
  return parseInt(n, 10) || 0;
}
function WA({
  y: t,
  rootId: e,
  sheetRef: n,
  snapPointsProp: r,
  startThreshold: o
}) {
  const s = $A().top;
  or(() => () => {
    e && zd(e);
  }, []), or(() => {
    if (!e) return;
    const i = document.querySelector(`#${e}`);
    if (!i) return;
    let a = 0;
    const l = t.on("animationStart", () => {
      a = Dr(n), jA(e);
    }), c = t.on("change", (h) => {
      if (!i) return;
      let v = Math.max(0, 1 - h / a);
      const m = r ? Mr({ snapPointsProp: r, sheetHeight: a }) : void 0, y = m && m.length > 1 ? m[1] : void 0;
      if (y !== void 0) {
        const C = a - Math.min(y, a);
        h <= C ? v = (C - h) / C : v = 0;
      }
      if (o !== void 0) {
        const C = a - Math.min(Math.floor(o * a), a);
        h <= C ? v = (C - h) / C : v = 0;
      }
      v = Math.max(0, Math.min(1, v));
      const b = window.innerWidth, w = Zo(v, [0, 1], [0, 24 + s]), x = Zo(v, [0, 1], [1, (b - 16) / b]), E = Zo(v, [0, 1], [0, 10]);
      i.style.transform = `scale(${x}) translate3d(0, ${w}px, 0)`, i.style.borderTopRightRadius = `${E}px`, i.style.borderTopLeftRadius = `${E}px`;
    });
    function u() {
      t.get() - 5 >= a && zd(e);
    }
    const d = t.on("animationComplete", u), p = t.on("animationCancel", u);
    return () => {
      l(), c(), d(), p();
    };
  }, [t, e, s, o, r]);
}
function jA(t) {
  const e = document.querySelector(`#${t}`), n = document.querySelector("body");
  e && (n.style.backgroundColor = "#000", e.style.overflow = "hidden", e.style.transitionTimingFunction = "cubic-bezier(0.32, 0.72, 0, 1)", e.style.transitionProperty = "transform, border-radius", e.style.transitionDuration = "0.5s", e.style.transformOrigin = "center top");
}
function zd(t) {
  const e = document.querySelector(`#${t}`), n = document.querySelector("body");
  e && (n.style.removeProperty("background-color"), e.style.removeProperty("overflow"), e.style.removeProperty("transition-timing-function"), e.style.removeProperty("transition-property"), e.style.removeProperty("transition-duration"), e.style.removeProperty("transform-origin"), e.style.removeProperty("transform"), e.style.removeProperty("border-top-right-radius"), e.style.removeProperty("border-top-left-radius"));
}
function UA() {
  const [t, e] = de(() => ({
    height: rr ? 0 : window.innerHeight,
    width: rr ? 0 : window.innerWidth
  }));
  return or(() => {
    function n() {
      e({
        height: window.innerHeight,
        width: window.innerWidth
      });
    }
    return n(), window.addEventListener("resize", n), () => {
      window.removeEventListener("resize", n);
    };
  }, []), t;
}
function Hi(t) {
  const e = Se(void 0);
  return or(() => {
    e.current = t;
  }), Dt((...n) => {
    const r = e.current;
    return r == null ? void 0 : r(...n);
  }, []);
}
var HA = 24;
function Wa(...t) {
  return (...e) => {
    for (const n of t)
      typeof n == "function" && n(...e);
  };
}
var zi = typeof document < "u" && window.visualViewport;
function Gd(t, e) {
  if (!t)
    return !1;
  const n = window.getComputedStyle(t);
  let r = /(auto|scroll)/.test(
    n.overflow + n.overflowX + n.overflowY
  );
  return r && e && (r = t.scrollHeight !== t.clientHeight || t.scrollWidth !== t.clientWidth), r;
}
function ym(t, e) {
  let n = t;
  for (Gd(n, e) && (n = n.parentElement); n && !Gd(n, e); )
    n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
var zA = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]), Lo = 0, Bo;
function GA(t = {}) {
  const { isDisabled: e } = t;
  or(() => {
    if (!e)
      return Lo++, Lo === 1 && (LA() ? Bo = YA() : Bo = KA()), () => {
        Lo--, Lo === 0 && (Bo == null || Bo());
      };
  }, [e]);
}
function KA() {
  return Wa(
    $r(
      document.documentElement,
      "paddingRight",
      `${window.innerWidth - document.documentElement.clientWidth}px`
    ),
    $r(document.documentElement, "overflow", "hidden")
  );
}
function YA() {
  let t, e = 0;
  const n = (d) => {
    var p;
    const h = (p = d.composedPath()) == null ? void 0 : p[0];
    t = ym(h, !0), !(t === document.documentElement && t === document.body) && (e = d.changedTouches[0].pageY);
  }, r = (d) => {
    if (t === void 0)
      return;
    if (!t || t === document.documentElement || t === document.body) {
      d.preventDefault();
      return;
    }
    const p = d.changedTouches[0].pageY, h = t.scrollTop, v = t.scrollHeight - t.clientHeight;
    v !== 0 && ((h <= 0 && p > e || h >= v && p < e) && d.preventDefault(), e = p);
  }, o = (d) => {
    var p;
    const h = (p = d.composedPath()) == null ? void 0 : p[0];
    Yd(h) && h !== document.activeElement && (d.preventDefault(), h.style.transform = "translateY(-2000px)", h.focus(), requestAnimationFrame(() => {
      h.style.transform = "";
    }));
  }, s = (d) => {
    var p;
    const h = (p = d.composedPath()) == null ? void 0 : p[0];
    Yd(h) && (h.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      h.style.transform = "", zi && (zi.height < window.innerHeight ? requestAnimationFrame(() => {
        Kd(h);
      }) : zi.addEventListener(
        "resize",
        () => Kd(h),
        { once: !0 }
      ));
    }));
  }, i = () => {
    window.scrollTo(0, 0);
  }, a = window.pageXOffset, l = window.pageYOffset, c = Wa(
    $r(
      document.documentElement,
      "paddingRight",
      `${window.innerWidth - document.documentElement.clientWidth}px`
    ),
    $r(document.documentElement, "overflow", "hidden"),
    $r(document.body, "marginTop", `-${l}px`)
  );
  window.scrollTo(0, 0);
  const u = Wa(
    _r(document, "touchstart", n, {
      passive: !1,
      capture: !0
    }),
    _r(document, "touchmove", r, {
      passive: !1,
      capture: !0
    }),
    _r(document, "touchend", o, {
      passive: !1,
      capture: !0
    }),
    _r(document, "focus", s, !0),
    _r(window, "scroll", i)
  );
  return () => {
    c(), u(), window.scrollTo(a, l);
  };
}
function $r(t, e, n) {
  const r = t.style[e];
  return t.style[e] = n, () => {
    t.style[e] = r;
  };
}
function _r(t, e, n, r) {
  return t.addEventListener(e, n, r), () => {
    t.removeEventListener(e, n, r);
  };
}
function Kd(t) {
  const e = document.scrollingElement || document.documentElement;
  for (; t && t !== e; ) {
    const n = ym(t);
    if (n !== document.documentElement && n !== document.body && n !== t) {
      const r = n.getBoundingClientRect().top, o = t.getBoundingClientRect().top, s = t.getBoundingClientRect().bottom, i = n.getBoundingClientRect().bottom + HA;
      s > i && (n.scrollTop += o - r);
    }
    t = n.parentElement;
  }
}
function Yd(t) {
  return t instanceof HTMLInputElement && !zA.has(t.type) || t instanceof HTMLTextAreaElement || t instanceof HTMLElement && t.isContentEditable;
}
var bm = Yt(
  ({
    onOpenStart: t,
    onOpenEnd: e,
    onClose: n,
    onCloseStart: r,
    onCloseEnd: o,
    onSnap: s,
    children: i,
    disableScrollLocking: a = !1,
    isOpen: l,
    snapPoints: c,
    rootId: u,
    modalEffectRootId: d,
    mountPoint: p,
    style: h,
    detent: v = "full-height",
    initialSnap: m = 0,
    disableDrag: y = !1,
    prefersReducedMotion: b = !1,
    tweenConfig: w = _A,
    dragVelocityThreshold: x = IA,
    dragCloseThreshold: E = kA,
    modalEffectThreshold: C,
    ...A
  }, S) => {
    const R = Se(null), P = $a(0), { height: k } = UA(), I = oA(), _ = !!(b || I), D = {
      type: "tween",
      ..._ ? PA : w
    }, N = $a(k), W = fs(
      N,
      (U) => U + 2 >= k ? -1 : (h == null ? void 0 : h.zIndex) ?? 9999
    ), L = fs(
      N,
      (U) => U + 2 >= k ? "hidden" : "visible"
    ), B = Se({
      onOpenStart: t,
      onOpenEnd: e,
      onCloseStart: r,
      onCloseEnd: o
    });
    or(() => {
      B.current = {
        onOpenStart: t,
        onOpenEnd: e,
        onCloseStart: r,
        onCloseEnd: o
      };
    });
    const V = Hi((U, X) => {
      const O = N.get();
      if (c) {
        const z = Dr(R), q = Mr({ snapPointsProp: c, sheetHeight: z }), Y = z - q[0];
        if (X.delta.y < 0 && O <= Y) {
          N.set(Y);
          return;
        }
      }
      const F = N.getVelocity();
      F > 0 && P.set(10), F < 0 && P.set(-10), N.set(Math.max(O + X.delta.y, 0));
    }), $ = Hi(() => {
      const U = document.activeElement;
      if (!U || !R.current) return;
      (U.tagName === "INPUT" || U.tagName === "TEXTAREA") && R.current.contains(U) && U.blur();
    }), T = Hi((U, { velocity: X }) => {
      if (X.y > x)
        n();
      else {
        const O = Dr(R), F = N.get();
        let z = 0;
        const q = c ? Mr({ snapPointsProp: c, sheetHeight: O }) : void 0;
        if (q) {
          const { snapY: Y, snapIndex: re } = DA({
            snapPoints: q,
            currentY: F,
            sheetHeight: O,
            detent: v
          });
          z = Y, s == null || s(re);
        } else F / O > E && (z = O);
        Ui(N, z, D), z + 1 >= O && n();
      }
      P.set(0);
    });
    ie(() => {
      c && s && s(l ? m : c.length - 1);
    }, [l]), ie(() => {
      if (!l) return;
      let U = 0;
      if (c) {
        const X = m, O = Dr(R), F = Mr({ snapPointsProp: c, sheetHeight: O }), z = Hd({ sheetHeight: O, snapPoints: F, snapIndex: X });
        z !== null && (U = z);
      }
      Ui(N, U, D);
    }, [l]), wb(S, () => ({
      y: N,
      snapTo: (U) => {
        if (!c) {
          console.warn("Snapping is not possible without `snapPoints` prop.");
          return;
        }
        const X = Dr(R), O = Mr({ snapPointsProp: c, sheetHeight: X }), F = Hd({ sheetHeight: X, snapPoints: O, snapIndex: U });
        F !== null && (Ui(N, F, D), s == null || s(U), F + 1 >= X && n());
      }
    })), u && console.warn(
      "The `rootId` prop is deprecated and will be removed in the next major version. Use `modalEffectRootId` instead."
    ), WA({
      y: N,
      sheetRef: R,
      snapPointsProp: c,
      rootId: u || d,
      startThreshold: C
    }), GA({
      isDisabled: a || !l
    });
    const M = Lt(() => y ? void 0 : {
      drag: "y",
      dragElastic: 0,
      dragMomentum: !1,
      dragPropagation: !1,
      onDrag: V,
      onDragStart: $,
      onDragEnd: T
    }, [y, k]), H = {
      y: N,
      sheetRef: R,
      isOpen: l,
      initialSnap: m,
      detent: v,
      indicatorRotation: P,
      callbacks: B,
      dragProps: M,
      windowHeight: k,
      animationOptions: D,
      reduceMotion: _,
      disableDrag: y
    }, Z = /* @__PURE__ */ ne.createElement(mm.Provider, { value: H }, /* @__PURE__ */ ne.createElement(
      Vt.div,
      {
        ...A,
        ref: S,
        style: { ...Mt.wrapper, zIndex: W, visibility: L, ...h }
      },
      /* @__PURE__ */ ne.createElement(Vw, null, l ? /* @__PURE__ */ ne.createElement(BA, null, tn.map(
        i,
        (U, X) => xb(U, { key: `sheet-child-${X}` })
      )) : null)
    ));
    return rr ? Z : vl(Z, p ?? document.body);
  }
);
bm.displayName = "Sheet";
function qA(t, e) {
  const n = XA(t), r = Se(!1), o = Dt(() => {
    var s, i, a, l;
    r.current ? ((l = (a = e.current).onCloseEnd) == null || l.call(a), r.current = !1) : ((i = (s = e.current).onOpenEnd) == null || i.call(s), r.current = !0);
  }, [t, n]);
  return ie(() => {
    var s, i, a, l;
    !n && t ? (i = (s = e.current).onOpenStart) == null || i.call(s) : !t && n && ((l = (a = e.current).onCloseStart) == null || l.call(a));
  }, [t, n]), { handleAnimationComplete: o };
}
function XA(t) {
  const e = Se(void 0);
  return ie(() => {
    e.current = t;
  }), e.current;
}
var wm = Yt(
  ({ children: t, style: e, className: n = "", ...r }, o) => {
    const {
      y: s,
      isOpen: i,
      callbacks: a,
      sheetRef: l,
      windowHeight: c,
      detent: u,
      animationOptions: d
    } = go(), { handleAnimationComplete: p } = qA(i, a), h = u === "full-height" ? jd : void 0, v = u === "content-height" ? jd : void 0;
    return /* @__PURE__ */ ne.createElement(
      Vt.div,
      {
        ...r,
        ref: pc([l, o]),
        className: `react-modal-sheet-container ${n}`,
        style: { ...Mt.container, height: h, maxHeight: v, ...e, y: s },
        initial: { y: c },
        exit: { y: c, transition: d },
        onAnimationComplete: p
      },
      t
    );
  }
);
wm.displayName = "SheetContainer";
var ZA = { bottom: 0, top: 0, left: 0, right: 0 };
function xm() {
  const t = Se(null), e = Dt(() => ZA, []);
  return { constraintsRef: t, onMeasureDragConstraints: e };
}
var Cm = Yt(
  ({ children: t, style: e, disableDrag: n, className: r = "", ...o }, s) => {
    const i = go(), a = vm(), { constraintsRef: l, onMeasureDragConstraints: c } = xm(), u = n || a.disableDrag ? void 0 : i.dragProps;
    return /* @__PURE__ */ ne.createElement(
      Vt.div,
      {
        ...o,
        ref: pc([s, l]),
        className: `react-modal-sheet-content ${r}`,
        style: { ...Mt.content, ...e },
        ...u,
        dragConstraints: l,
        onMeasureDragConstraints: c
      },
      t
    );
  }
);
Cm.displayName = "SheetContent";
var Em = Yt(
  ({ children: t, style: e, disableDrag: n, ...r }, o) => {
    const { indicatorRotation: s, dragProps: i } = go(), { constraintsRef: a, onMeasureDragConstraints: l } = xm(), c = n ? void 0 : i, u = fs(
      s,
      (p) => `translateX(2px) rotate(${p}deg)`
    ), d = fs(
      s,
      (p) => `translateX(-2px) rotate(${-1 * p}deg)`
    );
    return /* @__PURE__ */ ne.createElement(
      Vt.div,
      {
        ...r,
        ref: pc([o, a]),
        style: { ...Mt.headerWrapper, ...e },
        ...c,
        dragConstraints: a,
        onMeasureDragConstraints: l
      },
      t || /* @__PURE__ */ ne.createElement("div", { className: "react-modal-sheet-header", style: Mt.header }, /* @__PURE__ */ ne.createElement(
        Vt.span,
        {
          className: "react-modal-sheet-drag-indicator",
          style: { ...Mt.indicator, transform: u }
        }
      ), /* @__PURE__ */ ne.createElement(
        Vt.span,
        {
          className: "react-modal-sheet-drag-indicator",
          style: { ...Mt.indicator, transform: d }
        }
      ))
    );
  }
);
Em.displayName = "SheetHeader";
var qd = (t) => !!t.onClick || !!t.onTap, Sm = Yt(
  ({ style: t = {}, className: e = "", ...n }, r) => {
    const o = qd(n) ? Vt.button : Vt.div, s = qd(n) ? "auto" : "none";
    return /* @__PURE__ */ ne.createElement(
      o,
      {
        ...n,
        ref: r,
        className: `react-modal-sheet-backdrop ${e}`,
        style: { ...Mt.backdrop, ...t, pointerEvents: s },
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 }
      }
    );
  }
);
Sm.displayName = "SheetBackdrop";
var Am = Yt(
  ({
    autoPadding: t = !0,
    disableScroll: e = !1,
    draggableAt: n = "top",
    children: r,
    style: o,
    className: s = "",
    ...i
  }, a) => {
    const { y: l } = go(), { setDragEnabled: c, setDragDisabled: u } = vm();
    function d(y) {
      if (e) {
        c();
        return;
      }
      const { scrollTop: b, scrollHeight: w, clientHeight: x } = y;
      if (!(w > x)) return;
      const C = b <= 0, A = w - b === x;
      n === "top" && C || n === "bottom" && A || n === "both" && (C || A) ? c() : u();
    }
    function p(y) {
      d(y.currentTarget), i.onScroll && i.onScroll(y);
    }
    function h(y) {
      d(y.currentTarget), i.onTouchStart && i.onTouchStart(y);
    }
    const v = NA() ? { onScroll: p, onTouchStart: h } : void 0, m = {
      ...Mt.scroller,
      ...o
    };
    return t && (m.paddingBottom = l), e && (m.overflowY = "hidden"), /* @__PURE__ */ ne.createElement(
      Vt.div,
      {
        ...i,
        ref: a,
        className: `react-modal-sheet-scroller ${s}`,
        style: m,
        ...v
      },
      r
    );
  }
);
Am.displayName = "SheetScroller";
var Pr = Object.assign(bm, {
  Container: wm,
  Header: Em,
  Content: Cm,
  Backdrop: Sm,
  Scroller: Am
});
// @__NO_SIDE_EFFECTS__
function JA(t) {
  const e = /* @__PURE__ */ QA(t), n = f.forwardRef((r, o) => {
    const { children: s, ...i } = r, a = f.Children.toArray(s), l = a.find(tT);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ g(e, { ...i, ref: o, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ g(e, { ...i, ref: o, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function QA(t) {
  const e = f.forwardRef((n, r) => {
    const { children: o, ...s } = n, i = f.isValidElement(o) ? rT(o) : void 0, a = te(i, r);
    if (f.isValidElement(o)) {
      const l = nT(s, o.props);
      return o.type !== f.Fragment && (l.ref = a), f.cloneElement(o, l);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var eT = Symbol("radix.slottable");
function tT(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === eT;
}
function nT(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const l = s(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function rT(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var oT = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], vo = oT.reduce((t, e) => {
  const n = /* @__PURE__ */ JA(`Primitive.${e}`), r = f.forwardRef((o, s) => {
    const { asChild: i, ...a } = o, l = i ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {});
function Ne(t) {
  const e = f.useRef(t);
  return f.useEffect(() => {
    e.current = t;
  }), f.useMemo(() => (...n) => {
    var r;
    return (r = e.current) == null ? void 0 : r.call(e, ...n);
  }, []);
}
var sT = f.createContext(void 0);
function iT(t) {
  const e = f.useContext(sT);
  return t || e || "ltr";
}
function ja(t, [e, n]) {
  return Math.min(n, Math.max(e, t));
}
function aT(t, e) {
  return f.useReducer((n, r) => e[n][r] ?? n, t);
}
var mc = "ScrollArea", [Tm, BN] = je(mc), [lT, rt] = Tm(mc), Rm = f.forwardRef(
  (t, e) => {
    const {
      __scopeScrollArea: n,
      type: r = "hover",
      dir: o,
      scrollHideDelay: s = 600,
      ...i
    } = t, [a, l] = f.useState(null), [c, u] = f.useState(null), [d, p] = f.useState(null), [h, v] = f.useState(null), [m, y] = f.useState(null), [b, w] = f.useState(0), [x, E] = f.useState(0), [C, A] = f.useState(!1), [S, R] = f.useState(!1), P = te(e, (I) => l(I)), k = iT(o);
    return /* @__PURE__ */ g(
      lT,
      {
        scope: n,
        type: r,
        dir: k,
        scrollHideDelay: s,
        scrollArea: a,
        viewport: c,
        onViewportChange: u,
        content: d,
        onContentChange: p,
        scrollbarX: h,
        onScrollbarXChange: v,
        scrollbarXEnabled: C,
        onScrollbarXEnabledChange: A,
        scrollbarY: m,
        onScrollbarYChange: y,
        scrollbarYEnabled: S,
        onScrollbarYEnabledChange: R,
        onCornerWidthChange: w,
        onCornerHeightChange: E,
        children: /* @__PURE__ */ g(
          vo.div,
          {
            dir: k,
            ...i,
            ref: P,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": b + "px",
              "--radix-scroll-area-corner-height": x + "px",
              ...t.style
            }
          }
        )
      }
    );
  }
);
Rm.displayName = mc;
var _m = "ScrollAreaViewport", Pm = f.forwardRef(
  (t, e) => {
    const { __scopeScrollArea: n, children: r, nonce: o, ...s } = t, i = rt(_m, n), a = f.useRef(null), l = te(e, a, i.onViewportChange);
    return /* @__PURE__ */ G(Pe, { children: [
      /* @__PURE__ */ g(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ g(
        vo.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...s,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...t.style
          },
          children: /* @__PURE__ */ g("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: r })
        }
      )
    ] });
  }
);
Pm.displayName = _m;
var St = "ScrollAreaScrollbar", km = f.forwardRef(
  (t, e) => {
    const { forceMount: n, ...r } = t, o = rt(St, t.__scopeScrollArea), { onScrollbarXEnabledChange: s, onScrollbarYEnabledChange: i } = o, a = t.orientation === "horizontal";
    return f.useEffect(() => (a ? s(!0) : i(!0), () => {
      a ? s(!1) : i(!1);
    }), [a, s, i]), o.type === "hover" ? /* @__PURE__ */ g(cT, { ...r, ref: e, forceMount: n }) : o.type === "scroll" ? /* @__PURE__ */ g(uT, { ...r, ref: e, forceMount: n }) : o.type === "auto" ? /* @__PURE__ */ g(Im, { ...r, ref: e, forceMount: n }) : o.type === "always" ? /* @__PURE__ */ g(gc, { ...r, ref: e }) : null;
  }
);
km.displayName = St;
var cT = f.forwardRef((t, e) => {
  const { forceMount: n, ...r } = t, o = rt(St, t.__scopeScrollArea), [s, i] = f.useState(!1);
  return f.useEffect(() => {
    const a = o.scrollArea;
    let l = 0;
    if (a) {
      const c = () => {
        window.clearTimeout(l), i(!0);
      }, u = () => {
        l = window.setTimeout(() => i(!1), o.scrollHideDelay);
      };
      return a.addEventListener("pointerenter", c), a.addEventListener("pointerleave", u), () => {
        window.clearTimeout(l), a.removeEventListener("pointerenter", c), a.removeEventListener("pointerleave", u);
      };
    }
  }, [o.scrollArea, o.scrollHideDelay]), /* @__PURE__ */ g(Ge, { present: n || s, children: /* @__PURE__ */ g(
    Im,
    {
      "data-state": s ? "visible" : "hidden",
      ...r,
      ref: e
    }
  ) });
}), uT = f.forwardRef((t, e) => {
  const { forceMount: n, ...r } = t, o = rt(St, t.__scopeScrollArea), s = t.orientation === "horizontal", i = Hs(() => l("SCROLL_END"), 100), [a, l] = aT("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return f.useEffect(() => {
    if (a === "idle") {
      const c = window.setTimeout(() => l("HIDE"), o.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [a, o.scrollHideDelay, l]), f.useEffect(() => {
    const c = o.viewport, u = s ? "scrollLeft" : "scrollTop";
    if (c) {
      let d = c[u];
      const p = () => {
        const h = c[u];
        d !== h && (l("SCROLL"), i()), d = h;
      };
      return c.addEventListener("scroll", p), () => c.removeEventListener("scroll", p);
    }
  }, [o.viewport, s, l, i]), /* @__PURE__ */ g(Ge, { present: n || a !== "hidden", children: /* @__PURE__ */ g(
    gc,
    {
      "data-state": a === "hidden" ? "hidden" : "visible",
      ...r,
      ref: e,
      onPointerEnter: J(t.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: J(t.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), Im = f.forwardRef((t, e) => {
  const n = rt(St, t.__scopeScrollArea), { forceMount: r, ...o } = t, [s, i] = f.useState(!1), a = t.orientation === "horizontal", l = Hs(() => {
    if (n.viewport) {
      const c = n.viewport.offsetWidth < n.viewport.scrollWidth, u = n.viewport.offsetHeight < n.viewport.scrollHeight;
      i(a ? c : u);
    }
  }, 10);
  return sr(n.viewport, l), sr(n.content, l), /* @__PURE__ */ g(Ge, { present: r || s, children: /* @__PURE__ */ g(
    gc,
    {
      "data-state": s ? "visible" : "hidden",
      ...o,
      ref: e
    }
  ) });
}), gc = f.forwardRef((t, e) => {
  const { orientation: n = "vertical", ...r } = t, o = rt(St, t.__scopeScrollArea), s = f.useRef(null), i = f.useRef(0), [a, l] = f.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = Vm(a.viewport, a.content), u = {
    ...r,
    sizes: a,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (p) => s.current = p,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (p) => i.current = p
  };
  function d(p, h) {
    return gT(p, i.current, a, h);
  }
  return n === "horizontal" ? /* @__PURE__ */ g(
    dT,
    {
      ...u,
      ref: e,
      onThumbPositionChange: () => {
        if (o.viewport && s.current) {
          const p = o.viewport.scrollLeft, h = Xd(p, a, o.dir);
          s.current.style.transform = `translate3d(${h}px, 0, 0)`;
        }
      },
      onWheelScroll: (p) => {
        o.viewport && (o.viewport.scrollLeft = p);
      },
      onDragScroll: (p) => {
        o.viewport && (o.viewport.scrollLeft = d(p, o.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ g(
    fT,
    {
      ...u,
      ref: e,
      onThumbPositionChange: () => {
        if (o.viewport && s.current) {
          const p = o.viewport.scrollTop, h = Xd(p, a);
          s.current.style.transform = `translate3d(0, ${h}px, 0)`;
        }
      },
      onWheelScroll: (p) => {
        o.viewport && (o.viewport.scrollTop = p);
      },
      onDragScroll: (p) => {
        o.viewport && (o.viewport.scrollTop = d(p));
      }
    }
  ) : null;
}), dT = f.forwardRef((t, e) => {
  const { sizes: n, onSizesChange: r, ...o } = t, s = rt(St, t.__scopeScrollArea), [i, a] = f.useState(), l = f.useRef(null), c = te(e, l, s.onScrollbarXChange);
  return f.useEffect(() => {
    l.current && a(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ g(
    Mm,
    {
      "data-orientation": "horizontal",
      ...o,
      ref: c,
      sizes: n,
      style: {
        bottom: 0,
        left: s.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: s.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": Us(n) + "px",
        ...t.style
      },
      onThumbPointerDown: (u) => t.onThumbPointerDown(u.x),
      onDragScroll: (u) => t.onDragScroll(u.x),
      onWheelScroll: (u, d) => {
        if (s.viewport) {
          const p = s.viewport.scrollLeft + u.deltaX;
          t.onWheelScroll(p), Lm(p, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && s.viewport && i && r({
          content: s.viewport.scrollWidth,
          viewport: s.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: hs(i.paddingLeft),
            paddingEnd: hs(i.paddingRight)
          }
        });
      }
    }
  );
}), fT = f.forwardRef((t, e) => {
  const { sizes: n, onSizesChange: r, ...o } = t, s = rt(St, t.__scopeScrollArea), [i, a] = f.useState(), l = f.useRef(null), c = te(e, l, s.onScrollbarYChange);
  return f.useEffect(() => {
    l.current && a(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ g(
    Mm,
    {
      "data-orientation": "vertical",
      ...o,
      ref: c,
      sizes: n,
      style: {
        top: 0,
        right: s.dir === "ltr" ? 0 : void 0,
        left: s.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": Us(n) + "px",
        ...t.style
      },
      onThumbPointerDown: (u) => t.onThumbPointerDown(u.y),
      onDragScroll: (u) => t.onDragScroll(u.y),
      onWheelScroll: (u, d) => {
        if (s.viewport) {
          const p = s.viewport.scrollTop + u.deltaY;
          t.onWheelScroll(p), Lm(p, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && s.viewport && i && r({
          content: s.viewport.scrollHeight,
          viewport: s.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: hs(i.paddingTop),
            paddingEnd: hs(i.paddingBottom)
          }
        });
      }
    }
  );
}), [pT, Dm] = Tm(St), Mm = f.forwardRef((t, e) => {
  const {
    __scopeScrollArea: n,
    sizes: r,
    hasThumb: o,
    onThumbChange: s,
    onThumbPointerUp: i,
    onThumbPointerDown: a,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: u,
    onResize: d,
    ...p
  } = t, h = rt(St, n), [v, m] = f.useState(null), y = te(e, (P) => m(P)), b = f.useRef(null), w = f.useRef(""), x = h.viewport, E = r.content - r.viewport, C = Ne(u), A = Ne(l), S = Hs(d, 10);
  function R(P) {
    if (b.current) {
      const k = P.clientX - b.current.left, I = P.clientY - b.current.top;
      c({ x: k, y: I });
    }
  }
  return f.useEffect(() => {
    const P = (k) => {
      const I = k.target;
      (v == null ? void 0 : v.contains(I)) && C(k, E);
    };
    return document.addEventListener("wheel", P, { passive: !1 }), () => document.removeEventListener("wheel", P, { passive: !1 });
  }, [x, v, E, C]), f.useEffect(A, [r, A]), sr(v, S), sr(h.content, S), /* @__PURE__ */ g(
    pT,
    {
      scope: n,
      scrollbar: v,
      hasThumb: o,
      onThumbChange: Ne(s),
      onThumbPointerUp: Ne(i),
      onThumbPositionChange: A,
      onThumbPointerDown: Ne(a),
      children: /* @__PURE__ */ g(
        vo.div,
        {
          ...p,
          ref: y,
          style: { position: "absolute", ...p.style },
          onPointerDown: J(t.onPointerDown, (P) => {
            P.button === 0 && (P.target.setPointerCapture(P.pointerId), b.current = v.getBoundingClientRect(), w.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", h.viewport && (h.viewport.style.scrollBehavior = "auto"), R(P));
          }),
          onPointerMove: J(t.onPointerMove, R),
          onPointerUp: J(t.onPointerUp, (P) => {
            const k = P.target;
            k.hasPointerCapture(P.pointerId) && k.releasePointerCapture(P.pointerId), document.body.style.webkitUserSelect = w.current, h.viewport && (h.viewport.style.scrollBehavior = ""), b.current = null;
          })
        }
      )
    }
  );
}), ps = "ScrollAreaThumb", Nm = f.forwardRef(
  (t, e) => {
    const { forceMount: n, ...r } = t, o = Dm(ps, t.__scopeScrollArea);
    return /* @__PURE__ */ g(Ge, { present: n || o.hasThumb, children: /* @__PURE__ */ g(hT, { ref: e, ...r }) });
  }
), hT = f.forwardRef(
  (t, e) => {
    const { __scopeScrollArea: n, style: r, ...o } = t, s = rt(ps, n), i = Dm(ps, n), { onThumbPositionChange: a } = i, l = te(
      e,
      (d) => i.onThumbChange(d)
    ), c = f.useRef(void 0), u = Hs(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return f.useEffect(() => {
      const d = s.viewport;
      if (d) {
        const p = () => {
          if (u(), !c.current) {
            const h = vT(d, a);
            c.current = h, a();
          }
        };
        return a(), d.addEventListener("scroll", p), () => d.removeEventListener("scroll", p);
      }
    }, [s.viewport, u, a]), /* @__PURE__ */ g(
      vo.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...o,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...r
        },
        onPointerDownCapture: J(t.onPointerDownCapture, (d) => {
          const h = d.target.getBoundingClientRect(), v = d.clientX - h.left, m = d.clientY - h.top;
          i.onThumbPointerDown({ x: v, y: m });
        }),
        onPointerUp: J(t.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
Nm.displayName = ps;
var vc = "ScrollAreaCorner", Om = f.forwardRef(
  (t, e) => {
    const n = rt(vc, t.__scopeScrollArea), r = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && r ? /* @__PURE__ */ g(mT, { ...t, ref: e }) : null;
  }
);
Om.displayName = vc;
var mT = f.forwardRef((t, e) => {
  const { __scopeScrollArea: n, ...r } = t, o = rt(vc, n), [s, i] = f.useState(0), [a, l] = f.useState(0), c = !!(s && a);
  return sr(o.scrollbarX, () => {
    var d;
    const u = ((d = o.scrollbarX) == null ? void 0 : d.offsetHeight) || 0;
    o.onCornerHeightChange(u), l(u);
  }), sr(o.scrollbarY, () => {
    var d;
    const u = ((d = o.scrollbarY) == null ? void 0 : d.offsetWidth) || 0;
    o.onCornerWidthChange(u), i(u);
  }), c ? /* @__PURE__ */ g(
    vo.div,
    {
      ...r,
      ref: e,
      style: {
        width: s,
        height: a,
        position: "absolute",
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...t.style
      }
    }
  ) : null;
});
function hs(t) {
  return t ? parseInt(t, 10) : 0;
}
function Vm(t, e) {
  const n = t / e;
  return isNaN(n) ? 0 : n;
}
function Us(t) {
  const e = Vm(t.viewport, t.content), n = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, r = (t.scrollbar.size - n) * e;
  return Math.max(r, 18);
}
function gT(t, e, n, r = "ltr") {
  const o = Us(n), s = o / 2, i = e || s, a = o - i, l = n.scrollbar.paddingStart + i, c = n.scrollbar.size - n.scrollbar.paddingEnd - a, u = n.content - n.viewport, d = r === "ltr" ? [0, u] : [u * -1, 0];
  return Fm([l, c], d)(t);
}
function Xd(t, e, n = "ltr") {
  const r = Us(e), o = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, s = e.scrollbar.size - o, i = e.content - e.viewport, a = s - r, l = n === "ltr" ? [0, i] : [i * -1, 0], c = ja(t, l);
  return Fm([0, i], [0, a])(c);
}
function Fm(t, e) {
  return (n) => {
    if (t[0] === t[1] || e[0] === e[1]) return e[0];
    const r = (e[1] - e[0]) / (t[1] - t[0]);
    return e[0] + r * (n - t[0]);
  };
}
function Lm(t, e) {
  return t > 0 && t < e;
}
var vT = (t, e = () => {
}) => {
  let n = { left: t.scrollLeft, top: t.scrollTop }, r = 0;
  return function o() {
    const s = { left: t.scrollLeft, top: t.scrollTop }, i = n.left !== s.left, a = n.top !== s.top;
    (i || a) && e(), n = s, r = window.requestAnimationFrame(o);
  }(), () => window.cancelAnimationFrame(r);
};
function Hs(t, e) {
  const n = Ne(t), r = f.useRef(0);
  return f.useEffect(() => () => window.clearTimeout(r.current), []), f.useCallback(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, e);
  }, [n, e]);
}
function sr(t, e) {
  const n = Ne(e);
  ke(() => {
    let r = 0;
    if (t) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return o.observe(t), () => {
        window.cancelAnimationFrame(r), o.unobserve(t);
      };
    }
  }, [t, n]);
}
var yT = Rm, bT = Pm, Zd = km, Jd = Nm, wT = Om;
const xT = ae({
  slots: {
    root: "flex flex-1 scroll-area-root preflight w-full overflow-hidden [&:has([data-state=visible])_.scroll-area-viewport]:pr-3.5",
    scrollAreaViewport: "scroll-area-viewport w-full [&>div]:block",
    scrollbar: [
      "scrollbar flex select-none touch-none bg-clr-primary/10 transition-colors duration-150 ease-out",
      "hover:bg-clr-on-bg-low",
      "data-[orientation=vertical]:w-1 data-[orientation=horizontal]:flex-col data-[orientation=horizontal]:h-1"
    ],
    thumb: [
      "scrollbar-thumb flex-1 bg-clr-primary relative before:content-[''] before:absolute before:top-1/2",
      "before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:w-full before:h-full",
      "before:min-w-11 before:min-h-11"
    ],
    corner: "scroll-area-corner bg-clr-on-primary-low"
  },
  variants: { disabled: { true: { scrollAreaViewport: "overflow-hidden", scrollbar: "hidden" } } }
}), zs = Yt(
  ({ children: t, classes: e, verticalOnly: n = !1, disabled: r = !1 }, o) => {
    const { root: s, scrollAreaViewport: i, scrollbar: a, thumb: l, corner: c } = xT({ disabled: r });
    return /* @__PURE__ */ G(yT, { className: s(), type: "auto", ref: o, children: [
      /* @__PURE__ */ g(bT, { className: i({ class: e }), children: t }),
      /* @__PURE__ */ g(Zd, { className: a(), children: /* @__PURE__ */ g(Jd, { className: l() }) }),
      !n && /* @__PURE__ */ g(Zd, { className: a(), orientation: "horizontal", children: /* @__PURE__ */ g(Jd, { className: l() }) }),
      /* @__PURE__ */ g(wT, { className: c() })
    ] });
  }
), CT = ae({
  slots: {
    root: "preflight",
    container: "shadow-none rounded-none bg-clr-bg-modal",
    content: "select-auto",
    header: "[&>div]:h-[48px] [&>div]:items-start [&>div]:box-border [&>div]:pt-[16px] [&_span]:bg-clr-on-bg-mid",
    backdrop: Ns()
  },
  variants: {
    backdropShown: {
      true: {
        root: "pointer-events-auto block",
        backdrop: "block"
      },
      false: {
        backdrop: "hidden"
      }
    },
    nonClosable: { true: { root: "[&_.react-modal-sheet-drag-indicator]:hidden" } }
  }
}), ET = Yt(
  ({
    children: t,
    isOpen: e,
    modeless: n = !1,
    onClose: r,
    initialSnap: o,
    snapPoints: s,
    autoClose: i = !1,
    disableScrollbar: a = !1,
    onSnap: l = () => null,
    zIndex: c = 2
  }, u) => {
    const p = Tl("s", "m") && e, h = p && !n, v = !s && n && !r, m = s ? "full-height" : "content-height", { root: y, container: b, header: w, content: x, backdrop: E } = CT({ backdropShown: h, nonClosable: v }), C = i && e && setTimeout(() => r && r(), typeof i == "number" ? i : 5e3), A = () => {
      C && clearTimeout(C), r && r();
    };
    return ie(() => {
      e ? document.dispatchEvent(new Event("app:overlayOpened")) : document.dispatchEvent(new Event("app:overlayClosed"));
    }, [e]), /* @__PURE__ */ G(
      Pr,
      {
        isOpen: p,
        onClose: A,
        className: y(),
        snapPoints: s,
        detent: m,
        initialSnap: o,
        onSnap: (S) => e && l(S),
        disableDrag: v,
        disableScrollLocking: n,
        children: [
          /* @__PURE__ */ G(Pr.Container, { className: b(), ref: u, style: { zIndex: c }, children: [
            /* @__PURE__ */ g(Pr.Header, { className: w() }),
            /* @__PURE__ */ g(Pr.Content, { className: x(), disableDrag: !0, children: /* @__PURE__ */ g(zs, { disabled: a, children: t }) })
          ] }),
          /* @__PURE__ */ g(Pr.Backdrop, { onTap: A, className: E(), style: { zIndex: c - 1 } })
        ]
      }
    );
  }
), ST = ae({
  base: "preflight flex flex-col gap-1 text-clr-on-bg-high",
  slots: {
    link: "flex items-center gap-1 group focus:outline-none",
    icon: "w-7 h-7 fill-clr-on-bg-high",
    previousPageContainer: "border border-transparent group-focus:border-clr-primary rounded-sm",
    previousPage: [
      "typography-body1 pt-0.5 mx-0.5 border-b-2 border-transparent",
      "group-hover:border-clr-primary group-focus:group-hover:border-transparent"
    ],
    header: "flex gap-x-2 items-baseline flex-wrap",
    iconWrapper: "min-w-7 min-h-7"
  }
}), $N = ({ currentPageTitle: t, previousPageTitle: e, previousPageUrl: n, hideHeader: r = !1, numberOfItemsText: o = "" }) => {
  const { base: s, icon: i, previousPage: a, previousPageContainer: l, link: c, header: u, iconWrapper: d } = ST();
  return /* @__PURE__ */ G("div", { className: s(), children: [
    /* @__PURE__ */ G("a", { href: n, className: c(), children: [
      /* @__PURE__ */ g("span", { className: d(), children: /* @__PURE__ */ g(ge, { variant: "back", className: i() }) }),
      /* @__PURE__ */ g("span", { className: l(), children: /* @__PURE__ */ g("span", { className: a(), children: e }) })
    ] }),
    r ? null : /* @__PURE__ */ G("div", { className: u(), children: [
      /* @__PURE__ */ g(er, { variant: "bonprix-h3", children: t }),
      /* @__PURE__ */ g(er, { color: "on-bg-low", children: o })
    ] })
  ] });
};
function AT(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function TT(t, e, n) {
  return e && AT(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var Qd = "(prefers-reduced-motion: reduce)", Gn = 1, RT = 2, ir = 3, gr = 4, yo = 5, Jo = 6, ms = 7, _T = {
  CREATED: Gn,
  MOUNTED: RT,
  IDLE: ir,
  MOVING: gr,
  SCROLLING: yo,
  DRAGGING: Jo,
  DESTROYED: ms
};
function jt(t) {
  t.length = 0;
}
function dn(t, e, n) {
  return Array.prototype.slice.call(t, e, n);
}
function ve(t) {
  return t.bind.apply(t, [null].concat(dn(arguments, 1)));
}
var Bm = setTimeout, Ua = function() {
};
function ef(t) {
  return requestAnimationFrame(t);
}
function Gs(t, e) {
  return typeof e === t;
}
function Qr(t) {
  return !bc(t) && Gs("object", t);
}
var yc = Array.isArray, $m = ve(Gs, "function"), rn = ve(Gs, "string"), bo = ve(Gs, "undefined");
function bc(t) {
  return t === null;
}
function Wm(t) {
  try {
    return t instanceof (t.ownerDocument.defaultView || window).HTMLElement;
  } catch {
    return !1;
  }
}
function wo(t) {
  return yc(t) ? t : [t];
}
function nt(t, e) {
  wo(t).forEach(e);
}
function wc(t, e) {
  return t.indexOf(e) > -1;
}
function Qo(t, e) {
  return t.push.apply(t, wo(e)), t;
}
function Nt(t, e, n) {
  t && nt(e, function(r) {
    r && t.classList[n ? "add" : "remove"](r);
  });
}
function xt(t, e) {
  Nt(t, rn(e) ? e.split(" ") : e, !0);
}
function xo(t, e) {
  nt(e, t.appendChild.bind(t));
}
function xc(t, e) {
  nt(t, function(n) {
    var r = (e || n).parentNode;
    r && r.insertBefore(n, e);
  });
}
function eo(t, e) {
  return Wm(t) && (t.msMatchesSelector || t.matches).call(t, e);
}
function jm(t, e) {
  var n = t ? dn(t.children) : [];
  return e ? n.filter(function(r) {
    return eo(r, e);
  }) : n;
}
function Co(t, e) {
  return e ? jm(t, e)[0] : t.firstElementChild;
}
var to = Object.keys;
function An(t, e, n) {
  return t && (n ? to(t).reverse() : to(t)).forEach(function(r) {
    r !== "__proto__" && e(t[r], r);
  }), t;
}
function no(t) {
  return dn(arguments, 1).forEach(function(e) {
    An(e, function(n, r) {
      t[r] = e[r];
    });
  }), t;
}
function Qt(t) {
  return dn(arguments, 1).forEach(function(e) {
    An(e, function(n, r) {
      yc(n) ? t[r] = n.slice() : Qr(n) ? t[r] = Qt({}, Qr(t[r]) ? t[r] : {}, n) : t[r] = n;
    });
  }), t;
}
function tf(t, e) {
  nt(e || to(t), function(n) {
    delete t[n];
  });
}
function Ct(t, e) {
  nt(t, function(n) {
    nt(e, function(r) {
      n && n.removeAttribute(r);
    });
  });
}
function ue(t, e, n) {
  Qr(e) ? An(e, function(r, o) {
    ue(t, o, r);
  }) : nt(t, function(r) {
    bc(n) || n === "" ? Ct(r, e) : r.setAttribute(e, String(n));
  });
}
function Yn(t, e, n) {
  var r = document.createElement(t);
  return e && (rn(e) ? xt(r, e) : ue(r, e)), n && xo(n, r), r;
}
function at(t, e, n) {
  if (bo(n))
    return getComputedStyle(t)[e];
  bc(n) || (t.style[e] = "" + n);
}
function ro(t, e) {
  at(t, "display", e);
}
function Um(t) {
  t.setActive && t.setActive() || t.focus({
    preventScroll: !0
  });
}
function lt(t, e) {
  return t.getAttribute(e);
}
function nf(t, e) {
  return t && t.classList.contains(e);
}
function Xe(t) {
  return t.getBoundingClientRect();
}
function _n(t) {
  nt(t, function(e) {
    e && e.parentNode && e.parentNode.removeChild(e);
  });
}
function Hm(t) {
  return Co(new DOMParser().parseFromString(t, "text/html").body);
}
function kt(t, e) {
  t.preventDefault(), e && (t.stopPropagation(), t.stopImmediatePropagation());
}
function zm(t, e) {
  return t && t.querySelector(e);
}
function Cc(t, e) {
  return e ? dn(t.querySelectorAll(e)) : [];
}
function Ot(t, e) {
  Nt(t, e, !1);
}
function Ha(t) {
  return t.timeStamp;
}
function yn(t) {
  return rn(t) ? t : t ? t + "px" : "";
}
var Eo = "splide", Ec = "data-" + Eo;
function Wr(t, e) {
  if (!t)
    throw new Error("[" + Eo + "] " + (e || ""));
}
var on = Math.min, gs = Math.max, vs = Math.floor, oo = Math.ceil, We = Math.abs;
function Gm(t, e, n) {
  return We(t - e) < n;
}
function es(t, e, n, r) {
  var o = on(e, n), s = gs(e, n);
  return r ? o < t && t < s : o <= t && t <= s;
}
function Ln(t, e, n) {
  var r = on(e, n), o = gs(e, n);
  return on(gs(r, t), o);
}
function za(t) {
  return +(t > 0) - +(t < 0);
}
function Ga(t, e) {
  return nt(e, function(n) {
    t = t.replace("%s", "" + n);
  }), t;
}
function Sc(t) {
  return t < 10 ? "0" + t : "" + t;
}
var rf = {};
function PT(t) {
  return "" + t + Sc(rf[t] = (rf[t] || 0) + 1);
}
function Km() {
  var t = [];
  function e(i, a, l, c) {
    o(i, a, function(u, d, p) {
      var h = "addEventListener" in u, v = h ? u.removeEventListener.bind(u, d, l, c) : u.removeListener.bind(u, l);
      h ? u.addEventListener(d, l, c) : u.addListener(l), t.push([u, d, p, l, v]);
    });
  }
  function n(i, a, l) {
    o(i, a, function(c, u, d) {
      t = t.filter(function(p) {
        return p[0] === c && p[1] === u && p[2] === d && (!l || p[3] === l) ? (p[4](), !1) : !0;
      });
    });
  }
  function r(i, a, l) {
    var c, u = !0;
    return typeof CustomEvent == "function" ? c = new CustomEvent(a, {
      bubbles: u,
      detail: l
    }) : (c = document.createEvent("CustomEvent"), c.initCustomEvent(a, u, !1, l)), i.dispatchEvent(c), c;
  }
  function o(i, a, l) {
    nt(i, function(c) {
      c && nt(a, function(u) {
        u.split(" ").forEach(function(d) {
          var p = d.split(".");
          l(c, p[0], p[1]);
        });
      });
    });
  }
  function s() {
    t.forEach(function(i) {
      i[4]();
    }), jt(t);
  }
  return {
    bind: e,
    unbind: n,
    dispatch: r,
    destroy: s
  };
}
var fn = "mounted", Ka = "ready", Ut = "move", vr = "moved", Ac = "click", Ym = "active", qm = "inactive", Xm = "visible", Zm = "hidden", Te = "refresh", Le = "updated", ar = "resize", Ks = "resized", Jm = "drag", Qm = "dragging", eg = "dragged", Ys = "scroll", Nn = "scrolled", kT = "overflow", Tc = "destroy", tg = "arrows:mounted", ng = "arrows:updated", rg = "pagination:mounted", og = "pagination:updated", Rc = "navigation:mounted", _c = "autoplay:play", sg = "autoplay:playing", Pc = "autoplay:pause", kc = "lazyload:loaded", ig = "sk", ag = "sh", ys = "ei";
function Ce(t) {
  var e = t ? t.event.bus : document.createDocumentFragment(), n = Km();
  function r(s, i) {
    n.bind(e, wo(s).join(" "), function(a) {
      i.apply(i, yc(a.detail) ? a.detail : []);
    });
  }
  function o(s) {
    n.dispatch(e, s, dn(arguments, 1));
  }
  return t && t.event.on(Tc, n.destroy), no(n, {
    bus: e,
    on: r,
    off: ve(n.unbind, e),
    emit: o
  });
}
function qs(t, e, n, r) {
  var o = Date.now, s, i = 0, a, l = !0, c = 0;
  function u() {
    if (!l) {
      if (i = t ? on((o() - s) / t, 1) : 1, n && n(i), i >= 1 && (e(), s = o(), r && ++c >= r))
        return p();
      a = ef(u);
    }
  }
  function d(b) {
    b || v(), s = o() - (b ? i * t : 0), l = !1, a = ef(u);
  }
  function p() {
    l = !0;
  }
  function h() {
    s = o(), i = 0, n && n(i);
  }
  function v() {
    a && cancelAnimationFrame(a), i = 0, a = 0, l = !0;
  }
  function m(b) {
    t = b;
  }
  function y() {
    return l;
  }
  return {
    start: d,
    rewind: h,
    pause: p,
    cancel: v,
    set: m,
    isPaused: y
  };
}
function IT(t) {
  var e = t;
  function n(o) {
    e = o;
  }
  function r(o) {
    return wc(wo(o), e);
  }
  return {
    set: n,
    is: r
  };
}
function DT(t, e) {
  var n = qs(0, t, null, 1);
  return function() {
    n.isPaused() && n.start();
  };
}
function MT(t, e, n) {
  var r = t.state, o = n.breakpoints || {}, s = n.reducedMotion || {}, i = Km(), a = [];
  function l() {
    var v = n.mediaQuery === "min";
    to(o).sort(function(m, y) {
      return v ? +m - +y : +y - +m;
    }).forEach(function(m) {
      u(o[m], "(" + (v ? "min" : "max") + "-width:" + m + "px)");
    }), u(s, Qd), d();
  }
  function c(v) {
    v && i.destroy();
  }
  function u(v, m) {
    var y = matchMedia(m);
    i.bind(y, "change", d), a.push([v, y]);
  }
  function d() {
    var v = r.is(ms), m = n.direction, y = a.reduce(function(b, w) {
      return Qt(b, w[1].matches ? w[0] : {});
    }, {});
    tf(n), h(y), n.destroy ? t.destroy(n.destroy === "completely") : v ? (c(!0), t.mount()) : m !== n.direction && t.refresh();
  }
  function p(v) {
    matchMedia(Qd).matches && (v ? Qt(n, s) : tf(n, to(s)));
  }
  function h(v, m, y) {
    Qt(n, v), m && Qt(Object.getPrototypeOf(n), v), (y || !r.is(Gn)) && t.emit(Le, n);
  }
  return {
    setup: l,
    destroy: c,
    reduce: p,
    set: h
  };
}
var Xs = "Arrow", Zs = Xs + "Left", Js = Xs + "Right", lg = Xs + "Up", cg = Xs + "Down", of = "rtl", Qs = "ttb", Gi = {
  width: ["height"],
  left: ["top", "right"],
  right: ["bottom", "left"],
  x: ["y"],
  X: ["Y"],
  Y: ["X"],
  ArrowLeft: [lg, Js],
  ArrowRight: [cg, Zs]
};
function NT(t, e, n) {
  function r(s, i, a) {
    a = a || n.direction;
    var l = a === of && !i ? 1 : a === Qs ? 0 : -1;
    return Gi[s] && Gi[s][l] || s.replace(/width|left|right/i, function(c, u) {
      var d = Gi[c.toLowerCase()][l] || c;
      return u > 0 ? d.charAt(0).toUpperCase() + d.slice(1) : d;
    });
  }
  function o(s) {
    return s * (n.direction === of ? 1 : -1);
  }
  return {
    resolve: r,
    orient: o
  };
}
var Ft = "role", qn = "tabindex", OT = "disabled", ht = "aria-", So = ht + "controls", ug = ht + "current", sf = ht + "selected", Ze = ht + "label", Ic = ht + "labelledby", dg = ht + "hidden", Dc = ht + "orientation", so = ht + "roledescription", af = ht + "live", lf = ht + "busy", cf = ht + "atomic", Mc = [Ft, qn, OT, So, ug, Ze, Ic, dg, Dc, so], At = Eo + "__", pn = "is-", Ki = Eo, uf = At + "track", VT = At + "list", ei = At + "slide", fg = ei + "--clone", FT = ei + "__container", Nc = At + "arrows", ti = At + "arrow", pg = ti + "--prev", hg = ti + "--next", ni = At + "pagination", mg = ni + "__page", LT = At + "progress", BT = LT + "__bar", $T = At + "toggle", WT = At + "spinner", jT = At + "sr", UT = pn + "initialized", Pn = pn + "active", gg = pn + "prev", vg = pn + "next", Ya = pn + "visible", qa = pn + "loading", yg = pn + "focus-in", bg = pn + "overflow", HT = [Pn, Ya, gg, vg, qa, yg, bg], zT = {
  slide: ei,
  clone: fg,
  arrows: Nc,
  arrow: ti,
  prev: pg,
  next: hg,
  pagination: ni,
  page: mg,
  spinner: WT
};
function GT(t, e) {
  if ($m(t.closest))
    return t.closest(e);
  for (var n = t; n && n.nodeType === 1 && !eo(n, e); )
    n = n.parentElement;
  return n;
}
var KT = 5, df = 200, wg = "touchstart mousedown", Yi = "touchmove mousemove", qi = "touchend touchcancel mouseup click";
function YT(t, e, n) {
  var r = Ce(t), o = r.on, s = r.bind, i = t.root, a = n.i18n, l = {}, c = [], u = [], d = [], p, h, v;
  function m() {
    x(), E(), w();
  }
  function y() {
    o(Te, b), o(Te, m), o(Le, w), s(document, wg + " keydown", function(S) {
      v = S.type === "keydown";
    }, {
      capture: !0
    }), s(i, "focusin", function() {
      Nt(i, yg, !!v);
    });
  }
  function b(S) {
    var R = Mc.concat("style");
    jt(c), Ot(i, u), Ot(p, d), Ct([p, h], R), Ct(i, S ? R : ["style", so]);
  }
  function w() {
    Ot(i, u), Ot(p, d), u = A(Ki), d = A(uf), xt(i, u), xt(p, d), ue(i, Ze, n.label), ue(i, Ic, n.labelledby);
  }
  function x() {
    p = C("." + uf), h = Co(p, "." + VT), Wr(p && h, "A track/list element is missing."), Qo(c, jm(h, "." + ei + ":not(." + fg + ")")), An({
      arrows: Nc,
      pagination: ni,
      prev: pg,
      next: hg,
      bar: BT,
      toggle: $T
    }, function(S, R) {
      l[R] = C("." + S);
    }), no(l, {
      root: i,
      track: p,
      list: h,
      slides: c
    });
  }
  function E() {
    var S = i.id || PT(Eo), R = n.role;
    i.id = S, p.id = p.id || S + "-track", h.id = h.id || S + "-list", !lt(i, Ft) && i.tagName !== "SECTION" && R && ue(i, Ft, R), ue(i, so, a.carousel), ue(h, Ft, "presentation");
  }
  function C(S) {
    var R = zm(i, S);
    return R && GT(R, "." + Ki) === i ? R : void 0;
  }
  function A(S) {
    return [S + "--" + n.type, S + "--" + n.direction, n.drag && S + "--draggable", n.isNavigation && S + "--nav", S === Ki && Pn];
  }
  return no(l, {
    setup: m,
    mount: y,
    destroy: b
  });
}
var lr = "slide", yr = "loop", Ao = "fade";
function qT(t, e, n, r) {
  var o = Ce(t), s = o.on, i = o.emit, a = o.bind, l = t.Components, c = t.root, u = t.options, d = u.isNavigation, p = u.updateOnMove, h = u.i18n, v = u.pagination, m = u.slideFocus, y = l.Direction.resolve, b = lt(r, "style"), w = lt(r, Ze), x = n > -1, E = Co(r, "." + FT), C;
  function A() {
    x || (r.id = c.id + "-slide" + Sc(e + 1), ue(r, Ft, v ? "tabpanel" : "group"), ue(r, so, h.slide), ue(r, Ze, w || Ga(h.slideLabel, [e + 1, t.length]))), S();
  }
  function S() {
    a(r, "click", ve(i, Ac, V)), a(r, "keydown", ve(i, ig, V)), s([vr, ag, Nn], I), s(Rc, P), p && s(Ut, k);
  }
  function R() {
    C = !0, o.destroy(), Ot(r, HT), Ct(r, Mc), ue(r, "style", b), ue(r, Ze, w || "");
  }
  function P() {
    var $ = t.splides.map(function(T) {
      var M = T.splide.Components.Slides.getAt(e);
      return M ? M.slide.id : "";
    }).join(" ");
    ue(r, Ze, Ga(h.slideX, (x ? n : e) + 1)), ue(r, So, $), ue(r, Ft, m ? "button" : ""), m && Ct(r, so);
  }
  function k() {
    C || I();
  }
  function I() {
    if (!C) {
      var $ = t.index;
      _(), D(), Nt(r, gg, e === $ - 1), Nt(r, vg, e === $ + 1);
    }
  }
  function _() {
    var $ = W();
    $ !== nf(r, Pn) && (Nt(r, Pn, $), ue(r, ug, d && $ || ""), i($ ? Ym : qm, V));
  }
  function D() {
    var $ = L(), T = !$ && (!W() || x);
    if (t.state.is([gr, yo]) || ue(r, dg, T || ""), ue(Cc(r, u.focusableNodes || ""), qn, T ? -1 : ""), m && ue(r, qn, T ? -1 : 0), $ !== nf(r, Ya) && (Nt(r, Ya, $), i($ ? Xm : Zm, V)), !$ && document.activeElement === r) {
      var M = l.Slides.getAt(t.index);
      M && Um(M.slide);
    }
  }
  function N($, T, M) {
    at(M && E || r, $, T);
  }
  function W() {
    var $ = t.index;
    return $ === e || u.cloneStatus && $ === n;
  }
  function L() {
    if (t.is(Ao))
      return W();
    var $ = Xe(l.Elements.track), T = Xe(r), M = y("left", !0), H = y("right", !0);
    return vs($[M]) <= oo(T[M]) && vs(T[H]) <= oo($[H]);
  }
  function B($, T) {
    var M = We($ - e);
    return !x && (u.rewind || t.is(yr)) && (M = on(M, t.length - M)), M <= T;
  }
  var V = {
    index: e,
    slideIndex: n,
    slide: r,
    container: E,
    isClone: x,
    mount: A,
    destroy: R,
    update: I,
    style: N,
    isWithin: B
  };
  return V;
}
function XT(t, e, n) {
  var r = Ce(t), o = r.on, s = r.emit, i = r.bind, a = e.Elements, l = a.slides, c = a.list, u = [];
  function d() {
    p(), o(Te, h), o(Te, p);
  }
  function p() {
    l.forEach(function(I, _) {
      m(I, _, -1);
    });
  }
  function h() {
    C(function(I) {
      I.destroy();
    }), jt(u);
  }
  function v() {
    C(function(I) {
      I.update();
    });
  }
  function m(I, _, D) {
    var N = qT(t, _, D, I);
    N.mount(), u.push(N), u.sort(function(W, L) {
      return W.index - L.index;
    });
  }
  function y(I) {
    return I ? A(function(_) {
      return !_.isClone;
    }) : u;
  }
  function b(I) {
    var _ = e.Controller, D = _.toIndex(I), N = _.hasFocus() ? 1 : n.perPage;
    return A(function(W) {
      return es(W.index, D, D + N - 1);
    });
  }
  function w(I) {
    return A(I)[0];
  }
  function x(I, _) {
    nt(I, function(D) {
      if (rn(D) && (D = Hm(D)), Wm(D)) {
        var N = l[_];
        N ? xc(D, N) : xo(c, D), xt(D, n.classes.slide), R(D, ve(s, ar));
      }
    }), s(Te);
  }
  function E(I) {
    _n(A(I).map(function(_) {
      return _.slide;
    })), s(Te);
  }
  function C(I, _) {
    y(_).forEach(I);
  }
  function A(I) {
    return u.filter($m(I) ? I : function(_) {
      return rn(I) ? eo(_.slide, I) : wc(wo(I), _.index);
    });
  }
  function S(I, _, D) {
    C(function(N) {
      N.style(I, _, D);
    });
  }
  function R(I, _) {
    var D = Cc(I, "img"), N = D.length;
    N ? D.forEach(function(W) {
      i(W, "load error", function() {
        --N || _();
      });
    }) : _();
  }
  function P(I) {
    return I ? l.length : u.length;
  }
  function k() {
    return u.length > n.perPage;
  }
  return {
    mount: d,
    destroy: h,
    update: v,
    register: m,
    get: y,
    getIn: b,
    getAt: w,
    add: x,
    remove: E,
    forEach: C,
    filter: A,
    style: S,
    getLength: P,
    isEnough: k
  };
}
function ZT(t, e, n) {
  var r = Ce(t), o = r.on, s = r.bind, i = r.emit, a = e.Slides, l = e.Direction.resolve, c = e.Elements, u = c.root, d = c.track, p = c.list, h = a.getAt, v = a.style, m, y, b;
  function w() {
    x(), s(window, "resize load", DT(ve(i, ar))), o([Le, Te], x), o(ar, E);
  }
  function x() {
    m = n.direction === Qs, at(u, "maxWidth", yn(n.width)), at(d, l("paddingLeft"), C(!1)), at(d, l("paddingRight"), C(!0)), E(!0);
  }
  function E(V) {
    var $ = Xe(u);
    (V || y.width !== $.width || y.height !== $.height) && (at(d, "height", A()), v(l("marginRight"), yn(n.gap)), v("width", R()), v("height", P(), !0), y = $, i(Ks), b !== (b = B()) && (Nt(u, bg, b), i(kT, b)));
  }
  function C(V) {
    var $ = n.padding, T = l(V ? "right" : "left");
    return $ && yn($[T] || (Qr($) ? 0 : $)) || "0px";
  }
  function A() {
    var V = "";
    return m && (V = S(), Wr(V, "height or heightRatio is missing."), V = "calc(" + V + " - " + C(!1) + " - " + C(!0) + ")"), V;
  }
  function S() {
    return yn(n.height || Xe(p).width * n.heightRatio);
  }
  function R() {
    return n.autoWidth ? null : yn(n.fixedWidth) || (m ? "" : k());
  }
  function P() {
    return yn(n.fixedHeight) || (m ? n.autoHeight ? null : k() : S());
  }
  function k() {
    var V = yn(n.gap);
    return "calc((100%" + (V && " + " + V) + ")/" + (n.perPage || 1) + (V && " - " + V) + ")";
  }
  function I() {
    return Xe(p)[l("width")];
  }
  function _(V, $) {
    var T = h(V || 0);
    return T ? Xe(T.slide)[l("width")] + ($ ? 0 : W()) : 0;
  }
  function D(V, $) {
    var T = h(V);
    if (T) {
      var M = Xe(T.slide)[l("right")], H = Xe(p)[l("left")];
      return We(M - H) + ($ ? 0 : W());
    }
    return 0;
  }
  function N(V) {
    return D(t.length - 1) - D(0) + _(0, V);
  }
  function W() {
    var V = h(0);
    return V && parseFloat(at(V.slide, l("marginRight"))) || 0;
  }
  function L(V) {
    return parseFloat(at(d, l("padding" + (V ? "Right" : "Left")))) || 0;
  }
  function B() {
    return t.is(Ao) || N(!0) > I();
  }
  return {
    mount: w,
    resize: E,
    listSize: I,
    slideSize: _,
    sliderSize: N,
    totalSize: D,
    getPadding: L,
    isOverflow: B
  };
}
var JT = 2;
function QT(t, e, n) {
  var r = Ce(t), o = r.on, s = e.Elements, i = e.Slides, a = e.Direction.resolve, l = [], c;
  function u() {
    o(Te, d), o([Le, ar], h), (c = y()) && (v(c), e.Layout.resize(!0));
  }
  function d() {
    p(), u();
  }
  function p() {
    _n(l), jt(l), r.destroy();
  }
  function h() {
    var b = y();
    c !== b && (c < b || !b) && r.emit(Te);
  }
  function v(b) {
    var w = i.get().slice(), x = w.length;
    if (x) {
      for (; w.length < b; )
        Qo(w, w);
      Qo(w.slice(-b), w.slice(0, b)).forEach(function(E, C) {
        var A = C < b, S = m(E.slide, C);
        A ? xc(S, w[0].slide) : xo(s.list, S), Qo(l, S), i.register(S, C - b + (A ? 0 : x), E.index);
      });
    }
  }
  function m(b, w) {
    var x = b.cloneNode(!0);
    return xt(x, n.classes.clone), x.id = t.root.id + "-clone" + Sc(w + 1), x;
  }
  function y() {
    var b = n.clones;
    if (!t.is(yr))
      b = 0;
    else if (bo(b)) {
      var w = n[a("fixedWidth")] && e.Layout.slideSize(0), x = w && oo(Xe(s.track)[a("width")] / w);
      b = x || n[a("autoWidth")] && t.length || n.perPage * JT;
    }
    return b;
  }
  return {
    mount: u,
    destroy: p
  };
}
function eR(t, e, n) {
  var r = Ce(t), o = r.on, s = r.emit, i = t.state.set, a = e.Layout, l = a.slideSize, c = a.getPadding, u = a.totalSize, d = a.listSize, p = a.sliderSize, h = e.Direction, v = h.resolve, m = h.orient, y = e.Elements, b = y.list, w = y.track, x;
  function E() {
    x = e.Transition, o([fn, Ks, Le, Te], C);
  }
  function C() {
    e.Controller.isBusy() || (e.Scroll.cancel(), S(t.index), e.Slides.update());
  }
  function A(T, M, H, Z) {
    T !== M && V(T > H) && (I(), R(k(N(), T > H), !0)), i(gr), s(Ut, M, H, T), x.start(M, function() {
      i(ir), s(vr, M, H, T), Z && Z();
    });
  }
  function S(T) {
    R(D(T, !0));
  }
  function R(T, M) {
    if (!t.is(Ao)) {
      var H = M ? T : P(T);
      at(b, "transform", "translate" + v("X") + "(" + H + "px)"), T !== H && s(ag);
    }
  }
  function P(T) {
    if (t.is(yr)) {
      var M = _(T), H = M > e.Controller.getEnd(), Z = M < 0;
      (Z || H) && (T = k(T, H));
    }
    return T;
  }
  function k(T, M) {
    var H = T - B(M), Z = p();
    return T -= m(Z * (oo(We(H) / Z) || 1)) * (M ? 1 : -1), T;
  }
  function I() {
    R(N(), !0), x.cancel();
  }
  function _(T) {
    for (var M = e.Slides.get(), H = 0, Z = 1 / 0, U = 0; U < M.length; U++) {
      var X = M[U].index, O = We(D(X, !0) - T);
      if (O <= Z)
        Z = O, H = X;
      else
        break;
    }
    return H;
  }
  function D(T, M) {
    var H = m(u(T - 1) - L(T));
    return M ? W(H) : H;
  }
  function N() {
    var T = v("left");
    return Xe(b)[T] - Xe(w)[T] + m(c(!1));
  }
  function W(T) {
    return n.trimSpace && t.is(lr) && (T = Ln(T, 0, m(p(!0) - d()))), T;
  }
  function L(T) {
    var M = n.focus;
    return M === "center" ? (d() - l(T, !0)) / 2 : +M * l(T) || 0;
  }
  function B(T) {
    return D(T ? e.Controller.getEnd() : 0, !!n.trimSpace);
  }
  function V(T) {
    var M = m(k(N(), T));
    return T ? M >= 0 : M <= b[v("scrollWidth")] - Xe(w)[v("width")];
  }
  function $(T, M) {
    M = bo(M) ? N() : M;
    var H = T !== !0 && m(M) < m(B(!1)), Z = T !== !1 && m(M) > m(B(!0));
    return H || Z;
  }
  return {
    mount: E,
    move: A,
    jump: S,
    translate: R,
    shift: k,
    cancel: I,
    toIndex: _,
    toPosition: D,
    getPosition: N,
    getLimit: B,
    exceededLimit: $,
    reposition: C
  };
}
function tR(t, e, n) {
  var r = Ce(t), o = r.on, s = r.emit, i = e.Move, a = i.getPosition, l = i.getLimit, c = i.toPosition, u = e.Slides, d = u.isEnough, p = u.getLength, h = n.omitEnd, v = t.is(yr), m = t.is(lr), y = ve(N, !1), b = ve(N, !0), w = n.start || 0, x, E = w, C, A, S;
  function R() {
    P(), o([Le, Te, ys], P), o(Ks, k);
  }
  function P() {
    C = p(!0), A = n.perMove, S = n.perPage, x = V();
    var O = Ln(w, 0, h ? x : C - 1);
    O !== w && (w = O, i.reposition());
  }
  function k() {
    x !== V() && s(ys);
  }
  function I(O, F, z) {
    if (!X()) {
      var q = D(O), Y = B(q);
      Y > -1 && (F || Y !== w) && (H(Y), i.move(q, Y, E, z));
    }
  }
  function _(O, F, z, q) {
    e.Scroll.scroll(O, F, z, function() {
      var Y = B(i.toIndex(a()));
      H(h ? on(Y, x) : Y), q && q();
    });
  }
  function D(O) {
    var F = w;
    if (rn(O)) {
      var z = O.match(/([+\-<>])(\d+)?/) || [], q = z[1], Y = z[2];
      q === "+" || q === "-" ? F = W(w + +("" + q + (+Y || 1)), w) : q === ">" ? F = Y ? $(+Y) : y(!0) : q === "<" && (F = b(!0));
    } else
      F = v ? O : Ln(O, 0, x);
    return F;
  }
  function N(O, F) {
    var z = A || (U() ? 1 : S), q = W(w + z * (O ? -1 : 1), w, !(A || U()));
    return q === -1 && m && !Gm(a(), l(!O), 1) ? O ? 0 : x : F ? q : B(q);
  }
  function W(O, F, z) {
    if (d() || U()) {
      var q = L(O);
      q !== O && (F = O, O = q, z = !1), O < 0 || O > x ? !A && (es(0, O, F, !0) || es(x, F, O, !0)) ? O = $(T(O)) : v ? O = z ? O < 0 ? -(C % S || S) : C : O : n.rewind ? O = O < 0 ? x : 0 : O = -1 : z && O !== F && (O = $(T(F) + (O < F ? -1 : 1)));
    } else
      O = -1;
    return O;
  }
  function L(O) {
    if (m && n.trimSpace === "move" && O !== w)
      for (var F = a(); F === c(O, !0) && es(O, 0, t.length - 1, !n.rewind); )
        O < w ? --O : ++O;
    return O;
  }
  function B(O) {
    return v ? (O + C) % C || 0 : O;
  }
  function V() {
    for (var O = C - (U() || v && A ? 1 : S); h && O-- > 0; )
      if (c(C - 1, !0) !== c(O, !0)) {
        O++;
        break;
      }
    return Ln(O, 0, C - 1);
  }
  function $(O) {
    return Ln(U() ? O : S * O, 0, x);
  }
  function T(O) {
    return U() ? on(O, x) : vs((O >= x ? C - 1 : O) / S);
  }
  function M(O) {
    var F = i.toIndex(O);
    return m ? Ln(F, 0, x) : F;
  }
  function H(O) {
    O !== w && (E = w, w = O);
  }
  function Z(O) {
    return O ? E : w;
  }
  function U() {
    return !bo(n.focus) || n.isNavigation;
  }
  function X() {
    return t.state.is([gr, yo]) && !!n.waitForTransition;
  }
  return {
    mount: R,
    go: I,
    scroll: _,
    getNext: y,
    getPrev: b,
    getAdjacent: N,
    getEnd: V,
    setIndex: H,
    getIndex: Z,
    toIndex: $,
    toPage: T,
    toDest: M,
    hasFocus: U,
    isBusy: X
  };
}
var nR = "http://www.w3.org/2000/svg", rR = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z", $o = 40;
function oR(t, e, n) {
  var r = Ce(t), o = r.on, s = r.bind, i = r.emit, a = n.classes, l = n.i18n, c = e.Elements, u = e.Controller, d = c.arrows, p = c.track, h = d, v = c.prev, m = c.next, y, b, w = {};
  function x() {
    C(), o(Le, E);
  }
  function E() {
    A(), x();
  }
  function C() {
    var _ = n.arrows;
    _ && !(v && m) && P(), v && m && (no(w, {
      prev: v,
      next: m
    }), ro(h, _ ? "" : "none"), xt(h, b = Nc + "--" + n.direction), _ && (S(), I(), ue([v, m], So, p.id), i(tg, v, m)));
  }
  function A() {
    r.destroy(), Ot(h, b), y ? (_n(d ? [v, m] : h), v = m = null) : Ct([v, m], Mc);
  }
  function S() {
    o([fn, vr, Te, Nn, ys], I), s(m, "click", ve(R, ">")), s(v, "click", ve(R, "<"));
  }
  function R(_) {
    u.go(_, !0);
  }
  function P() {
    h = d || Yn("div", a.arrows), v = k(!0), m = k(!1), y = !0, xo(h, [v, m]), !d && xc(h, p);
  }
  function k(_) {
    var D = '<button class="' + a.arrow + " " + (_ ? a.prev : a.next) + '" type="button"><svg xmlns="' + nR + '" viewBox="0 0 ' + $o + " " + $o + '" width="' + $o + '" height="' + $o + '" focusable="false"><path d="' + (n.arrowPath || rR) + '" />';
    return Hm(D);
  }
  function I() {
    if (v && m) {
      var _ = t.index, D = u.getPrev(), N = u.getNext(), W = D > -1 && _ < D ? l.last : l.prev, L = N > -1 && _ > N ? l.first : l.next;
      v.disabled = D < 0, m.disabled = N < 0, ue(v, Ze, W), ue(m, Ze, L), i(ng, v, m, D, N);
    }
  }
  return {
    arrows: w,
    mount: x,
    destroy: A,
    update: I
  };
}
var sR = Ec + "-interval";
function iR(t, e, n) {
  var r = Ce(t), o = r.on, s = r.bind, i = r.emit, a = qs(n.interval, t.go.bind(t, ">"), S), l = a.isPaused, c = e.Elements, u = e.Elements, d = u.root, p = u.toggle, h = n.autoplay, v, m, y = h === "pause";
  function b() {
    h && (w(), p && ue(p, So, c.track.id), y || x(), A());
  }
  function w() {
    n.pauseOnHover && s(d, "mouseenter mouseleave", function(P) {
      v = P.type === "mouseenter", C();
    }), n.pauseOnFocus && s(d, "focusin focusout", function(P) {
      m = P.type === "focusin", C();
    }), p && s(p, "click", function() {
      y ? x() : E(!0);
    }), o([Ut, Ys, Te], a.rewind), o(Ut, R);
  }
  function x() {
    l() && e.Slides.isEnough() && (a.start(!n.resetProgress), m = v = y = !1, A(), i(_c));
  }
  function E(P) {
    P === void 0 && (P = !0), y = !!P, A(), l() || (a.pause(), i(Pc));
  }
  function C() {
    y || (v || m ? E(!1) : x());
  }
  function A() {
    p && (Nt(p, Pn, !y), ue(p, Ze, n.i18n[y ? "play" : "pause"]));
  }
  function S(P) {
    var k = c.bar;
    k && at(k, "width", P * 100 + "%"), i(sg, P);
  }
  function R(P) {
    var k = e.Slides.getAt(P);
    a.set(k && +lt(k.slide, sR) || n.interval);
  }
  return {
    mount: b,
    destroy: a.cancel,
    play: x,
    pause: E,
    isPaused: l
  };
}
function aR(t, e, n) {
  var r = Ce(t), o = r.on;
  function s() {
    n.cover && (o(kc, ve(a, !0)), o([fn, Le, Te], ve(i, !0)));
  }
  function i(l) {
    e.Slides.forEach(function(c) {
      var u = Co(c.container || c.slide, "img");
      u && u.src && a(l, u, c);
    });
  }
  function a(l, c, u) {
    u.style("background", l ? 'center/cover no-repeat url("' + c.src + '")' : "", !0), ro(c, l ? "none" : "");
  }
  return {
    mount: s,
    destroy: ve(i, !1)
  };
}
var lR = 10, cR = 600, uR = 0.6, dR = 1.5, fR = 800;
function pR(t, e, n) {
  var r = Ce(t), o = r.on, s = r.emit, i = t.state.set, a = e.Move, l = a.getPosition, c = a.getLimit, u = a.exceededLimit, d = a.translate, p = t.is(lr), h, v, m = 1;
  function y() {
    o(Ut, E), o([Le, Te], C);
  }
  function b(S, R, P, k, I) {
    var _ = l();
    if (E(), P && (!p || !u())) {
      var D = e.Layout.sliderSize(), N = za(S) * D * vs(We(S) / D) || 0;
      S = a.toPosition(e.Controller.toDest(S % D)) + N;
    }
    var W = Gm(_, S, 1);
    m = 1, R = W ? 0 : R || gs(We(S - _) / dR, fR), v = k, h = qs(R, w, ve(x, _, S, I), 1), i(yo), s(Ys), h.start();
  }
  function w() {
    i(ir), v && v(), s(Nn);
  }
  function x(S, R, P, k) {
    var I = l(), _ = S + (R - S) * A(k), D = (_ - I) * m;
    d(I + D), p && !P && u() && (m *= uR, We(D) < lR && b(c(u(!0)), cR, !1, v, !0));
  }
  function E() {
    h && h.cancel();
  }
  function C() {
    h && !h.isPaused() && (E(), w());
  }
  function A(S) {
    var R = n.easingFunc;
    return R ? R(S) : 1 - Math.pow(1 - S, 4);
  }
  return {
    mount: y,
    destroy: E,
    scroll: b,
    cancel: C
  };
}
var Bn = {
  passive: !1,
  capture: !0
};
function hR(t, e, n) {
  var r = Ce(t), o = r.on, s = r.emit, i = r.bind, a = r.unbind, l = t.state, c = e.Move, u = e.Scroll, d = e.Controller, p = e.Elements.track, h = e.Media.reduce, v = e.Direction, m = v.resolve, y = v.orient, b = c.getPosition, w = c.exceededLimit, x, E, C, A, S, R = !1, P, k, I;
  function _() {
    i(p, Yi, Ua, Bn), i(p, qi, Ua, Bn), i(p, wg, N, Bn), i(p, "click", B, {
      capture: !0
    }), i(p, "dragstart", kt), o([fn, Le], D);
  }
  function D() {
    var K = n.drag;
    j(!K), A = K === "free";
  }
  function N(K) {
    if (P = !1, !k) {
      var le = Y(K);
      q(K.target) && (le || !K.button) && (d.isBusy() ? kt(K, !0) : (I = le ? p : window, S = l.is([gr, yo]), C = null, i(I, Yi, W, Bn), i(I, qi, L, Bn), c.cancel(), u.cancel(), V(K)));
    }
  }
  function W(K) {
    if (l.is(Jo) || (l.set(Jo), s(Jm)), K.cancelable)
      if (S) {
        c.translate(x + z(U(K)));
        var le = X(K) > df, De = R !== (R = w());
        (le || De) && V(K), P = !0, s(Qm), kt(K);
      } else M(K) && (S = T(K), kt(K));
  }
  function L(K) {
    l.is(Jo) && (l.set(ir), s(eg)), S && ($(K), kt(K)), a(I, Yi, W), a(I, qi, L), S = !1;
  }
  function B(K) {
    !k && P && kt(K, !0);
  }
  function V(K) {
    C = E, E = K, x = b();
  }
  function $(K) {
    var le = H(K), De = Z(le), ot = n.rewind && n.rewindByDrag;
    h(!1), A ? d.scroll(De, 0, n.snap) : t.is(Ao) ? d.go(y(za(le)) < 0 ? ot ? "<" : "-" : ot ? ">" : "+") : t.is(lr) && R && ot ? d.go(w(!0) ? ">" : "<") : d.go(d.toDest(De), !0), h(!0);
  }
  function T(K) {
    var le = n.dragMinThreshold, De = Qr(le), ot = De && le.mouse || 0, gn = (De ? le.touch : +le) || 10;
    return We(U(K)) > (Y(K) ? gn : ot);
  }
  function M(K) {
    return We(U(K)) > We(U(K, !0));
  }
  function H(K) {
    if (t.is(yr) || !R) {
      var le = X(K);
      if (le && le < df)
        return U(K) / le;
    }
    return 0;
  }
  function Z(K) {
    return b() + za(K) * on(We(K) * (n.flickPower || 600), A ? 1 / 0 : e.Layout.listSize() * (n.flickMaxPages || 1));
  }
  function U(K, le) {
    return F(K, le) - F(O(K), le);
  }
  function X(K) {
    return Ha(K) - Ha(O(K));
  }
  function O(K) {
    return E === K && C || E;
  }
  function F(K, le) {
    return (Y(K) ? K.changedTouches[0] : K)["page" + m(le ? "Y" : "X")];
  }
  function z(K) {
    return K / (R && t.is(lr) ? KT : 1);
  }
  function q(K) {
    var le = n.noDrag;
    return !eo(K, "." + mg + ", ." + ti) && (!le || !eo(K, le));
  }
  function Y(K) {
    return typeof TouchEvent < "u" && K instanceof TouchEvent;
  }
  function re() {
    return S;
  }
  function j(K) {
    k = K;
  }
  return {
    mount: _,
    disable: j,
    isDragging: re
  };
}
var mR = {
  Spacebar: " ",
  Right: Js,
  Left: Zs,
  Up: lg,
  Down: cg
};
function Oc(t) {
  return t = rn(t) ? t : t.key, mR[t] || t;
}
var ff = "keydown";
function gR(t, e, n) {
  var r = Ce(t), o = r.on, s = r.bind, i = r.unbind, a = t.root, l = e.Direction.resolve, c, u;
  function d() {
    p(), o(Le, h), o(Le, p), o(Ut, m);
  }
  function p() {
    var b = n.keyboard;
    b && (c = b === "global" ? window : a, s(c, ff, y));
  }
  function h() {
    i(c, ff);
  }
  function v(b) {
    u = b;
  }
  function m() {
    var b = u;
    u = !0, Bm(function() {
      u = b;
    });
  }
  function y(b) {
    if (!u) {
      var w = Oc(b);
      w === l(Zs) ? t.go("<") : w === l(Js) && t.go(">");
    }
  }
  return {
    mount: d,
    destroy: h,
    disable: v
  };
}
var jr = Ec + "-lazy", ts = jr + "-srcset", vR = "[" + jr + "], [" + ts + "]";
function yR(t, e, n) {
  var r = Ce(t), o = r.on, s = r.off, i = r.bind, a = r.emit, l = n.lazyLoad === "sequential", c = [vr, Nn], u = [];
  function d() {
    n.lazyLoad && (p(), o(Te, p));
  }
  function p() {
    jt(u), h(), l ? b() : (s(c), o(c, v), v());
  }
  function h() {
    e.Slides.forEach(function(w) {
      Cc(w.slide, vR).forEach(function(x) {
        var E = lt(x, jr), C = lt(x, ts);
        if (E !== x.src || C !== x.srcset) {
          var A = n.classes.spinner, S = x.parentElement, R = Co(S, "." + A) || Yn("span", A, S);
          u.push([x, w, R]), x.src || ro(x, "none");
        }
      });
    });
  }
  function v() {
    u = u.filter(function(w) {
      var x = n.perPage * ((n.preloadPages || 1) + 1) - 1;
      return w[1].isWithin(t.index, x) ? m(w) : !0;
    }), u.length || s(c);
  }
  function m(w) {
    var x = w[0];
    xt(w[1].slide, qa), i(x, "load error", ve(y, w)), ue(x, "src", lt(x, jr)), ue(x, "srcset", lt(x, ts)), Ct(x, jr), Ct(x, ts);
  }
  function y(w, x) {
    var E = w[0], C = w[1];
    Ot(C.slide, qa), x.type !== "error" && (_n(w[2]), ro(E, ""), a(kc, E, C), a(ar)), l && b();
  }
  function b() {
    u.length && m(u.shift());
  }
  return {
    mount: d,
    destroy: ve(jt, u),
    check: v
  };
}
function bR(t, e, n) {
  var r = Ce(t), o = r.on, s = r.emit, i = r.bind, a = e.Slides, l = e.Elements, c = e.Controller, u = c.hasFocus, d = c.getIndex, p = c.go, h = e.Direction.resolve, v = l.pagination, m = [], y, b;
  function w() {
    x(), o([Le, Te, ys], w);
    var k = n.pagination;
    v && ro(v, k ? "" : "none"), k && (o([Ut, Ys, Nn], P), E(), P(), s(rg, {
      list: y,
      items: m
    }, R(t.index)));
  }
  function x() {
    y && (_n(v ? dn(y.children) : y), Ot(y, b), jt(m), y = null), r.destroy();
  }
  function E() {
    var k = t.length, I = n.classes, _ = n.i18n, D = n.perPage, N = u() ? c.getEnd() + 1 : oo(k / D);
    y = v || Yn("ul", I.pagination, l.track.parentElement), xt(y, b = ni + "--" + S()), ue(y, Ft, "tablist"), ue(y, Ze, _.select), ue(y, Dc, S() === Qs ? "vertical" : "");
    for (var W = 0; W < N; W++) {
      var L = Yn("li", null, y), B = Yn("button", {
        class: I.page,
        type: "button"
      }, L), V = a.getIn(W).map(function(T) {
        return T.slide.id;
      }), $ = !u() && D > 1 ? _.pageX : _.slideX;
      i(B, "click", ve(C, W)), n.paginationKeyboard && i(B, "keydown", ve(A, W)), ue(L, Ft, "presentation"), ue(B, Ft, "tab"), ue(B, So, V.join(" ")), ue(B, Ze, Ga($, W + 1)), ue(B, qn, -1), m.push({
        li: L,
        button: B,
        page: W
      });
    }
  }
  function C(k) {
    p(">" + k, !0);
  }
  function A(k, I) {
    var _ = m.length, D = Oc(I), N = S(), W = -1;
    D === h(Js, !1, N) ? W = ++k % _ : D === h(Zs, !1, N) ? W = (--k + _) % _ : D === "Home" ? W = 0 : D === "End" && (W = _ - 1);
    var L = m[W];
    L && (Um(L.button), p(">" + W), kt(I, !0));
  }
  function S() {
    return n.paginationDirection || n.direction;
  }
  function R(k) {
    return m[c.toPage(k)];
  }
  function P() {
    var k = R(d(!0)), I = R(d());
    if (k) {
      var _ = k.button;
      Ot(_, Pn), Ct(_, sf), ue(_, qn, -1);
    }
    if (I) {
      var D = I.button;
      xt(D, Pn), ue(D, sf, !0), ue(D, qn, "");
    }
    s(og, {
      list: y,
      items: m
    }, k, I);
  }
  return {
    items: m,
    mount: w,
    destroy: x,
    getAt: R,
    update: P
  };
}
var wR = [" ", "Enter"];
function xR(t, e, n) {
  var r = n.isNavigation, o = n.slideFocus, s = [];
  function i() {
    t.splides.forEach(function(v) {
      v.isParent || (c(t, v.splide), c(v.splide, t));
    }), r && u();
  }
  function a() {
    s.forEach(function(v) {
      v.destroy();
    }), jt(s);
  }
  function l() {
    a(), i();
  }
  function c(v, m) {
    var y = Ce(v);
    y.on(Ut, function(b, w, x) {
      m.go(m.is(yr) ? x : b);
    }), s.push(y);
  }
  function u() {
    var v = Ce(t), m = v.on;
    m(Ac, p), m(ig, h), m([fn, Le], d), s.push(v), v.emit(Rc, t.splides);
  }
  function d() {
    ue(e.Elements.list, Dc, n.direction === Qs ? "vertical" : "");
  }
  function p(v) {
    t.go(v.index);
  }
  function h(v, m) {
    wc(wR, Oc(m)) && (p(v), kt(m));
  }
  return {
    setup: ve(e.Media.set, {
      slideFocus: bo(o) ? r : o
    }, !0),
    mount: i,
    destroy: a,
    remount: l
  };
}
function CR(t, e, n) {
  var r = Ce(t), o = r.bind, s = 0;
  function i() {
    n.wheel && o(e.Elements.track, "wheel", a, Bn);
  }
  function a(c) {
    if (c.cancelable) {
      var u = c.deltaY, d = u < 0, p = Ha(c), h = n.wheelMinThreshold || 0, v = n.wheelSleep || 0;
      We(u) > h && p - s > v && (t.go(d ? "<" : ">"), s = p), l(d) && kt(c);
    }
  }
  function l(c) {
    return !n.releaseWheel || t.state.is(gr) || e.Controller.getAdjacent(c) !== -1;
  }
  return {
    mount: i
  };
}
var ER = 90;
function SR(t, e, n) {
  var r = Ce(t), o = r.on, s = e.Elements.track, i = n.live && !n.isNavigation, a = Yn("span", jT), l = qs(ER, ve(u, !1));
  function c() {
    i && (p(!e.Autoplay.isPaused()), ue(s, cf, !0), a.textContent = "…", o(_c, ve(p, !0)), o(Pc, ve(p, !1)), o([vr, Nn], ve(u, !0)));
  }
  function u(h) {
    ue(s, lf, h), h ? (xo(s, a), l.start()) : (_n(a), l.cancel());
  }
  function d() {
    Ct(s, [af, cf, lf]), _n(a);
  }
  function p(h) {
    i && ue(s, af, h ? "off" : "polite");
  }
  return {
    mount: c,
    disable: p,
    destroy: d
  };
}
var AR = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Media: MT,
  Direction: NT,
  Elements: YT,
  Slides: XT,
  Layout: ZT,
  Clones: QT,
  Move: eR,
  Controller: tR,
  Arrows: oR,
  Autoplay: iR,
  Cover: aR,
  Scroll: pR,
  Drag: hR,
  Keyboard: gR,
  LazyLoad: yR,
  Pagination: bR,
  Sync: xR,
  Wheel: CR,
  Live: SR
}), TR = {
  prev: "Previous slide",
  next: "Next slide",
  first: "Go to first slide",
  last: "Go to last slide",
  slideX: "Go to slide %s",
  pageX: "Go to page %s",
  play: "Start autoplay",
  pause: "Pause autoplay",
  carousel: "carousel",
  slide: "slide",
  select: "Select a slide to show",
  slideLabel: "%s of %s"
}, RR = {
  type: "slide",
  role: "region",
  speed: 400,
  perPage: 1,
  cloneStatus: !0,
  arrows: !0,
  pagination: !0,
  paginationKeyboard: !0,
  interval: 5e3,
  pauseOnHover: !0,
  pauseOnFocus: !0,
  resetProgress: !0,
  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
  drag: !0,
  direction: "ltr",
  trimSpace: !0,
  focusableNodes: "a, button, textarea, input, select, iframe",
  live: !0,
  classes: zT,
  i18n: TR,
  reducedMotion: {
    speed: 0,
    rewindSpeed: 0,
    autoplay: "pause"
  }
};
function _R(t, e, n) {
  var r = e.Slides;
  function o() {
    Ce(t).on([fn, Te], s);
  }
  function s() {
    r.forEach(function(a) {
      a.style("transform", "translateX(-" + 100 * a.index + "%)");
    });
  }
  function i(a, l) {
    r.style("transition", "opacity " + n.speed + "ms " + n.easing), Bm(l);
  }
  return {
    mount: o,
    start: i,
    cancel: Ua
  };
}
function PR(t, e, n) {
  var r = e.Move, o = e.Controller, s = e.Scroll, i = e.Elements.list, a = ve(at, i, "transition"), l;
  function c() {
    Ce(t).bind(i, "transitionend", function(h) {
      h.target === i && l && (d(), l());
    });
  }
  function u(h, v) {
    var m = r.toPosition(h, !0), y = r.getPosition(), b = p(h);
    We(m - y) >= 1 && b >= 1 ? n.useScroll ? s.scroll(m, b, !1, v) : (a("transform " + b + "ms " + n.easing), r.translate(m, !0), l = v) : (r.jump(h), v());
  }
  function d() {
    a(""), s.cancel();
  }
  function p(h) {
    var v = n.rewindSpeed;
    if (t.is(lr) && v) {
      var m = o.getIndex(!0), y = o.getEnd();
      if (m === 0 && h >= y || m >= y && h === 0)
        return v;
    }
    return n.speed;
  }
  return {
    mount: c,
    start: u,
    cancel: d
  };
}
var kR = /* @__PURE__ */ function() {
  function t(n, r) {
    this.event = Ce(), this.Components = {}, this.state = IT(Gn), this.splides = [], this._o = {}, this._E = {};
    var o = rn(n) ? zm(document, n) : n;
    Wr(o, o + " is invalid."), this.root = o, r = Qt({
      label: lt(o, Ze) || "",
      labelledby: lt(o, Ic) || ""
    }, RR, t.defaults, r || {});
    try {
      Qt(r, JSON.parse(lt(o, Ec)));
    } catch {
      Wr(!1, "Invalid JSON");
    }
    this._o = Object.create(Qt({}, r));
  }
  var e = t.prototype;
  return e.mount = function(r, o) {
    var s = this, i = this.state, a = this.Components;
    Wr(i.is([Gn, ms]), "Already mounted!"), i.set(Gn), this._C = a, this._T = o || this._T || (this.is(Ao) ? _R : PR), this._E = r || this._E;
    var l = no({}, AR, this._E, {
      Transition: this._T
    });
    return An(l, function(c, u) {
      var d = c(s, a, s._o);
      a[u] = d, d.setup && d.setup();
    }), An(a, function(c) {
      c.mount && c.mount();
    }), this.emit(fn), xt(this.root, UT), i.set(ir), this.emit(Ka), this;
  }, e.sync = function(r) {
    return this.splides.push({
      splide: r
    }), r.splides.push({
      splide: this,
      isParent: !0
    }), this.state.is(ir) && (this._C.Sync.remount(), r.Components.Sync.remount()), this;
  }, e.go = function(r) {
    return this._C.Controller.go(r), this;
  }, e.on = function(r, o) {
    return this.event.on(r, o), this;
  }, e.off = function(r) {
    return this.event.off(r), this;
  }, e.emit = function(r) {
    var o;
    return (o = this.event).emit.apply(o, [r].concat(dn(arguments, 1))), this;
  }, e.add = function(r, o) {
    return this._C.Slides.add(r, o), this;
  }, e.remove = function(r) {
    return this._C.Slides.remove(r), this;
  }, e.is = function(r) {
    return this._o.type === r;
  }, e.refresh = function() {
    return this.emit(Te), this;
  }, e.destroy = function(r) {
    r === void 0 && (r = !0);
    var o = this.event, s = this.state;
    return s.is(Gn) ? Ce(this).on(Ka, this.destroy.bind(this, r)) : (An(this._C, function(i) {
      i.destroy && i.destroy(r);
    }, !0), o.emit(Tc), o.destroy(), r && jt(this.splides), s.set(ms)), this;
  }, TT(t, [{
    key: "options",
    get: function() {
      return this._o;
    },
    set: function(r) {
      this._C.Media.set(r, !0, !0);
    }
  }, {
    key: "length",
    get: function() {
      return this._C.Slides.getLength(!0);
    }
  }, {
    key: "index",
    get: function() {
      return this._C.Controller.getIndex();
    }
  }]), t;
}(), Vc = kR;
Vc.defaults = {};
Vc.STATES = _T;
var pf = [
  [fn, "onMounted"],
  [Ka, "onReady"],
  [Ut, "onMove"],
  [vr, "onMoved"],
  [Ac, "onClick"],
  [Ym, "onActive"],
  [qm, "onInactive"],
  [Xm, "onVisible"],
  [Zm, "onHidden"],
  [Te, "onRefresh"],
  [Le, "onUpdated"],
  [ar, "onResize"],
  [Ks, "onResized"],
  [Jm, "onDrag"],
  [Qm, "onDragging"],
  [eg, "onDragged"],
  [Ys, "onScroll"],
  [Nn, "onScrolled"],
  [Tc, "onDestroy"],
  [tg, "onArrowsMounted"],
  [ng, "onArrowsUpdated"],
  [rg, "onPaginationMounted"],
  [og, "onPaginationUpdated"],
  [Rc, "onNavigationMounted"],
  [_c, "onAutoplayPlay"],
  [sg, "onAutoplayPlaying"],
  [Pc, "onAutoplayPause"],
  [kc, "onLazyLoadLoaded"]
];
function Fc(...t) {
  return t.filter(Boolean).join(" ");
}
function bs(t) {
  return t !== null && typeof t == "object";
}
function Xa(t, e) {
  if (Array.isArray(t) && Array.isArray(e))
    return t.length === e.length && !t.some((n, r) => !Xa(n, e[r]));
  if (bs(t) && bs(e)) {
    const n = Object.keys(t), r = Object.keys(e);
    return n.length === r.length && !n.some((o) => !Object.prototype.hasOwnProperty.call(e, o) || !Xa(t[o], e[o]));
  }
  return t === e;
}
function IR(t, e) {
  return t.length === e.length && !t.some((n, r) => n !== e[r]);
}
function DR(t, e) {
  if (t) {
    const n = Object.keys(t);
    for (let r = 0; r < n.length; r++) {
      const o = n[r];
      if (o !== "__proto__" && e(t[o], o) === !1)
        break;
    }
  }
  return t;
}
function Za(t, e) {
  const n = t;
  return DR(e, (r, o) => {
    Array.isArray(r) ? n[o] = r.slice() : bs(r) ? n[o] = Za(bs(n[o]) ? n[o] : {}, r) : n[o] = r;
  }), n;
}
var xg = ({ children: t, className: e, ...n }) => /* @__PURE__ */ ne.createElement("div", {
  className: Fc("splide__track", e),
  ...n
}, /* @__PURE__ */ ne.createElement("ul", {
  className: "splide__list"
}, t)), MR = class extends ne.Component {
  constructor() {
    super(...arguments), this.splideRef = ne.createRef(), this.slides = [];
  }
  componentDidMount() {
    const { options: t, extensions: e, transition: n } = this.props, { current: r } = this.splideRef;
    r && (this.splide = new Vc(r, t), this.bind(this.splide), this.splide.mount(e, n), this.options = Za({}, t || {}), this.slides = this.getSlides());
  }
  componentWillUnmount() {
    this.splide && (this.splide.destroy(), this.splide = void 0), this.options = void 0, this.slides.length = 0;
  }
  componentDidUpdate() {
    if (!this.splide)
      return;
    const { options: t } = this.props;
    t && !Xa(this.options, t) && (this.splide.options = t, this.options = Za({}, t));
    const e = this.getSlides();
    IR(this.slides, e) || (this.splide.refresh(), this.slides = e);
  }
  sync(t) {
    var e;
    (e = this.splide) == null || e.sync(t);
  }
  go(t) {
    var e;
    (e = this.splide) == null || e.go(t);
  }
  getSlides() {
    var t;
    if (this.splide) {
      const e = (t = this.splide.Components.Elements) == null ? void 0 : t.list.children;
      return e && Array.prototype.slice.call(e) || [];
    }
    return [];
  }
  bind(t) {
    pf.forEach(([e, n]) => {
      const r = this.props[n];
      typeof r == "function" && t.on(e, (...o) => {
        r(t, ...o);
      });
    });
  }
  omit(t, e) {
    return e.forEach((n) => {
      Object.prototype.hasOwnProperty.call(t, n) && delete t[n];
    }), t;
  }
  render() {
    const { className: t, tag: e = "div", hasTrack: n = !0, children: r, ...o } = this.props;
    return /* @__PURE__ */ ne.createElement(e, {
      className: Fc("splide", t),
      ref: this.splideRef,
      ...this.omit(o, ["options", ...pf.map((s) => s[1])])
    }, n ? /* @__PURE__ */ ne.createElement(xg, null, r) : r);
  }
}, Lc = ({ children: t, className: e, ...n }) => /* @__PURE__ */ ne.createElement("li", {
  className: Fc("splide__slide", e),
  ...n
}, t);
/*!
 * Splide.js
 * Version  : 4.1.3
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
const NR = ({ children: t, theme: e }) => /* @__PURE__ */ g("div", { "data-mode": e, children: t }), OR = ae({
  slots: {
    wrapper: "z-[1] absolute top-1/2 transform -translate-y-1/2",
    button: "disabled:hidden"
  },
  variants: {
    position: {
      left: {
        wrapper: "left-3",
        button: "splide__arrow--prev"
      },
      right: {
        wrapper: "right-3",
        button: "splide__arrow--next"
      }
    },
    disableHorizontalPadding: {
      true: "",
      false: ""
    }
  },
  compoundVariants: [
    {
      disableHorizontalPadding: !0,
      position: "left",
      class: {
        wrapper: "left-0"
      }
    },
    {
      disableHorizontalPadding: !0,
      position: "right",
      class: {
        wrapper: "right-0"
      }
    }
  ]
}), hf = ({ position: t, buttonsContrast: e, invertButtons: n, disableHorizontalPadding: r }) => {
  const o = t === "left", s = o ? "arrow-left" : "arrow-right", i = o ? "Previous Page" : "Next Page", a = e ? "primary" : "tertiary", l = n ? "dark" : "light", { wrapper: c, button: u } = OR({ position: t, disableHorizontalPadding: r });
  return /* @__PURE__ */ g(NR, { theme: l, children: /* @__PURE__ */ g("span", { className: c(), children: /* @__PURE__ */ g(Qn, { type: "button", className: u(), variant: a, icon: s, iconButton: !0, children: i }) }) });
}, VR = ae({
  slots: {
    paginationClass: "splide__pagination flex gap-1 absolute left-0 right-0 bottom-2 px-4 py-0 z-1",
    page: [
      "splide__pagination__page block p-0 relative bg-clr-on-bg-low w-3 h-0.25 m-0 opacity-100 border-none rounded-none transform-none transition-all",
      "[&.is-active]:bg-clr-black [&.is-active]:h-1",
      "after:content-[''] after:absolute after:left-0 after:-mt-1 after:h-2 after:w-3 after:cursor-pointer [&.is-active]:after:content-[]"
    ]
  }
}), FR = ({
  children: t,
  label: e,
  perPage: n = 1,
  perMove: r = 1,
  rewind: o = !1,
  buttonsContrast: s = !1,
  invertButtons: i = !1,
  focus: a,
  gap: l = 20,
  arrows: c = !0,
  pagination: u = !0,
  onMove: d,
  padding: p,
  disableHorizontalPadding: h = !1,
  start: v = 0
}) => {
  const { getChildrenFromSubcomponent: m, printBadConstructionMessage: y } = pt(t), { paginationClass: b, page: w } = VR();
  if (!t)
    return y("Carousel"), null;
  const x = {
    perPage: n,
    perMove: r,
    type: o ? "loop" : "slide",
    focus: a,
    gap: l,
    arrows: c,
    pagination: u,
    padding: p,
    start: v,
    lazyLoad: "nearby",
    classes: { pagination: b(), page: w() },
    i18n: {
      prev: "vorherige Ansicht",
      next: "nächste Ansicht",
      first: "erste Ansicht",
      last: "letzte Ansicht",
      slideX: "gehe zu Ansicht %s",
      pageX: "gehe zu Seite %s",
      play: "starte Wiedergabe",
      pause: "pausiere Wiedergabe",
      carousel: "carousel",
      select: "wähle eine Ansicht aus",
      slide: "slide",
      slideLabel: "%s von %s"
    }
  };
  return /* @__PURE__ */ G(
    MR,
    {
      "aria-label": e,
      options: x,
      hasTrack: !1,
      onMove: (E, C, A) => d && d(C, A),
      children: [
        /* @__PURE__ */ G("div", { className: "splide__arrows", children: [
          /* @__PURE__ */ g(
            hf,
            {
              invertButtons: i,
              position: "left",
              buttonsContrast: s,
              disableHorizontalPadding: h
            }
          ),
          /* @__PURE__ */ g(
            hf,
            {
              invertButtons: i,
              position: "right",
              buttonsContrast: s,
              disableHorizontalPadding: h
            }
          )
        ] }),
        /* @__PURE__ */ g(xg, { children: m(Lc) })
      ]
    }
  );
};
Lc.displayName = "Slide";
FR.Slide = Lc;
const LR = ae({
  base: "typography-input-helper-text w-full inline-block",
  variants: {
    type: {
      description: "text-clr-on-bg-mid",
      error: "text-clr-error"
    }
  }
}), mf = ({ children: t, type: e = "description" }) => {
  const n = LR({ type: e });
  return /* @__PURE__ */ g("span", { className: n, children: t });
}, BR = ae({
  base: "flex flex-col gap-1 mt-1 w-full"
}), Bc = ({ helperText: t, error: e = !1, errorText: n, className: r = "" }) => /* @__PURE__ */ G("div", { className: `${BR()} ${r}`, children: [
  t && /* @__PURE__ */ g(mf, { children: t }),
  e && n && /* @__PURE__ */ g(mf, { type: "error", children: n })
] }), $R = ae({
  base: "preflight typography-input-text flex gap-2 items-start py-3 text-clr-on-bg-high relative",
  slots: {
    input: [
      "appearance-none relative w-6 h-6 rounded-sm border text-current cursor-pointer shrink-0",
      "focus-visible:outline focus-visible:outline-clr-primary focus-visible:outline-1 focus-visible:outline-offset-2"
    ],
    icon: "w-[18px] h-[18px] absolute m-0.75"
  },
  variants: {
    disabled: {
      true: {
        base: "text-clr-on-bg-low",
        icon: "fill-clr-on-bg-low"
      },
      false: {
        base: "hover:cursor-pointer"
      }
    },
    error: {
      true: {
        input: "border-clr-error bg-clr-error-bg [&:checked::after]:bg-clr-error",
        icon: "fill-clr-error"
      }
    }
  }
}), Cg = ({ label: t, name: e, checked: n, onChange: r, onBlur: o, id: s, value: i = t, required: a, disabled: l, error: c, rootRef: u }) => {
  const { base: d, input: p, icon: h } = $R({ disabled: l, error: c }), v = (y) => {
    r(y.currentTarget.checked);
  }, m = (y) => {
    var b;
    if (o) {
      if ((b = y.relatedTarget) != null && b.contains(y.currentTarget)) {
        y.preventDefault();
        return;
      }
      o();
    }
  };
  return (
    // Label causes inconsistent blur event when interacts with input.
    // -1 tabIndex makes 'relatedTarget' not being always null and helps detecting correct blur event
    /* @__PURE__ */ G("label", { className: d(), tabIndex: -1, children: [
      /* @__PURE__ */ g(
        "input",
        {
          className: p(),
          type: "checkbox",
          checked: n,
          onChange: v,
          onBlur: m,
          value: i,
          id: s,
          name: e,
          disabled: l,
          ref: u,
          required: a
        }
      ),
      t,
      n && /* @__PURE__ */ g(ge, { variant: "check-bold", className: h() })
    ] })
  );
}, WN = (t) => {
  const { helperText: e = "", error: n, errorText: r = "", ...o } = t;
  return /* @__PURE__ */ G(Pe, { children: [
    /* @__PURE__ */ g(Cg, { ...o, error: n }),
    /* @__PURE__ */ g(Bc, { helperText: e, error: n, errorText: r })
  ] });
}, WR = ae({
  // min-w-0 is required because of the weird fieldset behavior
  // fieldset will be placed in some fixed width container or flexbox
  // we need to make sure that the helper texts are truncated with ellipsis and not extending the fieldset
  // https://stackoverflow.com/questions/7434756/overflow-and-text-overflow-within-fieldsets
  base: "preflight min-w-0",
  slots: {
    label: "typography-input-label text-clr-on-bg-mid truncate inline-block w-full"
  }
}), Eg = ({
  label: t,
  children: e,
  name: n,
  error: r = !1,
  errorText: o,
  disabled: s = !1,
  helperText: i,
  required: a = !1
}) => {
  const { base: l, label: c } = WR();
  return /* @__PURE__ */ G("fieldset", { className: l(), disabled: s, name: n, children: [
    /* @__PURE__ */ G("legend", { className: c(), children: [
      t,
      a && /* @__PURE__ */ g("span", { children: "*" })
    ] }),
    e,
    /* @__PURE__ */ g(Bc, { helperText: i, error: r, errorText: o })
  ] });
}, jR = ({
  label: t,
  values: e,
  children: n,
  onChange: r,
  error: o = !1,
  errorText: s,
  disabled: i = !1,
  helperText: a,
  required: l = !1
}) => {
  const { getChildrenFromSubcomponent: c, printBadConstructionMessage: u } = pt(n), d = { values: e, onChange: r, disabled: i, error: o, required: l };
  return n ? /* @__PURE__ */ g(
    Eg,
    {
      label: t,
      error: o,
      errorText: s,
      disabled: i,
      helperText: a,
      required: l,
      children: /* @__PURE__ */ g("div", { className: "preflight flex flex-wrap flex-col", children: c($c, d) })
    }
  ) : (u("CheckboxGroup"), null);
}, $c = (t) => {
  const { values: e, value: n, onChange: r } = t, o = e.includes(n);
  return /* @__PURE__ */ g(Cg, { ...t, checked: o, onChange: () => {
    const i = o ? e.filter((a) => a !== n) : [...e, n];
    r(i);
  } });
};
$c.displayName = "Item";
jR.Item = $c;
const jN = ({ children: t, disableFullScreen: e = !1 }) => /* @__PURE__ */ g("div", { className: `px-2.5 ${e ? "max-w-[1600px] xxxl:mx-auto" : ""}`, children: t });
// @__NO_SIDE_EFFECTS__
function UR(t) {
  const e = /* @__PURE__ */ HR(t), n = f.forwardRef((r, o) => {
    const { children: s, ...i } = r, a = f.Children.toArray(s), l = a.find(GR);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ g(e, { ...i, ref: o, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ g(e, { ...i, ref: o, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function HR(t) {
  const e = f.forwardRef((n, r) => {
    const { children: o, ...s } = n, i = f.isValidElement(o) ? YR(o) : void 0, a = te(i, r);
    if (f.isValidElement(o)) {
      const l = KR(s, o.props);
      return o.type !== f.Fragment && (l.ref = a), f.cloneElement(o, l);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var zR = Symbol("radix.slottable");
function GR(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === zR;
}
function KR(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const l = s(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function YR(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var qR = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Sg = qR.reduce((t, e) => {
  const n = /* @__PURE__ */ UR(`Primitive.${e}`), r = f.forwardRef((o, s) => {
    const { asChild: i, ...a } = o, l = i ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {});
function XR(t, e) {
  t && Ps.flushSync(() => t.dispatchEvent(e));
}
function ZR(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Ne(t);
  f.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return e.addEventListener("keydown", r, { capture: !0 }), () => e.removeEventListener("keydown", r, { capture: !0 });
  }, [n, e]);
}
var JR = "DismissableLayer", Ja = "dismissableLayer.update", QR = "dismissableLayer.pointerDownOutside", e1 = "dismissableLayer.focusOutside", gf, Ag = f.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), ri = f.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: s,
      onInteractOutside: i,
      onDismiss: a,
      ...l
    } = t, c = f.useContext(Ag), [u, d] = f.useState(null), p = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = f.useState({}), v = te(e, (S) => d(S)), m = Array.from(c.layers), [y] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), b = m.indexOf(y), w = u ? m.indexOf(u) : -1, x = c.layersWithOutsidePointerEventsDisabled.size > 0, E = w >= b, C = r1((S) => {
      const R = S.target, P = [...c.branches].some((k) => k.contains(R));
      !E || P || (o == null || o(S), i == null || i(S), S.defaultPrevented || a == null || a());
    }, p), A = o1((S) => {
      const R = S.target;
      [...c.branches].some((k) => k.contains(R)) || (s == null || s(S), i == null || i(S), S.defaultPrevented || a == null || a());
    }, p);
    return ZR((S) => {
      w === c.layers.size - 1 && (r == null || r(S), !S.defaultPrevented && a && (S.preventDefault(), a()));
    }, p), f.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (gf = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), vf(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = gf);
        };
    }, [u, p, n, c]), f.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), vf());
    }, [u, c]), f.useEffect(() => {
      const S = () => h({});
      return document.addEventListener(Ja, S), () => document.removeEventListener(Ja, S);
    }, []), /* @__PURE__ */ g(
      Sg.div,
      {
        ...l,
        ref: v,
        style: {
          pointerEvents: x ? E ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: J(t.onFocusCapture, A.onFocusCapture),
        onBlurCapture: J(t.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: J(
          t.onPointerDownCapture,
          C.onPointerDownCapture
        )
      }
    );
  }
);
ri.displayName = JR;
var t1 = "DismissableLayerBranch", n1 = f.forwardRef((t, e) => {
  const n = f.useContext(Ag), r = f.useRef(null), o = te(e, r);
  return f.useEffect(() => {
    const s = r.current;
    if (s)
      return n.branches.add(s), () => {
        n.branches.delete(s);
      };
  }, [n.branches]), /* @__PURE__ */ g(Sg.div, { ...t, ref: o });
});
n1.displayName = t1;
function r1(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Ne(t), r = f.useRef(!1), o = f.useRef(() => {
  });
  return f.useEffect(() => {
    const s = (a) => {
      if (a.target && !r.current) {
        let l = function() {
          Tg(
            QR,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: a };
        a.pointerType === "touch" ? (e.removeEventListener("click", o.current), o.current = l, e.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        e.removeEventListener("click", o.current);
      r.current = !1;
    }, i = window.setTimeout(() => {
      e.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(i), e.removeEventListener("pointerdown", s), e.removeEventListener("click", o.current);
    };
  }, [e, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function o1(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Ne(t), r = f.useRef(!1);
  return f.useEffect(() => {
    const o = (s) => {
      s.target && !r.current && Tg(e1, n, { originalEvent: s }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", o), () => e.removeEventListener("focusin", o);
  }, [e, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function vf() {
  const t = new CustomEvent(Ja);
  document.dispatchEvent(t);
}
function Tg(t, e, n, { discrete: r }) {
  const o = n.originalEvent.target, s = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: n });
  e && o.addEventListener(t, e, { once: !0 }), r ? XR(o, s) : o.dispatchEvent(s);
}
// @__NO_SIDE_EFFECTS__
function s1(t) {
  const e = /* @__PURE__ */ i1(t), n = f.forwardRef((r, o) => {
    const { children: s, ...i } = r, a = f.Children.toArray(s), l = a.find(l1);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ g(e, { ...i, ref: o, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ g(e, { ...i, ref: o, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function i1(t) {
  const e = f.forwardRef((n, r) => {
    const { children: o, ...s } = n, i = f.isValidElement(o) ? u1(o) : void 0, a = te(i, r);
    if (f.isValidElement(o)) {
      const l = c1(s, o.props);
      return o.type !== f.Fragment && (l.ref = a), f.cloneElement(o, l);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var a1 = Symbol("radix.slottable");
function l1(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === a1;
}
function c1(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const l = s(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function u1(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var d1 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], f1 = d1.reduce((t, e) => {
  const n = /* @__PURE__ */ s1(`Primitive.${e}`), r = f.forwardRef((o, s) => {
    const { asChild: i, ...a } = o, l = i ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {}), Xi = "focusScope.autoFocusOnMount", Zi = "focusScope.autoFocusOnUnmount", yf = { bubbles: !1, cancelable: !0 }, p1 = "FocusScope", Wc = f.forwardRef((t, e) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: s,
    ...i
  } = t, [a, l] = f.useState(null), c = Ne(o), u = Ne(s), d = f.useRef(null), p = te(e, (m) => l(m)), h = f.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  f.useEffect(() => {
    if (r) {
      let m = function(x) {
        if (h.paused || !a) return;
        const E = x.target;
        a.contains(E) ? d.current = E : Jt(d.current, { select: !0 });
      }, y = function(x) {
        if (h.paused || !a) return;
        const E = x.relatedTarget;
        E !== null && (a.contains(E) || Jt(d.current, { select: !0 }));
      }, b = function(x) {
        if (document.activeElement === document.body)
          for (const C of x)
            C.removedNodes.length > 0 && Jt(a);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", y);
      const w = new MutationObserver(b);
      return a && w.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", y), w.disconnect();
      };
    }
  }, [r, a, h.paused]), f.useEffect(() => {
    if (a) {
      wf.add(h);
      const m = document.activeElement;
      if (!a.contains(m)) {
        const b = new CustomEvent(Xi, yf);
        a.addEventListener(Xi, c), a.dispatchEvent(b), b.defaultPrevented || (h1(b1(Rg(a)), { select: !0 }), document.activeElement === m && Jt(a));
      }
      return () => {
        a.removeEventListener(Xi, c), setTimeout(() => {
          const b = new CustomEvent(Zi, yf);
          a.addEventListener(Zi, u), a.dispatchEvent(b), b.defaultPrevented || Jt(m ?? document.body, { select: !0 }), a.removeEventListener(Zi, u), wf.remove(h);
        }, 0);
      };
    }
  }, [a, c, u, h]);
  const v = f.useCallback(
    (m) => {
      if (!n && !r || h.paused) return;
      const y = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, b = document.activeElement;
      if (y && b) {
        const w = m.currentTarget, [x, E] = m1(w);
        x && E ? !m.shiftKey && b === E ? (m.preventDefault(), n && Jt(x, { select: !0 })) : m.shiftKey && b === x && (m.preventDefault(), n && Jt(E, { select: !0 })) : b === w && m.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ g(f1.div, { tabIndex: -1, ...i, ref: p, onKeyDown: v });
});
Wc.displayName = p1;
function h1(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (Jt(r, { select: e }), document.activeElement !== n) return;
}
function m1(t) {
  const e = Rg(t), n = bf(e, t), r = bf(e.reverse(), t);
  return [n, r];
}
function Rg(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
function bf(t, e) {
  for (const n of t)
    if (!g1(n, { upTo: e })) return n;
}
function g1(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden") return !0;
  for (; t; ) {
    if (e !== void 0 && t === e) return !1;
    if (getComputedStyle(t).display === "none") return !0;
    t = t.parentElement;
  }
  return !1;
}
function v1(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function Jt(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({ preventScroll: !0 }), t !== n && v1(t) && e && t.select();
  }
}
var wf = y1();
function y1() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = xf(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = xf(t, e), (n = t[0]) == null || n.resume();
    }
  };
}
function xf(t, e) {
  const n = [...t], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function b1(t) {
  return t.filter((e) => e.tagName !== "A");
}
// @__NO_SIDE_EFFECTS__
function w1(t) {
  const e = /* @__PURE__ */ x1(t), n = f.forwardRef((r, o) => {
    const { children: s, ...i } = r, a = f.Children.toArray(s), l = a.find(E1);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ g(e, { ...i, ref: o, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ g(e, { ...i, ref: o, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function x1(t) {
  const e = f.forwardRef((n, r) => {
    const { children: o, ...s } = n, i = f.isValidElement(o) ? A1(o) : void 0, a = te(i, r);
    if (f.isValidElement(o)) {
      const l = S1(s, o.props);
      return o.type !== f.Fragment && (l.ref = a), f.cloneElement(o, l);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var C1 = Symbol("radix.slottable");
function E1(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === C1;
}
function S1(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const l = s(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function A1(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var T1 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], R1 = T1.reduce((t, e) => {
  const n = /* @__PURE__ */ w1(`Primitive.${e}`), r = f.forwardRef((o, s) => {
    const { asChild: i, ...a } = o, l = i ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {}), _1 = "Portal", oi = f.forwardRef((t, e) => {
  var a;
  const { container: n, ...r } = t, [o, s] = f.useState(!1);
  ke(() => s(!0), []);
  const i = n || o && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return i ? Cb.createPortal(/* @__PURE__ */ g(R1.div, { ...r, ref: e }), i) : null;
});
oi.displayName = _1;
// @__NO_SIDE_EFFECTS__
function _g(t) {
  const e = /* @__PURE__ */ P1(t), n = f.forwardRef((r, o) => {
    const { children: s, ...i } = r, a = f.Children.toArray(s), l = a.find(I1);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ g(e, { ...i, ref: o, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ g(e, { ...i, ref: o, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function P1(t) {
  const e = f.forwardRef((n, r) => {
    const { children: o, ...s } = n, i = f.isValidElement(o) ? M1(o) : void 0, a = te(i, r);
    if (f.isValidElement(o)) {
      const l = D1(s, o.props);
      return o.type !== f.Fragment && (l.ref = a), f.cloneElement(o, l);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var k1 = Symbol("radix.slottable");
function I1(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === k1;
}
function D1(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const l = s(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function M1(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var N1 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], To = N1.reduce((t, e) => {
  const n = /* @__PURE__ */ _g(`Primitive.${e}`), r = f.forwardRef((o, s) => {
    const { asChild: i, ...a } = o, l = i ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {}), Ji = 0;
function O1() {
  f.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? Cf()), document.body.insertAdjacentElement("beforeend", t[1] ?? Cf()), Ji++, () => {
      Ji === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), Ji--;
    };
  }, []);
}
function Cf() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.outline = "none", t.style.opacity = "0", t.style.position = "fixed", t.style.pointerEvents = "none", t;
}
var gt = function() {
  return gt = Object.assign || function(e) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
    }
    return e;
  }, gt.apply(this, arguments);
};
function Pg(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(t); o < r.length; o++)
      e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
  return n;
}
function V1(t, e, n) {
  if (n || arguments.length === 2) for (var r = 0, o = e.length, s; r < o; r++)
    (s || !(r in e)) && (s || (s = Array.prototype.slice.call(e, 0, r)), s[r] = e[r]);
  return t.concat(s || Array.prototype.slice.call(e));
}
var ns = "right-scroll-bar-position", rs = "width-before-scroll-bar", F1 = "with-scroll-bars-hidden", L1 = "--removed-body-scroll-bar-size";
function Qi(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function B1(t, e) {
  var n = de(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = e, n.facade;
}
var $1 = typeof window < "u" ? f.useLayoutEffect : f.useEffect, Ef = /* @__PURE__ */ new WeakMap();
function W1(t, e) {
  var n = B1(null, function(r) {
    return t.forEach(function(o) {
      return Qi(o, r);
    });
  });
  return $1(function() {
    var r = Ef.get(n);
    if (r) {
      var o = new Set(r), s = new Set(t), i = n.current;
      o.forEach(function(a) {
        s.has(a) || Qi(a, null);
      }), s.forEach(function(a) {
        o.has(a) || Qi(a, i);
      });
    }
    Ef.set(n, t);
  }, [t]), n;
}
function j1(t) {
  return t;
}
function U1(t, e) {
  e === void 0 && (e = j1);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : t;
    },
    useMedium: function(s) {
      var i = e(s, r);
      return n.push(i), function() {
        n = n.filter(function(a) {
          return a !== i;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (r = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(s);
      }
      n = {
        push: function(a) {
          return s(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(s) {
      r = !0;
      var i = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(s), i = n;
      }
      var l = function() {
        var u = i;
        i = [], u.forEach(s);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          i.push(u), c();
        },
        filter: function(u) {
          return i = i.filter(u), n;
        }
      };
    }
  };
  return o;
}
function H1(t) {
  t === void 0 && (t = {});
  var e = U1(null);
  return e.options = gt({ async: !0, ssr: !1 }, t), e;
}
var kg = function(t) {
  var e = t.sideCar, n = Pg(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = e.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return f.createElement(r, gt({}, n));
};
kg.isSideCarExport = !0;
function z1(t, e) {
  return t.useMedium(e), kg;
}
var Ig = H1(), ea = function() {
}, si = f.forwardRef(function(t, e) {
  var n = f.useRef(null), r = f.useState({
    onScrollCapture: ea,
    onWheelCapture: ea,
    onTouchMoveCapture: ea
  }), o = r[0], s = r[1], i = t.forwardProps, a = t.children, l = t.className, c = t.removeScrollBar, u = t.enabled, d = t.shards, p = t.sideCar, h = t.noIsolation, v = t.inert, m = t.allowPinchZoom, y = t.as, b = y === void 0 ? "div" : y, w = t.gapMode, x = Pg(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), E = p, C = W1([n, e]), A = gt(gt({}, x), o);
  return f.createElement(
    f.Fragment,
    null,
    u && f.createElement(E, { sideCar: Ig, removeScrollBar: c, shards: d, noIsolation: h, inert: v, setCallbacks: s, allowPinchZoom: !!m, lockRef: n, gapMode: w }),
    i ? f.cloneElement(f.Children.only(a), gt(gt({}, A), { ref: C })) : f.createElement(b, gt({}, A, { className: l, ref: C }), a)
  );
});
si.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
si.classNames = {
  fullWidth: rs,
  zeroRight: ns
};
var G1 = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function K1() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = G1();
  return e && t.setAttribute("nonce", e), t;
}
function Y1(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function q1(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var X1 = function() {
  var t = 0, e = null;
  return {
    add: function(n) {
      t == 0 && (e = K1()) && (Y1(e, n), q1(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, Z1 = function() {
  var t = X1();
  return function(e, n) {
    f.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && n]);
  };
}, Dg = function() {
  var t = Z1(), e = function(n) {
    var r = n.styles, o = n.dynamic;
    return t(r, o), null;
  };
  return e;
}, J1 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, ta = function(t) {
  return parseInt(t || "", 10) || 0;
}, Q1 = function(t) {
  var e = window.getComputedStyle(document.body), n = e[t === "padding" ? "paddingLeft" : "marginLeft"], r = e[t === "padding" ? "paddingTop" : "marginTop"], o = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [ta(n), ta(r), ta(o)];
}, e_ = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return J1;
  var e = Q1(t), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, r - n + e[2] - e[0])
  };
}, t_ = Dg(), Xn = "data-scroll-locked", n_ = function(t, e, n, r) {
  var o = t.left, s = t.top, i = t.right, a = t.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(F1, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat(Xn, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ns, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(rs, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(ns, " .").concat(ns, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(rs, " .").concat(rs, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Xn, `] {
    `).concat(L1, ": ").concat(a, `px;
  }
`);
}, Sf = function() {
  var t = parseInt(document.body.getAttribute(Xn) || "0", 10);
  return isFinite(t) ? t : 0;
}, r_ = function() {
  f.useEffect(function() {
    return document.body.setAttribute(Xn, (Sf() + 1).toString()), function() {
      var t = Sf() - 1;
      t <= 0 ? document.body.removeAttribute(Xn) : document.body.setAttribute(Xn, t.toString());
    };
  }, []);
}, o_ = function(t) {
  var e = t.noRelative, n = t.noImportant, r = t.gapMode, o = r === void 0 ? "margin" : r;
  r_();
  var s = f.useMemo(function() {
    return e_(o);
  }, [o]);
  return f.createElement(t_, { styles: n_(s, !e, o, n ? "" : "!important") });
}, Qa = !1;
if (typeof window < "u")
  try {
    var Wo = Object.defineProperty({}, "passive", {
      get: function() {
        return Qa = !0, !0;
      }
    });
    window.addEventListener("test", Wo, Wo), window.removeEventListener("test", Wo, Wo);
  } catch {
    Qa = !1;
  }
var On = Qa ? { passive: !1 } : !1, s_ = function(t) {
  return t.tagName === "TEXTAREA";
}, Mg = function(t, e) {
  if (!(t instanceof Element))
    return !1;
  var n = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    n[e] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !s_(t) && n[e] === "visible")
  );
}, i_ = function(t) {
  return Mg(t, "overflowY");
}, a_ = function(t) {
  return Mg(t, "overflowX");
}, Af = function(t, e) {
  var n = e.ownerDocument, r = e;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Ng(t, r);
    if (o) {
      var s = Og(t, r), i = s[1], a = s[2];
      if (i > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, l_ = function(t) {
  var e = t.scrollTop, n = t.scrollHeight, r = t.clientHeight;
  return [
    e,
    n,
    r
  ];
}, c_ = function(t) {
  var e = t.scrollLeft, n = t.scrollWidth, r = t.clientWidth;
  return [
    e,
    n,
    r
  ];
}, Ng = function(t, e) {
  return t === "v" ? i_(e) : a_(e);
}, Og = function(t, e) {
  return t === "v" ? l_(e) : c_(e);
}, u_ = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, d_ = function(t, e, n, r, o) {
  var s = u_(t, window.getComputedStyle(e).direction), i = s * r, a = n.target, l = e.contains(a), c = !1, u = i > 0, d = 0, p = 0;
  do {
    var h = Og(t, a), v = h[0], m = h[1], y = h[2], b = m - y - s * v;
    (v || b) && Ng(t, a) && (d += b, p += v), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !l && a !== document.body || // self content
    l && (e.contains(a) || e === a)
  );
  return (u && (Math.abs(d) < 1 || !o) || !u && (Math.abs(p) < 1 || !o)) && (c = !0), c;
}, jo = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, Tf = function(t) {
  return [t.deltaX, t.deltaY];
}, Rf = function(t) {
  return t && "current" in t ? t.current : t;
}, f_ = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, p_ = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, h_ = 0, Vn = [];
function m_(t) {
  var e = f.useRef([]), n = f.useRef([0, 0]), r = f.useRef(), o = f.useState(h_++)[0], s = f.useState(Dg)[0], i = f.useRef(t);
  f.useEffect(function() {
    i.current = t;
  }, [t]), f.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var m = V1([t.lockRef.current], (t.shards || []).map(Rf), !0).filter(Boolean);
      return m.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), m.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var a = f.useCallback(function(m, y) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !i.current.allowPinchZoom;
    var b = jo(m), w = n.current, x = "deltaX" in m ? m.deltaX : w[0] - b[0], E = "deltaY" in m ? m.deltaY : w[1] - b[1], C, A = m.target, S = Math.abs(x) > Math.abs(E) ? "h" : "v";
    if ("touches" in m && S === "h" && A.type === "range")
      return !1;
    var R = Af(S, A);
    if (!R)
      return !0;
    if (R ? C = S : (C = S === "v" ? "h" : "v", R = Af(S, A)), !R)
      return !1;
    if (!r.current && "changedTouches" in m && (x || E) && (r.current = C), !C)
      return !0;
    var P = r.current || C;
    return d_(P, y, m, P === "h" ? x : E, !0);
  }, []), l = f.useCallback(function(m) {
    var y = m;
    if (!(!Vn.length || Vn[Vn.length - 1] !== s)) {
      var b = "deltaY" in y ? Tf(y) : jo(y), w = e.current.filter(function(C) {
        return C.name === y.type && (C.target === y.target || y.target === C.shadowParent) && f_(C.delta, b);
      })[0];
      if (w && w.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!w) {
        var x = (i.current.shards || []).map(Rf).filter(Boolean).filter(function(C) {
          return C.contains(y.target);
        }), E = x.length > 0 ? a(y, x[0]) : !i.current.noIsolation;
        E && y.cancelable && y.preventDefault();
      }
    }
  }, []), c = f.useCallback(function(m, y, b, w) {
    var x = { name: m, delta: y, target: b, should: w, shadowParent: g_(b) };
    e.current.push(x), setTimeout(function() {
      e.current = e.current.filter(function(E) {
        return E !== x;
      });
    }, 1);
  }, []), u = f.useCallback(function(m) {
    n.current = jo(m), r.current = void 0;
  }, []), d = f.useCallback(function(m) {
    c(m.type, Tf(m), m.target, a(m, t.lockRef.current));
  }, []), p = f.useCallback(function(m) {
    c(m.type, jo(m), m.target, a(m, t.lockRef.current));
  }, []);
  f.useEffect(function() {
    return Vn.push(s), t.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", l, On), document.addEventListener("touchmove", l, On), document.addEventListener("touchstart", u, On), function() {
      Vn = Vn.filter(function(m) {
        return m !== s;
      }), document.removeEventListener("wheel", l, On), document.removeEventListener("touchmove", l, On), document.removeEventListener("touchstart", u, On);
    };
  }, []);
  var h = t.removeScrollBar, v = t.inert;
  return f.createElement(
    f.Fragment,
    null,
    v ? f.createElement(s, { styles: p_(o) }) : null,
    h ? f.createElement(o_, { gapMode: t.gapMode }) : null
  );
}
function g_(t) {
  for (var e = null; t !== null; )
    t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
const v_ = z1(Ig, m_);
var jc = f.forwardRef(function(t, e) {
  return f.createElement(si, gt({}, t, { ref: e, sideCar: v_ }));
});
jc.classNames = si.classNames;
var y_ = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, Fn = /* @__PURE__ */ new WeakMap(), Uo = /* @__PURE__ */ new WeakMap(), Ho = {}, na = 0, Vg = function(t) {
  return t && (t.host || Vg(t.parentNode));
}, b_ = function(t, e) {
  return e.map(function(n) {
    if (t.contains(n))
      return n;
    var r = Vg(n);
    return r && t.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, w_ = function(t, e, n, r) {
  var o = b_(e, Array.isArray(t) ? t : [t]);
  Ho[n] || (Ho[n] = /* @__PURE__ */ new WeakMap());
  var s = Ho[n], i = [], a = /* @__PURE__ */ new Set(), l = new Set(o), c = function(d) {
    !d || a.has(d) || (a.add(d), c(d.parentNode));
  };
  o.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(p) {
      if (a.has(p))
        u(p);
      else
        try {
          var h = p.getAttribute(r), v = h !== null && h !== "false", m = (Fn.get(p) || 0) + 1, y = (s.get(p) || 0) + 1;
          Fn.set(p, m), s.set(p, y), i.push(p), m === 1 && v && Uo.set(p, !0), y === 1 && p.setAttribute(n, "true"), v || p.setAttribute(r, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", p, b);
        }
    });
  };
  return u(e), a.clear(), na++, function() {
    i.forEach(function(d) {
      var p = Fn.get(d) - 1, h = s.get(d) - 1;
      Fn.set(d, p), s.set(d, h), p || (Uo.has(d) || d.removeAttribute(r), Uo.delete(d)), h || d.removeAttribute(n);
    }), na--, na || (Fn = /* @__PURE__ */ new WeakMap(), Fn = /* @__PURE__ */ new WeakMap(), Uo = /* @__PURE__ */ new WeakMap(), Ho = {});
  };
}, Fg = function(t, e, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(t) ? t : [t]), o = y_(t);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), w_(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, ii = "Dialog", [Lg, UN] = je(ii), [x_, mt] = Lg(ii), Bg = (t) => {
  const {
    __scopeDialog: e,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: s,
    modal: i = !0
  } = t, a = f.useRef(null), l = f.useRef(null), [c, u] = tt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: s,
    caller: ii
  });
  return /* @__PURE__ */ g(
    x_,
    {
      scope: e,
      triggerRef: a,
      contentRef: l,
      contentId: Je(),
      titleId: Je(),
      descriptionId: Je(),
      open: c,
      onOpenChange: u,
      onOpenToggle: f.useCallback(() => u((d) => !d), [u]),
      modal: i,
      children: n
    }
  );
};
Bg.displayName = ii;
var $g = "DialogTrigger", C_ = f.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, o = mt($g, n), s = te(e, o.triggerRef);
    return /* @__PURE__ */ g(
      To.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": zc(o.open),
        ...r,
        ref: s,
        onClick: J(t.onClick, o.onOpenToggle)
      }
    );
  }
);
C_.displayName = $g;
var Uc = "DialogPortal", [E_, Wg] = Lg(Uc, {
  forceMount: void 0
}), jg = (t) => {
  const { __scopeDialog: e, forceMount: n, children: r, container: o } = t, s = mt(Uc, e);
  return /* @__PURE__ */ g(E_, { scope: e, forceMount: n, children: f.Children.map(r, (i) => /* @__PURE__ */ g(Ge, { present: n || s.open, children: /* @__PURE__ */ g(oi, { asChild: !0, container: o, children: i }) })) });
};
jg.displayName = Uc;
var ws = "DialogOverlay", Ug = f.forwardRef(
  (t, e) => {
    const n = Wg(ws, t.__scopeDialog), { forceMount: r = n.forceMount, ...o } = t, s = mt(ws, t.__scopeDialog);
    return s.modal ? /* @__PURE__ */ g(Ge, { present: r || s.open, children: /* @__PURE__ */ g(A_, { ...o, ref: e }) }) : null;
  }
);
Ug.displayName = ws;
var S_ = /* @__PURE__ */ _g("DialogOverlay.RemoveScroll"), A_ = f.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, o = mt(ws, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ g(jc, { as: S_, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ g(
        To.div,
        {
          "data-state": zc(o.open),
          ...r,
          ref: e,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), kn = "DialogContent", Hg = f.forwardRef(
  (t, e) => {
    const n = Wg(kn, t.__scopeDialog), { forceMount: r = n.forceMount, ...o } = t, s = mt(kn, t.__scopeDialog);
    return /* @__PURE__ */ g(Ge, { present: r || s.open, children: s.modal ? /* @__PURE__ */ g(T_, { ...o, ref: e }) : /* @__PURE__ */ g(R_, { ...o, ref: e }) });
  }
);
Hg.displayName = kn;
var T_ = f.forwardRef(
  (t, e) => {
    const n = mt(kn, t.__scopeDialog), r = f.useRef(null), o = te(e, n.contentRef, r);
    return f.useEffect(() => {
      const s = r.current;
      if (s) return Fg(s);
    }, []), /* @__PURE__ */ g(
      zg,
      {
        ...t,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: J(t.onCloseAutoFocus, (s) => {
          var i;
          s.preventDefault(), (i = n.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: J(t.onPointerDownOutside, (s) => {
          const i = s.detail.originalEvent, a = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || a) && s.preventDefault();
        }),
        onFocusOutside: J(
          t.onFocusOutside,
          (s) => s.preventDefault()
        )
      }
    );
  }
), R_ = f.forwardRef(
  (t, e) => {
    const n = mt(kn, t.__scopeDialog), r = f.useRef(!1), o = f.useRef(!1);
    return /* @__PURE__ */ g(
      zg,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          var i, a;
          (i = t.onCloseAutoFocus) == null || i.call(t, s), s.defaultPrevented || (r.current || (a = n.triggerRef.current) == null || a.focus(), s.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (s) => {
          var l, c;
          (l = t.onInteractOutside) == null || l.call(t, s), s.defaultPrevented || (r.current = !0, s.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const i = s.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(i)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && o.current && s.preventDefault();
        }
      }
    );
  }
), zg = f.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: s, ...i } = t, a = mt(kn, n), l = f.useRef(null), c = te(e, l);
    return O1(), /* @__PURE__ */ G(Pe, { children: [
      /* @__PURE__ */ g(
        Wc,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: s,
          children: /* @__PURE__ */ g(
            ri,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": zc(a.open),
              ...i,
              ref: c,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ G(Pe, { children: [
        /* @__PURE__ */ g(__, { titleId: a.titleId }),
        /* @__PURE__ */ g(k_, { contentRef: l, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), Hc = "DialogTitle", Gg = f.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, o = mt(Hc, n);
    return /* @__PURE__ */ g(To.h2, { id: o.titleId, ...r, ref: e });
  }
);
Gg.displayName = Hc;
var Kg = "DialogDescription", Yg = f.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, o = mt(Kg, n);
    return /* @__PURE__ */ g(To.p, { id: o.descriptionId, ...r, ref: e });
  }
);
Yg.displayName = Kg;
var qg = "DialogClose", Xg = f.forwardRef(
  (t, e) => {
    const { __scopeDialog: n, ...r } = t, o = mt(qg, n);
    return /* @__PURE__ */ g(
      To.button,
      {
        type: "button",
        ...r,
        ref: e,
        onClick: J(t.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Xg.displayName = qg;
function zc(t) {
  return t ? "open" : "closed";
}
var Zg = "DialogTitleWarning", [HN, Jg] = Eb(Zg, {
  contentName: kn,
  titleName: Hc,
  docsSlug: "dialog"
}), __ = ({ titleId: t }) => {
  const e = Jg(Zg), n = `\`${e.contentName}\` requires a \`${e.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${e.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${e.docsSlug}`;
  return f.useEffect(() => {
    t && (document.getElementById(t) || console.error(n));
  }, [n, t]), null;
}, P_ = "DialogDescriptionWarning", k_ = ({ contentRef: t, descriptionId: e }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Jg(P_).contentName}}.`;
  return f.useEffect(() => {
    var s;
    const o = (s = t.current) == null ? void 0 : s.getAttribute("aria-describedby");
    e && o && (document.getElementById(e) || console.warn(r));
  }, [r, t, e]), null;
}, Qg = Bg, ev = jg, tv = Ug, nv = Hg, Gc = Gg, I_ = Yg, rv = Xg;
const D_ = ae({
  slots: {
    box: [
      "flex flex-col relative bg-clr-bg-modal border-b-4 border-clr-primary h-fit max-h-full min-h-[198px] w-full max-w-[900px]",
      "p-10 pb-7 box-border pointer-events-auto [&_.scroll-area-root:has(.scrollbar)]:w-[calc(100%+20px)]"
    ],
    closeButtonWrapper: "absolute right-4 top-4",
    modal: [
      "preflight fixed top-0 left-0 h-full w-full flex justify-center items-center",
      "px-5 py-10 box-border pointer-events-none data-[state=open]:animate-fadeIn",
      Ap()
    ]
  },
  variants: {
    isDialog: {
      false: {
        box: "border-none"
      }
    }
  }
}), M_ = ({ children: t, isOpen: e, onClose: n, zIndex: r = 2, isDialog: o = !1 }) => {
  const { box: s, closeButtonWrapper: i, modal: a } = D_({ isDialog: o });
  return /* @__PURE__ */ g(Qg, { open: e, children: /* @__PURE__ */ G(ev, { children: [
    /* @__PURE__ */ g(tv, { className: Ns(), onClick: n, style: { zIndex: r - 1 } }),
    /* @__PURE__ */ g(nv, { className: a(), style: { zIndex: r }, children: /* @__PURE__ */ g(Al.Provider, { value: r, children: /* @__PURE__ */ G("div", { className: s(), style: { zIndex: r }, children: [
      /* @__PURE__ */ g(rv, { asChild: !0, children: /* @__PURE__ */ g("div", { className: i(), children: /* @__PURE__ */ g(Tn, { variant: "tertiary", icon: "closer", small: !0, label: "Schließen", onClick: n }) }) }),
      /* @__PURE__ */ g(I_, { className: "sr-only" }),
      !o && /* @__PURE__ */ g(Gc, { className: "sr-only" }),
      t
    ] }) }) })
  ] }) });
}, ai = ({ children: t, contentWidth: e }) => /* @__PURE__ */ g(Pl, { ...t.props, contentWidth: e });
ai.displayName = "PrimaryButton";
const li = ({ children: t, contentWidth: e }) => /* @__PURE__ */ g(Pl, { ...t.props, contentWidth: e, variant: "secondary" });
li.displayName = "SecondaryButton";
const N_ = ae({
  slots: { root: "flex justify-center flex-wrap py-6 gap-3" }
}), ov = ({ owner: t, primary: e, secondary: n, fullWidthButtons: r = !1, classes: o = "" }) => {
  const { getSingleChildFromSubcomponent: s, printBadConstructionMessage: i } = pt([e, n]), a = { contentWidth: !r }, { root: l } = N_();
  return e ? /* @__PURE__ */ G("div", { className: l({ class: o }), children: [
    s(ai, e, a),
    s(li, n || null, a)
  ] }) : (i(`${t}'s ButtonSection`), null);
}, O_ = ae({
  slots: {
    titleClass: "typography-bonprix-h4 text-clr-primary pb-5"
  }
}), ci = ({ isOpen: t, onClose: e, zIndex: n, children: r }) => {
  const { getSubcomponents: o, printBadConstructionMessage: s } = pt(r), { Title: i, Content: a, PrimaryButton: l, SecondaryButton: c } = o();
  return !i || !a ? (s("Dialog"), null) : /* @__PURE__ */ G(M_, { isOpen: t, onClose: e, zIndex: n, isDialog: !0, children: [
    i,
    a,
    l && /* @__PURE__ */ g(ov, { owner: "Dialog", primary: l, secondary: c })
  ] });
}, sv = ({ children: t }) => {
  const { titleClass: e } = O_();
  return /* @__PURE__ */ g(Gc, { className: e(), children: t });
};
sv.displayName = "Title";
const iv = ({ children: t }) => /* @__PURE__ */ g(zs, { verticalOnly: !0, children: t });
iv.displayName = "Content";
ci.Title = sv;
ci.Content = iv;
ci.PrimaryButton = ai;
ci.SecondaryButton = li;
const V_ = {
  1: "col-span-1",
  2: "col-span-2",
  3: "col-span-3",
  4: "col-span-4",
  5: "col-span-5",
  6: "col-span-6",
  7: "col-span-7",
  8: "col-span-8",
  9: "col-span-9",
  10: "col-span-10",
  11: "col-span-11",
  12: "col-span-12"
}, F_ = {
  1: "s:col-span-1",
  2: "s:col-span-2",
  3: "s:col-span-3",
  4: "s:col-span-4",
  5: "s:col-span-5",
  6: "s:col-span-6",
  7: "s:col-span-7",
  8: "s:col-span-8",
  9: "s:col-span-9",
  10: "s:col-span-10",
  11: "s:col-span-11",
  12: "s:col-span-12"
}, L_ = {
  1: "m:col-span-1",
  2: "m:col-span-2",
  3: "m:col-span-3",
  4: "m:col-span-4",
  5: "m:col-span-5",
  6: "m:col-span-6",
  7: "m:col-span-7",
  8: "m:col-span-8",
  9: "m:col-span-9",
  10: "m:col-span-10",
  11: "m:col-span-11",
  12: "m:col-span-12"
}, B_ = {
  1: "l:col-span-1",
  2: "l:col-span-2",
  3: "l:col-span-3",
  4: "l:col-span-4",
  5: "l:col-span-5",
  6: "l:col-span-6",
  7: "l:col-span-7",
  8: "l:col-span-8",
  9: "l:col-span-9",
  10: "l:col-span-10",
  11: "l:col-span-11",
  12: "l:col-span-12"
}, $_ = {
  1: "xl:col-span-1",
  2: "xl:col-span-2",
  3: "xl:col-span-3",
  4: "xl:col-span-4",
  5: "xl:col-span-5",
  6: "xl:col-span-6",
  7: "xl:col-span-7",
  8: "xl:col-span-8",
  9: "xl:col-span-9",
  10: "xl:col-span-10",
  11: "xl:col-span-11",
  12: "xl:col-span-12"
}, W_ = {
  1: "xxl:col-span-1",
  2: "xxl:col-span-2",
  3: "xxl:col-span-3",
  4: "xxl:col-span-4",
  5: "xxl:col-span-5",
  6: "xxl:col-span-6",
  7: "xxl:col-span-7",
  8: "xxl:col-span-8",
  9: "xxl:col-span-9",
  10: "xxl:col-span-10",
  11: "xxl:col-span-11",
  12: "xxl:col-span-12"
}, j_ = {
  1: "xxxl:col-span-1",
  2: "xxxl:col-span-2",
  3: "xxxl:col-span-3",
  4: "xxxl:col-span-4",
  5: "xxxl:col-span-5",
  6: "xxxl:col-span-6",
  7: "xxxl:col-span-7",
  8: "xxxl:col-span-8",
  9: "xxxl:col-span-9",
  10: "xxxl:col-span-10",
  11: "xxxl:col-span-11",
  12: "xxxl:col-span-12"
}, U_ = ae({
  base: "grid grid-cols-12",
  variants: {
    disableGutters: {
      true: "",
      false: "gap-x-5"
    }
  }
}), H_ = ({ children: t, disableGutters: e = !1 }) => {
  const n = U_({ disableGutters: e });
  return /* @__PURE__ */ g("div", { className: n, children: t });
}, av = ({ children: t, span: e = 1, s: n, m: r, l: o, xl: s, xxl: i, xxxl: a, className: l = "" }) => {
  const c = [];
  n && c.push(F_[n]), r && c.push(L_[r]), o && c.push(B_[o]), s && c.push($_[s]), i && c.push(W_[i]), a && c.push(j_[a]), c.length === 0 && c.push(V_[e]);
  const u = c.join(" ");
  return /* @__PURE__ */ g("div", { className: Jn(u, l), children: t });
};
H_.Item = av;
av.displayName = "Grid.Item";
const z_ = (t) => "carousel" in t, G_ = (t) => {
  const { defaultSrc: e, alt: n, title: r } = t;
  if (z_(t))
    return /* @__PURE__ */ g(
      "img",
      {
        className: "w-full h-auto",
        "data-splide-lazy": e,
        alt: n,
        title: r
      }
    );
  {
    const { srcSet: o, width: s, height: i } = t;
    return /* @__PURE__ */ G("picture", { className: "inline-block", children: [
      o.xxxl && /* @__PURE__ */ g("source", { media: `(min-width: ${pe.xxxl}px)`, srcSet: o.xxxl }),
      o.xxl && /* @__PURE__ */ g("source", { media: `(min-width: ${pe.xxl}px)`, srcSet: o.xxl }),
      o.xl && /* @__PURE__ */ g("source", { media: `(min-width: ${pe.xl}px)`, srcSet: o.xl }),
      o.l && /* @__PURE__ */ g("source", { media: `(min-width: ${pe.l}px)`, srcSet: o.l }),
      o.m && /* @__PURE__ */ g("source", { media: `(min-width: ${pe.m}px)`, srcSet: o.m }),
      o.s && /* @__PURE__ */ g("source", { media: `(min-width: ${pe.s}px)`, srcSet: o.s }),
      /* @__PURE__ */ g(
        "img",
        {
          src: e,
          alt: n,
          title: r,
          width: s,
          height: i
        }
      )
    ] });
  }
};
// @__NO_SIDE_EFFECTS__
function K_(t) {
  const e = /* @__PURE__ */ Y_(t), n = f.forwardRef((r, o) => {
    const { children: s, ...i } = r, a = f.Children.toArray(s), l = a.find(X_);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ g(e, { ...i, ref: o, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ g(e, { ...i, ref: o, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function Y_(t) {
  const e = f.forwardRef((n, r) => {
    const { children: o, ...s } = n, i = f.isValidElement(o) ? J_(o) : void 0, a = te(i, r);
    if (f.isValidElement(o)) {
      const l = Z_(s, o.props);
      return o.type !== f.Fragment && (l.ref = a), f.cloneElement(o, l);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var q_ = Symbol("radix.slottable");
function X_(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === q_;
}
function Z_(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const l = s(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function J_(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var Q_ = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], eP = Q_.reduce((t, e) => {
  const n = /* @__PURE__ */ K_(`Primitive.${e}`), r = f.forwardRef((o, s) => {
    const { asChild: i, ...a } = o, l = i ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {}), tP = "Label", lv = f.forwardRef((t, e) => /* @__PURE__ */ g(
  eP.label,
  {
    ...t,
    ref: e,
    onMouseDown: (n) => {
      var o;
      n.target.closest("button, input, select, textarea") || ((o = t.onMouseDown) == null || o.call(t, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
lv.displayName = tP;
var nP = lv;
const rP = ae({
  slots: {
    root: [
      "preflight relative text-clr-primary fill-clr-primary",
      // opacity is just there to create a new stack context
      "[&_.input]:w-full [&_.input]:rounded-sm [&_.input]:typography-input-text [&_.input]:text-inherit",
      "[&_.input]:border [&_.input]:border-transparent [&_.input]:border-b-clr-on-bg-low",
      //border
      "[&_.input]:hover:border-clr-primary ",
      // hover
      "[&_.input]:focus-within:border-clr-primary",
      // focus border
      "[&_.input]:placeholder:typography-caption [&_.input]:text-ellipsis",
      "[&_.input]:placeholder:text-clr-on-bg-mid [&_.input]:placeholder:truncate",
      //input's placeholder
      "[&_.input]:caret-clr-primary"
      // caret
    ],
    inputLabel: "inputLabel text-clr-primary absolute top-3 left-0 duration-300 origin-top-left px-1.5 mx-1.5 inline-block truncate max-w-[calc(100%-12px)] pointer-events-none"
  },
  variants: {
    placeholderShown: {
      false: {
        inputLabel: "typography-input-label top-2 -translate-y-4"
      },
      true: {
        inputLabel: "typography-input-text"
      }
    },
    disabled: {
      true: {
        root: "[&_.input]:placeholder:text-clr-on-bg-disabled text-clr-on-bg-disabled fill-clr-on-bg-disabled pointer-events-none",
        inputLabel: "text-clr-on-bg-disabled"
      }
    },
    error: {
      true: {
        root: [
          "text-clr-error text-clr-error fill-clr-error ",
          "[&_.input]:border-b-clr-error",
          //border
          "[&_.input]:hover:border-clr-error",
          //hover
          "[&_.input]:focus-within:border-clr-error",
          //focus
          "[&_.input]:caret-clr-error"
          //caret
        ],
        inputLabel: "text-clr-error"
      }
    }
  }
}), Kc = ({
  children: t,
  id: e,
  label: n,
  placeholderShown: r,
  disabled: o,
  error: s,
  required: i,
  helperText: a,
  errorText: l,
  labelClassName: c = ""
}) => {
  const { root: u, inputLabel: d } = rP({ placeholderShown: r, disabled: o, error: s }), p = Se(null), h = S0(p);
  return /* @__PURE__ */ G("div", { className: u(), children: [
    t,
    /* @__PURE__ */ G(nP, { htmlFor: e, className: `${d()} ${c}`, ref: p, style: { backgroundColor: h }, children: [
      n,
      i && /* @__PURE__ */ g("span", { "aria-hidden": "true", children: "*" })
    ] }),
    /* @__PURE__ */ g(Bc, { className: "px-3", helperText: a, error: s, errorText: l })
  ] });
}, oP = ae({
  slots: {
    root: "preflight w-full group",
    container: "input flex gap-3 pt-3 px-3 pb-2.5",
    input: "w-full flex-grow outline-none text-ellipsis text-inherit typography-input-text bg-transparent",
    buttonSection: "flex gap-3 items-center",
    clearButton: "opacity-0",
    iconSeparator: "opacity-0 w-px h-5 bg-clr-on-bg-low"
  },
  variants: {
    hasValue: {
      true: "",
      false: ""
    },
    disabled: {
      true: "",
      false: ""
    }
  },
  compoundVariants: [
    {
      hasValue: !0,
      disabled: !1,
      class: {
        clearButton: "group-hover:opacity-100 group-focus-within:opacity-100",
        iconSeparator: "group-hover:opacity-100 group-focus-within:opacity-100"
      }
    }
  ]
}), ui = ({
  type: t,
  onFocus: e,
  onBlur: n,
  onKeyDown: r,
  onKeyUp: o,
  inputRef: s,
  label: i,
  name: a,
  id: l,
  helperText: c,
  errorText: u,
  disabled: d = !1,
  required: p = !1,
  error: h = !1,
  inputMode: v,
  pattern: m,
  autoComplete: y,
  autoCorrect: b,
  spellCheck: w,
  maxLength: x,
  hideClear: E = !1,
  describedBy: C,
  buttonIcon: A,
  iconButtonType: S = "button",
  onIconButtonClick: R,
  iconButtonLabel: P,
  ...k
}) => {
  const I = l || cn();
  let _;
  k.value !== void 0 ? _ = !!k.value : _ = !!k.defaultValue;
  const [D, N] = de(!1), [W, L] = de(_), B = !W && !D, V = Se(null), $ = s || V, { root: T, container: M, input: H, buttonSection: Z, clearButton: U, iconSeparator: X } = oP({
    disabled: d,
    hasValue: W
  }), O = () => {
    N(!0), e && e();
  }, F = () => {
    N(!1), n && n();
  }, z = (j) => {
    var le;
    const K = j.currentTarget.value;
    (le = k.onChange) == null || le.call(k, K), W !== !!K && L(!!K);
  }, q = "Eingabe löschen", Y = () => {
    var j;
    k.value ? k.onChange("") : $.current && ($.current.value = ""), L(!1), (j = $.current) == null || j.focus();
  }, re = A && !E;
  return /* @__PURE__ */ g("div", { className: T(), children: /* @__PURE__ */ g(
    Kc,
    {
      label: i,
      id: I,
      placeholderShown: B,
      disabled: d,
      error: h,
      required: p,
      helperText: c,
      errorText: u,
      children: /* @__PURE__ */ G("div", { className: M(), children: [
        /* @__PURE__ */ g(
          "input",
          {
            ...k,
            type: t,
            className: H(),
            id: I,
            name: a,
            onChange: z,
            onFocus: O,
            onBlur: F,
            onKeyDown: r,
            onKeyUp: o,
            inputMode: v,
            pattern: m,
            autoComplete: y,
            autoCorrect: b,
            spellCheck: w,
            ref: $,
            "aria-describedby": C,
            maxLength: x
          }
        ),
        /* @__PURE__ */ G("div", { className: Z(), children: [
          !E && /* @__PURE__ */ g("div", { className: U(), children: /* @__PURE__ */ g(Tn, { variant: "tertiary", small: !0, type: "button", icon: "closer", onClick: Y, label: q }) }),
          re && /* @__PURE__ */ g("span", { className: X() }),
          A && /* @__PURE__ */ g(
            Tn,
            {
              variant: "tertiary",
              small: !0,
              type: S,
              icon: A,
              onClick: R,
              label: P,
              disabled: d
            }
          )
        ] })
      ] })
    }
  ) });
}, zN = (t) => {
  const [e, n] = de("password");
  return /* @__PURE__ */ g(
    ui,
    {
      type: e,
      buttonIcon: e === "password" ? "visibility" : "visibility-off",
      onIconButtonClick: () => n((i) => i === "password" ? "text" : "password"),
      iconButtonLabel: e === "password" ? "Passwort anzeigen" : "Passwort verstecken",
      hideClear: !0,
      ...t
    }
  );
};
function en(t) {
  return typeof t == "string" || t instanceof String;
}
function _f(t) {
  var e;
  return typeof t == "object" && t != null && (t == null || (e = t.constructor) == null ? void 0 : e.name) === "Object";
}
function cv(t, e) {
  return Array.isArray(e) ? cv(t, (n, r) => e.includes(r)) : Object.entries(t).reduce((n, r) => {
    let [o, s] = r;
    return e(s, o) && (n[o] = s), n;
  }, {});
}
const ee = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function sP(t) {
  switch (t) {
    case ee.LEFT:
      return ee.FORCE_LEFT;
    case ee.RIGHT:
      return ee.FORCE_RIGHT;
    default:
      return t;
  }
}
function ra(t) {
  return t.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
}
function xs(t, e) {
  if (e === t) return !0;
  const n = Array.isArray(e), r = Array.isArray(t);
  let o;
  if (n && r) {
    if (e.length != t.length) return !1;
    for (o = 0; o < e.length; o++) if (!xs(e[o], t[o])) return !1;
    return !0;
  }
  if (n != r) return !1;
  if (e && t && typeof e == "object" && typeof t == "object") {
    const s = e instanceof Date, i = t instanceof Date;
    if (s && i) return e.getTime() == t.getTime();
    if (s != i) return !1;
    const a = e instanceof RegExp, l = t instanceof RegExp;
    if (a && l) return e.toString() == t.toString();
    if (a != l) return !1;
    const c = Object.keys(e);
    for (o = 0; o < c.length; o++) if (!Object.prototype.hasOwnProperty.call(t, c[o])) return !1;
    for (o = 0; o < c.length; o++) if (!xs(t[c[o]], e[c[o]])) return !1;
    return !0;
  } else if (e && t && typeof e == "function" && typeof t == "function")
    return e.toString() === t.toString();
  return !1;
}
class iP {
  /** Current input value */
  /** Current cursor position */
  /** Old input value */
  /** Old selection */
  constructor(e) {
    for (Object.assign(this, e); this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos); )
      --this.oldSelection.start;
    if (this.insertedCount)
      for (; this.value.slice(this.cursorPos) !== this.oldValue.slice(this.oldSelection.end); )
        this.value.length - this.cursorPos < this.oldValue.length - this.oldSelection.end ? ++this.oldSelection.end : ++this.cursorPos;
  }
  /** Start changing position */
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }
  /** Inserted symbols count */
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }
  /** Inserted symbols */
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }
  /** Removed symbols count */
  get removedCount() {
    return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
    this.oldValue.length - this.value.length, 0);
  }
  /** Removed symbols */
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }
  /** Unchanged head symbols */
  get head() {
    return this.value.substring(0, this.startChangePos);
  }
  /** Unchanged tail symbols */
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }
  /** Remove direction */
  get removeDirection() {
    return !this.removedCount || this.insertedCount ? ee.NONE : (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
    this.oldSelection.end === this.oldSelection.start ? ee.RIGHT : ee.LEFT;
  }
}
function se(t, e) {
  return new se.InputMask(t, e);
}
function uv(t) {
  if (t == null) throw new Error("mask property should be defined");
  return t instanceof RegExp ? se.MaskedRegExp : en(t) ? se.MaskedPattern : t === Date ? se.MaskedDate : t === Number ? se.MaskedNumber : Array.isArray(t) || t === Array ? se.MaskedDynamic : se.Masked && t.prototype instanceof se.Masked ? t : se.Masked && t instanceof se.Masked ? t.constructor : t instanceof Function ? se.MaskedFunction : (console.warn("Mask not found for mask", t), se.Masked);
}
function io(t) {
  if (!t) throw new Error("Options in not defined");
  if (se.Masked) {
    if (t.prototype instanceof se.Masked) return {
      mask: t
    };
    const {
      mask: e = void 0,
      ...n
    } = t instanceof se.Masked ? {
      mask: t
    } : _f(t) && t.mask instanceof se.Masked ? t : {};
    if (e) {
      const r = e.mask;
      return {
        ...cv(e, (o, s) => !s.startsWith("_")),
        mask: e.constructor,
        _mask: r,
        ...n
      };
    }
  }
  return _f(t) ? {
    ...t
  } : {
    mask: t
  };
}
function Ht(t) {
  if (se.Masked && t instanceof se.Masked) return t;
  const e = io(t), n = uv(e.mask);
  if (!n) throw new Error("Masked class is not found for provided mask " + e.mask + ", appropriate module needs to be imported manually before creating mask.");
  return e.mask === n && delete e.mask, e._mask && (e.mask = e._mask, delete e._mask), new n(e);
}
se.createMask = Ht;
class Yc {
  /** */
  /** */
  /** */
  /** Safely returns selection start */
  get selectionStart() {
    let e;
    try {
      e = this._unsafeSelectionStart;
    } catch {
    }
    return e ?? this.value.length;
  }
  /** Safely returns selection end */
  get selectionEnd() {
    let e;
    try {
      e = this._unsafeSelectionEnd;
    } catch {
    }
    return e ?? this.value.length;
  }
  /** Safely sets element selection */
  select(e, n) {
    if (!(e == null || n == null || e === this.selectionStart && n === this.selectionEnd))
      try {
        this._unsafeSelect(e, n);
      } catch {
      }
  }
  /** */
  get isActive() {
    return !1;
  }
  /** */
  /** */
  /** */
}
se.MaskElement = Yc;
const Pf = 90, aP = 89;
class di extends Yc {
  /** HTMLElement to use mask on */
  constructor(e) {
    super(), this.input = e, this._onKeydown = this._onKeydown.bind(this), this._onInput = this._onInput.bind(this), this._onBeforeinput = this._onBeforeinput.bind(this), this._onCompositionEnd = this._onCompositionEnd.bind(this);
  }
  get rootElement() {
    var e, n, r;
    return (e = (n = (r = this.input).getRootNode) == null ? void 0 : n.call(r)) != null ? e : document;
  }
  /** Is element in focus */
  get isActive() {
    return this.input === this.rootElement.activeElement;
  }
  /** Binds HTMLElement events to mask internal events */
  bindEvents(e) {
    this.input.addEventListener("keydown", this._onKeydown), this.input.addEventListener("input", this._onInput), this.input.addEventListener("beforeinput", this._onBeforeinput), this.input.addEventListener("compositionend", this._onCompositionEnd), this.input.addEventListener("drop", e.drop), this.input.addEventListener("click", e.click), this.input.addEventListener("focus", e.focus), this.input.addEventListener("blur", e.commit), this._handlers = e;
  }
  _onKeydown(e) {
    if (this._handlers.redo && (e.keyCode === Pf && e.shiftKey && (e.metaKey || e.ctrlKey) || e.keyCode === aP && e.ctrlKey))
      return e.preventDefault(), this._handlers.redo(e);
    if (this._handlers.undo && e.keyCode === Pf && (e.metaKey || e.ctrlKey))
      return e.preventDefault(), this._handlers.undo(e);
    e.isComposing || this._handlers.selectionChange(e);
  }
  _onBeforeinput(e) {
    if (e.inputType === "historyUndo" && this._handlers.undo)
      return e.preventDefault(), this._handlers.undo(e);
    if (e.inputType === "historyRedo" && this._handlers.redo)
      return e.preventDefault(), this._handlers.redo(e);
  }
  _onCompositionEnd(e) {
    this._handlers.input(e);
  }
  _onInput(e) {
    e.isComposing || this._handlers.input(e);
  }
  /** Unbinds HTMLElement events to mask internal events */
  unbindEvents() {
    this.input.removeEventListener("keydown", this._onKeydown), this.input.removeEventListener("input", this._onInput), this.input.removeEventListener("beforeinput", this._onBeforeinput), this.input.removeEventListener("compositionend", this._onCompositionEnd), this.input.removeEventListener("drop", this._handlers.drop), this.input.removeEventListener("click", this._handlers.click), this.input.removeEventListener("focus", this._handlers.focus), this.input.removeEventListener("blur", this._handlers.commit), this._handlers = {};
  }
}
se.HTMLMaskElement = di;
class lP extends di {
  /** InputElement to use mask on */
  constructor(e) {
    super(e), this.input = e;
  }
  /** Returns InputElement selection start */
  get _unsafeSelectionStart() {
    return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
  }
  /** Returns InputElement selection end */
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }
  /** Sets InputElement selection */
  _unsafeSelect(e, n) {
    this.input.setSelectionRange(e, n);
  }
  get value() {
    return this.input.value;
  }
  set value(e) {
    this.input.value = e;
  }
}
se.HTMLMaskElement = di;
class dv extends di {
  /** Returns HTMLElement selection start */
  get _unsafeSelectionStart() {
    const e = this.rootElement, n = e.getSelection && e.getSelection(), r = n && n.anchorOffset, o = n && n.focusOffset;
    return o == null || r == null || r < o ? r : o;
  }
  /** Returns HTMLElement selection end */
  get _unsafeSelectionEnd() {
    const e = this.rootElement, n = e.getSelection && e.getSelection(), r = n && n.anchorOffset, o = n && n.focusOffset;
    return o == null || r == null || r > o ? r : o;
  }
  /** Sets HTMLElement selection */
  _unsafeSelect(e, n) {
    if (!this.rootElement.createRange) return;
    const r = this.rootElement.createRange();
    r.setStart(this.input.firstChild || this.input, e), r.setEnd(this.input.lastChild || this.input, n);
    const o = this.rootElement, s = o.getSelection && o.getSelection();
    s && (s.removeAllRanges(), s.addRange(r));
  }
  /** HTMLElement value */
  get value() {
    return this.input.textContent || "";
  }
  set value(e) {
    this.input.textContent = e;
  }
}
se.HTMLContenteditableMaskElement = dv;
class fi {
  constructor() {
    this.states = [], this.currentIndex = 0;
  }
  get currentState() {
    return this.states[this.currentIndex];
  }
  get isEmpty() {
    return this.states.length === 0;
  }
  push(e) {
    this.currentIndex < this.states.length - 1 && (this.states.length = this.currentIndex + 1), this.states.push(e), this.states.length > fi.MAX_LENGTH && this.states.shift(), this.currentIndex = this.states.length - 1;
  }
  go(e) {
    return this.currentIndex = Math.min(Math.max(this.currentIndex + e, 0), this.states.length - 1), this.currentState;
  }
  undo() {
    return this.go(-1);
  }
  redo() {
    return this.go(1);
  }
  clear() {
    this.states.length = 0, this.currentIndex = 0;
  }
}
fi.MAX_LENGTH = 100;
class cP {
  /**
    View element
  */
  /** Internal {@link Masked} model */
  constructor(e, n) {
    this.el = e instanceof Yc ? e : e.isContentEditable && e.tagName !== "INPUT" && e.tagName !== "TEXTAREA" ? new dv(e) : new lP(e), this.masked = Ht(n), this._listeners = {}, this._value = "", this._unmaskedValue = "", this._rawInputValue = "", this.history = new fi(), this._saveSelection = this._saveSelection.bind(this), this._onInput = this._onInput.bind(this), this._onChange = this._onChange.bind(this), this._onDrop = this._onDrop.bind(this), this._onFocus = this._onFocus.bind(this), this._onClick = this._onClick.bind(this), this._onUndo = this._onUndo.bind(this), this._onRedo = this._onRedo.bind(this), this.alignCursor = this.alignCursor.bind(this), this.alignCursorFriendly = this.alignCursorFriendly.bind(this), this._bindEvents(), this.updateValue(), this._onChange();
  }
  maskEquals(e) {
    var n;
    return e == null || ((n = this.masked) == null ? void 0 : n.maskEquals(e));
  }
  /** Masked */
  get mask() {
    return this.masked.mask;
  }
  set mask(e) {
    if (this.maskEquals(e)) return;
    if (!(e instanceof se.Masked) && this.masked.constructor === uv(e)) {
      this.masked.updateOptions({
        mask: e
      });
      return;
    }
    const n = e instanceof se.Masked ? e : Ht({
      mask: e
    });
    n.unmaskedValue = this.masked.unmaskedValue, this.masked = n;
  }
  /** Raw value */
  get value() {
    return this._value;
  }
  set value(e) {
    this.value !== e && (this.masked.value = e, this.updateControl("auto"));
  }
  /** Unmasked value */
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(e) {
    this.unmaskedValue !== e && (this.masked.unmaskedValue = e, this.updateControl("auto"));
  }
  /** Raw input value */
  get rawInputValue() {
    return this._rawInputValue;
  }
  set rawInputValue(e) {
    this.rawInputValue !== e && (this.masked.rawInputValue = e, this.updateControl(), this.alignCursor());
  }
  /** Typed unmasked value */
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(e) {
    this.masked.typedValueEquals(e) || (this.masked.typedValue = e, this.updateControl("auto"));
  }
  /** Display value */
  get displayValue() {
    return this.masked.displayValue;
  }
  /** Starts listening to element events */
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange,
      undo: this._onUndo,
      redo: this._onRedo
    });
  }
  /** Stops listening to element events */
  _unbindEvents() {
    this.el && this.el.unbindEvents();
  }
  /** Fires custom event */
  _fireEvent(e, n) {
    const r = this._listeners[e];
    r && r.forEach((o) => o(n));
  }
  /** Current selection start */
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }
  /** Current cursor position */
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(e) {
    !this.el || !this.el.isActive || (this.el.select(e, e), this._saveSelection());
  }
  /** Stores current selection */
  _saveSelection() {
    this.displayValue !== this.el.value && console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."), this._selection = {
      start: this.selectionStart,
      end: this.cursorPos
    };
  }
  /** Syncronizes model value from view */
  updateValue() {
    this.masked.value = this.el.value, this._value = this.masked.value, this._unmaskedValue = this.masked.unmaskedValue, this._rawInputValue = this.masked.rawInputValue;
  }
  /** Syncronizes view from model value, fires change events */
  updateControl(e) {
    const n = this.masked.unmaskedValue, r = this.masked.value, o = this.masked.rawInputValue, s = this.displayValue, i = this.unmaskedValue !== n || this.value !== r || this._rawInputValue !== o;
    this._unmaskedValue = n, this._value = r, this._rawInputValue = o, this.el.value !== s && (this.el.value = s), e === "auto" ? this.alignCursor() : e != null && (this.cursorPos = e), i && this._fireChangeEvents(), !this._historyChanging && (i || this.history.isEmpty) && this.history.push({
      unmaskedValue: n,
      selection: {
        start: this.selectionStart,
        end: this.cursorPos
      }
    });
  }
  /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */
  updateOptions(e) {
    const {
      mask: n,
      ...r
    } = e, o = !this.maskEquals(n), s = this.masked.optionsIsChanged(r);
    o && (this.mask = n), s && this.masked.updateOptions(r), (o || s) && this.updateControl();
  }
  /** Updates cursor */
  updateCursor(e) {
    e != null && (this.cursorPos = e, this._delayUpdateCursor(e));
  }
  /** Delays cursor update to support mobile browsers */
  _delayUpdateCursor(e) {
    this._abortUpdateCursor(), this._changingCursorPos = e, this._cursorChanging = setTimeout(() => {
      this.el && (this.cursorPos = this._changingCursorPos, this._abortUpdateCursor());
    }, 10);
  }
  /** Fires custom events */
  _fireChangeEvents() {
    this._fireEvent("accept", this._inputEvent), this.masked.isComplete && this._fireEvent("complete", this._inputEvent);
  }
  /** Aborts delayed cursor update */
  _abortUpdateCursor() {
    this._cursorChanging && (clearTimeout(this._cursorChanging), delete this._cursorChanging);
  }
  /** Aligns cursor to nearest available position */
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, ee.LEFT));
  }
  /** Aligns cursor only if selection is empty */
  alignCursorFriendly() {
    this.selectionStart === this.cursorPos && this.alignCursor();
  }
  /** Adds listener on custom event */
  on(e, n) {
    return this._listeners[e] || (this._listeners[e] = []), this._listeners[e].push(n), this;
  }
  /** Removes custom event listener */
  off(e, n) {
    if (!this._listeners[e]) return this;
    if (!n)
      return delete this._listeners[e], this;
    const r = this._listeners[e].indexOf(n);
    return r >= 0 && this._listeners[e].splice(r, 1), this;
  }
  /** Handles view input event */
  _onInput(e) {
    this._inputEvent = e, this._abortUpdateCursor();
    const n = new iP({
      // new state
      value: this.el.value,
      cursorPos: this.cursorPos,
      // old state
      oldValue: this.displayValue,
      oldSelection: this._selection
    }), r = this.masked.rawInputValue, o = this.masked.splice(n.startChangePos, n.removed.length, n.inserted, n.removeDirection, {
      input: !0,
      raw: !0
    }).offset, s = r === this.masked.rawInputValue ? n.removeDirection : ee.NONE;
    let i = this.masked.nearestInputPos(n.startChangePos + o, s);
    s !== ee.NONE && (i = this.masked.nearestInputPos(i, ee.NONE)), this.updateControl(i), delete this._inputEvent;
  }
  /** Handles view change event and commits model value */
  _onChange() {
    this.displayValue !== this.el.value && this.updateValue(), this.masked.doCommit(), this.updateControl(), this._saveSelection();
  }
  /** Handles view drop event, prevents by default */
  _onDrop(e) {
    e.preventDefault(), e.stopPropagation();
  }
  /** Restore last selection on focus */
  _onFocus(e) {
    this.alignCursorFriendly();
  }
  /** Restore last selection on focus */
  _onClick(e) {
    this.alignCursorFriendly();
  }
  _onUndo() {
    this._applyHistoryState(this.history.undo());
  }
  _onRedo() {
    this._applyHistoryState(this.history.redo());
  }
  _applyHistoryState(e) {
    e && (this._historyChanging = !0, this.unmaskedValue = e.unmaskedValue, this.el.select(e.selection.start, e.selection.end), this._saveSelection(), this._historyChanging = !1);
  }
  /** Unbind view events and removes element reference */
  destroy() {
    this._unbindEvents(), this._listeners.length = 0, delete this.el;
  }
}
se.InputMask = cP;
class fe {
  /** Inserted symbols */
  /** Additional offset if any changes occurred before tail */
  /** Raw inserted is used by dynamic mask */
  /** Can skip chars */
  static normalize(e) {
    return Array.isArray(e) ? e : [e, new fe()];
  }
  constructor(e) {
    Object.assign(this, {
      inserted: "",
      rawInserted: "",
      tailShift: 0,
      skip: !1
    }, e);
  }
  /** Aggregate changes */
  aggregate(e) {
    return this.inserted += e.inserted, this.rawInserted += e.rawInserted, this.tailShift += e.tailShift, this.skip = this.skip || e.skip, this;
  }
  /** Total offset considering all changes */
  get offset() {
    return this.tailShift + this.inserted.length;
  }
  get consumed() {
    return !!this.rawInserted || this.skip;
  }
  equals(e) {
    return this.inserted === e.inserted && this.tailShift === e.tailShift && this.rawInserted === e.rawInserted && this.skip === e.skip;
  }
}
se.ChangeDetails = fe;
class vt {
  /** Tail value as string */
  /** Tail start position */
  /** Start position */
  constructor(e, n, r) {
    e === void 0 && (e = ""), n === void 0 && (n = 0), this.value = e, this.from = n, this.stop = r;
  }
  toString() {
    return this.value;
  }
  extend(e) {
    this.value += String(e);
  }
  appendTo(e) {
    return e.append(this.toString(), {
      tail: !0
    }).aggregate(e._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  unshift(e) {
    if (!this.value.length || e != null && this.from >= e) return "";
    const n = this.value[0];
    return this.value = this.value.slice(1), n;
  }
  shift() {
    if (!this.value.length) return "";
    const e = this.value[this.value.length - 1];
    return this.value = this.value.slice(0, -1), e;
  }
}
class Oe {
  /** */
  /** */
  /** Transforms value before mask processing */
  /** Transforms each char before mask processing */
  /** Validates if value is acceptable */
  /** Does additional processing at the end of editing */
  /** Format typed value to string */
  /** Parse string to get typed value */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    this._value = "", this._update({
      ...Oe.DEFAULTS,
      ...e
    }), this._initialized = !0;
  }
  /** Sets and applies new options */
  updateOptions(e) {
    this.optionsIsChanged(e) && this.withValueRefresh(this._update.bind(this, e));
  }
  /** Sets new options */
  _update(e) {
    Object.assign(this, e);
  }
  /** Mask state */
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(e) {
    this._value = e._value;
  }
  /** Resets value */
  reset() {
    this._value = "";
  }
  get value() {
    return this._value;
  }
  set value(e) {
    this.resolve(e, {
      input: !0
    });
  }
  /** Resolve new value */
  resolve(e, n) {
    n === void 0 && (n = {
      input: !0
    }), this.reset(), this.append(e, n, ""), this.doCommit();
  }
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(e) {
    this.resolve(e, {});
  }
  get typedValue() {
    return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
  }
  set typedValue(e) {
    this.format ? this.value = this.format(e, this) : this.unmaskedValue = String(e);
  }
  /** Value that includes raw user input */
  get rawInputValue() {
    return this.extractInput(0, this.displayValue.length, {
      raw: !0
    });
  }
  set rawInputValue(e) {
    this.resolve(e, {
      raw: !0
    });
  }
  get displayValue() {
    return this.value;
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return this.isComplete;
  }
  /** Finds nearest input position in direction */
  nearestInputPos(e, n) {
    return e;
  }
  totalInputPositions(e, n) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), Math.min(this.displayValue.length, n - e);
  }
  /** Extracts value in range considering flags */
  extractInput(e, n, r) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), this.displayValue.slice(e, n);
  }
  /** Extracts tail in range */
  extractTail(e, n) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), new vt(this.extractInput(e, n), e);
  }
  /** Appends tail */
  appendTail(e) {
    return en(e) && (e = new vt(String(e))), e.appendTo(this);
  }
  /** Appends char */
  _appendCharRaw(e, n) {
    return e ? (this._value += e, new fe({
      inserted: e,
      rawInserted: e
    })) : new fe();
  }
  /** Appends char */
  _appendChar(e, n, r) {
    n === void 0 && (n = {});
    const o = this.state;
    let s;
    if ([e, s] = this.doPrepareChar(e, n), e && (s = s.aggregate(this._appendCharRaw(e, n)), !s.rawInserted && this.autofix === "pad")) {
      const i = this.state;
      this.state = o;
      let a = this.pad(n);
      const l = this._appendCharRaw(e, n);
      a = a.aggregate(l), l.rawInserted || a.equals(s) ? s = a : this.state = i;
    }
    if (s.inserted) {
      let i, a = this.doValidate(n) !== !1;
      if (a && r != null) {
        const l = this.state;
        if (this.overwrite === !0) {
          i = r.state;
          for (let u = 0; u < s.rawInserted.length; ++u)
            r.unshift(this.displayValue.length - s.tailShift);
        }
        let c = this.appendTail(r);
        if (a = c.rawInserted.length === r.toString().length, !(a && c.inserted) && this.overwrite === "shift") {
          this.state = l, i = r.state;
          for (let u = 0; u < s.rawInserted.length; ++u)
            r.shift();
          c = this.appendTail(r), a = c.rawInserted.length === r.toString().length;
        }
        a && c.inserted && (this.state = l);
      }
      a || (s = new fe(), this.state = o, r && i && (r.state = i));
    }
    return s;
  }
  /** Appends optional placeholder at the end */
  _appendPlaceholder() {
    return new fe();
  }
  /** Appends optional eager placeholder at the end */
  _appendEager() {
    return new fe();
  }
  /** Appends symbols considering flags */
  append(e, n, r) {
    if (!en(e)) throw new Error("value should be string");
    const o = en(r) ? new vt(String(r)) : r;
    n != null && n.tail && (n._beforeTailState = this.state);
    let s;
    [e, s] = this.doPrepare(e, n);
    for (let i = 0; i < e.length; ++i) {
      const a = this._appendChar(e[i], n, o);
      if (!a.rawInserted && !this.doSkipInvalid(e[i], n, o)) break;
      s.aggregate(a);
    }
    return (this.eager === !0 || this.eager === "append") && n != null && n.input && e && s.aggregate(this._appendEager()), o != null && (s.tailShift += this.appendTail(o).tailShift), s;
  }
  remove(e, n) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), this._value = this.displayValue.slice(0, e) + this.displayValue.slice(n), new fe();
  }
  /** Calls function and reapplies current value */
  withValueRefresh(e) {
    if (this._refreshing || !this._initialized) return e();
    this._refreshing = !0;
    const n = this.rawInputValue, r = this.value, o = e();
    return this.rawInputValue = n, this.value && this.value !== r && r.indexOf(this.value) === 0 && (this.append(r.slice(this.displayValue.length), {}, ""), this.doCommit()), delete this._refreshing, o;
  }
  runIsolated(e) {
    if (this._isolated || !this._initialized) return e(this);
    this._isolated = !0;
    const n = this.state, r = e(this);
    return this.state = n, delete this._isolated, r;
  }
  doSkipInvalid(e, n, r) {
    return !!this.skipInvalid;
  }
  /** Prepares string before mask processing */
  doPrepare(e, n) {
    return n === void 0 && (n = {}), fe.normalize(this.prepare ? this.prepare(e, this, n) : e);
  }
  /** Prepares each char before mask processing */
  doPrepareChar(e, n) {
    return n === void 0 && (n = {}), fe.normalize(this.prepareChar ? this.prepareChar(e, this, n) : e);
  }
  /** Validates if value is acceptable */
  doValidate(e) {
    return (!this.validate || this.validate(this.value, this, e)) && (!this.parent || this.parent.doValidate(e));
  }
  /** Does additional processing at the end of editing */
  doCommit() {
    this.commit && this.commit(this.value, this);
  }
  splice(e, n, r, o, s) {
    r === void 0 && (r = ""), o === void 0 && (o = ee.NONE), s === void 0 && (s = {
      input: !0
    });
    const i = e + n, a = this.extractTail(i), l = this.eager === !0 || this.eager === "remove";
    let c;
    l && (o = sP(o), c = this.extractInput(0, i, {
      raw: !0
    }));
    let u = e;
    const d = new fe();
    if (o !== ee.NONE && (u = this.nearestInputPos(e, n > 1 && e !== 0 && !l ? ee.NONE : o), d.tailShift = u - e), d.aggregate(this.remove(u)), l && o !== ee.NONE && c === this.rawInputValue)
      if (o === ee.FORCE_LEFT) {
        let p;
        for (; c === this.rawInputValue && (p = this.displayValue.length); )
          d.aggregate(new fe({
            tailShift: -1
          })).aggregate(this.remove(p - 1));
      } else o === ee.FORCE_RIGHT && a.unshift();
    return d.aggregate(this.append(r, s, a));
  }
  maskEquals(e) {
    return this.mask === e;
  }
  optionsIsChanged(e) {
    return !xs(this, e);
  }
  typedValueEquals(e) {
    const n = this.typedValue;
    return e === n || Oe.EMPTY_VALUES.includes(e) && Oe.EMPTY_VALUES.includes(n) || (this.format ? this.format(e, this) === this.format(this.typedValue, this) : !1);
  }
  pad(e) {
    return new fe();
  }
}
Oe.DEFAULTS = {
  skipInvalid: !0
};
Oe.EMPTY_VALUES = [void 0, null, ""];
se.Masked = Oe;
class Cn {
  /** */
  constructor(e, n) {
    e === void 0 && (e = []), n === void 0 && (n = 0), this.chunks = e, this.from = n;
  }
  toString() {
    return this.chunks.map(String).join("");
  }
  extend(e) {
    if (!String(e)) return;
    e = en(e) ? new vt(String(e)) : e;
    const n = this.chunks[this.chunks.length - 1], r = n && // if stops are same or tail has no stop
    (n.stop === e.stop || e.stop == null) && // if tail chunk goes just after last chunk
    e.from === n.from + n.toString().length;
    if (e instanceof vt)
      r ? n.extend(e.toString()) : this.chunks.push(e);
    else if (e instanceof Cn) {
      if (e.stop == null) {
        let o;
        for (; e.chunks.length && e.chunks[0].stop == null; )
          o = e.chunks.shift(), o.from += e.from, this.extend(o);
      }
      e.toString() && (e.stop = e.blockIndex, this.chunks.push(e));
    }
  }
  appendTo(e) {
    if (!(e instanceof se.MaskedPattern))
      return new vt(this.toString()).appendTo(e);
    const n = new fe();
    for (let r = 0; r < this.chunks.length; ++r) {
      const o = this.chunks[r], s = e._mapPosToBlock(e.displayValue.length), i = o.stop;
      let a;
      if (i != null && // if block not found or stop is behind lastBlock
      (!s || s.index <= i) && ((o instanceof Cn || // for continuous block also check if stop is exist
      e._stops.indexOf(i) >= 0) && n.aggregate(e._appendPlaceholder(i)), a = o instanceof Cn && e._blocks[i]), a) {
        const l = a.appendTail(o);
        n.aggregate(l);
        const c = o.toString().slice(l.rawInserted.length);
        c && n.aggregate(e.append(c, {
          tail: !0
        }));
      } else
        n.aggregate(e.append(o.toString(), {
          tail: !0
        }));
    }
    return n;
  }
  get state() {
    return {
      chunks: this.chunks.map((e) => e.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(e) {
    const {
      chunks: n,
      ...r
    } = e;
    Object.assign(this, r), this.chunks = n.map((o) => {
      const s = "chunks" in o ? new Cn() : new vt();
      return s.state = o, s;
    });
  }
  unshift(e) {
    if (!this.chunks.length || e != null && this.from >= e) return "";
    const n = e != null ? e - this.from : e;
    let r = 0;
    for (; r < this.chunks.length; ) {
      const o = this.chunks[r], s = o.unshift(n);
      if (o.toString()) {
        if (!s) break;
        ++r;
      } else
        this.chunks.splice(r, 1);
      if (s) return s;
    }
    return "";
  }
  shift() {
    if (!this.chunks.length) return "";
    let e = this.chunks.length - 1;
    for (; 0 <= e; ) {
      const n = this.chunks[e], r = n.shift();
      if (n.toString()) {
        if (!r) break;
        --e;
      } else
        this.chunks.splice(e, 1);
      if (r) return r;
    }
    return "";
  }
}
class uP {
  constructor(e, n) {
    this.masked = e, this._log = [];
    const {
      offset: r,
      index: o
    } = e._mapPosToBlock(n) || (n < 0 ? (
      // first
      {
        index: 0,
        offset: 0
      }
    ) : (
      // last
      {
        index: this.masked._blocks.length,
        offset: 0
      }
    ));
    this.offset = r, this.index = o, this.ok = !1;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok
    };
  }
  set state(e) {
    Object.assign(this, e);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const e = this._log.pop();
    return e && (this.state = e), e;
  }
  bindBlock() {
    this.block || (this.index < 0 && (this.index = 0, this.offset = 0), this.index >= this.masked._blocks.length && (this.index = this.masked._blocks.length - 1, this.offset = this.block.displayValue.length));
  }
  _pushLeft(e) {
    for (this.pushState(), this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((n = this.block) == null ? void 0 : n.displayValue.length) || 0) {
      var n;
      if (e()) return this.ok = !0;
    }
    return this.ok = !1;
  }
  _pushRight(e) {
    for (this.pushState(), this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0)
      if (e()) return this.ok = !0;
    return this.ok = !1;
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, ee.FORCE_LEFT), this.offset !== 0))
        return !0;
    });
  }
  pushLeftBeforeInput() {
    return this._pushLeft(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, ee.LEFT), !0;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, ee.LEFT), !0;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || !this.block.value) && (this.offset = this.block.nearestInputPos(this.offset, ee.FORCE_RIGHT), this.offset !== this.block.value.length))
        return !0;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (!this.block.isFixed)
        return this.offset = this.block.nearestInputPos(this.offset, ee.NONE), !0;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (!(this.block.isFixed || this.block.isOptional && !this.block.value))
        return this.offset = this.block.nearestInputPos(this.offset, ee.NONE), !0;
    });
  }
}
class fv {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    Object.assign(this, e), this._value = "", this.isFixed = !0;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : "";
  }
  get rawInputValue() {
    return this._isRawInput ? this.value : "";
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = !1, this._value = "";
  }
  remove(e, n) {
    return e === void 0 && (e = 0), n === void 0 && (n = this._value.length), this._value = this._value.slice(0, e) + this._value.slice(n), this._value || (this._isRawInput = !1), new fe();
  }
  nearestInputPos(e, n) {
    n === void 0 && (n = ee.NONE);
    const r = 0, o = this._value.length;
    switch (n) {
      case ee.LEFT:
      case ee.FORCE_LEFT:
        return r;
      case ee.NONE:
      case ee.RIGHT:
      case ee.FORCE_RIGHT:
      default:
        return o;
    }
  }
  totalInputPositions(e, n) {
    return e === void 0 && (e = 0), n === void 0 && (n = this._value.length), this._isRawInput ? n - e : 0;
  }
  extractInput(e, n, r) {
    return e === void 0 && (e = 0), n === void 0 && (n = this._value.length), r === void 0 && (r = {}), r.raw && this._isRawInput && this._value.slice(e, n) || "";
  }
  get isComplete() {
    return !0;
  }
  get isFilled() {
    return !!this._value;
  }
  _appendChar(e, n) {
    if (n === void 0 && (n = {}), this.isFilled) return new fe();
    const r = this.eager === !0 || this.eager === "append", s = this.char === e && (this.isUnmasking || n.input || n.raw) && (!n.raw || !r) && !n.tail, i = new fe({
      inserted: this.char,
      rawInserted: s ? this.char : ""
    });
    return this._value = this.char, this._isRawInput = s && (n.raw || n.input), i;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: !0
    });
  }
  _appendPlaceholder() {
    const e = new fe();
    return this.isFilled || (this._value = e.inserted = this.char), e;
  }
  extractTail() {
    return new vt("");
  }
  appendTail(e) {
    return en(e) && (e = new vt(String(e))), e.appendTo(this);
  }
  append(e, n, r) {
    const o = this._appendChar(e[0], n);
    return r != null && (o.tailShift += this.appendTail(r).tailShift), o;
  }
  doCommit() {
  }
  get state() {
    return {
      _value: this._value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(e) {
    this._value = e._value, this._isRawInput = !!e._rawInputValue;
  }
  pad(e) {
    return this._appendPlaceholder();
  }
}
class Cs {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(e) {
    const {
      parent: n,
      isOptional: r,
      placeholderChar: o,
      displayChar: s,
      lazy: i,
      eager: a,
      ...l
    } = e;
    this.masked = Ht(l), Object.assign(this, {
      parent: n,
      isOptional: r,
      placeholderChar: o,
      displayChar: s,
      lazy: i,
      eager: a
    });
  }
  reset() {
    this.isFilled = !1, this.masked.reset();
  }
  remove(e, n) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.value.length), e === 0 && n >= 1 ? (this.isFilled = !1, this.masked.remove(e, n)) : new fe();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get rawInputValue() {
    return this.masked.rawInputValue;
  }
  get displayValue() {
    return this.masked.value && this.displayChar || this.value;
  }
  get isComplete() {
    return !!this.masked.value || this.isOptional;
  }
  _appendChar(e, n) {
    if (n === void 0 && (n = {}), this.isFilled) return new fe();
    const r = this.masked.state;
    let o = this.masked._appendChar(e, this.currentMaskFlags(n));
    return o.inserted && this.doValidate(n) === !1 && (o = new fe(), this.masked.state = r), !o.inserted && !this.isOptional && !this.lazy && !n.input && (o.inserted = this.placeholderChar), o.skip = !o.inserted && !this.isOptional, this.isFilled = !!o.inserted, o;
  }
  append(e, n, r) {
    return this.masked.append(e, this.currentMaskFlags(n), r);
  }
  _appendPlaceholder() {
    return this.isFilled || this.isOptional ? new fe() : (this.isFilled = !0, new fe({
      inserted: this.placeholderChar
    }));
  }
  _appendEager() {
    return new fe();
  }
  extractTail(e, n) {
    return this.masked.extractTail(e, n);
  }
  appendTail(e) {
    return this.masked.appendTail(e);
  }
  extractInput(e, n, r) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.value.length), this.masked.extractInput(e, n, r);
  }
  nearestInputPos(e, n) {
    n === void 0 && (n = ee.NONE);
    const r = 0, o = this.value.length, s = Math.min(Math.max(e, r), o);
    switch (n) {
      case ee.LEFT:
      case ee.FORCE_LEFT:
        return this.isComplete ? s : r;
      case ee.RIGHT:
      case ee.FORCE_RIGHT:
        return this.isComplete ? s : o;
      case ee.NONE:
      default:
        return s;
    }
  }
  totalInputPositions(e, n) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.value.length), this.value.slice(e, n).length;
  }
  doValidate(e) {
    return this.masked.doValidate(this.currentMaskFlags(e)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(e)));
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue,
      masked: this.masked.state,
      isFilled: this.isFilled
    };
  }
  set state(e) {
    this.masked.state = e.masked, this.isFilled = e.isFilled;
  }
  currentMaskFlags(e) {
    var n;
    return {
      ...e,
      _beforeTailState: (e == null || (n = e._beforeTailState) == null ? void 0 : n.masked) || (e == null ? void 0 : e._beforeTailState)
    };
  }
  pad(e) {
    return new fe();
  }
}
Cs.DEFAULT_DEFINITIONS = {
  0: /\d/,
  a: /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  "*": /./
};
class dP extends Oe {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const n = e.mask;
    n && (e.validate = (r) => r.search(n) >= 0), super._update(e);
  }
}
se.MaskedRegExp = dP;
class Ve extends Oe {
  /** */
  /** */
  /** Single char for empty input */
  /** Single char for filled input */
  /** Show placeholder only when needed */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  constructor(e) {
    super({
      ...Ve.DEFAULTS,
      ...e,
      definitions: Object.assign({}, Cs.DEFAULT_DEFINITIONS, e == null ? void 0 : e.definitions)
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    e.definitions = Object.assign({}, this.definitions, e.definitions), super._update(e), this._rebuildMask();
  }
  _rebuildMask() {
    const e = this.definitions;
    this._blocks = [], this.exposeBlock = void 0, this._stops = [], this._maskedBlocks = {};
    const n = this.mask;
    if (!n || !e) return;
    let r = !1, o = !1;
    for (let s = 0; s < n.length; ++s) {
      if (this.blocks) {
        const c = n.slice(s), u = Object.keys(this.blocks).filter((p) => c.indexOf(p) === 0);
        u.sort((p, h) => h.length - p.length);
        const d = u[0];
        if (d) {
          const {
            expose: p,
            repeat: h,
            ...v
          } = io(this.blocks[d]), m = {
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            overwrite: this.overwrite,
            autofix: this.autofix,
            ...v,
            repeat: h,
            parent: this
          }, y = h != null ? new se.RepeatBlock(
            m
            /* TODO */
          ) : Ht(m);
          y && (this._blocks.push(y), p && (this.exposeBlock = y), this._maskedBlocks[d] || (this._maskedBlocks[d] = []), this._maskedBlocks[d].push(this._blocks.length - 1)), s += d.length - 1;
          continue;
        }
      }
      let i = n[s], a = i in e;
      if (i === Ve.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (i === "{" || i === "}") {
        r = !r;
        continue;
      }
      if (i === "[" || i === "]") {
        o = !o;
        continue;
      }
      if (i === Ve.ESCAPE_CHAR) {
        if (++s, i = n[s], !i) break;
        a = !1;
      }
      const l = a ? new Cs({
        isOptional: o,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar,
        ...io(e[i]),
        parent: this
      }) : new fv({
        char: i,
        eager: this.eager,
        isUnmasking: r
      });
      this._blocks.push(l);
    }
  }
  get state() {
    return {
      ...super.state,
      _blocks: this._blocks.map((e) => e.state)
    };
  }
  set state(e) {
    if (!e) {
      this.reset();
      return;
    }
    const {
      _blocks: n,
      ...r
    } = e;
    this._blocks.forEach((o, s) => o.state = n[s]), super.state = r;
  }
  reset() {
    super.reset(), this._blocks.forEach((e) => e.reset());
  }
  get isComplete() {
    return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every((e) => e.isComplete);
  }
  get isFilled() {
    return this._blocks.every((e) => e.isFilled);
  }
  get isFixed() {
    return this._blocks.every((e) => e.isFixed);
  }
  get isOptional() {
    return this._blocks.every((e) => e.isOptional);
  }
  doCommit() {
    this._blocks.forEach((e) => e.doCommit()), super.doCommit();
  }
  get unmaskedValue() {
    return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((e, n) => e += n.unmaskedValue, "");
  }
  set unmaskedValue(e) {
    if (this.exposeBlock) {
      const n = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.unmaskedValue = e, this.appendTail(n), this.doCommit();
    } else super.unmaskedValue = e;
  }
  get value() {
    return this.exposeBlock ? this.exposeBlock.value : (
      // TODO return _value when not in change?
      this._blocks.reduce((e, n) => e += n.value, "")
    );
  }
  set value(e) {
    if (this.exposeBlock) {
      const n = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.value = e, this.appendTail(n), this.doCommit();
    } else super.value = e;
  }
  get typedValue() {
    return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
  }
  set typedValue(e) {
    if (this.exposeBlock) {
      const n = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.typedValue = e, this.appendTail(n), this.doCommit();
    } else super.typedValue = e;
  }
  get displayValue() {
    return this._blocks.reduce((e, n) => e += n.displayValue, "");
  }
  appendTail(e) {
    return super.appendTail(e).aggregate(this._appendPlaceholder());
  }
  _appendEager() {
    var e;
    const n = new fe();
    let r = (e = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : e.index;
    if (r == null) return n;
    this._blocks[r].isFilled && ++r;
    for (let o = r; o < this._blocks.length; ++o) {
      const s = this._blocks[o]._appendEager();
      if (!s.inserted) break;
      n.aggregate(s);
    }
    return n;
  }
  _appendCharRaw(e, n) {
    n === void 0 && (n = {});
    const r = this._mapPosToBlock(this.displayValue.length), o = new fe();
    if (!r) return o;
    for (let i = r.index, a; a = this._blocks[i]; ++i) {
      var s;
      const l = a._appendChar(e, {
        ...n,
        _beforeTailState: (s = n._beforeTailState) == null || (s = s._blocks) == null ? void 0 : s[i]
      });
      if (o.aggregate(l), l.consumed) break;
    }
    return o;
  }
  extractTail(e, n) {
    e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length);
    const r = new Cn();
    return e === n || this._forEachBlocksInRange(e, n, (o, s, i, a) => {
      const l = o.extractTail(i, a);
      l.stop = this._findStopBefore(s), l.from = this._blockStartPos(s), l instanceof Cn && (l.blockIndex = s), r.extend(l);
    }), r;
  }
  extractInput(e, n, r) {
    if (e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), r === void 0 && (r = {}), e === n) return "";
    let o = "";
    return this._forEachBlocksInRange(e, n, (s, i, a, l) => {
      o += s.extractInput(a, l, r);
    }), o;
  }
  _findStopBefore(e) {
    let n;
    for (let r = 0; r < this._stops.length; ++r) {
      const o = this._stops[r];
      if (o <= e) n = o;
      else break;
    }
    return n;
  }
  /** Appends placeholder depending on laziness */
  _appendPlaceholder(e) {
    const n = new fe();
    if (this.lazy && e == null) return n;
    const r = this._mapPosToBlock(this.displayValue.length);
    if (!r) return n;
    const o = r.index, s = e ?? this._blocks.length;
    return this._blocks.slice(o, s).forEach((i) => {
      if (!i.lazy || e != null) {
        var a;
        n.aggregate(i._appendPlaceholder((a = i._blocks) == null ? void 0 : a.length));
      }
    }), n;
  }
  /** Finds block in pos */
  _mapPosToBlock(e) {
    let n = "";
    for (let r = 0; r < this._blocks.length; ++r) {
      const o = this._blocks[r], s = n.length;
      if (n += o.displayValue, e <= n.length)
        return {
          index: r,
          offset: e - s
        };
    }
  }
  _blockStartPos(e) {
    return this._blocks.slice(0, e).reduce((n, r) => n += r.displayValue.length, 0);
  }
  _forEachBlocksInRange(e, n, r) {
    n === void 0 && (n = this.displayValue.length);
    const o = this._mapPosToBlock(e);
    if (o) {
      const s = this._mapPosToBlock(n), i = s && o.index === s.index, a = o.offset, l = s && i ? s.offset : this._blocks[o.index].displayValue.length;
      if (r(this._blocks[o.index], o.index, a, l), s && !i) {
        for (let c = o.index + 1; c < s.index; ++c)
          r(this._blocks[c], c, 0, this._blocks[c].displayValue.length);
        r(this._blocks[s.index], s.index, 0, s.offset);
      }
    }
  }
  remove(e, n) {
    e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length);
    const r = super.remove(e, n);
    return this._forEachBlocksInRange(e, n, (o, s, i, a) => {
      r.aggregate(o.remove(i, a));
    }), r;
  }
  nearestInputPos(e, n) {
    if (n === void 0 && (n = ee.NONE), !this._blocks.length) return 0;
    const r = new uP(this, e);
    if (n === ee.NONE)
      return r.pushRightBeforeInput() || (r.popState(), r.pushLeftBeforeInput()) ? r.pos : this.displayValue.length;
    if (n === ee.LEFT || n === ee.FORCE_LEFT) {
      if (n === ee.LEFT) {
        if (r.pushRightBeforeFilled(), r.ok && r.pos === e) return e;
        r.popState();
      }
      if (r.pushLeftBeforeInput(), r.pushLeftBeforeRequired(), r.pushLeftBeforeFilled(), n === ee.LEFT) {
        if (r.pushRightBeforeInput(), r.pushRightBeforeRequired(), r.ok && r.pos <= e || (r.popState(), r.ok && r.pos <= e)) return r.pos;
        r.popState();
      }
      return r.ok ? r.pos : n === ee.FORCE_LEFT ? 0 : (r.popState(), r.ok || (r.popState(), r.ok) ? r.pos : 0);
    }
    return n === ee.RIGHT || n === ee.FORCE_RIGHT ? (r.pushRightBeforeInput(), r.pushRightBeforeRequired(), r.pushRightBeforeFilled() ? r.pos : n === ee.FORCE_RIGHT ? this.displayValue.length : (r.popState(), r.ok || (r.popState(), r.ok) ? r.pos : this.nearestInputPos(e, ee.LEFT))) : e;
  }
  totalInputPositions(e, n) {
    e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length);
    let r = 0;
    return this._forEachBlocksInRange(e, n, (o, s, i, a) => {
      r += o.totalInputPositions(i, a);
    }), r;
  }
  /** Get block by name */
  maskedBlock(e) {
    return this.maskedBlocks(e)[0];
  }
  /** Get all blocks by name */
  maskedBlocks(e) {
    const n = this._maskedBlocks[e];
    return n ? n.map((r) => this._blocks[r]) : [];
  }
  pad(e) {
    const n = new fe();
    return this._forEachBlocksInRange(0, this.displayValue.length, (r) => n.aggregate(r.pad(e))), n;
  }
}
Ve.DEFAULTS = {
  ...Oe.DEFAULTS,
  lazy: !0,
  placeholderChar: "_"
};
Ve.STOP_CHAR = "`";
Ve.ESCAPE_CHAR = "\\";
Ve.InputDefinition = Cs;
Ve.FixedDefinition = fv;
se.MaskedPattern = Ve;
class os extends Ve {
  /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */
  /** Min bound */
  /** Max bound */
  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  constructor(e) {
    super(e);
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      to: n = this.to || 0,
      from: r = this.from || 0,
      maxLength: o = this.maxLength || 0,
      autofix: s = this.autofix,
      ...i
    } = e;
    this.to = n, this.from = r, this.maxLength = Math.max(String(n).length, o), this.autofix = s;
    const a = String(this.from).padStart(this.maxLength, "0"), l = String(this.to).padStart(this.maxLength, "0");
    let c = 0;
    for (; c < l.length && l[c] === a[c]; ) ++c;
    i.mask = l.slice(0, c).replace(/0/g, "\\0") + "0".repeat(this.maxLength - c), super._update(i);
  }
  get isComplete() {
    return super.isComplete && !!this.value;
  }
  boundaries(e) {
    let n = "", r = "";
    const [, o, s] = e.match(/^(\D*)(\d*)(\D*)/) || [];
    return s && (n = "0".repeat(o.length) + s, r = "9".repeat(o.length) + s), n = n.padEnd(this.maxLength, "0"), r = r.padEnd(this.maxLength, "9"), [n, r];
  }
  doPrepareChar(e, n) {
    n === void 0 && (n = {});
    let r;
    return [e, r] = super.doPrepareChar(e.replace(/\D/g, ""), n), e || (r.skip = !this.isComplete), [e, r];
  }
  _appendCharRaw(e, n) {
    if (n === void 0 && (n = {}), !this.autofix || this.value.length + 1 > this.maxLength) return super._appendCharRaw(e, n);
    const r = String(this.from).padStart(this.maxLength, "0"), o = String(this.to).padStart(this.maxLength, "0"), [s, i] = this.boundaries(this.value + e);
    return Number(i) < this.from ? super._appendCharRaw(r[this.value.length], n) : Number(s) > this.to ? !n.tail && this.autofix === "pad" && this.value.length + 1 < this.maxLength ? super._appendCharRaw(r[this.value.length], n).aggregate(this._appendCharRaw(e, n)) : super._appendCharRaw(o[this.value.length], n) : super._appendCharRaw(e, n);
  }
  doValidate(e) {
    const n = this.value;
    if (n.search(/[^0]/) === -1 && n.length <= this._matchFrom) return !0;
    const [o, s] = this.boundaries(n);
    return this.from <= Number(s) && Number(o) <= this.to && super.doValidate(e);
  }
  pad(e) {
    const n = new fe();
    if (this.value.length === this.maxLength) return n;
    const r = this.value, o = this.maxLength - this.value.length;
    if (o) {
      this.reset();
      for (let s = 0; s < o; ++s)
        n.aggregate(super._appendCharRaw("0", e));
      r.split("").forEach((s) => this._appendCharRaw(s));
    }
    return n;
  }
}
se.MaskedRange = os;
const fP = "d{.}`m{.}`Y";
class It extends Ve {
  static extractPatternOptions(e) {
    const {
      mask: n,
      pattern: r,
      ...o
    } = e;
    return {
      ...o,
      mask: en(n) ? n : r
    };
  }
  /** Pattern mask for date according to {@link MaskedDate#format} */
  /** Start date */
  /** End date */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(e) {
    super(It.extractPatternOptions({
      ...It.DEFAULTS,
      ...e
    }));
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      mask: n,
      pattern: r,
      blocks: o,
      ...s
    } = {
      ...It.DEFAULTS,
      ...e
    }, i = Object.assign({}, It.GET_DEFAULT_BLOCKS());
    e.min && (i.Y.from = e.min.getFullYear()), e.max && (i.Y.to = e.max.getFullYear()), e.min && e.max && i.Y.from === i.Y.to && (i.m.from = e.min.getMonth() + 1, i.m.to = e.max.getMonth() + 1, i.m.from === i.m.to && (i.d.from = e.min.getDate(), i.d.to = e.max.getDate())), Object.assign(i, this.blocks, o), super._update({
      ...s,
      mask: en(n) ? n : r,
      blocks: i
    });
  }
  doValidate(e) {
    const n = this.date;
    return super.doValidate(e) && (!this.isComplete || this.isDateExist(this.value) && n != null && (this.min == null || this.min <= n) && (this.max == null || n <= this.max));
  }
  /** Checks if date is exists */
  isDateExist(e) {
    return this.format(this.parse(e, this), this).indexOf(e) >= 0;
  }
  /** Parsed Date */
  get date() {
    return this.typedValue;
  }
  set date(e) {
    this.typedValue = e;
  }
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(e) {
    super.typedValue = e;
  }
  maskEquals(e) {
    return e === Date || super.maskEquals(e);
  }
  optionsIsChanged(e) {
    return super.optionsIsChanged(It.extractPatternOptions(e));
  }
}
It.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: os,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: os,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: os,
    from: 1900,
    to: 9999
  }
});
It.DEFAULTS = {
  ...Ve.DEFAULTS,
  mask: Date,
  pattern: fP,
  format: (t, e) => {
    if (!t) return "";
    const n = String(t.getDate()).padStart(2, "0"), r = String(t.getMonth() + 1).padStart(2, "0"), o = t.getFullYear();
    return [n, r, o].join(".");
  },
  parse: (t, e) => {
    const [n, r, o] = t.split(".").map(Number);
    return new Date(o, r - 1, n);
  }
};
se.MaskedDate = It;
class pi extends Oe {
  constructor(e) {
    super({
      ...pi.DEFAULTS,
      ...e
    }), this.currentMask = void 0;
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update(e), "mask" in e && (this.exposeMask = void 0, this.compiledMasks = Array.isArray(e.mask) ? e.mask.map((n) => {
      const {
        expose: r,
        ...o
      } = io(n), s = Ht({
        overwrite: this._overwrite,
        eager: this._eager,
        skipInvalid: this._skipInvalid,
        ...o
      });
      return r && (this.exposeMask = s), s;
    }) : []);
  }
  _appendCharRaw(e, n) {
    n === void 0 && (n = {});
    const r = this._applyDispatch(e, n);
    return this.currentMask && r.aggregate(this.currentMask._appendChar(e, this.currentMaskFlags(n))), r;
  }
  _applyDispatch(e, n, r) {
    e === void 0 && (e = ""), n === void 0 && (n = {}), r === void 0 && (r = "");
    const o = n.tail && n._beforeTailState != null ? n._beforeTailState._value : this.value, s = this.rawInputValue, i = n.tail && n._beforeTailState != null ? n._beforeTailState._rawInputValue : s, a = s.slice(i.length), l = this.currentMask, c = new fe(), u = l == null ? void 0 : l.state;
    return this.currentMask = this.doDispatch(e, {
      ...n
    }, r), this.currentMask && (this.currentMask !== l ? (this.currentMask.reset(), i && (this.currentMask.append(i, {
      raw: !0
    }), c.tailShift = this.currentMask.value.length - o.length), a && (c.tailShift += this.currentMask.append(a, {
      raw: !0,
      tail: !0
    }).tailShift)) : u && (this.currentMask.state = u)), c;
  }
  _appendPlaceholder() {
    const e = this._applyDispatch();
    return this.currentMask && e.aggregate(this.currentMask._appendPlaceholder()), e;
  }
  _appendEager() {
    const e = this._applyDispatch();
    return this.currentMask && e.aggregate(this.currentMask._appendEager()), e;
  }
  appendTail(e) {
    const n = new fe();
    return e && n.aggregate(this._applyDispatch("", {}, e)), n.aggregate(this.currentMask ? this.currentMask.appendTail(e) : super.appendTail(e));
  }
  currentMaskFlags(e) {
    var n, r;
    return {
      ...e,
      _beforeTailState: ((n = e._beforeTailState) == null ? void 0 : n.currentMaskRef) === this.currentMask && ((r = e._beforeTailState) == null ? void 0 : r.currentMask) || e._beforeTailState
    };
  }
  doDispatch(e, n, r) {
    return n === void 0 && (n = {}), r === void 0 && (r = ""), this.dispatch(e, this, n, r);
  }
  doValidate(e) {
    return super.doValidate(e) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(e)));
  }
  doPrepare(e, n) {
    n === void 0 && (n = {});
    let [r, o] = super.doPrepare(e, n);
    if (this.currentMask) {
      let s;
      [r, s] = super.doPrepare(r, this.currentMaskFlags(n)), o = o.aggregate(s);
    }
    return [r, o];
  }
  doPrepareChar(e, n) {
    n === void 0 && (n = {});
    let [r, o] = super.doPrepareChar(e, n);
    if (this.currentMask) {
      let s;
      [r, s] = super.doPrepareChar(r, this.currentMaskFlags(n)), o = o.aggregate(s);
    }
    return [r, o];
  }
  reset() {
    var e;
    (e = this.currentMask) == null || e.reset(), this.compiledMasks.forEach((n) => n.reset());
  }
  get value() {
    return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : "";
  }
  set value(e) {
    this.exposeMask ? (this.exposeMask.value = e, this.currentMask = this.exposeMask, this._applyDispatch()) : super.value = e;
  }
  get unmaskedValue() {
    return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : "";
  }
  set unmaskedValue(e) {
    this.exposeMask ? (this.exposeMask.unmaskedValue = e, this.currentMask = this.exposeMask, this._applyDispatch()) : super.unmaskedValue = e;
  }
  get typedValue() {
    return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : "";
  }
  set typedValue(e) {
    if (this.exposeMask) {
      this.exposeMask.typedValue = e, this.currentMask = this.exposeMask, this._applyDispatch();
      return;
    }
    let n = String(e);
    this.currentMask && (this.currentMask.typedValue = e, n = this.currentMask.unmaskedValue), this.unmaskedValue = n;
  }
  get displayValue() {
    return this.currentMask ? this.currentMask.displayValue : "";
  }
  get isComplete() {
    var e;
    return !!((e = this.currentMask) != null && e.isComplete);
  }
  get isFilled() {
    var e;
    return !!((e = this.currentMask) != null && e.isFilled);
  }
  remove(e, n) {
    const r = new fe();
    return this.currentMask && r.aggregate(this.currentMask.remove(e, n)).aggregate(this._applyDispatch()), r;
  }
  get state() {
    var e;
    return {
      ...super.state,
      _rawInputValue: this.rawInputValue,
      compiledMasks: this.compiledMasks.map((n) => n.state),
      currentMaskRef: this.currentMask,
      currentMask: (e = this.currentMask) == null ? void 0 : e.state
    };
  }
  set state(e) {
    const {
      compiledMasks: n,
      currentMaskRef: r,
      currentMask: o,
      ...s
    } = e;
    n && this.compiledMasks.forEach((i, a) => i.state = n[a]), r != null && (this.currentMask = r, this.currentMask.state = o), super.state = s;
  }
  extractInput(e, n, r) {
    return this.currentMask ? this.currentMask.extractInput(e, n, r) : "";
  }
  extractTail(e, n) {
    return this.currentMask ? this.currentMask.extractTail(e, n) : super.extractTail(e, n);
  }
  doCommit() {
    this.currentMask && this.currentMask.doCommit(), super.doCommit();
  }
  nearestInputPos(e, n) {
    return this.currentMask ? this.currentMask.nearestInputPos(e, n) : super.nearestInputPos(e, n);
  }
  get overwrite() {
    return this.currentMask ? this.currentMask.overwrite : this._overwrite;
  }
  set overwrite(e) {
    this._overwrite = e;
  }
  get eager() {
    return this.currentMask ? this.currentMask.eager : this._eager;
  }
  set eager(e) {
    this._eager = e;
  }
  get skipInvalid() {
    return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
  }
  set skipInvalid(e) {
    this._skipInvalid = e;
  }
  get autofix() {
    return this.currentMask ? this.currentMask.autofix : this._autofix;
  }
  set autofix(e) {
    this._autofix = e;
  }
  maskEquals(e) {
    return Array.isArray(e) ? this.compiledMasks.every((n, r) => {
      if (!e[r]) return;
      const {
        mask: o,
        ...s
      } = e[r];
      return xs(n, s) && n.maskEquals(o);
    }) : super.maskEquals(e);
  }
  typedValueEquals(e) {
    var n;
    return !!((n = this.currentMask) != null && n.typedValueEquals(e));
  }
}
pi.DEFAULTS = {
  ...Oe.DEFAULTS,
  dispatch: (t, e, n, r) => {
    if (!e.compiledMasks.length) return;
    const o = e.rawInputValue, s = e.compiledMasks.map((i, a) => {
      const l = e.currentMask === i, c = l ? i.displayValue.length : i.nearestInputPos(i.displayValue.length, ee.FORCE_LEFT);
      return i.rawInputValue !== o ? (i.reset(), i.append(o, {
        raw: !0
      })) : l || i.remove(c), i.append(t, e.currentMaskFlags(n)), i.appendTail(r), {
        index: a,
        weight: i.rawInputValue.length,
        totalInputPositions: i.totalInputPositions(0, Math.max(c, i.nearestInputPos(i.displayValue.length, ee.FORCE_LEFT)))
      };
    });
    return s.sort((i, a) => a.weight - i.weight || a.totalInputPositions - i.totalInputPositions), e.compiledMasks[s[0].index];
  }
};
se.MaskedDynamic = pi;
class hi extends Ve {
  constructor(e) {
    super({
      ...hi.DEFAULTS,
      ...e
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    const {
      enum: n,
      ...r
    } = e;
    if (n) {
      const o = n.map((a) => a.length), s = Math.min(...o), i = Math.max(...o) - s;
      r.mask = "*".repeat(s), i && (r.mask += "[" + "*".repeat(i) + "]"), this.enum = n;
    }
    super._update(r);
  }
  _appendCharRaw(e, n) {
    n === void 0 && (n = {});
    const r = Math.min(this.nearestInputPos(0, ee.FORCE_RIGHT), this.value.length), o = this.enum.filter((s) => this.matchValue(s, this.unmaskedValue + e, r));
    if (o.length) {
      o.length === 1 && this._forEachBlocksInRange(0, this.value.length, (i, a) => {
        const l = o[0][a];
        a >= this.value.length || l === i.value || (i.reset(), i._appendChar(l, n));
      });
      const s = super._appendCharRaw(o[0][this.value.length], n);
      return o.length === 1 && o[0].slice(this.unmaskedValue.length).split("").forEach((i) => s.aggregate(super._appendCharRaw(i))), s;
    }
    return new fe({
      skip: !this.isComplete
    });
  }
  extractTail(e, n) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), new vt("", e);
  }
  remove(e, n) {
    if (e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), e === n) return new fe();
    const r = Math.min(super.nearestInputPos(0, ee.FORCE_RIGHT), this.value.length);
    let o;
    for (o = e; o >= 0 && !(this.enum.filter((a) => this.matchValue(a, this.value.slice(r, o), r)).length > 1); --o)
      ;
    const s = super.remove(o, n);
    return s.tailShift += o - e, s;
  }
  get isComplete() {
    return this.enum.indexOf(this.value) >= 0;
  }
}
hi.DEFAULTS = {
  ...Ve.DEFAULTS,
  matchValue: (t, e, n) => t.indexOf(e, n) === n
};
se.MaskedEnum = hi;
class pP extends Oe {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update({
      ...e,
      validate: e.mask
    });
  }
}
se.MaskedFunction = pP;
var pv;
class Ue extends Oe {
  /** Single char */
  /** Single char */
  /** Array of single chars */
  /** */
  /** */
  /** Digits after point */
  /** Flag to remove leading and trailing zeros in the end of editing */
  /** Flag to pad trailing zeros after point in the end of editing */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(e) {
    super({
      ...Ue.DEFAULTS,
      ...e
    });
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    super._update(e), this._updateRegExps();
  }
  _updateRegExps() {
    const e = "^" + (this.allowNegative ? "[+|\\-]?" : ""), n = "\\d*", r = (this.scale ? "(" + ra(this.radix) + "\\d{0," + this.scale + "})?" : "") + "$";
    this._numberRegExp = new RegExp(e + n + r), this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map(ra).join("") + "]", "g"), this._thousandsSeparatorRegExp = new RegExp(ra(this.thousandsSeparator), "g");
  }
  _removeThousandsSeparators(e) {
    return e.replace(this._thousandsSeparatorRegExp, "");
  }
  _insertThousandsSeparators(e) {
    const n = e.split(this.radix);
    return n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator), n.join(this.radix);
  }
  doPrepareChar(e, n) {
    n === void 0 && (n = {});
    const [r, o] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */
    (n.input && n.raw || !n.input && !n.raw) ? e.replace(this._mapToRadixRegExp, this.radix) : e), n);
    return e && !r && (o.skip = !0), r && !this.allowPositive && !this.value && r !== "-" && o.aggregate(this._appendChar("-")), [r, o];
  }
  _separatorsCount(e, n) {
    n === void 0 && (n = !1);
    let r = 0;
    for (let o = 0; o < e; ++o)
      this._value.indexOf(this.thousandsSeparator, o) === o && (++r, n && (e += this.thousandsSeparator.length));
    return r;
  }
  _separatorsCountFromSlice(e) {
    return e === void 0 && (e = this._value), this._separatorsCount(this._removeThousandsSeparators(e).length, !0);
  }
  extractInput(e, n, r) {
    return e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), [e, n] = this._adjustRangeWithSeparators(e, n), this._removeThousandsSeparators(super.extractInput(e, n, r));
  }
  _appendCharRaw(e, n) {
    n === void 0 && (n = {});
    const r = n.tail && n._beforeTailState ? n._beforeTailState._value : this._value, o = this._separatorsCountFromSlice(r);
    this._value = this._removeThousandsSeparators(this.value);
    const s = this._value;
    this._value += e;
    const i = this.number;
    let a = !isNaN(i), l = !1;
    if (a) {
      let p;
      this.min != null && this.min < 0 && this.number < this.min && (p = this.min), this.max != null && this.max > 0 && this.number > this.max && (p = this.max), p != null && (this.autofix ? (this._value = this.format(p, this).replace(Ue.UNMASKED_RADIX, this.radix), l || (l = s === this._value && !n.tail)) : a = !1), a && (a = !!this._value.match(this._numberRegExp));
    }
    let c;
    a ? c = new fe({
      inserted: this._value.slice(s.length),
      rawInserted: l ? "" : e,
      skip: l
    }) : (this._value = s, c = new fe()), this._value = this._insertThousandsSeparators(this._value);
    const u = n.tail && n._beforeTailState ? n._beforeTailState._value : this._value, d = this._separatorsCountFromSlice(u);
    return c.tailShift += (d - o) * this.thousandsSeparator.length, c;
  }
  _findSeparatorAround(e) {
    if (this.thousandsSeparator) {
      const n = e - this.thousandsSeparator.length + 1, r = this.value.indexOf(this.thousandsSeparator, n);
      if (r <= e) return r;
    }
    return -1;
  }
  _adjustRangeWithSeparators(e, n) {
    const r = this._findSeparatorAround(e);
    r >= 0 && (e = r);
    const o = this._findSeparatorAround(n);
    return o >= 0 && (n = o + this.thousandsSeparator.length), [e, n];
  }
  remove(e, n) {
    e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length), [e, n] = this._adjustRangeWithSeparators(e, n);
    const r = this.value.slice(0, e), o = this.value.slice(n), s = this._separatorsCount(r.length);
    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(r + o));
    const i = this._separatorsCountFromSlice(r);
    return new fe({
      tailShift: (i - s) * this.thousandsSeparator.length
    });
  }
  nearestInputPos(e, n) {
    if (!this.thousandsSeparator) return e;
    switch (n) {
      case ee.NONE:
      case ee.LEFT:
      case ee.FORCE_LEFT: {
        const r = this._findSeparatorAround(e - 1);
        if (r >= 0) {
          const o = r + this.thousandsSeparator.length;
          if (e < o || this.value.length <= o || n === ee.FORCE_LEFT)
            return r;
        }
        break;
      }
      case ee.RIGHT:
      case ee.FORCE_RIGHT: {
        const r = this._findSeparatorAround(e);
        if (r >= 0)
          return r + this.thousandsSeparator.length;
      }
    }
    return e;
  }
  doCommit() {
    if (this.value) {
      const e = this.number;
      let n = e;
      this.min != null && (n = Math.max(n, this.min)), this.max != null && (n = Math.min(n, this.max)), n !== e && (this.unmaskedValue = this.format(n, this));
      let r = this.value;
      this.normalizeZeros && (r = this._normalizeZeros(r)), this.padFractionalZeros && this.scale > 0 && (r = this._padFractionalZeros(r)), this._value = r;
    }
    super.doCommit();
  }
  _normalizeZeros(e) {
    const n = this._removeThousandsSeparators(e).split(this.radix);
    return n[0] = n[0].replace(/^(\D*)(0*)(\d*)/, (r, o, s, i) => o + i), e.length && !/\d$/.test(n[0]) && (n[0] = n[0] + "0"), n.length > 1 && (n[1] = n[1].replace(/0*$/, ""), n[1].length || (n.length = 1)), this._insertThousandsSeparators(n.join(this.radix));
  }
  _padFractionalZeros(e) {
    if (!e) return e;
    const n = e.split(this.radix);
    return n.length < 2 && n.push(""), n[1] = n[1].padEnd(this.scale, "0"), n.join(this.radix);
  }
  doSkipInvalid(e, n, r) {
    n === void 0 && (n = {});
    const o = this.scale === 0 && e !== this.thousandsSeparator && (e === this.radix || e === Ue.UNMASKED_RADIX || this.mapToRadix.includes(e));
    return super.doSkipInvalid(e, n, r) && !o;
  }
  get unmaskedValue() {
    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, Ue.UNMASKED_RADIX);
  }
  set unmaskedValue(e) {
    super.unmaskedValue = e;
  }
  get typedValue() {
    return this.parse(this.unmaskedValue, this);
  }
  set typedValue(e) {
    this.rawInputValue = this.format(e, this).replace(Ue.UNMASKED_RADIX, this.radix);
  }
  /** Parsed Number */
  get number() {
    return this.typedValue;
  }
  set number(e) {
    this.typedValue = e;
  }
  get allowNegative() {
    return this.min != null && this.min < 0 || this.max != null && this.max < 0;
  }
  get allowPositive() {
    return this.min != null && this.min > 0 || this.max != null && this.max > 0;
  }
  typedValueEquals(e) {
    return (super.typedValueEquals(e) || Ue.EMPTY_VALUES.includes(e) && Ue.EMPTY_VALUES.includes(this.typedValue)) && !(e === 0 && this.value === "");
  }
}
pv = Ue;
Ue.UNMASKED_RADIX = ".";
Ue.EMPTY_VALUES = [...Oe.EMPTY_VALUES, 0];
Ue.DEFAULTS = {
  ...Oe.DEFAULTS,
  mask: Number,
  radix: ",",
  thousandsSeparator: "",
  mapToRadix: [pv.UNMASKED_RADIX],
  min: Number.MIN_SAFE_INTEGER,
  max: Number.MAX_SAFE_INTEGER,
  scale: 2,
  normalizeZeros: !0,
  padFractionalZeros: !1,
  parse: Number,
  format: (t) => t.toLocaleString("en-US", {
    useGrouping: !1,
    maximumFractionDigits: 20
  })
};
se.MaskedNumber = Ue;
const el = {
  MASKED: "value",
  UNMASKED: "unmaskedValue",
  TYPED: "typedValue"
};
function hv(t, e, n) {
  e === void 0 && (e = el.MASKED), n === void 0 && (n = el.MASKED);
  const r = Ht(t);
  return (o) => r.runIsolated((s) => (s[e] = o, s[n]));
}
function hP(t, e, n, r) {
  return hv(e, n, r)(t);
}
se.PIPE_TYPE = el;
se.createPipe = hv;
se.pipe = hP;
class mP extends Ve {
  get repeatFrom() {
    var e;
    return (e = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === 1 / 0 ? 0 : this.repeat) != null ? e : 0;
  }
  get repeatTo() {
    var e;
    return (e = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? e : 1 / 0;
  }
  constructor(e) {
    super(e);
  }
  updateOptions(e) {
    super.updateOptions(e);
  }
  _update(e) {
    var n, r, o;
    const {
      repeat: s,
      ...i
    } = io(e);
    this._blockOpts = Object.assign({}, this._blockOpts, i);
    const a = Ht(this._blockOpts);
    this.repeat = (n = (r = s ?? a.repeat) != null ? r : this.repeat) != null ? n : 1 / 0, super._update({
      mask: "m".repeat(Math.max(this.repeatTo === 1 / 0 && ((o = this._blocks) == null ? void 0 : o.length) || 0, this.repeatFrom)),
      blocks: {
        m: a
      },
      eager: a.eager,
      overwrite: a.overwrite,
      skipInvalid: a.skipInvalid,
      lazy: a.lazy,
      placeholderChar: a.placeholderChar,
      displayChar: a.displayChar
    });
  }
  _allocateBlock(e) {
    if (e < this._blocks.length) return this._blocks[e];
    if (this.repeatTo === 1 / 0 || this._blocks.length < this.repeatTo)
      return this._blocks.push(Ht(this._blockOpts)), this.mask += "m", this._blocks[this._blocks.length - 1];
  }
  _appendCharRaw(e, n) {
    n === void 0 && (n = {});
    const r = new fe();
    for (
      let l = (o = (s = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : s.index) != null ? o : Math.max(this._blocks.length - 1, 0), c, u;
      // try to get a block or
      // try to allocate a new block if not allocated already
      c = (i = this._blocks[l]) != null ? i : u = !u && this._allocateBlock(l);
      ++l
    ) {
      var o, s, i, a;
      const d = c._appendChar(e, {
        ...n,
        _beforeTailState: (a = n._beforeTailState) == null || (a = a._blocks) == null ? void 0 : a[l]
      });
      if (d.skip && u) {
        this._blocks.pop(), this.mask = this.mask.slice(1);
        break;
      }
      if (r.aggregate(d), d.consumed) break;
    }
    return r;
  }
  _trimEmptyTail(e, n) {
    var r, o;
    e === void 0 && (e = 0);
    const s = Math.max(((r = this._mapPosToBlock(e)) == null ? void 0 : r.index) || 0, this.repeatFrom, 0);
    let i;
    n != null && (i = (o = this._mapPosToBlock(n)) == null ? void 0 : o.index), i == null && (i = this._blocks.length - 1);
    let a = 0;
    for (let l = i; s <= l && !this._blocks[l].unmaskedValue; --l, ++a)
      ;
    a && (this._blocks.splice(i - a + 1, a), this.mask = this.mask.slice(a));
  }
  reset() {
    super.reset(), this._trimEmptyTail();
  }
  remove(e, n) {
    e === void 0 && (e = 0), n === void 0 && (n = this.displayValue.length);
    const r = super.remove(e, n);
    return this._trimEmptyTail(e, n), r;
  }
  totalInputPositions(e, n) {
    return e === void 0 && (e = 0), n == null && this.repeatTo === 1 / 0 ? 1 / 0 : super.totalInputPositions(e, n);
  }
  get state() {
    return super.state;
  }
  set state(e) {
    this._blocks.length = e._blocks.length, this.mask = this.mask.slice(0, this._blocks.length), super.state = e;
  }
}
se.RepeatBlock = mP;
try {
  globalThis.IMask = se;
} catch {
}
var tl = { exports: {} }, zo = { exports: {} }, he = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kf;
function gP() {
  if (kf) return he;
  kf = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, s = t ? Symbol.for("react.profiler") : 60114, i = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, v = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, y = t ? Symbol.for("react.fundamental") : 60117, b = t ? Symbol.for("react.responder") : 60118, w = t ? Symbol.for("react.scope") : 60119;
  function x(C) {
    if (typeof C == "object" && C !== null) {
      var A = C.$$typeof;
      switch (A) {
        case e:
          switch (C = C.type, C) {
            case l:
            case c:
            case r:
            case s:
            case o:
            case d:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case a:
                case u:
                case v:
                case h:
                case i:
                  return C;
                default:
                  return A;
              }
          }
        case n:
          return A;
      }
    }
  }
  function E(C) {
    return x(C) === c;
  }
  return he.AsyncMode = l, he.ConcurrentMode = c, he.ContextConsumer = a, he.ContextProvider = i, he.Element = e, he.ForwardRef = u, he.Fragment = r, he.Lazy = v, he.Memo = h, he.Portal = n, he.Profiler = s, he.StrictMode = o, he.Suspense = d, he.isAsyncMode = function(C) {
    return E(C) || x(C) === l;
  }, he.isConcurrentMode = E, he.isContextConsumer = function(C) {
    return x(C) === a;
  }, he.isContextProvider = function(C) {
    return x(C) === i;
  }, he.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === e;
  }, he.isForwardRef = function(C) {
    return x(C) === u;
  }, he.isFragment = function(C) {
    return x(C) === r;
  }, he.isLazy = function(C) {
    return x(C) === v;
  }, he.isMemo = function(C) {
    return x(C) === h;
  }, he.isPortal = function(C) {
    return x(C) === n;
  }, he.isProfiler = function(C) {
    return x(C) === s;
  }, he.isStrictMode = function(C) {
    return x(C) === o;
  }, he.isSuspense = function(C) {
    return x(C) === d;
  }, he.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === r || C === c || C === s || C === o || C === d || C === p || typeof C == "object" && C !== null && (C.$$typeof === v || C.$$typeof === h || C.$$typeof === i || C.$$typeof === a || C.$$typeof === u || C.$$typeof === y || C.$$typeof === b || C.$$typeof === w || C.$$typeof === m);
  }, he.typeOf = x, he;
}
var me = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var If;
function vP() {
  return If || (If = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, s = t ? Symbol.for("react.profiler") : 60114, i = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, v = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, y = t ? Symbol.for("react.fundamental") : 60117, b = t ? Symbol.for("react.responder") : 60118, w = t ? Symbol.for("react.scope") : 60119;
    function x(j) {
      return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      j === r || j === c || j === s || j === o || j === d || j === p || typeof j == "object" && j !== null && (j.$$typeof === v || j.$$typeof === h || j.$$typeof === i || j.$$typeof === a || j.$$typeof === u || j.$$typeof === y || j.$$typeof === b || j.$$typeof === w || j.$$typeof === m);
    }
    function E(j) {
      if (typeof j == "object" && j !== null) {
        var K = j.$$typeof;
        switch (K) {
          case e:
            var le = j.type;
            switch (le) {
              case l:
              case c:
              case r:
              case s:
              case o:
              case d:
                return le;
              default:
                var De = le && le.$$typeof;
                switch (De) {
                  case a:
                  case u:
                  case v:
                  case h:
                  case i:
                    return De;
                  default:
                    return K;
                }
            }
          case n:
            return K;
        }
      }
    }
    var C = l, A = c, S = a, R = i, P = e, k = u, I = r, _ = v, D = h, N = n, W = s, L = o, B = d, V = !1;
    function $(j) {
      return V || (V = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), T(j) || E(j) === l;
    }
    function T(j) {
      return E(j) === c;
    }
    function M(j) {
      return E(j) === a;
    }
    function H(j) {
      return E(j) === i;
    }
    function Z(j) {
      return typeof j == "object" && j !== null && j.$$typeof === e;
    }
    function U(j) {
      return E(j) === u;
    }
    function X(j) {
      return E(j) === r;
    }
    function O(j) {
      return E(j) === v;
    }
    function F(j) {
      return E(j) === h;
    }
    function z(j) {
      return E(j) === n;
    }
    function q(j) {
      return E(j) === s;
    }
    function Y(j) {
      return E(j) === o;
    }
    function re(j) {
      return E(j) === d;
    }
    me.AsyncMode = C, me.ConcurrentMode = A, me.ContextConsumer = S, me.ContextProvider = R, me.Element = P, me.ForwardRef = k, me.Fragment = I, me.Lazy = _, me.Memo = D, me.Portal = N, me.Profiler = W, me.StrictMode = L, me.Suspense = B, me.isAsyncMode = $, me.isConcurrentMode = T, me.isContextConsumer = M, me.isContextProvider = H, me.isElement = Z, me.isForwardRef = U, me.isFragment = X, me.isLazy = O, me.isMemo = F, me.isPortal = z, me.isProfiler = q, me.isStrictMode = Y, me.isSuspense = re, me.isValidElementType = x, me.typeOf = E;
  }()), me;
}
var Df;
function mv() {
  return Df || (Df = 1, process.env.NODE_ENV === "production" ? zo.exports = gP() : zo.exports = vP()), zo.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var oa, Mf;
function yP() {
  if (Mf) return oa;
  Mf = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var i = {}, a = 0; a < 10; a++)
        i["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(i).map(function(u) {
        return i[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return oa = o() ? Object.assign : function(s, i) {
    for (var a, l = r(s), c, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var d in a)
        e.call(a, d) && (l[d] = a[d]);
      if (t) {
        c = t(a);
        for (var p = 0; p < c.length; p++)
          n.call(a, c[p]) && (l[c[p]] = a[c[p]]);
      }
    }
    return l;
  }, oa;
}
var sa, Nf;
function qc() {
  if (Nf) return sa;
  Nf = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return sa = t, sa;
}
var ia, Of;
function gv() {
  return Of || (Of = 1, ia = Function.call.bind(Object.prototype.hasOwnProperty)), ia;
}
var aa, Vf;
function bP() {
  if (Vf) return aa;
  Vf = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = qc(), n = {}, r = gv();
    t = function(s) {
      var i = "Warning: " + s;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function o(s, i, a, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in s)
        if (r(s, u)) {
          var d;
          try {
            if (typeof s[u] != "function") {
              var p = Error(
                (l || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            d = s[u](i, u, l, a, null, e);
          } catch (v) {
            d = v;
          }
          if (d && !(d instanceof Error) && t(
            (l || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = c ? c() : "";
            t(
              "Failed " + a + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, aa = o, aa;
}
var la, Ff;
function wP() {
  if (Ff) return la;
  Ff = 1;
  var t = mv(), e = yP(), n = qc(), r = gv(), o = bP(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return la = function(a, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(T) {
      var M = T && (c && T[c] || T[u]);
      if (typeof M == "function")
        return M;
    }
    var p = "<<anonymous>>", h = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: w(),
      arrayOf: x,
      element: E(),
      elementType: C(),
      instanceOf: A,
      node: k(),
      objectOf: R,
      oneOf: S,
      oneOfType: P,
      shape: _,
      exact: D
    };
    function v(T, M) {
      return T === M ? T !== 0 || 1 / T === 1 / M : T !== T && M !== M;
    }
    function m(T, M) {
      this.message = T, this.data = M && typeof M == "object" ? M : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function y(T) {
      if (process.env.NODE_ENV !== "production")
        var M = {}, H = 0;
      function Z(X, O, F, z, q, Y, re) {
        if (z = z || p, Y = Y || F, re !== n) {
          if (l) {
            var j = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw j.name = "Invariant Violation", j;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var K = z + ":" + F;
            !M[K] && // Avoid spamming the console because they are often not actionable except for lib authors
            H < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + Y + "` prop on `" + z + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), M[K] = !0, H++);
          }
        }
        return O[F] == null ? X ? O[F] === null ? new m("The " + q + " `" + Y + "` is marked as required " + ("in `" + z + "`, but its value is `null`.")) : new m("The " + q + " `" + Y + "` is marked as required in " + ("`" + z + "`, but its value is `undefined`.")) : null : T(O, F, z, q, Y);
      }
      var U = Z.bind(null, !1);
      return U.isRequired = Z.bind(null, !0), U;
    }
    function b(T) {
      function M(H, Z, U, X, O, F) {
        var z = H[Z], q = L(z);
        if (q !== T) {
          var Y = B(z);
          return new m(
            "Invalid " + X + " `" + O + "` of type " + ("`" + Y + "` supplied to `" + U + "`, expected ") + ("`" + T + "`."),
            { expectedType: T }
          );
        }
        return null;
      }
      return y(M);
    }
    function w() {
      return y(i);
    }
    function x(T) {
      function M(H, Z, U, X, O) {
        if (typeof T != "function")
          return new m("Property `" + O + "` of component `" + U + "` has invalid PropType notation inside arrayOf.");
        var F = H[Z];
        if (!Array.isArray(F)) {
          var z = L(F);
          return new m("Invalid " + X + " `" + O + "` of type " + ("`" + z + "` supplied to `" + U + "`, expected an array."));
        }
        for (var q = 0; q < F.length; q++) {
          var Y = T(F, q, U, X, O + "[" + q + "]", n);
          if (Y instanceof Error)
            return Y;
        }
        return null;
      }
      return y(M);
    }
    function E() {
      function T(M, H, Z, U, X) {
        var O = M[H];
        if (!a(O)) {
          var F = L(O);
          return new m("Invalid " + U + " `" + X + "` of type " + ("`" + F + "` supplied to `" + Z + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(T);
    }
    function C() {
      function T(M, H, Z, U, X) {
        var O = M[H];
        if (!t.isValidElementType(O)) {
          var F = L(O);
          return new m("Invalid " + U + " `" + X + "` of type " + ("`" + F + "` supplied to `" + Z + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(T);
    }
    function A(T) {
      function M(H, Z, U, X, O) {
        if (!(H[Z] instanceof T)) {
          var F = T.name || p, z = $(H[Z]);
          return new m("Invalid " + X + " `" + O + "` of type " + ("`" + z + "` supplied to `" + U + "`, expected ") + ("instance of `" + F + "`."));
        }
        return null;
      }
      return y(M);
    }
    function S(T) {
      if (!Array.isArray(T))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), i;
      function M(H, Z, U, X, O) {
        for (var F = H[Z], z = 0; z < T.length; z++)
          if (v(F, T[z]))
            return null;
        var q = JSON.stringify(T, function(re, j) {
          var K = B(j);
          return K === "symbol" ? String(j) : j;
        });
        return new m("Invalid " + X + " `" + O + "` of value `" + String(F) + "` " + ("supplied to `" + U + "`, expected one of " + q + "."));
      }
      return y(M);
    }
    function R(T) {
      function M(H, Z, U, X, O) {
        if (typeof T != "function")
          return new m("Property `" + O + "` of component `" + U + "` has invalid PropType notation inside objectOf.");
        var F = H[Z], z = L(F);
        if (z !== "object")
          return new m("Invalid " + X + " `" + O + "` of type " + ("`" + z + "` supplied to `" + U + "`, expected an object."));
        for (var q in F)
          if (r(F, q)) {
            var Y = T(F, q, U, X, O + "." + q, n);
            if (Y instanceof Error)
              return Y;
          }
        return null;
      }
      return y(M);
    }
    function P(T) {
      if (!Array.isArray(T))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var M = 0; M < T.length; M++) {
        var H = T[M];
        if (typeof H != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + V(H) + " at index " + M + "."
          ), i;
      }
      function Z(U, X, O, F, z) {
        for (var q = [], Y = 0; Y < T.length; Y++) {
          var re = T[Y], j = re(U, X, O, F, z, n);
          if (j == null)
            return null;
          j.data && r(j.data, "expectedType") && q.push(j.data.expectedType);
        }
        var K = q.length > 0 ? ", expected one of type [" + q.join(", ") + "]" : "";
        return new m("Invalid " + F + " `" + z + "` supplied to " + ("`" + O + "`" + K + "."));
      }
      return y(Z);
    }
    function k() {
      function T(M, H, Z, U, X) {
        return N(M[H]) ? null : new m("Invalid " + U + " `" + X + "` supplied to " + ("`" + Z + "`, expected a ReactNode."));
      }
      return y(T);
    }
    function I(T, M, H, Z, U) {
      return new m(
        (T || "React class") + ": " + M + " type `" + H + "." + Z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + U + "`."
      );
    }
    function _(T) {
      function M(H, Z, U, X, O) {
        var F = H[Z], z = L(F);
        if (z !== "object")
          return new m("Invalid " + X + " `" + O + "` of type `" + z + "` " + ("supplied to `" + U + "`, expected `object`."));
        for (var q in T) {
          var Y = T[q];
          if (typeof Y != "function")
            return I(U, X, O, q, B(Y));
          var re = Y(F, q, U, X, O + "." + q, n);
          if (re)
            return re;
        }
        return null;
      }
      return y(M);
    }
    function D(T) {
      function M(H, Z, U, X, O) {
        var F = H[Z], z = L(F);
        if (z !== "object")
          return new m("Invalid " + X + " `" + O + "` of type `" + z + "` " + ("supplied to `" + U + "`, expected `object`."));
        var q = e({}, H[Z], T);
        for (var Y in q) {
          var re = T[Y];
          if (r(T, Y) && typeof re != "function")
            return I(U, X, O, Y, B(re));
          if (!re)
            return new m(
              "Invalid " + X + " `" + O + "` key `" + Y + "` supplied to `" + U + "`.\nBad object: " + JSON.stringify(H[Z], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(T), null, "  ")
            );
          var j = re(F, Y, U, X, O + "." + Y, n);
          if (j)
            return j;
        }
        return null;
      }
      return y(M);
    }
    function N(T) {
      switch (typeof T) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !T;
        case "object":
          if (Array.isArray(T))
            return T.every(N);
          if (T === null || a(T))
            return !0;
          var M = d(T);
          if (M) {
            var H = M.call(T), Z;
            if (M !== T.entries) {
              for (; !(Z = H.next()).done; )
                if (!N(Z.value))
                  return !1;
            } else
              for (; !(Z = H.next()).done; ) {
                var U = Z.value;
                if (U && !N(U[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function W(T, M) {
      return T === "symbol" ? !0 : M ? M["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && M instanceof Symbol : !1;
    }
    function L(T) {
      var M = typeof T;
      return Array.isArray(T) ? "array" : T instanceof RegExp ? "object" : W(M, T) ? "symbol" : M;
    }
    function B(T) {
      if (typeof T > "u" || T === null)
        return "" + T;
      var M = L(T);
      if (M === "object") {
        if (T instanceof Date)
          return "date";
        if (T instanceof RegExp)
          return "regexp";
      }
      return M;
    }
    function V(T) {
      var M = B(T);
      switch (M) {
        case "array":
        case "object":
          return "an " + M;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + M;
        default:
          return M;
      }
    }
    function $(T) {
      return !T.constructor || !T.constructor.name ? p : T.constructor.name;
    }
    return h.checkPropTypes = o, h.resetWarningCache = o.resetWarningCache, h.PropTypes = h, h;
  }, la;
}
var ca, Lf;
function xP() {
  if (Lf) return ca;
  Lf = 1;
  var t = qc();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, ca = function() {
    function r(i, a, l, c, u, d) {
      if (d !== t) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var s = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return s.PropTypes = s, s;
  }, ca;
}
if (process.env.NODE_ENV !== "production") {
  var CP = mv(), EP = !0;
  tl.exports = wP()(CP.isElement, EP);
} else
  tl.exports = xP()();
var SP = tl.exports;
const Q = /* @__PURE__ */ hp(SP), vv = {
  // common
  mask: Q.oneOfType([Q.array, Q.func, Q.string, Q.instanceOf(RegExp), Q.oneOf([Date, Number, se.Masked]), Q.instanceOf(se.Masked)]),
  value: Q.any,
  unmask: Q.oneOfType([Q.bool, Q.oneOf(["typed"])]),
  prepare: Q.func,
  prepareChar: Q.func,
  validate: Q.func,
  commit: Q.func,
  overwrite: Q.oneOfType([Q.bool, Q.oneOf(["shift"])]),
  eager: Q.oneOfType([Q.bool, Q.oneOf(["append", "remove"])]),
  skipInvalid: Q.bool,
  // events
  onAccept: Q.func,
  onComplete: Q.func,
  // pattern
  placeholderChar: Q.string,
  displayChar: Q.string,
  lazy: Q.bool,
  definitions: Q.object,
  blocks: Q.object,
  // enum
  enum: Q.arrayOf(Q.string),
  // range
  maxLength: Q.number,
  from: Q.number,
  to: Q.number,
  // date
  pattern: Q.string,
  format: Q.func,
  parse: Q.func,
  autofix: Q.oneOfType([Q.bool, Q.oneOf(["pad"])]),
  // number
  radix: Q.string,
  thousandsSeparator: Q.string,
  mapToRadix: Q.arrayOf(Q.string),
  scale: Q.number,
  normalizeZeros: Q.bool,
  padFractionalZeros: Q.bool,
  min: Q.oneOfType([Q.number, Q.instanceOf(Date)]),
  max: Q.oneOfType([Q.number, Q.instanceOf(Date)]),
  // dynamic
  dispatch: Q.func,
  // ref
  inputRef: Q.oneOfType([Q.func, Q.shape({
    current: Q.object
  })])
}, yv = Object.keys(vv).filter((t) => t !== "value"), AP = ["value", "unmask", "onAccept", "onComplete", "inputRef"], TP = yv.filter((t) => AP.indexOf(t) < 0);
function RP(t) {
  var e;
  const n = (e = class extends ne.Component {
    constructor(s) {
      super(s), this._inputRef = this._inputRef.bind(this);
    }
    componentDidMount() {
      this.props.mask && this.initMask();
    }
    componentDidUpdate() {
      const s = this.props, i = this._extractMaskOptionsFromProps(s);
      if (i.mask)
        this.maskRef ? (this.maskRef.updateOptions(i), "value" in s && s.value !== void 0 && (this.maskValue = s.value)) : this.initMask(i);
      else if (this.destroyMask(), "value" in s && s.value !== void 0) {
        var a;
        (a = this.element) != null && a.isContentEditable && this.element.tagName !== "INPUT" && this.element.tagName !== "TEXTAREA" ? this.element.textContent = s.value : this.element.value = s.value;
      }
    }
    componentWillUnmount() {
      this.destroyMask();
    }
    _inputRef(s) {
      this.element = s, this.props.inputRef && (Object.prototype.hasOwnProperty.call(this.props.inputRef, "current") ? this.props.inputRef.current = s : this.props.inputRef(s));
    }
    initMask(s) {
      s === void 0 && (s = this._extractMaskOptionsFromProps(this.props)), this.maskRef = se(this.element, s).on("accept", this._onAccept.bind(this)).on("complete", this._onComplete.bind(this)), "value" in this.props && this.props.value !== void 0 && (this.maskValue = this.props.value);
    }
    destroyMask() {
      this.maskRef && (this.maskRef.destroy(), delete this.maskRef);
    }
    _extractMaskOptionsFromProps(s) {
      const {
        ...i
      } = s;
      return Object.keys(i).filter((a) => TP.indexOf(a) < 0).forEach((a) => {
        delete i[a];
      }), i;
    }
    _extractNonMaskProps(s) {
      const {
        ...i
      } = s;
      return yv.forEach((a) => {
        a !== "maxLength" && delete i[a];
      }), "defaultValue" in i || (i.defaultValue = s.mask ? "" : i.value), delete i.value, i;
    }
    get maskValue() {
      return this.maskRef ? this.props.unmask === "typed" ? this.maskRef.typedValue : this.props.unmask ? this.maskRef.unmaskedValue : this.maskRef.value : "";
    }
    set maskValue(s) {
      this.maskRef && (s = s == null && this.props.unmask !== "typed" ? "" : s, this.props.unmask === "typed" ? this.maskRef.typedValue = s : this.props.unmask ? this.maskRef.unmaskedValue = s : this.maskRef.value = s);
    }
    _onAccept(s) {
      this.props.onAccept && this.maskRef && this.props.onAccept(this.maskValue, this.maskRef, s);
    }
    _onComplete(s) {
      this.props.onComplete && this.maskRef && this.props.onComplete(this.maskValue, this.maskRef, s);
    }
    render() {
      return ne.createElement(t, {
        ...this._extractNonMaskProps(this.props),
        inputRef: this._inputRef
      });
    }
  }, e.displayName = void 0, e.propTypes = void 0, e), r = t.displayName || t.name || "Component";
  return n.displayName = "IMask(" + r + ")", n.propTypes = vv, ne.forwardRef((o, s) => ne.createElement(n, {
    ...o,
    ref: s
  }));
}
const _P = RP((t) => {
  let {
    inputRef: e,
    ...n
  } = t;
  return ne.createElement("input", {
    ...n,
    ref: e
  });
}), PP = (t, e) => ne.createElement(_P, {
  ...t,
  ref: e
});
ne.forwardRef(PP);
function kP(t, e) {
  let {
    onAccept: n,
    onComplete: r,
    ref: o = Se(null),
    defaultValue: s,
    defaultUnmaskedValue: i,
    defaultTypedValue: a
  } = {};
  const l = Se(null), [c, u] = de({}), [d, p] = de(""), [h, v] = de(""), [m, y] = de(), b = Dt(() => {
    var C;
    (C = l.current) == null || C.destroy(), l.current = null;
  }, []), w = Dt(() => {
    const C = l.current;
    C && (u({
      value: C.value,
      unmaskedValue: C.unmaskedValue,
      typedValue: C.typedValue
    }), y(C.typedValue), v(C.unmaskedValue), p(C.value));
  }, []), x = Dt((C) => {
    const A = l.current;
    A && (w(), n == null || n(A.value, A, C));
  }, [n]), E = Dt((C) => l.current && (r == null ? void 0 : r(l.current.value, l.current, C)), [r]);
  return ie(() => {
    const {
      value: C,
      ...A
    } = c, S = l.current;
    !S || d === void 0 || (C !== d && (S.value = d, S.value !== d && x()), u(A));
  }, [d]), ie(() => {
    const {
      unmaskedValue: C,
      ...A
    } = c, S = l.current;
    !S || h === void 0 || (C !== h && (S.unmaskedValue = h, S.unmaskedValue !== h && x()), u(A));
  }, [h]), ie(() => {
    const {
      typedValue: C,
      ...A
    } = c, S = l.current;
    !S || m === void 0 || (C !== m && (S.typedValue = m, S.masked.typedValueEquals(m) || x()), u(A));
  }, [m]), ie(() => {
    const C = o.current;
    if (!C || !(t != null && t.mask)) return b();
    const A = l.current;
    A ? A == null || A.updateOptions(t) : C && t != null && t.mask && (l.current = se(C, t), w(), s !== void 0 && p(s), i !== void 0 && v(i), a !== void 0 && y(a));
  }, [t, b, x]), ie(() => {
    if (!l.current) return;
    const C = l.current;
    return C.on("accept", x), C.on("complete", E), () => {
      C.off("accept", x), C.off("complete", E);
    };
  }, [x, E]), ie(() => b, [b]), {
    ref: o,
    maskRef: l,
    value: d,
    setValue: p,
    unmaskedValue: h,
    setUnmaskedValue: v,
    typedValue: m,
    setTypedValue: y
  };
}
const KN = (t) => t.mask ? /* @__PURE__ */ g(DP, { ...t }) : /* @__PURE__ */ g(IP, { ...t }), IP = (t) => {
  const { unmask: e, ...n } = t;
  return /* @__PURE__ */ g(ui, { type: t.type || "text", ...n });
}, DP = (t) => {
  let e;
  t.value ? e = t.value : t.defaultValue ? e = t.defaultValue : e = "";
  const {
    ref: n,
    value: r,
    unmaskedValue: o,
    setValue: s
  } = kP({
    mask: t.mask,
    defaultValue: e
  }), i = () => {
    t.onChange && t.onChange(t.unmask ? o : r), s(r);
  }, { unmask: a, ...l } = t;
  return /* @__PURE__ */ g(ui, { type: "text", ...l, inputRef: n, value: r, onChange: i });
}, YN = (t) => /* @__PURE__ */ g(
  ui,
  {
    ...t,
    type: "text",
    buttonIcon: "search",
    iconButtonType: "submit",
    iconButtonLabel: "Suchen",
    onIconButtonClick: t.onSearch
  }
), MP = ae({
  /* the before: styles are used to create content that allows proper baseline alignment when suing inline-flex elements with text:
    https://stackoverflow.com/questions/73715565/how-to-get-a-flex-item-to-participate-in-baseline-alignment-and-be-centered
    https://www.w3.org/TR/css-flexbox-1/#flex-baselines
  */
  base: [
    "preflight rounded-sm inline-flex before:content-['_'] before:whitespace-pre before:w-0 relative items-center",
    "focus-visible:outline focus-visible:outline-clr-primary focus-visible:outline-1 group"
  ],
  slots: {
    icon: "h-4 w-4 inline-block fill-clr-primary",
    label: "typography-link-large text-clr-primary underline underline-offset-2 hover:decoration-2 group-focus:no-underline"
  },
  variants: {
    small: {
      true: {
        label: "typography-link-small"
      }
    },
    hideUnderline: {
      true: {
        label: "no-underline hover:underline"
      }
    },
    arrowPosition: {
      left: "",
      right: "flex-row-reverse justify-end"
    }
  }
}), qN = ({
  children: t,
  small: e = !1,
  hideUnderline: n = !1,
  showArrow: r = !1,
  arrowPosition: o = "left",
  button: s = !1,
  onClick: i,
  tabIndex: a,
  srLabel: l,
  ...c
}) => {
  const { base: u, icon: d, label: p } = MP({ small: e, hideUnderline: n, arrowPosition: o }), h = /* @__PURE__ */ G(Pe, { children: [
    r && /* @__PURE__ */ g(ge, { variant: o === "left" ? "arrow-left" : "arrow-right", className: d() }),
    l && /* @__PURE__ */ g("span", { className: "sr-only", children: l }),
    /* @__PURE__ */ g("span", { "aria-hidden": l ? "true" : void 0, className: p(), children: t })
  ] });
  if (s)
    return /* @__PURE__ */ g("button", { type: "button", className: u(), onClick: i, tabIndex: a, children: h });
  {
    const { href: v, target: m, rel: y } = c;
    return /* @__PURE__ */ g("a", { href: v, target: m, rel: y, className: u(), onClick: i, tabIndex: a, children: h });
  }
}, NP = ae({
  slots: {
    listItem: "preflight list-none",
    button: "w-full",
    contentParent: "pt-2 px-2 pb-0.5 typography-input-text flex gap-2 items-top text-clr-primary fill-clr-primary focus:outline-none group",
    content: "flex gap-2 grow-1 items-top w-full",
    textWrapper: "text-left border-b border-transparent pb-1",
    text: "px-1 border border-transparent rounded-sm group-focus-visible:border-clr-primary inline-block",
    icon: "w-5 h-5 shrink-0",
    iconWrapper: "min-w-5 min-h-5"
  },
  variants: {
    type: {
      text: {},
      button: {
        textWrapper: "group-hover:border-b-clr-primary"
      },
      link: {
        textWrapper: "group-hover:border-b-clr-primary"
      }
    }
  }
}), bv = ({
  children: t,
  icon: e,
  target: n = "_self",
  showArrow: r = !1,
  type: o = "text",
  onClick: s,
  href: i = "#"
}) => {
  const a = { type: o }, {
    listItem: l,
    button: c,
    text: u,
    icon: d,
    contentParent: p,
    content: h,
    textWrapper: v,
    iconWrapper: m
  } = NP(a), y = /* @__PURE__ */ G(Pe, { children: [
    /* @__PURE__ */ G("span", { className: h(), children: [
      e ? /* @__PURE__ */ g("span", { className: m(), children: /* @__PURE__ */ g(ge, { variant: e, className: d() }) }) : null,
      /* @__PURE__ */ g("span", { className: v(), children: /* @__PURE__ */ g("span", { className: u(), children: t }) })
    ] }),
    r ? /* @__PURE__ */ g(ge, { variant: "arrow-right", className: d() }) : null
  ] });
  switch (o) {
    case "text":
      return /* @__PURE__ */ g("li", { className: `${l()} ${p()}`, children: y });
    case "button":
      return /* @__PURE__ */ g("li", { className: l(), children: /* @__PURE__ */ g("button", { onClick: s, className: `${c()} ${p()}`, children: y }) });
    case "link":
      return /* @__PURE__ */ g("li", { className: l(), children: /* @__PURE__ */ g("a", { href: i, target: n, className: p(), onClick: s, children: y }) });
  }
};
bv.displayName = "Item";
const OP = ae({
  base: "preflight flex flex-col"
}), VP = ({ children: t, type: e = "text", showArrows: n = !1, className: r = "" }) => {
  const o = OP(), s = { type: e, showArrow: n };
  return /* @__PURE__ */ g("ol", { className: `${o} ${r}`, children: tn.map(t, (i) => ne.isValidElement(i) ? ne.cloneElement(i, { ...s }) : i) });
};
VP.Item = bv;
const XN = ({ variant: t, label: e, className: n, ...r }) => {
  const [o, s] = de(null);
  ie(() => {
    (async () => {
      try {
        const l = await Tp(/* @__PURE__ */ Object.assign({ "../../assets/logos/app-apple-cz-logo.svg": () => import("./app-apple-cz-logo-DHAVTgki.js"), "../../assets/logos/app-apple-de-logo.svg": () => import("./app-apple-de-logo-CzPD_M54.js"), "../../assets/logos/app-apple-en-logo.svg": () => import("./app-apple-en-logo-0PCWKAKs.js"), "../../assets/logos/app-apple-es-logo.svg": () => import("./app-apple-es-logo-6akvpwAj.js"), "../../assets/logos/app-apple-fi-logo.svg": () => import("./app-apple-fi-logo-BfB24zeE.js"), "../../assets/logos/app-apple-fr-logo.svg": () => import("./app-apple-fr-logo-BKK-zHeP.js"), "../../assets/logos/app-apple-hu-logo.svg": () => import("./app-apple-hu-logo-C0pJzgUo.js"), "../../assets/logos/app-apple-it-logo.svg": () => import("./app-apple-it-logo-DtjT1acw.js"), "../../assets/logos/app-apple-nl-logo.svg": () => import("./app-apple-nl-logo-DdT_d2u1.js"), "../../assets/logos/app-apple-no-logo.svg": () => import("./app-apple-no-logo-BL_cU9GW.js"), "../../assets/logos/app-apple-ro-logo.svg": () => import("./app-apple-ro-logo-N8_Ta7s9.js"), "../../assets/logos/app-apple-se-logo.svg": () => import("./app-apple-se-logo-B3ZdmXU3.js"), "../../assets/logos/app-apple-si-logo.svg": () => import("./app-apple-si-logo-C3H4FT4W.js"), "../../assets/logos/app-google-play-cz-logo.svg": () => import("./app-google-play-cz-logo-DGz6f3PO.js"), "../../assets/logos/app-google-play-de-logo.svg": () => import("./app-google-play-de-logo-Bt0qCZlg.js"), "../../assets/logos/app-google-play-en-logo.svg": () => import("./app-google-play-en-logo-yjiz1-f7.js"), "../../assets/logos/app-google-play-es-logo.svg": () => import("./app-google-play-es-logo-B6hmMB-D.js"), "../../assets/logos/app-google-play-fi-logo.svg": () => import("./app-google-play-fi-logo-aYktO_BS.js"), "../../assets/logos/app-google-play-fr-logo.svg": () => import("./app-google-play-fr-logo-dgBnUcX-.js"), "../../assets/logos/app-google-play-hu-logo.svg": () => import("./app-google-play-hu-logo-uLCX49xm.js"), "../../assets/logos/app-google-play-it-logo.svg": () => import("./app-google-play-it-logo-Cp5all9k.js"), "../../assets/logos/app-google-play-nl-logo.svg": () => import("./app-google-play-nl-logo-Cr8VMD3x.js"), "../../assets/logos/app-google-play-no-logo.svg": () => import("./app-google-play-no-logo-Bwtxo6sR.js"), "../../assets/logos/app-google-play-ro-logo.svg": () => import("./app-google-play-ro-logo-DTwHwr5-.js"), "../../assets/logos/app-google-play-se-logo.svg": () => import("./app-google-play-se-logo-9iYOU2XV.js"), "../../assets/logos/app-google-play-si-logo.svg": () => import("./app-google-play-si-logo-DIO9tadT.js"), "../../assets/logos/badge-save-shopping-logo.svg": () => import("./badge-save-shopping-logo-DdwEF9T3.js"), "../../assets/logos/badge-shop-award-logo.svg": () => import("./badge-shop-award-logo-C6GYedro.js"), "../../assets/logos/bonprix-logo.svg": () => import("./bonprix-logo-BBiV4AL5.js"), "../../assets/logos/payment-american-express-logo.svg": () => import("./payment-american-express-logo-DYDLsybt.js"), "../../assets/logos/payment-american-express-nrm-logo.svg": () => import("./payment-american-express-nrm-logo-BzKpDzVI.js"), "../../assets/logos/payment-bancontact-colored-logo.svg": () => import("./payment-bancontact-colored-logo-BN5ZOdo_.js"), "../../assets/logos/payment-bancontact-colored-nrm-logo.svg": () => import("./payment-bancontact-colored-nrm-logo-D0e4bYrQ.js"), "../../assets/logos/payment-bancontact-mono-logo.svg": () => import("./payment-bancontact-mono-logo-BPg0x3fy.js"), "../../assets/logos/payment-bancontact-mono-nrm-logo.svg": () => import("./payment-bancontact-mono-nrm-logo-CMejt-6W.js"), "../../assets/logos/payment-cb-colored-logo.svg": () => import("./payment-cb-colored-logo-mWWBPmVv.js"), "../../assets/logos/payment-cb-colored-nrm-logo.svg": () => import("./payment-cb-colored-nrm-logo-BySnuYyM.js"), "../../assets/logos/payment-cb-mono-logo.svg": () => import("./payment-cb-mono-logo-DCPWr04Y.js"), "../../assets/logos/payment-cb-mono-nrm-logo.svg": () => import("./payment-cb-mono-nrm-logo-DJdANB-h.js"), "../../assets/logos/payment-diners-club-logo.svg": () => import("./payment-diners-club-logo-DTFQlq00.js"), "../../assets/logos/payment-diners-club-nrm-logo.svg": () => import("./payment-diners-club-nrm-logo-op07-okd.js"), "../../assets/logos/payment-discover-logo.svg": () => import("./payment-discover-logo-B1fqmlhZ.js"), "../../assets/logos/payment-discover-nrm-logo.svg": () => import("./payment-discover-nrm-logo-COXoYZKU.js"), "../../assets/logos/payment-giropay-colored-logo.svg": () => import("./payment-giropay-colored-logo-DtKHXxWx.js"), "../../assets/logos/payment-giropay-colored-nrm-logo.svg": () => import("./payment-giropay-colored-nrm-logo-CpCd8yOD.js"), "../../assets/logos/payment-giropay-mono-logo.svg": () => import("./payment-giropay-mono-logo-erjd1Pr0.js"), "../../assets/logos/payment-giropay-mono-nrm-logo.svg": () => import("./payment-giropay-mono-nrm-logo-DOKBLVFV.js"), "../../assets/logos/payment-ideal-colored-logo.svg": () => import("./payment-ideal-colored-logo-D1tGyT20.js"), "../../assets/logos/payment-ideal-colored-nrm-logo.svg": () => import("./payment-ideal-colored-nrm-logo-CjoNvtIa.js"), "../../assets/logos/payment-ideal-mono-logo.svg": () => import("./payment-ideal-mono-logo-Y4M6iTMG.js"), "../../assets/logos/payment-ideal-mono-nrm-logo.svg": () => import("./payment-ideal-mono-nrm-logo-M7B19_8z.js"), "../../assets/logos/payment-instalment-logo.svg": () => import("./payment-instalment-logo-Lk6hpggG.js"), "../../assets/logos/payment-instalment-nrm-logo.svg": () => import("./payment-instalment-nrm-logo-DSlbH7i-.js"), "../../assets/logos/payment-invoice-logo.svg": () => import("./payment-invoice-logo-C7VfQCrM.js"), "../../assets/logos/payment-invoice-nrm-logo.svg": () => import("./payment-invoice-nrm-logo-DIpZd5JG.js"), "../../assets/logos/payment-klarna-colored-logo.svg": () => import("./payment-klarna-colored-logo-Btdr9KMH.js"), "../../assets/logos/payment-klarna-colored-nrm-logo.svg": () => import("./payment-klarna-colored-nrm-logo-fR_wcnas.js"), "../../assets/logos/payment-klarna-mono-logo.svg": () => import("./payment-klarna-mono-logo-CDXKXGsa.js"), "../../assets/logos/payment-klarna-mono-nrm-logo.svg": () => import("./payment-klarna-mono-nrm-logo-DDcD2voE.js"), "../../assets/logos/payment-mastercard-logo.svg": () => import("./payment-mastercard-logo-BBoiNHWt.js"), "../../assets/logos/payment-mastercard-nrm-logo.svg": () => import("./payment-mastercard-nrm-logo-BmKgeN-H.js"), "../../assets/logos/payment-part-payment-logo.svg": () => import("./payment-part-payment-logo-DdOUYTIb.js"), "../../assets/logos/payment-part-payment-nrm-logo.svg": () => import("./payment-part-payment-nrm-logo-Dz4HoipW.js"), "../../assets/logos/payment-paypal-logo.svg": () => import("./payment-paypal-logo-DlW84v5P.js"), "../../assets/logos/payment-paypal-nrm-logo.svg": () => import("./payment-paypal-nrm-logo-C3FbRUjb.js"), "../../assets/logos/payment-prepayment-logo.svg": () => import("./payment-prepayment-logo-mCmz2ay1.js"), "../../assets/logos/payment-prepayment-nrm-logo.svg": () => import("./payment-prepayment-nrm-logo-k3gd4cJi.js"), "../../assets/logos/payment-sepa-logo.svg": () => import("./payment-sepa-logo-C87W0rxJ.js"), "../../assets/logos/payment-sepa-nrm-logo.svg": () => import("./payment-sepa-nrm-logo-DgkNx6mG.js"), "../../assets/logos/payment-visa-logo.svg": () => import("./payment-visa-logo-BQ3zcMdn.js"), "../../assets/logos/payment-visa-nrm-logo.svg": () => import("./payment-visa-nrm-logo-Og3vXFKp.js"), "../../assets/logos/product-fit-finder-logo.svg": () => import("./product-fit-finder-logo-akMKcj8m.js"), "../../assets/logos/product-green-button-logo.svg": () => import("./product-green-button-logo-8BQIKMqG.js"), "../../assets/logos/product-higg-index-logo.svg": () => import("./product-higg-index-logo-acju6nPS.js"), "../../assets/logos/product-sustainable-logo.svg": () => import("./product-sustainable-logo-sHpGGeOb.js"), "../../assets/logos/social-facebook-colored-logo.svg": () => import("./social-facebook-colored-logo-B1CiNVvO.js"), "../../assets/logos/social-facebook-mono-logo.svg": () => import("./social-facebook-mono-logo-yqraC3E1.js"), "../../assets/logos/social-instagram-colored-logo.svg": () => import("./social-instagram-colored-logo-NpucGR4O.js"), "../../assets/logos/social-instagram-mono-logo.svg": () => import("./social-instagram-mono-logo-DTa8WXcl.js"), "../../assets/logos/social-pinterest-colored-logo.svg": () => import("./social-pinterest-colored-logo-CCmC8O5o.js"), "../../assets/logos/social-pinterest-mono-logo.svg": () => import("./social-pinterest-mono-logo-C_-QNPHh.js"), "../../assets/logos/social-tiktok-colored-logo.svg": () => import("./social-tiktok-colored-logo-D5Ca7FDj.js"), "../../assets/logos/social-tiktok-mono-logo.svg": () => import("./social-tiktok-mono-logo-Bhny7xiO.js"), "../../assets/logos/social-whatsapp-colored-logo.svg": () => import("./social-whatsapp-colored-logo-UgdFgMSq.js"), "../../assets/logos/social-whatsapp-mono-logo.svg": () => import("./social-whatsapp-mono-logo-Dj-XPilJ.js"), "../../assets/logos/social-x-logo.svg": () => import("./social-x-logo-CBkq-OwV.js"), "../../assets/logos/social-youtube-colored-logo.svg": () => import("./social-youtube-colored-logo-QqSlPnlI.js"), "../../assets/logos/social-youtube-mono-logo.svg": () => import("./social-youtube-mono-logo-DpkOrk7t.js") }), `../../assets/logos/${t}-logo.svg`, 5);
        s(() => l.default);
      } catch (l) {
        console.error("Fehler beim dynamischen Import des SVG-Icons:", l);
      }
    })();
  }, [t]);
  const i = Jn("shrink-0", n), a = !e;
  if (!o)
    return /* @__PURE__ */ g("div", { className: i });
  if (r.isLink) {
    const { href: l, rel: c, target: u } = r;
    return /* @__PURE__ */ G("a", { href: l, rel: c, target: u, children: [
      /* @__PURE__ */ g(o, { className: i, "aria-hidden": !0 }),
      /* @__PURE__ */ g("span", { className: "sr-only", children: e })
    ] });
  } else
    return /* @__PURE__ */ g(o, { className: i, "aria-label": e, "aria-hidden": a });
}, ZN = ({ children: t, isOpen: e, onClose: n = () => null, zIndex: r = 1 }) => {
  const { shouldRender: o, handleAnimationEnd: s } = y0(e);
  return /* @__PURE__ */ g(Pe, { children: vl(
    o ? /* @__PURE__ */ g(
      "div",
      {
        className: Ns(),
        onClick: n,
        "data-state": e ? "open" : "closed",
        onAnimationEnd: s,
        style: { zIndex: r },
        children: t
      }
    ) : null,
    document.body
  ) });
}, Bf = ({ position: t = "left", href: e, onClick: n, disabled: r = !1 }) => {
  const o = (c) => {
    c.preventDefault(), n();
  };
  return r ? /* @__PURE__ */ g("div", { className: "w-6 h-6" }) : /* @__PURE__ */ g(Tn, { link: !0, href: e, onClick: o, label: t === "left" ? "vorherige Seite" : "nächste Seite", icon: t === "left" ? "arrow-left" : "arrow-right", small: !0 });
}, FP = ae({
  base: "preflight group relative inline-block leading-6 w-6 typography-body1 text-clr-primary text-center align-middle",
  slots: {
    indicator: "absolute left-0 bottom-0 w-full bg-clr-primary"
  },
  variants: {
    active: {
      true: {
        indicator: "h-1"
      },
      false: {
        base: "focus-visible:outline focus-visible:outline-offset-0 focus-visible:rounded-sm",
        indicator: "group-hover:h-[1px] group-focus:group-hover:h-0"
      }
    }
  }
}), LP = ({ pageNumber: t, baseHref: e, onClick: n, active: r = !1 }) => {
  const { base: o, indicator: s } = FP({ active: r }), i = nl(e, t), a = (l) => {
    l.preventDefault(), n();
  };
  return r ? /* @__PURE__ */ G("span", { className: o(), children: [
    t,
    /* @__PURE__ */ g("span", { className: s() })
  ] }) : /* @__PURE__ */ G("a", { href: i, className: o(), onClick: a, children: [
    t,
    /* @__PURE__ */ g("span", { className: s() })
  ] });
}, BP = ae({
  base: "preflight flex items-center gap-4"
}), JN = ({ currentPage: t = 1, totalPages: e, onPageChange: n, baseHref: r }) => {
  const o = () => t < e && n(t + 1, "next"), s = () => t > 1 && n(t - 1, "prev"), a = t === 1, l = t === e, c = Lt(() => {
    const p = [];
    if (e <= 7) {
      for (let b = 1; b <= e; b++)
        p.push(b);
      return p;
    }
    const h = Math.max(Math.min(t - 1, e - 4), 3), v = Math.max(Math.min(e - 2, t + 1), 5), m = h === 3 ? 2 : "ellipsis", y = v === e - 2 ? e - 1 : "ellipsis";
    for (let b = h; b <= v; b++)
      p.push(b);
    return [1, m, ...p, y, e];
  }, [t, e]), u = nl(r, t - 1), d = nl(r, t + 1);
  return /* @__PURE__ */ G("div", { className: BP(), children: [
    /* @__PURE__ */ g(Bf, { position: "left", href: u, onClick: s, disabled: a }),
    c.map(
      (p, h) => typeof p == "number" ? /* @__PURE__ */ g(
        LP,
        {
          pageNumber: p,
          baseHref: r,
          onClick: () => n(p, "page"),
          active: p === t
        },
        h
      ) : /* @__PURE__ */ g($P, {})
    ),
    /* @__PURE__ */ g(Bf, { position: "right", href: d, onClick: o, disabled: l })
  ] });
}, $P = () => /* @__PURE__ */ g("span", { className: "h-6 w-6 text-center typography-body1 text-clr-primary", children: "..." }), nl = (t, e) => {
  let n;
  try {
    n = new URL(t);
  } catch {
    n = new URL(t, window.location.origin);
  }
  return e !== 1 && n.searchParams.set("page", e.toString()), n.toString();
}, WP = ae({
  slots: {
    root: "preflight flex flex-col",
    mainRow: "font-bonprixRegular flex gap-1 items-end text-clr-on-bg-high",
    fromPart: "font-sourceSans3",
    currentPricePart: "",
    oldPricePart: "font-bonprixRegular text-clr-on-bg-low line-through",
    discountPart: "font-sourceSans3 text-clr-sale bg-[#BE181A]/[15%] text-[12px]/[14px] px-0.5 rounded-sm",
    unitsRow: "font-sourceSans3 text-clr-on-bg-low",
    bestPriceRow: "flex gap-1 font-sourceSans3 text-clr-on-bg-high",
    noPriceRoot: "preflight flex flex-col gap-3 font-sourceSans3 text-[14px]/[14px]"
  },
  variants: {
    size: {
      small: {
        root: "gap-2",
        mainRow: "text-[15px]/[15px]",
        fromPart: "text-[10px]/[10px]",
        oldPricePart: "text-[12px]/[12px]",
        discountPart: "text-[12px]/[14px]",
        bestPriceRow: "text-[10px]/[10px]",
        unitsRow: "text-[10px]/[10px]",
        noPriceRoot: "text-[10px]/[10px]"
      },
      large: {
        root: "gap-3",
        mainRow: "text-[22px]/[22px]",
        fromPart: "text-[15px]/[15px]",
        oldPricePart: "text-[16px]/[16px]",
        discountPart: "text-[16px]/[16px] py-0.25",
        bestPriceRow: "text-[14px]/[14px]",
        unitsRow: "text-[14px]/[14px]",
        noPriceRoot: "text-[14px]/[14px]"
      }
    },
    variant: {
      regular: "",
      sale: {
        fromPart: "text-clr-sale",
        currentPricePart: "text-clr-sale"
      },
      "best-price": {
        fromPart: "text-clr-sale",
        currentPricePart: "text-clr-sale"
      },
      "no-price": ""
    }
  }
}), ua = (t) => `€ ${t.toFixed(2).replace(".", ",")}`, QN = ({
  variant: t = "regular",
  currentPrice: e,
  size: n = "small",
  isFromPrice: r = !1,
  showUnits: o,
  amount: s = 1,
  oldPrice: i = e
}) => {
  const { root: a, mainRow: l, fromPart: c, currentPricePart: u, oldPricePart: d, discountPart: p, unitsRow: h, bestPriceRow: v, noPriceRoot: m } = WP({
    variant: t,
    size: n
  }), y = ua(e), b = ua(i), x = `-${Math.round(100 - e / i * 100)}%`, E = ua(e / s), C = `${s} Stück | ${E} / Stk.`;
  return t === "no-price" ? /* @__PURE__ */ G("div", { className: m(), children: [
    /* @__PURE__ */ g("p", { className: "text-clr-error", children: "Preis zur Zeit nicht Verfügbar" }),
    /* @__PURE__ */ g("p", { className: "text-clr-on-bg-low", children: "Bitte versuche es später erneut" })
  ] }) : /* @__PURE__ */ G("div", { className: a(), children: [
    /* @__PURE__ */ G("p", { className: l(), children: [
      r && /* @__PURE__ */ g("span", { className: c(), children: "ab" }),
      /* @__PURE__ */ g("span", { className: u(), children: y }),
      t === "sale" && /* @__PURE__ */ G(Pe, { children: [
        /* @__PURE__ */ g("span", { className: d(), children: b }),
        /* @__PURE__ */ g("span", { className: p(), children: x })
      ] }),
      t === "best-price" && /* @__PURE__ */ g("span", { className: p(), children: x })
    ] }),
    t === "best-price" && /* @__PURE__ */ G("p", { className: v(), children: [
      /* @__PURE__ */ g("span", { className: "line-through", children: b }),
      "30-Tage Bestpreis",
      /* @__PURE__ */ g("span", { className: "text-clr-sale", children: x })
    ] }),
    o && /* @__PURE__ */ g("p", { className: h(), children: C })
  ] });
};
// @__NO_SIDE_EFFECTS__
function jP(t) {
  const e = /* @__PURE__ */ UP(t), n = f.forwardRef((r, o) => {
    const { children: s, ...i } = r, a = f.Children.toArray(s), l = a.find(zP);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ g(e, { ...i, ref: o, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ g(e, { ...i, ref: o, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function UP(t) {
  const e = f.forwardRef((n, r) => {
    const { children: o, ...s } = n, i = f.isValidElement(o) ? KP(o) : void 0, a = te(i, r);
    if (f.isValidElement(o)) {
      const l = GP(s, o.props);
      return o.type !== f.Fragment && (l.ref = a), f.cloneElement(o, l);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var HP = Symbol("radix.slottable");
function zP(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === HP;
}
function GP(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const l = s(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function KP(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var YP = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], br = YP.reduce((t, e) => {
  const n = /* @__PURE__ */ jP(`Primitive.${e}`), r = f.forwardRef((o, s) => {
    const { asChild: i, ...a } = o, l = i ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {}), qP = f.createContext(void 0);
function wv(t) {
  const e = f.useContext(qP);
  return t || e || "ltr";
}
var da = "rovingFocusGroup.onEntryFocus", XP = { bubbles: !1, cancelable: !0 }, Ro = "RovingFocusGroup", [rl, xv, ZP] = ks(Ro), [JP, Cv] = je(
  Ro,
  [ZP]
), [QP, ek] = JP(Ro), Ev = f.forwardRef(
  (t, e) => /* @__PURE__ */ g(rl.Provider, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ g(rl.Slot, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ g(tk, { ...t, ref: e }) }) })
);
Ev.displayName = Ro;
var tk = f.forwardRef((t, e) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: s,
    currentTabStopId: i,
    defaultCurrentTabStopId: a,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = t, p = f.useRef(null), h = te(e, p), v = wv(s), [m, y] = tt({
    prop: i,
    defaultProp: a ?? null,
    onChange: l,
    caller: Ro
  }), [b, w] = f.useState(!1), x = Ne(c), E = xv(n), C = f.useRef(!1), [A, S] = f.useState(0);
  return f.useEffect(() => {
    const R = p.current;
    if (R)
      return R.addEventListener(da, x), () => R.removeEventListener(da, x);
  }, [x]), /* @__PURE__ */ g(
    QP,
    {
      scope: n,
      orientation: r,
      dir: v,
      loop: o,
      currentTabStopId: m,
      onItemFocus: f.useCallback(
        (R) => y(R),
        [y]
      ),
      onItemShiftTab: f.useCallback(() => w(!0), []),
      onFocusableItemAdd: f.useCallback(
        () => S((R) => R + 1),
        []
      ),
      onFocusableItemRemove: f.useCallback(
        () => S((R) => R - 1),
        []
      ),
      children: /* @__PURE__ */ g(
        br.div,
        {
          tabIndex: b || A === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: h,
          style: { outline: "none", ...t.style },
          onMouseDown: J(t.onMouseDown, () => {
            C.current = !0;
          }),
          onFocus: J(t.onFocus, (R) => {
            const P = !C.current;
            if (R.target === R.currentTarget && P && !b) {
              const k = new CustomEvent(da, XP);
              if (R.currentTarget.dispatchEvent(k), !k.defaultPrevented) {
                const I = E().filter((L) => L.focusable), _ = I.find((L) => L.active), D = I.find((L) => L.id === m), W = [_, D, ...I].filter(
                  Boolean
                ).map((L) => L.ref.current);
                Tv(W, u);
              }
            }
            C.current = !1;
          }),
          onBlur: J(t.onBlur, () => w(!1))
        }
      )
    }
  );
}), Sv = "RovingFocusGroupItem", Av = f.forwardRef(
  (t, e) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: s,
      children: i,
      ...a
    } = t, l = Je(), c = s || l, u = ek(Sv, n), d = u.currentTabStopId === c, p = xv(n), { onFocusableItemAdd: h, onFocusableItemRemove: v, currentTabStopId: m } = u;
    return f.useEffect(() => {
      if (r)
        return h(), () => v();
    }, [r, h, v]), /* @__PURE__ */ g(
      rl.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ g(
          br.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": u.orientation,
            ...a,
            ref: e,
            onMouseDown: J(t.onMouseDown, (y) => {
              r ? u.onItemFocus(c) : y.preventDefault();
            }),
            onFocus: J(t.onFocus, () => u.onItemFocus(c)),
            onKeyDown: J(t.onKeyDown, (y) => {
              if (y.key === "Tab" && y.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (y.target !== y.currentTarget) return;
              const b = ok(y, u.orientation, u.dir);
              if (b !== void 0) {
                if (y.metaKey || y.ctrlKey || y.altKey || y.shiftKey) return;
                y.preventDefault();
                let x = p().filter((E) => E.focusable).map((E) => E.ref.current);
                if (b === "last") x.reverse();
                else if (b === "prev" || b === "next") {
                  b === "prev" && x.reverse();
                  const E = x.indexOf(y.currentTarget);
                  x = u.loop ? sk(x, E + 1) : x.slice(E + 1);
                }
                setTimeout(() => Tv(x));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: d, hasTabStop: m != null }) : i
          }
        )
      }
    );
  }
);
Av.displayName = Sv;
var nk = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function rk(t, e) {
  return e !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function ok(t, e, n) {
  const r = rk(t.key, n);
  if (!(e === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(e === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return nk[r];
}
function Tv(t, e = !1) {
  const n = document.activeElement;
  for (const r of t)
    if (r === n || (r.focus({ preventScroll: e }), document.activeElement !== n)) return;
}
function sk(t, e) {
  return t.map((n, r) => t[(e + r) % t.length]);
}
var ik = Ev, ak = Av;
function Xc(t) {
  const [e, n] = f.useState(void 0);
  return ke(() => {
    if (t) {
      n({ width: t.offsetWidth, height: t.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const s = o[0];
        let i, a;
        if ("borderBoxSize" in s) {
          const l = s.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          i = c.inlineSize, a = c.blockSize;
        } else
          i = t.offsetWidth, a = t.offsetHeight;
        n({ width: i, height: a });
      });
      return r.observe(t, { box: "border-box" }), () => r.unobserve(t);
    } else
      n(void 0);
  }, [t]), e;
}
function lk(t) {
  const e = f.useRef({ value: t, previous: t });
  return f.useMemo(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [t]);
}
var Zc = "Radio", [ck, Rv] = je(Zc), [uk, dk] = ck(Zc), _v = f.forwardRef(
  (t, e) => {
    const {
      __scopeRadio: n,
      name: r,
      checked: o = !1,
      required: s,
      disabled: i,
      value: a = "on",
      onCheck: l,
      form: c,
      ...u
    } = t, [d, p] = f.useState(null), h = te(e, (y) => p(y)), v = f.useRef(!1), m = d ? c || !!d.closest("form") : !0;
    return /* @__PURE__ */ G(uk, { scope: n, checked: o, disabled: i, children: [
      /* @__PURE__ */ g(
        br.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": Dv(o),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: a,
          ...u,
          ref: h,
          onClick: J(t.onClick, (y) => {
            o || l == null || l(), m && (v.current = y.isPropagationStopped(), v.current || y.stopPropagation());
          })
        }
      ),
      m && /* @__PURE__ */ g(
        Iv,
        {
          control: d,
          bubbles: !v.current,
          name: r,
          value: a,
          checked: o,
          required: s,
          disabled: i,
          form: c,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
_v.displayName = Zc;
var Pv = "RadioIndicator", kv = f.forwardRef(
  (t, e) => {
    const { __scopeRadio: n, forceMount: r, ...o } = t, s = dk(Pv, n);
    return /* @__PURE__ */ g(Ge, { present: r || s.checked, children: /* @__PURE__ */ g(
      br.span,
      {
        "data-state": Dv(s.checked),
        "data-disabled": s.disabled ? "" : void 0,
        ...o,
        ref: e
      }
    ) });
  }
);
kv.displayName = Pv;
var fk = "RadioBubbleInput", Iv = f.forwardRef(
  ({
    __scopeRadio: t,
    control: e,
    checked: n,
    bubbles: r = !0,
    ...o
  }, s) => {
    const i = f.useRef(null), a = te(i, s), l = lk(n), c = Xc(e);
    return f.useEffect(() => {
      const u = i.current;
      if (!u) return;
      const d = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        d,
        "checked"
      ).set;
      if (l !== n && h) {
        const v = new Event("click", { bubbles: r });
        h.call(u, n), u.dispatchEvent(v);
      }
    }, [l, n, r]), /* @__PURE__ */ g(
      br.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: n,
        ...o,
        tabIndex: -1,
        ref: a,
        style: {
          ...o.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Iv.displayName = fk;
function Dv(t) {
  return t ? "checked" : "unchecked";
}
var pk = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], mi = "RadioGroup", [hk, eO] = je(mi, [
  Cv,
  Rv
]), Mv = Cv(), Nv = Rv(), [mk, gk] = hk(mi), Ov = f.forwardRef(
  (t, e) => {
    const {
      __scopeRadioGroup: n,
      name: r,
      defaultValue: o,
      value: s,
      required: i = !1,
      disabled: a = !1,
      orientation: l,
      dir: c,
      loop: u = !0,
      onValueChange: d,
      ...p
    } = t, h = Mv(n), v = wv(c), [m, y] = tt({
      prop: s,
      defaultProp: o ?? null,
      onChange: d,
      caller: mi
    });
    return /* @__PURE__ */ g(
      mk,
      {
        scope: n,
        name: r,
        required: i,
        disabled: a,
        value: m,
        onValueChange: y,
        children: /* @__PURE__ */ g(
          ik,
          {
            asChild: !0,
            ...h,
            orientation: l,
            dir: v,
            loop: u,
            children: /* @__PURE__ */ g(
              br.div,
              {
                role: "radiogroup",
                "aria-required": i,
                "aria-orientation": l,
                "data-disabled": a ? "" : void 0,
                dir: v,
                ...p,
                ref: e
              }
            )
          }
        )
      }
    );
  }
);
Ov.displayName = mi;
var Vv = "RadioGroupItem", Fv = f.forwardRef(
  (t, e) => {
    const { __scopeRadioGroup: n, disabled: r, ...o } = t, s = gk(Vv, n), i = s.disabled || r, a = Mv(n), l = Nv(n), c = f.useRef(null), u = te(e, c), d = s.value === o.value, p = f.useRef(!1);
    return f.useEffect(() => {
      const h = (m) => {
        pk.includes(m.key) && (p.current = !0);
      }, v = () => p.current = !1;
      return document.addEventListener("keydown", h), document.addEventListener("keyup", v), () => {
        document.removeEventListener("keydown", h), document.removeEventListener("keyup", v);
      };
    }, []), /* @__PURE__ */ g(
      ak,
      {
        asChild: !0,
        ...a,
        focusable: !i,
        active: d,
        children: /* @__PURE__ */ g(
          _v,
          {
            disabled: i,
            required: s.required,
            checked: d,
            ...l,
            ...o,
            name: s.name,
            ref: u,
            onCheck: () => s.onValueChange(o.value),
            onKeyDown: J((h) => {
              h.key === "Enter" && h.preventDefault();
            }),
            onFocus: J(o.onFocus, () => {
              var h;
              p.current && ((h = c.current) == null || h.click());
            })
          }
        )
      }
    );
  }
);
Fv.displayName = Vv;
var vk = "RadioGroupIndicator", Lv = f.forwardRef(
  (t, e) => {
    const { __scopeRadioGroup: n, ...r } = t, o = Nv(n);
    return /* @__PURE__ */ g(kv, { ...o, ...r, ref: e });
  }
);
Lv.displayName = vk;
var yk = Ov, bk = Fv, wk = Lv;
const xk = ae({
  // items-start is needed, in order to wrap longer item labels according to design
  // py is used instead of h-8, because h-8 will make the item label vertically centered
  base: "preflight typography-input-text flex gap-2 items-start py-3 text-clr-on-bg-high fill-clr-primary",
  slots: {
    item: [
      "w-6 h-6 border border-clr-primary rounded-full shrink-0",
      "focus-visible:outline focus-visible:outline-clr-primary focus-visible:outline-1 focus-visible:outline-offset-2"
    ],
    indicator: [
      "flex items-center justify-center w-full h-full relative after:content-[''] after:block after:w-2.5",
      "after:h-2.5 after:bg-clr-primary after:rounded-[50%]"
    ]
  },
  variants: {
    disabled: {
      true: {
        base: "text-clr-on-bg-low",
        item: "border-clr-on-bg-low",
        indicator: "after:bg-clr-on-bg-low"
      },
      false: {
        base: "hover:cursor-pointer"
      }
    }
  }
}), Jc = ({ value: t, label: e, disabled: n = !1 }) => {
  const { base: r, item: o, indicator: s } = xk({ disabled: n });
  return /* @__PURE__ */ g("div", { children: /* @__PURE__ */ G("label", { className: r(), children: [
    /* @__PURE__ */ g(bk, { value: t, className: o(), disabled: n, children: /* @__PURE__ */ g(wk, { className: s() }) }),
    e
  ] }) });
};
Jc.displayName = "Item";
const Ck = ({
  value: t,
  onChange: e,
  label: n,
  children: r,
  name: o,
  disabled: s = !1,
  helperText: i,
  required: a = !1
}) => {
  const { getChildrenFromSubcomponent: l, printBadConstructionMessage: c } = pt(r), u = { disabled: s };
  return r ? /* @__PURE__ */ g(Eg, { label: n, disabled: s, helperText: i, required: a, children: /* @__PURE__ */ g(
    yk,
    {
      className: "preflight flex-col flex gap-2",
      name: o,
      value: t,
      onValueChange: e,
      orientation: "vertical",
      disabled: s,
      required: a,
      children: l(Jc, u)
    }
  ) }) : (c("RadioGroup"), null);
};
Ck.Item = Jc;
const Ek = ae({
  slots: {
    root: "preflight w-full h-full flex flex-col px-8 py-19 items-center justify-center",
    label: "pb-3 typography-body1 text-clr-primary text-center"
  }
}), tO = ({ children: t, actionLabel: e, onClick: n }) => {
  const { root: r, label: o } = Ek();
  return /* @__PURE__ */ G("div", { className: r(), children: [
    /* @__PURE__ */ g("div", { className: o(), children: t }),
    /* @__PURE__ */ g(Pl, { type: "button", variant: "secondary", onClick: n, contentWidth: !0, children: e })
  ] });
};
var Sk = f.createContext(void 0);
function Ak(t) {
  const e = f.useContext(Sk);
  return t || e || "ltr";
}
var fa = 0;
function Tk() {
  f.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? $f()), document.body.insertAdjacentElement("beforeend", t[1] ?? $f()), fa++, () => {
      fa === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), fa--;
    };
  }, []);
}
function $f() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.outline = "none", t.style.opacity = "0", t.style.position = "fixed", t.style.pointerEvents = "none", t;
}
const Rk = ["top", "right", "bottom", "left"], sn = Math.min, He = Math.max, Es = Math.round, Go = Math.floor, wt = (t) => ({
  x: t,
  y: t
}), _k = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Pk = {
  start: "end",
  end: "start"
};
function ol(t, e, n) {
  return He(t, sn(e, n));
}
function zt(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Gt(t) {
  return t.split("-")[0];
}
function wr(t) {
  return t.split("-")[1];
}
function Qc(t) {
  return t === "x" ? "y" : "x";
}
function eu(t) {
  return t === "y" ? "height" : "width";
}
function an(t) {
  return ["top", "bottom"].includes(Gt(t)) ? "y" : "x";
}
function tu(t) {
  return Qc(an(t));
}
function kk(t, e, n) {
  n === void 0 && (n = !1);
  const r = wr(t), o = tu(t), s = eu(o);
  let i = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[s] > e.floating[s] && (i = Ss(i)), [i, Ss(i)];
}
function Ik(t) {
  const e = Ss(t);
  return [sl(t), e, sl(e)];
}
function sl(t) {
  return t.replace(/start|end/g, (e) => Pk[e]);
}
function Dk(t, e, n) {
  const r = ["left", "right"], o = ["right", "left"], s = ["top", "bottom"], i = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? o : r : e ? r : o;
    case "left":
    case "right":
      return e ? s : i;
    default:
      return [];
  }
}
function Mk(t, e, n, r) {
  const o = wr(t);
  let s = Dk(Gt(t), n === "start", r);
  return o && (s = s.map((i) => i + "-" + o), e && (s = s.concat(s.map(sl)))), s;
}
function Ss(t) {
  return t.replace(/left|right|bottom|top/g, (e) => _k[e]);
}
function Nk(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Bv(t) {
  return typeof t != "number" ? Nk(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function As(t) {
  const {
    x: e,
    y: n,
    width: r,
    height: o
  } = t;
  return {
    width: r,
    height: o,
    top: n,
    left: e,
    right: e + r,
    bottom: n + o,
    x: e,
    y: n
  };
}
function Wf(t, e, n) {
  let {
    reference: r,
    floating: o
  } = t;
  const s = an(e), i = tu(e), a = eu(i), l = Gt(e), c = s === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, p = r[a] / 2 - o[a] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (wr(e)) {
    case "start":
      h[i] -= p * (n && c ? -1 : 1);
      break;
    case "end":
      h[i] += p * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const Ok = async (t, e, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: s = [],
    platform: i
  } = n, a = s.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(e));
  let c = await i.getElementRects({
    reference: t,
    floating: e,
    strategy: o
  }), {
    x: u,
    y: d
  } = Wf(c, r, l), p = r, h = {}, v = 0;
  for (let m = 0; m < a.length; m++) {
    const {
      name: y,
      fn: b
    } = a[m], {
      x: w,
      y: x,
      data: E,
      reset: C
    } = await b({
      x: u,
      y: d,
      initialPlacement: r,
      placement: p,
      strategy: o,
      middlewareData: h,
      rects: c,
      platform: i,
      elements: {
        reference: t,
        floating: e
      }
    });
    u = w ?? u, d = x ?? d, h = {
      ...h,
      [y]: {
        ...h[y],
        ...E
      }
    }, C && v <= 50 && (v++, typeof C == "object" && (C.placement && (p = C.placement), C.rects && (c = C.rects === !0 ? await i.getElementRects({
      reference: t,
      floating: e,
      strategy: o
    }) : C.rects), {
      x: u,
      y: d
    } = Wf(c, p, l)), m = -1);
  }
  return {
    x: u,
    y: d,
    placement: p,
    strategy: o,
    middlewareData: h
  };
};
async function ao(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: r,
    y: o,
    platform: s,
    rects: i,
    elements: a,
    strategy: l
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: p = !1,
    padding: h = 0
  } = zt(e, t), v = Bv(h), y = a[p ? d === "floating" ? "reference" : "floating" : d], b = As(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(y))) == null || n ? y : y.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), w = d === "floating" ? {
    x: r,
    y: o,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, x = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a.floating)), E = await (s.isElement == null ? void 0 : s.isElement(x)) ? await (s.getScale == null ? void 0 : s.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, C = As(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: w,
    offsetParent: x,
    strategy: l
  }) : w);
  return {
    top: (b.top - C.top + v.top) / E.y,
    bottom: (C.bottom - b.bottom + v.bottom) / E.y,
    left: (b.left - C.left + v.left) / E.x,
    right: (C.right - b.right + v.right) / E.x
  };
}
const Vk = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: s,
      platform: i,
      elements: a,
      middlewareData: l
    } = e, {
      element: c,
      padding: u = 0
    } = zt(t, e) || {};
    if (c == null)
      return {};
    const d = Bv(u), p = {
      x: n,
      y: r
    }, h = tu(o), v = eu(h), m = await i.getDimensions(c), y = h === "y", b = y ? "top" : "left", w = y ? "bottom" : "right", x = y ? "clientHeight" : "clientWidth", E = s.reference[v] + s.reference[h] - p[h] - s.floating[v], C = p[h] - s.reference[h], A = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c));
    let S = A ? A[x] : 0;
    (!S || !await (i.isElement == null ? void 0 : i.isElement(A))) && (S = a.floating[x] || s.floating[v]);
    const R = E / 2 - C / 2, P = S / 2 - m[v] / 2 - 1, k = sn(d[b], P), I = sn(d[w], P), _ = k, D = S - m[v] - I, N = S / 2 - m[v] / 2 + R, W = ol(_, N, D), L = !l.arrow && wr(o) != null && N !== W && s.reference[v] / 2 - (N < _ ? k : I) - m[v] / 2 < 0, B = L ? N < _ ? N - _ : N - D : 0;
    return {
      [h]: p[h] + B,
      data: {
        [h]: W,
        centerOffset: N - W - B,
        ...L && {
          alignmentOffset: B
        }
      },
      reset: L
    };
  }
}), Fk = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, r;
      const {
        placement: o,
        middlewareData: s,
        rects: i,
        initialPlacement: a,
        platform: l,
        elements: c
      } = e, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: p,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: m = !0,
        ...y
      } = zt(t, e);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const b = Gt(o), w = an(a), x = Gt(a) === a, E = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), C = p || (x || !m ? [Ss(a)] : Ik(a)), A = v !== "none";
      !p && A && C.push(...Mk(a, m, v, E));
      const S = [a, ...C], R = await ao(e, y), P = [];
      let k = ((r = s.flip) == null ? void 0 : r.overflows) || [];
      if (u && P.push(R[b]), d) {
        const N = kk(o, i, E);
        P.push(R[N[0]], R[N[1]]);
      }
      if (k = [...k, {
        placement: o,
        overflows: P
      }], !P.every((N) => N <= 0)) {
        var I, _;
        const N = (((I = s.flip) == null ? void 0 : I.index) || 0) + 1, W = S[N];
        if (W)
          return {
            data: {
              index: N,
              overflows: k
            },
            reset: {
              placement: W
            }
          };
        let L = (_ = k.filter((B) => B.overflows[0] <= 0).sort((B, V) => B.overflows[1] - V.overflows[1])[0]) == null ? void 0 : _.placement;
        if (!L)
          switch (h) {
            case "bestFit": {
              var D;
              const B = (D = k.filter((V) => {
                if (A) {
                  const $ = an(V.placement);
                  return $ === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  $ === "y";
                }
                return !0;
              }).map((V) => [V.placement, V.overflows.filter(($) => $ > 0).reduce(($, T) => $ + T, 0)]).sort((V, $) => V[1] - $[1])[0]) == null ? void 0 : D[0];
              B && (L = B);
              break;
            }
            case "initialPlacement":
              L = a;
              break;
          }
        if (o !== L)
          return {
            reset: {
              placement: L
            }
          };
      }
      return {};
    }
  };
};
function jf(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function Uf(t) {
  return Rk.some((e) => t[e] >= 0);
}
const Lk = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n
      } = e, {
        strategy: r = "referenceHidden",
        ...o
      } = zt(t, e);
      switch (r) {
        case "referenceHidden": {
          const s = await ao(e, {
            ...o,
            elementContext: "reference"
          }), i = jf(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: Uf(i)
            }
          };
        }
        case "escaped": {
          const s = await ao(e, {
            ...o,
            altBoundary: !0
          }), i = jf(s, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: Uf(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Bk(t, e) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = t, s = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), i = Gt(n), a = wr(n), l = an(n) === "y", c = ["left", "top"].includes(i) ? -1 : 1, u = s && l ? -1 : 1, d = zt(e, t);
  let {
    mainAxis: p,
    crossAxis: h,
    alignmentAxis: v
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return a && typeof v == "number" && (h = a === "end" ? v * -1 : v), l ? {
    x: h * u,
    y: p * c
  } : {
    x: p * c,
    y: h * u
  };
}
const $k = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, r;
      const {
        x: o,
        y: s,
        placement: i,
        middlewareData: a
      } = e, l = await Bk(e, t);
      return i === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: s + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, Wk = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r,
        placement: o
      } = e, {
        mainAxis: s = !0,
        crossAxis: i = !1,
        limiter: a = {
          fn: (y) => {
            let {
              x: b,
              y: w
            } = y;
            return {
              x: b,
              y: w
            };
          }
        },
        ...l
      } = zt(t, e), c = {
        x: n,
        y: r
      }, u = await ao(e, l), d = an(Gt(o)), p = Qc(d);
      let h = c[p], v = c[d];
      if (s) {
        const y = p === "y" ? "top" : "left", b = p === "y" ? "bottom" : "right", w = h + u[y], x = h - u[b];
        h = ol(w, h, x);
      }
      if (i) {
        const y = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", w = v + u[y], x = v - u[b];
        v = ol(w, v, x);
      }
      const m = a.fn({
        ...e,
        [p]: h,
        [d]: v
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r,
          enabled: {
            [p]: s,
            [d]: i
          }
        }
      };
    }
  };
}, jk = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: s,
        middlewareData: i
      } = e, {
        offset: a = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = zt(t, e), u = {
        x: n,
        y: r
      }, d = an(o), p = Qc(d);
      let h = u[p], v = u[d];
      const m = zt(a, e), y = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (l) {
        const x = p === "y" ? "height" : "width", E = s.reference[p] - s.floating[x] + y.mainAxis, C = s.reference[p] + s.reference[x] - y.mainAxis;
        h < E ? h = E : h > C && (h = C);
      }
      if (c) {
        var b, w;
        const x = p === "y" ? "width" : "height", E = ["top", "left"].includes(Gt(o)), C = s.reference[d] - s.floating[x] + (E && ((b = i.offset) == null ? void 0 : b[d]) || 0) + (E ? 0 : y.crossAxis), A = s.reference[d] + s.reference[x] + (E ? 0 : ((w = i.offset) == null ? void 0 : w[d]) || 0) - (E ? y.crossAxis : 0);
        v < C ? v = C : v > A && (v = A);
      }
      return {
        [p]: h,
        [d]: v
      };
    }
  };
}, Uk = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var n, r;
      const {
        placement: o,
        rects: s,
        platform: i,
        elements: a
      } = e, {
        apply: l = () => {
        },
        ...c
      } = zt(t, e), u = await ao(e, c), d = Gt(o), p = wr(o), h = an(o) === "y", {
        width: v,
        height: m
      } = s.floating;
      let y, b;
      d === "top" || d === "bottom" ? (y = d, b = p === (await (i.isRTL == null ? void 0 : i.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (b = d, y = p === "end" ? "top" : "bottom");
      const w = m - u.top - u.bottom, x = v - u.left - u.right, E = sn(m - u[y], w), C = sn(v - u[b], x), A = !e.middlewareData.shift;
      let S = E, R = C;
      if ((n = e.middlewareData.shift) != null && n.enabled.x && (R = x), (r = e.middlewareData.shift) != null && r.enabled.y && (S = w), A && !p) {
        const k = He(u.left, 0), I = He(u.right, 0), _ = He(u.top, 0), D = He(u.bottom, 0);
        h ? R = v - 2 * (k !== 0 || I !== 0 ? k + I : He(u.left, u.right)) : S = m - 2 * (_ !== 0 || D !== 0 ? _ + D : He(u.top, u.bottom));
      }
      await l({
        ...e,
        availableWidth: R,
        availableHeight: S
      });
      const P = await i.getDimensions(a.floating);
      return v !== P.width || m !== P.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function gi() {
  return typeof window < "u";
}
function xr(t) {
  return $v(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function ze(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Tt(t) {
  var e;
  return (e = ($v(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function $v(t) {
  return gi() ? t instanceof Node || t instanceof ze(t).Node : !1;
}
function ut(t) {
  return gi() ? t instanceof Element || t instanceof ze(t).Element : !1;
}
function Et(t) {
  return gi() ? t instanceof HTMLElement || t instanceof ze(t).HTMLElement : !1;
}
function Hf(t) {
  return !gi() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof ze(t).ShadowRoot;
}
function _o(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: r,
    display: o
  } = dt(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !["inline", "contents"].includes(o);
}
function Hk(t) {
  return ["table", "td", "th"].includes(xr(t));
}
function vi(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function nu(t) {
  const e = ru(), n = ut(t) ? dt(t) : t;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function zk(t) {
  let e = ln(t);
  for (; Et(e) && !cr(e); ) {
    if (nu(e))
      return e;
    if (vi(e))
      return null;
    e = ln(e);
  }
  return null;
}
function ru() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function cr(t) {
  return ["html", "body", "#document"].includes(xr(t));
}
function dt(t) {
  return ze(t).getComputedStyle(t);
}
function yi(t) {
  return ut(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function ln(t) {
  if (xr(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Hf(t) && t.host || // Fallback.
    Tt(t)
  );
  return Hf(e) ? e.host : e;
}
function Wv(t) {
  const e = ln(t);
  return cr(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Et(e) && _o(e) ? e : Wv(e);
}
function lo(t, e, n) {
  var r;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const o = Wv(t), s = o === ((r = t.ownerDocument) == null ? void 0 : r.body), i = ze(o);
  if (s) {
    const a = il(i);
    return e.concat(i, i.visualViewport || [], _o(o) ? o : [], a && n ? lo(a) : []);
  }
  return e.concat(o, lo(o, [], n));
}
function il(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function jv(t) {
  const e = dt(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const o = Et(t), s = o ? t.offsetWidth : n, i = o ? t.offsetHeight : r, a = Es(n) !== s || Es(r) !== i;
  return a && (n = s, r = i), {
    width: n,
    height: r,
    $: a
  };
}
function ou(t) {
  return ut(t) ? t : t.contextElement;
}
function Zn(t) {
  const e = ou(t);
  if (!Et(e))
    return wt(1);
  const n = e.getBoundingClientRect(), {
    width: r,
    height: o,
    $: s
  } = jv(e);
  let i = (s ? Es(n.width) : n.width) / r, a = (s ? Es(n.height) : n.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: i,
    y: a
  };
}
const Gk = /* @__PURE__ */ wt(0);
function Uv(t) {
  const e = ze(t);
  return !ru() || !e.visualViewport ? Gk : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Kk(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== ze(t) ? !1 : e;
}
function In(t, e, n, r) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const o = t.getBoundingClientRect(), s = ou(t);
  let i = wt(1);
  e && (r ? ut(r) && (i = Zn(r)) : i = Zn(t));
  const a = Kk(s, n, r) ? Uv(s) : wt(0);
  let l = (o.left + a.x) / i.x, c = (o.top + a.y) / i.y, u = o.width / i.x, d = o.height / i.y;
  if (s) {
    const p = ze(s), h = r && ut(r) ? ze(r) : r;
    let v = p, m = il(v);
    for (; m && r && h !== v; ) {
      const y = Zn(m), b = m.getBoundingClientRect(), w = dt(m), x = b.left + (m.clientLeft + parseFloat(w.paddingLeft)) * y.x, E = b.top + (m.clientTop + parseFloat(w.paddingTop)) * y.y;
      l *= y.x, c *= y.y, u *= y.x, d *= y.y, l += x, c += E, v = ze(m), m = il(v);
    }
  }
  return As({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function su(t, e) {
  const n = yi(t).scrollLeft;
  return e ? e.left + n : In(Tt(t)).left + n;
}
function Hv(t, e, n) {
  n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), o = r.left + e.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    su(t, r)
  )), s = r.top + e.scrollTop;
  return {
    x: o,
    y: s
  };
}
function Yk(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: r,
    strategy: o
  } = t;
  const s = o === "fixed", i = Tt(r), a = e ? vi(e.floating) : !1;
  if (r === i || a && s)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = wt(1);
  const u = wt(0), d = Et(r);
  if ((d || !d && !s) && ((xr(r) !== "body" || _o(i)) && (l = yi(r)), Et(r))) {
    const h = In(r);
    c = Zn(r), u.x = h.x + r.clientLeft, u.y = h.y + r.clientTop;
  }
  const p = i && !d && !s ? Hv(i, l, !0) : wt(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x + p.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y + p.y
  };
}
function qk(t) {
  return Array.from(t.getClientRects());
}
function Xk(t) {
  const e = Tt(t), n = yi(t), r = t.ownerDocument.body, o = He(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), s = He(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let i = -n.scrollLeft + su(t);
  const a = -n.scrollTop;
  return dt(r).direction === "rtl" && (i += He(e.clientWidth, r.clientWidth) - o), {
    width: o,
    height: s,
    x: i,
    y: a
  };
}
function Zk(t, e) {
  const n = ze(t), r = Tt(t), o = n.visualViewport;
  let s = r.clientWidth, i = r.clientHeight, a = 0, l = 0;
  if (o) {
    s = o.width, i = o.height;
    const c = ru();
    (!c || c && e === "fixed") && (a = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: s,
    height: i,
    x: a,
    y: l
  };
}
function Jk(t, e) {
  const n = In(t, !0, e === "fixed"), r = n.top + t.clientTop, o = n.left + t.clientLeft, s = Et(t) ? Zn(t) : wt(1), i = t.clientWidth * s.x, a = t.clientHeight * s.y, l = o * s.x, c = r * s.y;
  return {
    width: i,
    height: a,
    x: l,
    y: c
  };
}
function zf(t, e, n) {
  let r;
  if (e === "viewport")
    r = Zk(t, n);
  else if (e === "document")
    r = Xk(Tt(t));
  else if (ut(e))
    r = Jk(e, n);
  else {
    const o = Uv(t);
    r = {
      x: e.x - o.x,
      y: e.y - o.y,
      width: e.width,
      height: e.height
    };
  }
  return As(r);
}
function zv(t, e) {
  const n = ln(t);
  return n === e || !ut(n) || cr(n) ? !1 : dt(n).position === "fixed" || zv(n, e);
}
function Qk(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let r = lo(t, [], !1).filter((a) => ut(a) && xr(a) !== "body"), o = null;
  const s = dt(t).position === "fixed";
  let i = s ? ln(t) : t;
  for (; ut(i) && !cr(i); ) {
    const a = dt(i), l = nu(i);
    !l && a.position === "fixed" && (o = null), (s ? !l && !o : !l && a.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || _o(i) && !l && zv(t, i)) ? r = r.filter((u) => u !== i) : o = a, i = ln(i);
  }
  return e.set(t, r), r;
}
function eI(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = t;
  const i = [...n === "clippingAncestors" ? vi(e) ? [] : Qk(e, this._c) : [].concat(n), r], a = i[0], l = i.reduce((c, u) => {
    const d = zf(e, u, o);
    return c.top = He(d.top, c.top), c.right = sn(d.right, c.right), c.bottom = sn(d.bottom, c.bottom), c.left = He(d.left, c.left), c;
  }, zf(e, a, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function tI(t) {
  const {
    width: e,
    height: n
  } = jv(t);
  return {
    width: e,
    height: n
  };
}
function nI(t, e, n) {
  const r = Et(e), o = Tt(e), s = n === "fixed", i = In(t, !0, s, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = wt(0);
  if (r || !r && !s)
    if ((xr(e) !== "body" || _o(o)) && (a = yi(e)), r) {
      const p = In(e, !0, s, e);
      l.x = p.x + e.clientLeft, l.y = p.y + e.clientTop;
    } else o && (l.x = su(o));
  const c = o && !r && !s ? Hv(o, a) : wt(0), u = i.left + a.scrollLeft - l.x - c.x, d = i.top + a.scrollTop - l.y - c.y;
  return {
    x: u,
    y: d,
    width: i.width,
    height: i.height
  };
}
function pa(t) {
  return dt(t).position === "static";
}
function Gf(t, e) {
  if (!Et(t) || dt(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return Tt(t) === n && (n = n.ownerDocument.body), n;
}
function Gv(t, e) {
  const n = ze(t);
  if (vi(t))
    return n;
  if (!Et(t)) {
    let o = ln(t);
    for (; o && !cr(o); ) {
      if (ut(o) && !pa(o))
        return o;
      o = ln(o);
    }
    return n;
  }
  let r = Gf(t, e);
  for (; r && Hk(r) && pa(r); )
    r = Gf(r, e);
  return r && cr(r) && pa(r) && !nu(r) ? n : r || zk(t) || n;
}
const rI = async function(t) {
  const e = this.getOffsetParent || Gv, n = this.getDimensions, r = await n(t.floating);
  return {
    reference: nI(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function oI(t) {
  return dt(t).direction === "rtl";
}
const sI = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Yk,
  getDocumentElement: Tt,
  getClippingRect: eI,
  getOffsetParent: Gv,
  getElementRects: rI,
  getClientRects: qk,
  getDimensions: tI,
  getScale: Zn,
  isElement: ut,
  isRTL: oI
};
function iI(t, e) {
  let n = null, r;
  const o = Tt(t);
  function s() {
    var a;
    clearTimeout(r), (a = n) == null || a.disconnect(), n = null;
  }
  function i(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), s();
    const {
      left: c,
      top: u,
      width: d,
      height: p
    } = t.getBoundingClientRect();
    if (a || e(), !d || !p)
      return;
    const h = Go(u), v = Go(o.clientWidth - (c + d)), m = Go(o.clientHeight - (u + p)), y = Go(c), w = {
      rootMargin: -h + "px " + -v + "px " + -m + "px " + -y + "px",
      threshold: He(0, sn(1, l)) || 1
    };
    let x = !0;
    function E(C) {
      const A = C[0].intersectionRatio;
      if (A !== l) {
        if (!x)
          return i();
        A ? i(!1, A) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      x = !1;
    }
    try {
      n = new IntersectionObserver(E, {
        ...w,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(E, w);
    }
    n.observe(t);
  }
  return i(!0), s;
}
function aI(t, e, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: s = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = ou(t), u = o || s ? [...c ? lo(c) : [], ...lo(e)] : [];
  u.forEach((b) => {
    o && b.addEventListener("scroll", n, {
      passive: !0
    }), s && b.addEventListener("resize", n);
  });
  const d = c && a ? iI(c, n) : null;
  let p = -1, h = null;
  i && (h = new ResizeObserver((b) => {
    let [w] = b;
    w && w.target === c && h && (h.unobserve(e), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var x;
      (x = h) == null || x.observe(e);
    })), n();
  }), c && !l && h.observe(c), h.observe(e));
  let v, m = l ? In(t) : null;
  l && y();
  function y() {
    const b = In(t);
    m && (b.x !== m.x || b.y !== m.y || b.width !== m.width || b.height !== m.height) && n(), m = b, v = requestAnimationFrame(y);
  }
  return n(), () => {
    var b;
    u.forEach((w) => {
      o && w.removeEventListener("scroll", n), s && w.removeEventListener("resize", n);
    }), d == null || d(), (b = h) == null || b.disconnect(), h = null, l && cancelAnimationFrame(v);
  };
}
const lI = $k, cI = Wk, uI = Fk, dI = Uk, fI = Lk, Kf = Vk, pI = jk, hI = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: sI,
    ...n
  }, s = {
    ...o.platform,
    _c: r
  };
  return Ok(t, e, {
    ...o,
    platform: s
  });
};
var ss = typeof document < "u" ? gl : ie;
function Ts(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, r, o;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== e.length) return !1;
      for (r = n; r-- !== 0; )
        if (!Ts(t[r], e[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(t), n = o.length, n !== Object.keys(e).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(e, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const s = o[r];
      if (!(s === "_owner" && t.$$typeof) && !Ts(t[s], e[s]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function Kv(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Yf(t, e) {
  const n = Kv(t);
  return Math.round(e * n) / n;
}
function ha(t) {
  const e = f.useRef(t);
  return ss(() => {
    e.current = t;
  }), e;
}
function mI(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: s,
      floating: i
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = t, [u, d] = f.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [p, h] = f.useState(r);
  Ts(p, r) || h(r);
  const [v, m] = f.useState(null), [y, b] = f.useState(null), w = f.useCallback((V) => {
    V !== A.current && (A.current = V, m(V));
  }, []), x = f.useCallback((V) => {
    V !== S.current && (S.current = V, b(V));
  }, []), E = s || v, C = i || y, A = f.useRef(null), S = f.useRef(null), R = f.useRef(u), P = l != null, k = ha(l), I = ha(o), _ = ha(c), D = f.useCallback(() => {
    if (!A.current || !S.current)
      return;
    const V = {
      placement: e,
      strategy: n,
      middleware: p
    };
    I.current && (V.platform = I.current), hI(A.current, S.current, V).then(($) => {
      const T = {
        ...$,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: _.current !== !1
      };
      N.current && !Ts(R.current, T) && (R.current = T, Ps.flushSync(() => {
        d(T);
      }));
    });
  }, [p, e, n, I, _]);
  ss(() => {
    c === !1 && R.current.isPositioned && (R.current.isPositioned = !1, d((V) => ({
      ...V,
      isPositioned: !1
    })));
  }, [c]);
  const N = f.useRef(!1);
  ss(() => (N.current = !0, () => {
    N.current = !1;
  }), []), ss(() => {
    if (E && (A.current = E), C && (S.current = C), E && C) {
      if (k.current)
        return k.current(E, C, D);
      D();
    }
  }, [E, C, D, k, P]);
  const W = f.useMemo(() => ({
    reference: A,
    floating: S,
    setReference: w,
    setFloating: x
  }), [w, x]), L = f.useMemo(() => ({
    reference: E,
    floating: C
  }), [E, C]), B = f.useMemo(() => {
    const V = {
      position: n,
      left: 0,
      top: 0
    };
    if (!L.floating)
      return V;
    const $ = Yf(L.floating, u.x), T = Yf(L.floating, u.y);
    return a ? {
      ...V,
      transform: "translate(" + $ + "px, " + T + "px)",
      ...Kv(L.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: $,
      top: T
    };
  }, [n, a, L.floating, u.x, u.y]);
  return f.useMemo(() => ({
    ...u,
    update: D,
    refs: W,
    elements: L,
    floatingStyles: B
  }), [u, D, W, L, B]);
}
const gI = (t) => {
  function e(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof t == "function" ? t(n) : t;
      return r && e(r) ? r.current != null ? Kf({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? Kf({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, vI = (t, e) => ({
  ...lI(t),
  options: [t, e]
}), yI = (t, e) => ({
  ...cI(t),
  options: [t, e]
}), bI = (t, e) => ({
  ...pI(t),
  options: [t, e]
}), wI = (t, e) => ({
  ...uI(t),
  options: [t, e]
}), xI = (t, e) => ({
  ...dI(t),
  options: [t, e]
}), CI = (t, e) => ({
  ...fI(t),
  options: [t, e]
}), EI = (t, e) => ({
  ...gI(t),
  options: [t, e]
});
// @__NO_SIDE_EFFECTS__
function SI(t) {
  const e = /* @__PURE__ */ AI(t), n = f.forwardRef((r, o) => {
    const { children: s, ...i } = r, a = f.Children.toArray(s), l = a.find(RI);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ g(e, { ...i, ref: o, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ g(e, { ...i, ref: o, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function AI(t) {
  const e = f.forwardRef((n, r) => {
    const { children: o, ...s } = n, i = f.isValidElement(o) ? PI(o) : void 0, a = te(i, r);
    if (f.isValidElement(o)) {
      const l = _I(s, o.props);
      return o.type !== f.Fragment && (l.ref = a), f.cloneElement(o, l);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var TI = Symbol("radix.slottable");
function RI(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === TI;
}
function _I(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const l = s(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function PI(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var kI = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], II = kI.reduce((t, e) => {
  const n = /* @__PURE__ */ SI(`Primitive.${e}`), r = f.forwardRef((o, s) => {
    const { asChild: i, ...a } = o, l = i ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {}), DI = "Arrow", Yv = f.forwardRef((t, e) => {
  const { children: n, width: r = 10, height: o = 5, ...s } = t;
  return /* @__PURE__ */ g(
    II.svg,
    {
      ...s,
      ref: e,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: t.asChild ? n : /* @__PURE__ */ g("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Yv.displayName = DI;
var MI = Yv;
// @__NO_SIDE_EFFECTS__
function NI(t) {
  const e = /* @__PURE__ */ OI(t), n = f.forwardRef((r, o) => {
    const { children: s, ...i } = r, a = f.Children.toArray(s), l = a.find(FI);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ g(e, { ...i, ref: o, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ g(e, { ...i, ref: o, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function OI(t) {
  const e = f.forwardRef((n, r) => {
    const { children: o, ...s } = n, i = f.isValidElement(o) ? BI(o) : void 0, a = te(i, r);
    if (f.isValidElement(o)) {
      const l = LI(s, o.props);
      return o.type !== f.Fragment && (l.ref = a), f.cloneElement(o, l);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var VI = Symbol("radix.slottable");
function FI(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === VI;
}
function LI(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const l = s(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function BI(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var $I = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], qv = $I.reduce((t, e) => {
  const n = /* @__PURE__ */ NI(`Primitive.${e}`), r = f.forwardRef((o, s) => {
    const { asChild: i, ...a } = o, l = i ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {}), iu = "Popper", [Xv, bi] = je(iu), [WI, Zv] = Xv(iu), Jv = (t) => {
  const { __scopePopper: e, children: n } = t, [r, o] = f.useState(null);
  return /* @__PURE__ */ g(WI, { scope: e, anchor: r, onAnchorChange: o, children: n });
};
Jv.displayName = iu;
var Qv = "PopperAnchor", ey = f.forwardRef(
  (t, e) => {
    const { __scopePopper: n, virtualRef: r, ...o } = t, s = Zv(Qv, n), i = f.useRef(null), a = te(e, i);
    return f.useEffect(() => {
      s.onAnchorChange((r == null ? void 0 : r.current) || i.current);
    }), r ? null : /* @__PURE__ */ g(qv.div, { ...o, ref: a });
  }
);
ey.displayName = Qv;
var au = "PopperContent", [jI, UI] = Xv(au), ty = f.forwardRef(
  (t, e) => {
    var F, z, q, Y, re, j;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: s = "center",
      alignOffset: i = 0,
      arrowPadding: a = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: p = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: v,
      ...m
    } = t, y = Zv(au, n), [b, w] = f.useState(null), x = te(e, (K) => w(K)), [E, C] = f.useState(null), A = Xc(E), S = (A == null ? void 0 : A.width) ?? 0, R = (A == null ? void 0 : A.height) ?? 0, P = r + (s !== "center" ? "-" + s : ""), k = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, I = Array.isArray(c) ? c : [c], _ = I.length > 0, D = {
      padding: k,
      boundary: I.filter(zI),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: _
    }, { refs: N, floatingStyles: W, placement: L, isPositioned: B, middlewareData: V } = mI({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: P,
      whileElementsMounted: (...K) => aI(...K, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: y.anchor
      },
      middleware: [
        vI({ mainAxis: o + R, alignmentAxis: i }),
        l && yI({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? bI() : void 0,
          ...D
        }),
        l && wI({ ...D }),
        xI({
          ...D,
          apply: ({ elements: K, rects: le, availableWidth: De, availableHeight: ot }) => {
            const { width: gn, height: vb } = le.reference, Io = K.floating.style;
            Io.setProperty("--radix-popper-available-width", `${De}px`), Io.setProperty("--radix-popper-available-height", `${ot}px`), Io.setProperty("--radix-popper-anchor-width", `${gn}px`), Io.setProperty("--radix-popper-anchor-height", `${vb}px`);
          }
        }),
        E && EI({ element: E, padding: a }),
        GI({ arrowWidth: S, arrowHeight: R }),
        p && CI({ strategy: "referenceHidden", ...D })
      ]
    }), [$, T] = oy(L), M = Ne(v);
    ke(() => {
      B && (M == null || M());
    }, [B, M]);
    const H = (F = V.arrow) == null ? void 0 : F.x, Z = (z = V.arrow) == null ? void 0 : z.y, U = ((q = V.arrow) == null ? void 0 : q.centerOffset) !== 0, [X, O] = f.useState();
    return ke(() => {
      b && O(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ g(
      "div",
      {
        ref: N.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...W,
          transform: B ? W.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: X,
          "--radix-popper-transform-origin": [
            (Y = V.transformOrigin) == null ? void 0 : Y.x,
            (re = V.transformOrigin) == null ? void 0 : re.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((j = V.hide) == null ? void 0 : j.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: t.dir,
        children: /* @__PURE__ */ g(
          jI,
          {
            scope: n,
            placedSide: $,
            onArrowChange: C,
            arrowX: H,
            arrowY: Z,
            shouldHideArrow: U,
            children: /* @__PURE__ */ g(
              qv.div,
              {
                "data-side": $,
                "data-align": T,
                ...m,
                ref: x,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: B ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
ty.displayName = au;
var ny = "PopperArrow", HI = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, ry = f.forwardRef(function(e, n) {
  const { __scopePopper: r, ...o } = e, s = UI(ny, r), i = HI[s.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ g(
      "span",
      {
        ref: s.onArrowChange,
        style: {
          position: "absolute",
          left: s.arrowX,
          top: s.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[s.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[s.placedSide],
          visibility: s.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ g(
          MI,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
ry.displayName = ny;
function zI(t) {
  return t !== null;
}
var GI = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var y, b, w;
    const { placement: n, rects: r, middlewareData: o } = e, i = ((y = o.arrow) == null ? void 0 : y.centerOffset) !== 0, a = i ? 0 : t.arrowWidth, l = i ? 0 : t.arrowHeight, [c, u] = oy(n), d = { start: "0%", center: "50%", end: "100%" }[u], p = (((b = o.arrow) == null ? void 0 : b.x) ?? 0) + a / 2, h = (((w = o.arrow) == null ? void 0 : w.y) ?? 0) + l / 2;
    let v = "", m = "";
    return c === "bottom" ? (v = i ? d : `${p}px`, m = `${-l}px`) : c === "top" ? (v = i ? d : `${p}px`, m = `${r.floating.height + l}px`) : c === "right" ? (v = `${-l}px`, m = i ? d : `${h}px`) : c === "left" && (v = `${r.floating.width + l}px`, m = i ? d : `${h}px`), { data: { x: v, y: m } };
  }
});
function oy(t) {
  const [e, n = "center"] = t.split("-");
  return [e, n];
}
var sy = Jv, iy = ey, ay = ty, ly = ry;
// @__NO_SIDE_EFFECTS__
function cy(t) {
  const e = /* @__PURE__ */ KI(t), n = f.forwardRef((r, o) => {
    const { children: s, ...i } = r, a = f.Children.toArray(s), l = a.find(qI);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ g(e, { ...i, ref: o, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ g(e, { ...i, ref: o, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function KI(t) {
  const e = f.forwardRef((n, r) => {
    const { children: o, ...s } = n, i = f.isValidElement(o) ? ZI(o) : void 0, a = te(i, r);
    if (f.isValidElement(o)) {
      const l = XI(s, o.props);
      return o.type !== f.Fragment && (l.ref = a), f.cloneElement(o, l);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var YI = Symbol("radix.slottable");
function qI(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === YI;
}
function XI(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const l = s(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function ZI(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var JI = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Ke = JI.reduce((t, e) => {
  const n = /* @__PURE__ */ cy(`Primitive.${e}`), r = f.forwardRef((o, s) => {
    const { asChild: i, ...a } = o, l = i ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {});
function QI(t) {
  const e = f.useRef({ value: t, previous: t });
  return f.useMemo(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [t]);
}
// @__NO_SIDE_EFFECTS__
function eD(t) {
  const e = /* @__PURE__ */ tD(t), n = f.forwardRef((r, o) => {
    const { children: s, ...i } = r, a = f.Children.toArray(s), l = a.find(rD);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ g(e, { ...i, ref: o, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ g(e, { ...i, ref: o, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function tD(t) {
  const e = f.forwardRef((n, r) => {
    const { children: o, ...s } = n, i = f.isValidElement(o) ? sD(o) : void 0, a = te(i, r);
    if (f.isValidElement(o)) {
      const l = oD(s, o.props);
      return o.type !== f.Fragment && (l.ref = a), f.cloneElement(o, l);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var nD = Symbol("radix.slottable");
function rD(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === nD;
}
function oD(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const l = s(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function sD(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var iD = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], aD = iD.reduce((t, e) => {
  const n = /* @__PURE__ */ eD(`Primitive.${e}`), r = f.forwardRef((o, s) => {
    const { asChild: i, ...a } = o, l = i ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {}), uy = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), lD = "VisuallyHidden", dy = f.forwardRef(
  (t, e) => /* @__PURE__ */ g(
    aD.span,
    {
      ...t,
      ref: e,
      style: { ...uy, ...t.style }
    }
  )
);
dy.displayName = lD;
var cD = dy, uD = [" ", "Enter", "ArrowUp", "ArrowDown"], dD = [" ", "Enter"], Dn = "Select", [wi, xi, fD] = ks(Dn), [Cr, nO] = je(Dn, [
  fD,
  bi
]), Ci = bi(), [pD, hn] = Cr(Dn), [hD, mD] = Cr(Dn), fy = (t) => {
  const {
    __scopeSelect: e,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: s,
    value: i,
    defaultValue: a,
    onValueChange: l,
    dir: c,
    name: u,
    autoComplete: d,
    disabled: p,
    required: h,
    form: v
  } = t, m = Ci(e), [y, b] = f.useState(null), [w, x] = f.useState(null), [E, C] = f.useState(!1), A = Ak(c), [S, R] = tt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: s,
    caller: Dn
  }), [P, k] = tt({
    prop: i,
    defaultProp: a,
    onChange: l,
    caller: Dn
  }), I = f.useRef(null), _ = y ? v || !!y.closest("form") : !0, [D, N] = f.useState(/* @__PURE__ */ new Set()), W = Array.from(D).map((L) => L.props.value).join(";");
  return /* @__PURE__ */ g(sy, { ...m, children: /* @__PURE__ */ G(
    pD,
    {
      required: h,
      scope: e,
      trigger: y,
      onTriggerChange: b,
      valueNode: w,
      onValueNodeChange: x,
      valueNodeHasChildren: E,
      onValueNodeHasChildrenChange: C,
      contentId: Je(),
      value: P,
      onValueChange: k,
      open: S,
      onOpenChange: R,
      dir: A,
      triggerPointerDownPosRef: I,
      disabled: p,
      children: [
        /* @__PURE__ */ g(wi.Provider, { scope: e, children: /* @__PURE__ */ g(
          hD,
          {
            scope: t.__scopeSelect,
            onNativeOptionAdd: f.useCallback((L) => {
              N((B) => new Set(B).add(L));
            }, []),
            onNativeOptionRemove: f.useCallback((L) => {
              N((B) => {
                const V = new Set(B);
                return V.delete(L), V;
              });
            }, []),
            children: n
          }
        ) }),
        _ ? /* @__PURE__ */ G(
          Iy,
          {
            "aria-hidden": !0,
            required: h,
            tabIndex: -1,
            name: u,
            autoComplete: d,
            value: P,
            onChange: (L) => k(L.target.value),
            disabled: p,
            form: v,
            children: [
              P === void 0 ? /* @__PURE__ */ g("option", { value: "" }) : null,
              Array.from(D)
            ]
          },
          W
        ) : null
      ]
    }
  ) });
};
fy.displayName = Dn;
var py = "SelectTrigger", hy = f.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = t, s = Ci(n), i = hn(py, n), a = i.disabled || r, l = te(e, i.onTriggerChange), c = xi(n), u = f.useRef("touch"), [d, p, h] = My((m) => {
      const y = c().filter((x) => !x.disabled), b = y.find((x) => x.value === i.value), w = Ny(y, m, b);
      w !== void 0 && i.onValueChange(w.value);
    }), v = (m) => {
      a || (i.onOpenChange(!0), h()), m && (i.triggerPointerDownPosRef.current = {
        x: Math.round(m.pageX),
        y: Math.round(m.pageY)
      });
    };
    return /* @__PURE__ */ g(iy, { asChild: !0, ...s, children: /* @__PURE__ */ g(
      Ke.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.contentId,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: a,
        "data-disabled": a ? "" : void 0,
        "data-placeholder": Dy(i.value) ? "" : void 0,
        ...o,
        ref: l,
        onClick: J(o.onClick, (m) => {
          m.currentTarget.focus(), u.current !== "mouse" && v(m);
        }),
        onPointerDown: J(o.onPointerDown, (m) => {
          u.current = m.pointerType;
          const y = m.target;
          y.hasPointerCapture(m.pointerId) && y.releasePointerCapture(m.pointerId), m.button === 0 && m.ctrlKey === !1 && m.pointerType === "mouse" && (v(m), m.preventDefault());
        }),
        onKeyDown: J(o.onKeyDown, (m) => {
          const y = d.current !== "";
          !(m.ctrlKey || m.altKey || m.metaKey) && m.key.length === 1 && p(m.key), !(y && m.key === " ") && uD.includes(m.key) && (v(), m.preventDefault());
        })
      }
    ) });
  }
);
hy.displayName = py;
var my = "SelectValue", gy = f.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, className: r, style: o, children: s, placeholder: i = "", ...a } = t, l = hn(my, n), { onValueNodeHasChildrenChange: c } = l, u = s !== void 0, d = te(e, l.onValueNodeChange);
    return ke(() => {
      c(u);
    }, [c, u]), /* @__PURE__ */ g(
      Ke.span,
      {
        ...a,
        ref: d,
        style: { pointerEvents: "none" },
        children: Dy(l.value) ? /* @__PURE__ */ g(Pe, { children: i }) : s
      }
    );
  }
);
gy.displayName = my;
var gD = "SelectIcon", vy = f.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, children: r, ...o } = t;
    return /* @__PURE__ */ g(Ke.span, { "aria-hidden": !0, ...o, ref: e, children: r || "▼" });
  }
);
vy.displayName = gD;
var vD = "SelectPortal", yy = (t) => /* @__PURE__ */ g(oi, { asChild: !0, ...t });
yy.displayName = vD;
var Mn = "SelectContent", by = f.forwardRef(
  (t, e) => {
    const n = hn(Mn, t.__scopeSelect), [r, o] = f.useState();
    if (ke(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const s = r;
      return s ? Ps.createPortal(
        /* @__PURE__ */ g(wy, { scope: t.__scopeSelect, children: /* @__PURE__ */ g(wi.Slot, { scope: t.__scopeSelect, children: /* @__PURE__ */ g("div", { children: t.children }) }) }),
        s
      ) : null;
    }
    return /* @__PURE__ */ g(xy, { ...t, ref: e });
  }
);
by.displayName = Mn;
var it = 10, [wy, mn] = Cr(Mn), yD = "SelectContentImpl", bD = /* @__PURE__ */ cy("SelectContent.RemoveScroll"), xy = f.forwardRef(
  (t, e) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: s,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: a,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: p,
      collisionPadding: h,
      sticky: v,
      hideWhenDetached: m,
      avoidCollisions: y,
      //
      ...b
    } = t, w = hn(Mn, n), [x, E] = f.useState(null), [C, A] = f.useState(null), S = te(e, (F) => E(F)), [R, P] = f.useState(null), [k, I] = f.useState(
      null
    ), _ = xi(n), [D, N] = f.useState(!1), W = f.useRef(!1);
    f.useEffect(() => {
      if (x) return Fg(x);
    }, [x]), Tk();
    const L = f.useCallback(
      (F) => {
        const [z, ...q] = _().map((j) => j.ref.current), [Y] = q.slice(-1), re = document.activeElement;
        for (const j of F)
          if (j === re || (j == null || j.scrollIntoView({ block: "nearest" }), j === z && C && (C.scrollTop = 0), j === Y && C && (C.scrollTop = C.scrollHeight), j == null || j.focus(), document.activeElement !== re)) return;
      },
      [_, C]
    ), B = f.useCallback(
      () => L([R, x]),
      [L, R, x]
    );
    f.useEffect(() => {
      D && B();
    }, [D, B]);
    const { onOpenChange: V, triggerPointerDownPosRef: $ } = w;
    f.useEffect(() => {
      if (x) {
        let F = { x: 0, y: 0 };
        const z = (Y) => {
          var re, j;
          F = {
            x: Math.abs(Math.round(Y.pageX) - (((re = $.current) == null ? void 0 : re.x) ?? 0)),
            y: Math.abs(Math.round(Y.pageY) - (((j = $.current) == null ? void 0 : j.y) ?? 0))
          };
        }, q = (Y) => {
          F.x <= 10 && F.y <= 10 ? Y.preventDefault() : x.contains(Y.target) || V(!1), document.removeEventListener("pointermove", z), $.current = null;
        };
        return $.current !== null && (document.addEventListener("pointermove", z), document.addEventListener("pointerup", q, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", z), document.removeEventListener("pointerup", q, { capture: !0 });
        };
      }
    }, [x, V, $]), f.useEffect(() => {
      const F = () => V(!1);
      return window.addEventListener("blur", F), window.addEventListener("resize", F), () => {
        window.removeEventListener("blur", F), window.removeEventListener("resize", F);
      };
    }, [V]);
    const [T, M] = My((F) => {
      const z = _().filter((re) => !re.disabled), q = z.find((re) => re.ref.current === document.activeElement), Y = Ny(z, F, q);
      Y && setTimeout(() => Y.ref.current.focus());
    }), H = f.useCallback(
      (F, z, q) => {
        const Y = !W.current && !q;
        (w.value !== void 0 && w.value === z || Y) && (P(F), Y && (W.current = !0));
      },
      [w.value]
    ), Z = f.useCallback(() => x == null ? void 0 : x.focus(), [x]), U = f.useCallback(
      (F, z, q) => {
        const Y = !W.current && !q;
        (w.value !== void 0 && w.value === z || Y) && I(F);
      },
      [w.value]
    ), X = r === "popper" ? al : Cy, O = X === al ? {
      side: a,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: p,
      collisionPadding: h,
      sticky: v,
      hideWhenDetached: m,
      avoidCollisions: y
    } : {};
    return /* @__PURE__ */ g(
      wy,
      {
        scope: n,
        content: x,
        viewport: C,
        onViewportChange: A,
        itemRefCallback: H,
        selectedItem: R,
        onItemLeave: Z,
        itemTextRefCallback: U,
        focusSelectedItem: B,
        selectedItemText: k,
        position: r,
        isPositioned: D,
        searchRef: T,
        children: /* @__PURE__ */ g(jc, { as: bD, allowPinchZoom: !0, children: /* @__PURE__ */ g(
          Wc,
          {
            asChild: !0,
            trapped: w.open,
            onMountAutoFocus: (F) => {
              F.preventDefault();
            },
            onUnmountAutoFocus: J(o, (F) => {
              var z;
              (z = w.trigger) == null || z.focus({ preventScroll: !0 }), F.preventDefault();
            }),
            children: /* @__PURE__ */ g(
              ri,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: s,
                onPointerDownOutside: i,
                onFocusOutside: (F) => F.preventDefault(),
                onDismiss: () => w.onOpenChange(!1),
                children: /* @__PURE__ */ g(
                  X,
                  {
                    role: "listbox",
                    id: w.contentId,
                    "data-state": w.open ? "open" : "closed",
                    dir: w.dir,
                    onContextMenu: (F) => F.preventDefault(),
                    ...b,
                    ...O,
                    onPlaced: () => N(!0),
                    ref: S,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...b.style
                    },
                    onKeyDown: J(b.onKeyDown, (F) => {
                      const z = F.ctrlKey || F.altKey || F.metaKey;
                      if (F.key === "Tab" && F.preventDefault(), !z && F.key.length === 1 && M(F.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(F.key)) {
                        let Y = _().filter((re) => !re.disabled).map((re) => re.ref.current);
                        if (["ArrowUp", "End"].includes(F.key) && (Y = Y.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(F.key)) {
                          const re = F.target, j = Y.indexOf(re);
                          Y = Y.slice(j + 1);
                        }
                        setTimeout(() => L(Y)), F.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
xy.displayName = yD;
var wD = "SelectItemAlignedPosition", Cy = f.forwardRef((t, e) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = t, s = hn(Mn, n), i = mn(Mn, n), [a, l] = f.useState(null), [c, u] = f.useState(null), d = te(e, (S) => u(S)), p = xi(n), h = f.useRef(!1), v = f.useRef(!0), { viewport: m, selectedItem: y, selectedItemText: b, focusSelectedItem: w } = i, x = f.useCallback(() => {
    if (s.trigger && s.valueNode && a && c && m && y && b) {
      const S = s.trigger.getBoundingClientRect(), R = c.getBoundingClientRect(), P = s.valueNode.getBoundingClientRect(), k = b.getBoundingClientRect();
      if (s.dir !== "rtl") {
        const re = k.left - R.left, j = P.left - re, K = S.left - j, le = S.width + K, De = Math.max(le, R.width), ot = window.innerWidth - it, gn = ja(j, [
          it,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(it, ot - De)
        ]);
        a.style.minWidth = le + "px", a.style.left = gn + "px";
      } else {
        const re = R.right - k.right, j = window.innerWidth - P.right - re, K = window.innerWidth - S.right - j, le = S.width + K, De = Math.max(le, R.width), ot = window.innerWidth - it, gn = ja(j, [
          it,
          Math.max(it, ot - De)
        ]);
        a.style.minWidth = le + "px", a.style.right = gn + "px";
      }
      const I = p(), _ = window.innerHeight - it * 2, D = m.scrollHeight, N = window.getComputedStyle(c), W = parseInt(N.borderTopWidth, 10), L = parseInt(N.paddingTop, 10), B = parseInt(N.borderBottomWidth, 10), V = parseInt(N.paddingBottom, 10), $ = W + L + D + V + B, T = Math.min(y.offsetHeight * 5, $), M = window.getComputedStyle(m), H = parseInt(M.paddingTop, 10), Z = parseInt(M.paddingBottom, 10), U = S.top + S.height / 2 - it, X = _ - U, O = y.offsetHeight / 2, F = y.offsetTop + O, z = W + L + F, q = $ - z;
      if (z <= U) {
        const re = I.length > 0 && y === I[I.length - 1].ref.current;
        a.style.bottom = "0px";
        const j = c.clientHeight - m.offsetTop - m.offsetHeight, K = Math.max(
          X,
          O + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (re ? Z : 0) + j + B
        ), le = z + K;
        a.style.height = le + "px";
      } else {
        const re = I.length > 0 && y === I[0].ref.current;
        a.style.top = "0px";
        const K = Math.max(
          U,
          W + m.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (re ? H : 0) + O
        ) + q;
        a.style.height = K + "px", m.scrollTop = z - U + m.offsetTop;
      }
      a.style.margin = `${it}px 0`, a.style.minHeight = T + "px", a.style.maxHeight = _ + "px", r == null || r(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    p,
    s.trigger,
    s.valueNode,
    a,
    c,
    m,
    y,
    b,
    s.dir,
    r
  ]);
  ke(() => x(), [x]);
  const [E, C] = f.useState();
  ke(() => {
    c && C(window.getComputedStyle(c).zIndex);
  }, [c]);
  const A = f.useCallback(
    (S) => {
      S && v.current === !0 && (x(), w == null || w(), v.current = !1);
    },
    [x, w]
  );
  return /* @__PURE__ */ g(
    CD,
    {
      scope: n,
      contentWrapper: a,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: A,
      children: /* @__PURE__ */ g(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: E
          },
          children: /* @__PURE__ */ g(
            Ke.div,
            {
              ...o,
              ref: d,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
Cy.displayName = wD;
var xD = "SelectPopperPosition", al = f.forwardRef((t, e) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = it,
    ...s
  } = t, i = Ci(n);
  return /* @__PURE__ */ g(
    ay,
    {
      ...i,
      ...s,
      ref: e,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...s.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
al.displayName = xD;
var [CD, lu] = Cr(Mn, {}), ll = "SelectViewport", Ey = f.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, nonce: r, ...o } = t, s = mn(ll, n), i = lu(ll, n), a = te(e, s.onViewportChange), l = f.useRef(0);
    return /* @__PURE__ */ G(Pe, { children: [
      /* @__PURE__ */ g(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ g(wi.Slot, { scope: n, children: /* @__PURE__ */ g(
        Ke.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: a,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: J(o.onScroll, (c) => {
            const u = c.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: p } = i;
            if (p != null && p.current && d) {
              const h = Math.abs(l.current - u.scrollTop);
              if (h > 0) {
                const v = window.innerHeight - it * 2, m = parseFloat(d.style.minHeight), y = parseFloat(d.style.height), b = Math.max(m, y);
                if (b < v) {
                  const w = b + h, x = Math.min(v, w), E = w - x;
                  d.style.height = x + "px", d.style.bottom === "0px" && (u.scrollTop = E > 0 ? E : 0, d.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Ey.displayName = ll;
var Sy = "SelectGroup", [ED, SD] = Cr(Sy), AD = f.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t, o = Je();
    return /* @__PURE__ */ g(ED, { scope: n, id: o, children: /* @__PURE__ */ g(Ke.div, { role: "group", "aria-labelledby": o, ...r, ref: e }) });
  }
);
AD.displayName = Sy;
var Ay = "SelectLabel", TD = f.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t, o = SD(Ay, n);
    return /* @__PURE__ */ g(Ke.div, { id: o.id, ...r, ref: e });
  }
);
TD.displayName = Ay;
var Rs = "SelectItem", [RD, Ty] = Cr(Rs), Ry = f.forwardRef(
  (t, e) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: s,
      ...i
    } = t, a = hn(Rs, n), l = mn(Rs, n), c = a.value === r, [u, d] = f.useState(s ?? ""), [p, h] = f.useState(!1), v = te(
      e,
      (w) => {
        var x;
        return (x = l.itemRefCallback) == null ? void 0 : x.call(l, w, r, o);
      }
    ), m = Je(), y = f.useRef("touch"), b = () => {
      o || (a.onValueChange(r), a.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ g(
      RD,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: m,
        isSelected: c,
        onItemTextChange: f.useCallback((w) => {
          d((x) => x || ((w == null ? void 0 : w.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ g(
          wi.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: u,
            children: /* @__PURE__ */ g(
              Ke.div,
              {
                role: "option",
                "aria-labelledby": m,
                "data-highlighted": p ? "" : void 0,
                "aria-selected": c && p,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...i,
                ref: v,
                onFocus: J(i.onFocus, () => h(!0)),
                onBlur: J(i.onBlur, () => h(!1)),
                onClick: J(i.onClick, () => {
                  y.current !== "mouse" && b();
                }),
                onPointerUp: J(i.onPointerUp, () => {
                  y.current === "mouse" && b();
                }),
                onPointerDown: J(i.onPointerDown, (w) => {
                  y.current = w.pointerType;
                }),
                onPointerMove: J(i.onPointerMove, (w) => {
                  var x;
                  y.current = w.pointerType, o ? (x = l.onItemLeave) == null || x.call(l) : y.current === "mouse" && w.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: J(i.onPointerLeave, (w) => {
                  var x;
                  w.currentTarget === document.activeElement && ((x = l.onItemLeave) == null || x.call(l));
                }),
                onKeyDown: J(i.onKeyDown, (w) => {
                  var E;
                  ((E = l.searchRef) == null ? void 0 : E.current) !== "" && w.key === " " || (dD.includes(w.key) && b(), w.key === " " && w.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
Ry.displayName = Rs;
var Nr = "SelectItemText", _y = f.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, className: r, style: o, ...s } = t, i = hn(Nr, n), a = mn(Nr, n), l = Ty(Nr, n), c = mD(Nr, n), [u, d] = f.useState(null), p = te(
      e,
      (b) => d(b),
      l.onItemTextChange,
      (b) => {
        var w;
        return (w = a.itemTextRefCallback) == null ? void 0 : w.call(a, b, l.value, l.disabled);
      }
    ), h = u == null ? void 0 : u.textContent, v = f.useMemo(
      () => /* @__PURE__ */ g("option", { value: l.value, disabled: l.disabled, children: h }, l.value),
      [l.disabled, l.value, h]
    ), { onNativeOptionAdd: m, onNativeOptionRemove: y } = c;
    return ke(() => (m(v), () => y(v)), [m, y, v]), /* @__PURE__ */ G(Pe, { children: [
      /* @__PURE__ */ g(Ke.span, { id: l.textId, ...s, ref: p }),
      l.isSelected && i.valueNode && !i.valueNodeHasChildren ? Ps.createPortal(s.children, i.valueNode) : null
    ] });
  }
);
_y.displayName = Nr;
var Py = "SelectItemIndicator", _D = f.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t;
    return Ty(Py, n).isSelected ? /* @__PURE__ */ g(Ke.span, { "aria-hidden": !0, ...r, ref: e }) : null;
  }
);
_D.displayName = Py;
var cl = "SelectScrollUpButton", PD = f.forwardRef((t, e) => {
  const n = mn(cl, t.__scopeSelect), r = lu(cl, t.__scopeSelect), [o, s] = f.useState(!1), i = te(e, r.onScrollButtonChange);
  return ke(() => {
    if (n.viewport && n.isPositioned) {
      let a = function() {
        const c = l.scrollTop > 0;
        s(c);
      };
      const l = n.viewport;
      return a(), l.addEventListener("scroll", a), () => l.removeEventListener("scroll", a);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ g(
    ky,
    {
      ...t,
      ref: i,
      onAutoScroll: () => {
        const { viewport: a, selectedItem: l } = n;
        a && l && (a.scrollTop = a.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
PD.displayName = cl;
var ul = "SelectScrollDownButton", kD = f.forwardRef((t, e) => {
  const n = mn(ul, t.__scopeSelect), r = lu(ul, t.__scopeSelect), [o, s] = f.useState(!1), i = te(e, r.onScrollButtonChange);
  return ke(() => {
    if (n.viewport && n.isPositioned) {
      let a = function() {
        const c = l.scrollHeight - l.clientHeight, u = Math.ceil(l.scrollTop) < c;
        s(u);
      };
      const l = n.viewport;
      return a(), l.addEventListener("scroll", a), () => l.removeEventListener("scroll", a);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ g(
    ky,
    {
      ...t,
      ref: i,
      onAutoScroll: () => {
        const { viewport: a, selectedItem: l } = n;
        a && l && (a.scrollTop = a.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
kD.displayName = ul;
var ky = f.forwardRef((t, e) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = t, s = mn("SelectScrollButton", n), i = f.useRef(null), a = xi(n), l = f.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return f.useEffect(() => () => l(), [l]), ke(() => {
    var u;
    const c = a().find((d) => d.ref.current === document.activeElement);
    (u = c == null ? void 0 : c.ref.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [a]), /* @__PURE__ */ g(
    Ke.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: e,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: J(o.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(r, 50));
      }),
      onPointerMove: J(o.onPointerMove, () => {
        var c;
        (c = s.onItemLeave) == null || c.call(s), i.current === null && (i.current = window.setInterval(r, 50));
      }),
      onPointerLeave: J(o.onPointerLeave, () => {
        l();
      })
    }
  );
}), ID = "SelectSeparator", DD = f.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t;
    return /* @__PURE__ */ g(Ke.div, { "aria-hidden": !0, ...r, ref: e });
  }
);
DD.displayName = ID;
var dl = "SelectArrow", MD = f.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...r } = t, o = Ci(n), s = hn(dl, n), i = mn(dl, n);
    return s.open && i.position === "popper" ? /* @__PURE__ */ g(ly, { ...o, ...r, ref: e }) : null;
  }
);
MD.displayName = dl;
var ND = "SelectBubbleInput", Iy = f.forwardRef(
  ({ __scopeSelect: t, value: e, ...n }, r) => {
    const o = f.useRef(null), s = te(r, o), i = QI(e);
    return f.useEffect(() => {
      const a = o.current;
      if (!a) return;
      const l = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (i !== e && u) {
        const d = new Event("change", { bubbles: !0 });
        u.call(a, e), a.dispatchEvent(d);
      }
    }, [i, e]), /* @__PURE__ */ g(
      Ke.select,
      {
        ...n,
        style: { ...uy, ...n.style },
        ref: s,
        defaultValue: e
      }
    );
  }
);
Iy.displayName = ND;
function Dy(t) {
  return t === "" || t === void 0;
}
function My(t) {
  const e = Ne(t), n = f.useRef(""), r = f.useRef(0), o = f.useCallback(
    (i) => {
      const a = n.current + i;
      e(a), function l(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }(a);
    },
    [e]
  ), s = f.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return f.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, s];
}
function Ny(t, e, n) {
  const o = e.length > 1 && Array.from(e).every((c) => c === e[0]) ? e[0] : e, s = n ? t.indexOf(n) : -1;
  let i = OD(t, Math.max(s, 0));
  o.length === 1 && (i = i.filter((c) => c !== n));
  const l = i.find(
    (c) => c.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function OD(t, e) {
  return t.map((n, r) => t[(e + r) % t.length]);
}
var VD = fy, FD = hy, LD = gy, BD = vy, $D = yy, WD = by, jD = Ey, UD = Ry, HD = _y;
const zD = ae({
  slots: {
    root: [
      "group cursor-pointer py-3 ps-3 pe-2 typography-input-text text-left text-clr-primary focus:outline-none",
      "data-[disabled]:text-clr-on-primary-low data-[disabled]:cursor-default"
      //disabled
    ],
    text: [
      "border border-transparent rounded-sm px-0.5",
      "group-focus:border-clr-primary group-data-[state=closed]:group-focus:border-transparent",
      //focus
      "group-hover:group-focus:border-transparent group-hover:group-focus:border-b-clr-primary",
      //hover
      "group-data-[state=checked]:border-b-4 group-data-[state=checked]:border-b-clr-primary"
      // selected
    ]
  }
}), cu = ne.forwardRef(
  ({ children: t, value: e, disabled: n = !1, hidden: r = !1 }, o) => {
    const { root: s, text: i } = zD();
    return /* @__PURE__ */ g(UD, { value: e, disabled: n, hidden: r, ref: o, className: s(), children: /* @__PURE__ */ g(HD, { children: /* @__PURE__ */ g("span", { className: i(), children: t }) }) });
  }
);
cu.displayName = "Item";
const GD = ae({
  slots: {
    trigger: [
      "input group bg-transparent h-11.5 flex align-center items-center gap-3 p-3 border-box",
      "focus-visible:outline focus-visible:outline-1 focus-visible:outline-clr-primary focus-visible:outline-offset-1 data-[state=open]:data-[state=open]:border-clr-primary"
      //Focus
    ],
    icon: "w-5 h-5 fill-inherit shrink-0 [button[data-state='open']_span>&]:rotate-180",
    title: "mx-5 px-1.25 py-3 border-b border-clr-on-bg-low",
    menu: [
      "preflight overflow-hidden w-[--radix-select-trigger-width] whitespace-nowrap",
      "m:border m:border-clr-primary m:border-t-0 rounded-b-sm",
      "data-[side=top]:border-b-0 data-[side=top]:border-t data-[side=top]:pb-4"
      // data-side=top variant
    ],
    selectList: "pl-2",
    text: "typography-input-text grow text-left truncate",
    inputWrapperLabel: ""
  },
  variants: {
    error: {
      true: {
        trigger: "focus-visible:outline-clr-error data-[state=open]:data-[state=open]:border-clr-error"
      }
    },
    placeholderShown: {
      true: {
        inputWrapperLabel: "pr-7 bg-transparent"
      },
      false: ""
    }
  }
}), fl = ne.forwardRef(
  ({ name: t, label: e, value: n, onValueChange: r, children: o, disabled: s = !1, error: i = !1, required: a = !1, helperText: l, errorText: c }, u) => {
    const d = cn(), { getChildrenFromSubcomponent: p, printBadConstructionMessage: h } = pt(o), v = Tl("s", "m"), [m, y] = de(!1), b = !n, w = { error: i, placeholderShown: b }, { trigger: x, icon: E, title: C, menu: A, selectList: S, text: R, inputWrapperLabel: P } = GD(w), k = Se(null), I = Se(null), [_, D] = de(null);
    ie(() => {
      m && D(k.current);
    }, [m]), ie(() => {
      v && y(!1);
    }, [n, v]), ie(() => {
      m === !1 && v && D(I.current);
    }, [v, m]);
    const N = T0();
    if (!o)
      return h("Select"), null;
    const W = p(cu);
    return /* @__PURE__ */ G(Pe, { children: [
      /* @__PURE__ */ g(
        Kc,
        {
          label: e,
          id: d,
          error: i,
          required: a,
          placeholderShown: b,
          disabled: s,
          helperText: l,
          errorText: c,
          labelClassName: P(),
          children: /* @__PURE__ */ G(
            VD,
            {
              name: t,
              disabled: s,
              value: n,
              onValueChange: r,
              onOpenChange: () => {
                y(v ? !0 : !m);
              },
              open: m,
              children: [
                /* @__PURE__ */ G(FD, { id: d, className: x(), ref: u, children: [
                  /* @__PURE__ */ g("span", { className: R(), children: /* @__PURE__ */ g(LD, {}) }),
                  /* @__PURE__ */ g(BD, { children: /* @__PURE__ */ g(ge, { variant: "arrow-down", className: E() }) })
                ] }),
                /* @__PURE__ */ g($D, { children: /* @__PURE__ */ g(WD, { position: "popper", side: "bottom", align: "start", avoidCollisions: !0, className: A(), style: { zIndex: N }, children: /* @__PURE__ */ g(jD, { asChild: !0, children: v ? _ && /* @__PURE__ */ g(Pe, { children: vl(W, _) }) : /* @__PURE__ */ g(zs, { classes: "bg-clr-bg max-h-[275px]", children: W }) }) }) })
              ]
            }
          )
        }
      ),
      //this dummy div is for preserving the list of Select Items and the selected value when the BottomSheet is closed
      !m && v ? /* @__PURE__ */ g("div", { ref: I, className: "hidden" }) : null,
      /* @__PURE__ */ G(ET, { isOpen: m, onClose: () => y(!1), children: [
        /* @__PURE__ */ g("div", { className: C(), children: /* @__PURE__ */ g(er, { variant: "h5", children: e }) }),
        /* @__PURE__ */ g("div", { ref: k, className: S() })
      ] })
    ] });
  }
);
fl.Item = cu;
const KD = ae({
  slots: {
    root: "",
    input: "peer appearance-none sr-only",
    label: [
      "group pt-1 pb-2 border-b border-transparent hover:cursor-pointer hover:border-clr-primary",
      "peer-checked:border-b-2 peer-checked:border-clr-primary"
    ],
    content: "",
    icon: "w-4 h-4 fill-clr-on-bg-high",
    imageContainer: "inline-block relative",
    focusContainer: "border border-transparent rounded-sm peer-focus-visible:group-[]:border-clr-primary"
  },
  variants: {
    disabled: {
      true: {
        root: "hidden"
      },
      false: ""
    },
    readOnly: {
      true: {
        root: "hidden"
      }
    },
    variant: {
      text: {
        content: "inline-flex gap-x-0.5 px-1 py-0.5 items-center typography-input-text text-clr-on-bg-high"
      },
      image: {
        content: "hidden"
      }
    }
  }
}), _s = (t) => {
  const { name: e, value: n, checked: r, children: o, disabled: s = !1, readOnly: i = !1, ...a } = t, l = cn(), {
    root: c,
    input: u,
    label: d,
    content: p,
    icon: h,
    imageContainer: v,
    focusContainer: m
  } = KD({ disabled: s, readOnly: i, variant: a.variant || "text" });
  let y, b;
  if (a.variant === "text") {
    const { availability: w = "available", onChange: x } = a, E = a.availability === "out-of-stock" ? /* @__PURE__ */ G("s", { children: [
      " ",
      o,
      " "
    ] }) : o;
    y = /* @__PURE__ */ G("span", { className: `${m()} ${p()}`, children: [
      E,
      w === "currently-out-of-stock" && /* @__PURE__ */ g(ge, { variant: "bell", className: h() })
    ] }), b = (C) => x(C.target.value, w);
  } else if (a.variant === "image") {
    const { availability: w = "available", onChange: x } = a;
    y = /* @__PURE__ */ G(Pe, { children: [
      /* @__PURE__ */ g("span", { className: p(), children: o }),
      /* @__PURE__ */ G("div", { className: `${m()} ${v()}`, children: [
        /* @__PURE__ */ g(G_, { ...a }),
        w === "out-of-stock" && /* @__PURE__ */ G("svg", { className: "absolute top-0 left-0 right-0 bottom-0 m-auto w-[45px] h-[60px]", viewBox: "0 0 45 60", preserveAspectRatio: "none", children: [
          /* @__PURE__ */ g("line", { x1: "0", y1: "60", x2: "45", y2: "0", vectorEffect: "non-scaling-stroke", stroke: "black" }),
          /* @__PURE__ */ g("line", { x1: "1", y1: "60", x2: "45", y2: "1", vectorEffect: "non-scaling-storke", stroke: "white" })
        ] })
      ] })
    ] }), b = (E) => x(E.target.value, w);
  }
  return /* @__PURE__ */ G("span", { className: c(), children: [
    /* @__PURE__ */ g(
      "input",
      {
        className: u(),
        type: "radio",
        id: l,
        name: e,
        value: n || o,
        disabled: s,
        checked: r,
        onChange: b,
        readOnly: i
      }
    ),
    /* @__PURE__ */ g("label", { htmlFor: l, className: d(), children: y })
  ] });
};
_s.displayName = "Item";
const YD = ae({
  base: "preflight flex flex-col",
  slots: {
    header: "flex gap-0.5",
    label: "typography-input-label text-clr-on-bg-mid",
    selectedValue: "typography-input-label text-clr-on-bg-high",
    group: "flex flex-wrap gap-x-4 gap-y-2",
    selectOption: "inline-flex gap-x-0.5 items-center",
    selectOptionIcon: "w-4 h-4 fill-clr-on-bg-high"
  },
  variants: {
    variant: {
      text: "",
      image: {
        base: "gap-2"
      }
    }
  }
}), Oy = (t) => {
  var E;
  const { value: e = "", label: n, children: r, ...o } = t, {
    base: s,
    header: i,
    label: a,
    selectedValue: l,
    group: c,
    selectOption: u,
    selectOptionIcon: d
  } = YD({ variant: o.variant }), p = cn(), { getSingleChildFromSubcomponent: h, getChildrenFromSubcomponent: v, printBadConstructionMessage: m } = pt(r), y = v(Oy.Item).map((C) => ({
    value: C.props.value || C.props.children,
    label: C.props.children,
    availability: C.props.availability
  })), b = y.some((C) => C.label.length > 15);
  if (!r)
    return m("Selection"), null;
  let w = [];
  if (o.variant === "text") {
    const { variant: C, onChange: A, placeholder: S = "" } = o;
    if (b)
      return /* @__PURE__ */ g(fl, { label: n, onValueChange: (k) => {
        var I;
        return A(k, (I = y.find((_) => _.value === k)) == null ? void 0 : I.availability);
      }, value: e, children: y.map(({ value: k, label: I, availability: _ }) => {
        let D = I;
        return _ === "out-of-stock" ? D = /* @__PURE__ */ g("s", { children: I }) : _ === "currently-out-of-stock" && (D = /* @__PURE__ */ G("span", { className: u(), children: [
          /* @__PURE__ */ g("span", { children: I }),
          /* @__PURE__ */ g(ge, { variant: "bell", className: d() })
        ] })), /* @__PURE__ */ g(fl.Item, { value: k, children: D }, k);
      }) });
    y.push({ value: "", label: S, availability: "available" }), w = tn.map(r, (P) => {
      const k = {
        name: p,
        onChange: A,
        checked: e === (P !== null && Ur(P) && (P.props.value || P.props.children)),
        variant: C
      };
      return h(_s, P, k);
    });
  } else {
    const { variant: C, onChange: A, imageWidth: S, imageHeight: R } = o;
    w = tn.map(r, (P) => {
      const k = {
        name: p,
        onChange: A,
        checked: e === (P !== null && Ur(P) && (P.props.value || P.props.children)),
        variant: C,
        width: S,
        height: R
      };
      return h(_s, P, k);
    });
  }
  const x = (E = y.find((C) => C.value === e)) == null ? void 0 : E.label;
  return /* @__PURE__ */ G("fieldset", { className: s(), children: [
    /* @__PURE__ */ G("div", { className: i(), children: [
      /* @__PURE__ */ g("legend", { className: a(), children: n + ":" }),
      /* @__PURE__ */ g("span", { className: l(), children: x })
    ] }),
    /* @__PURE__ */ g("div", { className: c(), children: w })
  ] });
};
Oy.Item = _s;
const qD = ae({
  slots: {
    modal: [
      // pointer-events:auto is the default value, but without this class modal is closing itself when you interact
      // with the content
      "preflight pointer-events-auto fixed w-100 h-dvh px-4 flex flex-col bg-clr-bg-modal -right-100 top-0 outline-none",
      gw()
    ],
    header: "flex gap-2 items-center py-6",
    titleClass: "flex-grow text-clr-primary typography-bonprix-h6 line-clamp-2"
  }
}), Ei = ({ children: t, isOpen: e, modeless: n = !1, onClose: r = () => null, onBack: o, zIndex: s = 2 }) => {
  const i = N0("m"), { getSubcomponents: a, printBadConstructionMessage: l } = pt(t), { Title: c, Content: u, PrimaryButton: d, SecondaryButton: p } = a(), { modal: h, titleClass: v, header: m } = qD();
  if (!c || !u)
    return l("SideSheet"), null;
  if (i) return;
  const y = (b) => {
    b.preventDefault(), b.target.focus();
  };
  return /* @__PURE__ */ g(Qg, { open: e, modal: !n, children: /* @__PURE__ */ G(ev, { children: [
    /* @__PURE__ */ g(tv, { className: Ns(), onClick: r, style: { zIndex: s - 1 } }),
    /* @__PURE__ */ g(
      nv,
      {
        className: h(),
        style: { zIndex: s },
        "aria-describedby": void 0,
        onOpenAutoFocus: y,
        tabIndex: -1,
        children: /* @__PURE__ */ G(Al.Provider, { value: s, children: [
          /* @__PURE__ */ G("div", { className: m(), children: [
            o && /* @__PURE__ */ g(Tn, { onClick: o, icon: "arrow-left", label: "Zurück", variant: "tertiary" }),
            /* @__PURE__ */ g(Gc, { className: v(), children: c }),
            /* @__PURE__ */ g(rv, { asChild: !0, children: /* @__PURE__ */ g(Tn, { onClick: r, icon: "closer", label: "Schließen", variant: "tertiary" }) })
          ] }),
          u,
          d && /* @__PURE__ */ g(ov, { owner: "SideSheet", primary: d, secondary: p, fullWidthButtons: !0 })
        ] })
      }
    )
  ] }) });
}, Vy = ({ children: t }) => t;
Vy.displayName = "Title";
const Fy = ({ children: t }) => /* @__PURE__ */ g(zs, { verticalOnly: !0, children: t });
Fy.displayName = "Content";
Ei.Title = Vy;
Ei.Content = Fy;
Ei.PrimaryButton = ai;
Ei.SecondaryButton = li;
const XD = ae({
  slots: {
    container: "preflight w-full flex flex-col gap-1.5 items-center l:items-start xl:items-start group focus:outline-none",
    icon: "h-5 w-5 fill-clr-success invisible",
    bar: "w-full h-1 bg-clr-on-bg-disabled",
    labelSlot: [
      "typography-input-helper-text text-center text-clr-primary l:text-left xl:text-left px-1 break-all",
      "border border-transparent rounded-sm group-focus:border-clr-primary"
    ]
  },
  variants: {
    active: {
      true: {
        bar: "bg-clr-primary"
      }
    },
    completed: {
      true: { icon: "visible" }
    },
    disabled: {
      true: {
        labelSlot: "text-clr-on-bg-low"
      },
      false: {
        bar: "group-hover:bg-clr-primary"
      }
    }
  }
}), uu = ({ children: t, href: e = "#", active: n, completed: r, disabled: o }) => {
  const { container: s, icon: i, bar: a, labelSlot: l } = XD({ active: n, completed: r, disabled: o });
  return /* @__PURE__ */ G(
    "a",
    {
      href: o ? void 0 : e,
      className: s(),
      "aria-current": n ? "step" : "false",
      "aria-disabled": o ? "true" : "false",
      children: [
        /* @__PURE__ */ g(ge, { variant: "check-bold", className: i() }),
        /* @__PURE__ */ g("div", { className: a() }),
        /* @__PURE__ */ G("div", { className: l(), children: [
          t,
          r && /* @__PURE__ */ g("span", { className: "sr-only", children: " erfüllter schritt" })
        ] })
      ]
    }
  );
};
uu.displayName = "Step";
const ZD = (t, e, n) => t > n + 1 ? (console.error("activeStep must not be greater than completedSteps + 1"), n + 1) : t > e ? (console.error("activeStep must not be greater than the amount of steps. activeStep is set to last available step"), e) : t, JD = ({ completedSteps: t = 0, activeStep: e = t + 1, children: n, ariaLabel: r }) => {
  const o = ne.Children.count(n), s = ZD(e, o, t), { getSingleChildFromSubcomponent: i, printBadConstructionMessage: a } = pt(n);
  return n ? /* @__PURE__ */ g("nav", { "aria-label": r, children: /* @__PURE__ */ g("ol", { className: "preflight list-none m-0 p-0 flex flex-row gap-1 px-5 l:px-10 xl:px-10", children: tn.map(n, (l, c) => {
    const u = c + 1, d = s === u, p = t >= u, h = u > t + 1;
    return /* @__PURE__ */ g("li", { className: "flex-1", children: i(uu, l, { active: d, completed: p, disabled: h }) }, u);
  }) }) }) : (a("StepNavi"), null);
};
JD.Step = uu;
function QD(t) {
  const e = f.useRef({ value: t, previous: t });
  return f.useMemo(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [t]);
}
// @__NO_SIDE_EFFECTS__
function eM(t) {
  const e = /* @__PURE__ */ tM(t), n = f.forwardRef((r, o) => {
    const { children: s, ...i } = r, a = f.Children.toArray(s), l = a.find(rM);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ g(e, { ...i, ref: o, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ g(e, { ...i, ref: o, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function tM(t) {
  const e = f.forwardRef((n, r) => {
    const { children: o, ...s } = n, i = f.isValidElement(o) ? sM(o) : void 0, a = te(i, r);
    if (f.isValidElement(o)) {
      const l = oM(s, o.props);
      return o.type !== f.Fragment && (l.ref = a), f.cloneElement(o, l);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var nM = Symbol("radix.slottable");
function rM(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === nM;
}
function oM(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const l = s(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function sM(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var iM = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Ly = iM.reduce((t, e) => {
  const n = /* @__PURE__ */ eM(`Primitive.${e}`), r = f.forwardRef((o, s) => {
    const { asChild: i, ...a } = o, l = i ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {}), Si = "Switch", [aM, rO] = je(Si), [lM, cM] = aM(Si), By = f.forwardRef(
  (t, e) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: o,
      defaultChecked: s,
      required: i,
      disabled: a,
      value: l = "on",
      onCheckedChange: c,
      form: u,
      ...d
    } = t, [p, h] = f.useState(null), v = te(e, (x) => h(x)), m = f.useRef(!1), y = p ? u || !!p.closest("form") : !0, [b, w] = tt({
      prop: o,
      defaultProp: s ?? !1,
      onChange: c,
      caller: Si
    });
    return /* @__PURE__ */ G(lM, { scope: n, checked: b, disabled: a, children: [
      /* @__PURE__ */ g(
        Ly.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": b,
          "aria-required": i,
          "data-state": Uy(b),
          "data-disabled": a ? "" : void 0,
          disabled: a,
          value: l,
          ...d,
          ref: v,
          onClick: J(t.onClick, (x) => {
            w((E) => !E), y && (m.current = x.isPropagationStopped(), m.current || x.stopPropagation());
          })
        }
      ),
      y && /* @__PURE__ */ g(
        jy,
        {
          control: p,
          bubbles: !m.current,
          name: r,
          value: l,
          checked: b,
          required: i,
          disabled: a,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
By.displayName = Si;
var $y = "SwitchThumb", Wy = f.forwardRef(
  (t, e) => {
    const { __scopeSwitch: n, ...r } = t, o = cM($y, n);
    return /* @__PURE__ */ g(
      Ly.span,
      {
        "data-state": Uy(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: e
      }
    );
  }
);
Wy.displayName = $y;
var uM = "SwitchBubbleInput", jy = f.forwardRef(
  ({
    __scopeSwitch: t,
    control: e,
    checked: n,
    bubbles: r = !0,
    ...o
  }, s) => {
    const i = f.useRef(null), a = te(i, s), l = QD(n), c = Xc(e);
    return f.useEffect(() => {
      const u = i.current;
      if (!u) return;
      const d = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        d,
        "checked"
      ).set;
      if (l !== n && h) {
        const v = new Event("click", { bubbles: r });
        h.call(u, n), u.dispatchEvent(v);
      }
    }, [l, n, r]), /* @__PURE__ */ g(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: n,
        ...o,
        tabIndex: -1,
        ref: a,
        style: {
          ...o.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
jy.displayName = uM;
function Uy(t) {
  return t ? "checked" : "unchecked";
}
var dM = By, fM = Wy;
const pM = ae({
  slots: {
    wrapper: "preflight flex justify-between gap-3",
    label: "text-clr-on-bg-high",
    root: [
      "relative w-9 h-5 shrink-0 border border-clr-on-bg-high rounded-full group",
      "focus-visible:outline focus-visible:outline-offset-1 focus-visible:outline-clr-on-bg-high"
    ],
    icon: "absolute w-3 h-3 left-[3px] top-[3px] fill-clr-on-primary-high",
    thumb: "block w-3.5 h-3.5 rounded-full translate-x-0.5"
  },
  variants: {
    checked: {
      true: {
        root: "bg-clr-on-bg-high",
        thumb: "bg-clr-on-primary-high translate-x-[18px]"
      },
      false: {
        thumb: "bg-clr-on-bg-high"
      }
    },
    smallLabel: {
      true: {
        label: "typography-body2 pt-0.5"
      },
      false: {
        label: "typography-body1"
      }
    },
    disabled: {
      true: {
        label: "text-clr-disabled",
        root: "border-clr-disabled",
        icon: "fill-clr-disabled",
        thumb: "bg-clr-disabled"
      },
      false: {
        root: "hover:border-clr-on-bg-low"
      }
    }
  },
  compoundVariants: [
    {
      checked: !0,
      disabled: !0,
      class: {
        root: "bg-clr-on-bg-disabled"
      }
    },
    {
      checked: !1,
      disabled: !1,
      class: {
        thumb: "group-hover:bg-clr-on-bg-low"
      }
    },
    {
      checked: !0,
      disabled: !1,
      class: {
        root: "hover:bg-clr-on-bg-low"
      }
    }
  ]
}), oO = ({ checked: t, onChange: e, label: n, smallLabel: r = !1, disabled: o = !1 }) => {
  const s = cn(), { wrapper: i, root: a, label: l, icon: c, thumb: u } = pM({ checked: t, smallLabel: r, disabled: o });
  return /* @__PURE__ */ G("div", { className: i(), children: [
    /* @__PURE__ */ g("label", { htmlFor: s, className: l(), children: n }),
    /* @__PURE__ */ G(dM, { id: s, checked: t, onCheckedChange: e, disabled: o, className: a(), children: [
      t && /* @__PURE__ */ g(ge, { variant: "check", className: c() }),
      /* @__PURE__ */ g(fM, { className: u() })
    ] })
  ] });
};
// @__NO_SIDE_EFFECTS__
function hM(t) {
  const e = /* @__PURE__ */ mM(t), n = f.forwardRef((r, o) => {
    const { children: s, ...i } = r, a = f.Children.toArray(s), l = a.find(vM);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ g(e, { ...i, ref: o, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ g(e, { ...i, ref: o, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function mM(t) {
  const e = f.forwardRef((n, r) => {
    const { children: o, ...s } = n, i = f.isValidElement(o) ? bM(o) : void 0, a = te(i, r);
    if (f.isValidElement(o)) {
      const l = yM(s, o.props);
      return o.type !== f.Fragment && (l.ref = a), f.cloneElement(o, l);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var gM = Symbol("radix.slottable");
function vM(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === gM;
}
function yM(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const l = s(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function bM(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var wM = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Er = wM.reduce((t, e) => {
  const n = /* @__PURE__ */ hM(`Primitive.${e}`), r = f.forwardRef((o, s) => {
    const { asChild: i, ...a } = o, l = i ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {}), xM = f.createContext(void 0);
function Hy(t) {
  const e = f.useContext(xM);
  return t || e || "ltr";
}
var ma = "rovingFocusGroup.onEntryFocus", CM = { bubbles: !1, cancelable: !0 }, Po = "RovingFocusGroup", [pl, zy, EM] = ks(Po), [SM, Gy] = je(
  Po,
  [EM]
), [AM, TM] = SM(Po), Ky = f.forwardRef(
  (t, e) => /* @__PURE__ */ g(pl.Provider, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ g(pl.Slot, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ g(RM, { ...t, ref: e }) }) })
);
Ky.displayName = Po;
var RM = f.forwardRef((t, e) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: s,
    currentTabStopId: i,
    defaultCurrentTabStopId: a,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = t, p = f.useRef(null), h = te(e, p), v = Hy(s), [m, y] = tt({
    prop: i,
    defaultProp: a ?? null,
    onChange: l,
    caller: Po
  }), [b, w] = f.useState(!1), x = Ne(c), E = zy(n), C = f.useRef(!1), [A, S] = f.useState(0);
  return f.useEffect(() => {
    const R = p.current;
    if (R)
      return R.addEventListener(ma, x), () => R.removeEventListener(ma, x);
  }, [x]), /* @__PURE__ */ g(
    AM,
    {
      scope: n,
      orientation: r,
      dir: v,
      loop: o,
      currentTabStopId: m,
      onItemFocus: f.useCallback(
        (R) => y(R),
        [y]
      ),
      onItemShiftTab: f.useCallback(() => w(!0), []),
      onFocusableItemAdd: f.useCallback(
        () => S((R) => R + 1),
        []
      ),
      onFocusableItemRemove: f.useCallback(
        () => S((R) => R - 1),
        []
      ),
      children: /* @__PURE__ */ g(
        Er.div,
        {
          tabIndex: b || A === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: h,
          style: { outline: "none", ...t.style },
          onMouseDown: J(t.onMouseDown, () => {
            C.current = !0;
          }),
          onFocus: J(t.onFocus, (R) => {
            const P = !C.current;
            if (R.target === R.currentTarget && P && !b) {
              const k = new CustomEvent(ma, CM);
              if (R.currentTarget.dispatchEvent(k), !k.defaultPrevented) {
                const I = E().filter((L) => L.focusable), _ = I.find((L) => L.active), D = I.find((L) => L.id === m), W = [_, D, ...I].filter(
                  Boolean
                ).map((L) => L.ref.current);
                Xy(W, u);
              }
            }
            C.current = !1;
          }),
          onBlur: J(t.onBlur, () => w(!1))
        }
      )
    }
  );
}), Yy = "RovingFocusGroupItem", qy = f.forwardRef(
  (t, e) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: s,
      children: i,
      ...a
    } = t, l = Je(), c = s || l, u = TM(Yy, n), d = u.currentTabStopId === c, p = zy(n), { onFocusableItemAdd: h, onFocusableItemRemove: v, currentTabStopId: m } = u;
    return f.useEffect(() => {
      if (r)
        return h(), () => v();
    }, [r, h, v]), /* @__PURE__ */ g(
      pl.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ g(
          Er.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": u.orientation,
            ...a,
            ref: e,
            onMouseDown: J(t.onMouseDown, (y) => {
              r ? u.onItemFocus(c) : y.preventDefault();
            }),
            onFocus: J(t.onFocus, () => u.onItemFocus(c)),
            onKeyDown: J(t.onKeyDown, (y) => {
              if (y.key === "Tab" && y.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (y.target !== y.currentTarget) return;
              const b = kM(y, u.orientation, u.dir);
              if (b !== void 0) {
                if (y.metaKey || y.ctrlKey || y.altKey || y.shiftKey) return;
                y.preventDefault();
                let x = p().filter((E) => E.focusable).map((E) => E.ref.current);
                if (b === "last") x.reverse();
                else if (b === "prev" || b === "next") {
                  b === "prev" && x.reverse();
                  const E = x.indexOf(y.currentTarget);
                  x = u.loop ? IM(x, E + 1) : x.slice(E + 1);
                }
                setTimeout(() => Xy(x));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: d, hasTabStop: m != null }) : i
          }
        )
      }
    );
  }
);
qy.displayName = Yy;
var _M = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function PM(t, e) {
  return e !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function kM(t, e, n) {
  const r = PM(t.key, n);
  if (!(e === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(e === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return _M[r];
}
function Xy(t, e = !1) {
  const n = document.activeElement;
  for (const r of t)
    if (r === n || (r.focus({ preventScroll: e }), document.activeElement !== n)) return;
}
function IM(t, e) {
  return t.map((n, r) => t[(e + r) % t.length]);
}
var DM = Ky, MM = qy, Ai = "Tabs", [NM, sO] = je(Ai, [
  Gy
]), Zy = Gy(), [OM, du] = NM(Ai), Jy = f.forwardRef(
  (t, e) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: o,
      defaultValue: s,
      orientation: i = "horizontal",
      dir: a,
      activationMode: l = "automatic",
      ...c
    } = t, u = Hy(a), [d, p] = tt({
      prop: r,
      onChange: o,
      defaultProp: s ?? "",
      caller: Ai
    });
    return /* @__PURE__ */ g(
      OM,
      {
        scope: n,
        baseId: Je(),
        value: d,
        onValueChange: p,
        orientation: i,
        dir: u,
        activationMode: l,
        children: /* @__PURE__ */ g(
          Er.div,
          {
            dir: u,
            "data-orientation": i,
            ...c,
            ref: e
          }
        )
      }
    );
  }
);
Jy.displayName = Ai;
var Qy = "TabsList", eb = f.forwardRef(
  (t, e) => {
    const { __scopeTabs: n, loop: r = !0, ...o } = t, s = du(Qy, n), i = Zy(n);
    return /* @__PURE__ */ g(
      DM,
      {
        asChild: !0,
        ...i,
        orientation: s.orientation,
        dir: s.dir,
        loop: r,
        children: /* @__PURE__ */ g(
          Er.div,
          {
            role: "tablist",
            "aria-orientation": s.orientation,
            ...o,
            ref: e
          }
        )
      }
    );
  }
);
eb.displayName = Qy;
var tb = "TabsTrigger", nb = f.forwardRef(
  (t, e) => {
    const { __scopeTabs: n, value: r, disabled: o = !1, ...s } = t, i = du(tb, n), a = Zy(n), l = ob(i.baseId, r), c = sb(i.baseId, r), u = r === i.value;
    return /* @__PURE__ */ g(
      MM,
      {
        asChild: !0,
        ...a,
        focusable: !o,
        active: u,
        children: /* @__PURE__ */ g(
          Er.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": c,
            "data-state": u ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: l,
            ...s,
            ref: e,
            onMouseDown: J(t.onMouseDown, (d) => {
              !o && d.button === 0 && d.ctrlKey === !1 ? i.onValueChange(r) : d.preventDefault();
            }),
            onKeyDown: J(t.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && i.onValueChange(r);
            }),
            onFocus: J(t.onFocus, () => {
              const d = i.activationMode !== "manual";
              !u && !o && d && i.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
nb.displayName = tb;
var rb = "TabsContent", VM = f.forwardRef(
  (t, e) => {
    const { __scopeTabs: n, value: r, forceMount: o, children: s, ...i } = t, a = du(rb, n), l = ob(a.baseId, r), c = sb(a.baseId, r), u = r === a.value, d = f.useRef(u);
    return f.useEffect(() => {
      const p = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(p);
    }, []), /* @__PURE__ */ g(Ge, { present: o || u, children: ({ present: p }) => /* @__PURE__ */ g(
      Er.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": a.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !p,
        id: c,
        tabIndex: 0,
        ...i,
        ref: e,
        style: {
          ...t.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: p && s
      }
    ) });
  }
);
VM.displayName = rb;
function ob(t, e) {
  return `${t}-trigger-${e}`;
}
function sb(t, e) {
  return `${t}-content-${e}`;
}
var FM = Jy, LM = eb, BM = nb;
const $M = ae({
  slots: {
    container: [
      "preflight group flex flex-col shrink-0 relative min-w-8 max-w-35 cursor-pointer focus-visible:outline-0",
      "after:content-[''] after:h-2"
    ],
    iconContainer: "flex align-center max-w-10 h-7",
    labelContainer: "flex flex-col mb-auto typography-body1 text-clr-primary text-left px-0.5 border border-transparent group-focus-visible:border-clr-primary rounded-sm",
    labelClass: "line-clamp-2",
    sublabelClass: "line-clamp-1"
  },
  variants: {
    isActive: {
      true: {
        container: "after:left-0 after:w-full after:border-b-4 after:border-clr-primary"
      },
      false: {
        container: "hover:after:content-[''] hover:after:left-0 hover:after:w-full hover:after:border-b hover:after:border-clr-primary"
      }
    }
  }
}), fu = ({ label: t, subLabel: e, icon: n, onClick: r, isActive: o, value: s, callback: i }) => {
  const { container: a, iconContainer: l, labelContainer: c, labelClass: u, sublabelClass: d } = $M({ isActive: o });
  return /* @__PURE__ */ G(
    BM,
    {
      className: a(),
      onClick: () => {
        i(), r && r();
      },
      value: s,
      children: [
        n && /* @__PURE__ */ g("div", { className: l(), children: n }),
        /* @__PURE__ */ G("div", { className: c(), children: [
          /* @__PURE__ */ g("p", { className: u(), children: t }),
          e && /* @__PURE__ */ g("p", { className: d(), children: e })
        ] })
      ]
    }
  );
};
fu.displayName = "Tabs.Item";
const WM = ae({
  base: "preflight flex gap-7 border-b border-b-clr-on-bg-disabled overflow-x-auto"
}), jM = ({ children: t, activeTab: e = 0 }) => {
  const [n, r] = de(e), { getSingleChildFromSubcomponent: o, printBadConstructionMessage: s } = pt(t);
  return t ? /* @__PURE__ */ g(FM, { defaultValue: `tab${e}`, children: /* @__PURE__ */ g(LM, { className: WM(), style: { scrollbarWidth: "none" }, children: tn.map(t, (i, a) => {
    const l = {
      isActive: n === a,
      value: `tab${a}`,
      callback: () => r(a)
    };
    return o(fu, i, l);
  }) }) }) : (s("Tabs"), null);
};
jM.Item = fu;
const UM = ae({
  slots: {
    root: "preflight w-full relative [&_.inputLabel]:z-1",
    container: [
      "grid relative min-h-[100px] text-inherit",
      // This is for the autogrow functionality:
      // https://css-tricks.com/the-cleanest-trick-for-autogrowing-textareas/
      "after:content-[attr(data-value)] after:px-3 after:pt-2 after:pb-5 after:whitespace-pre-wrap",
      "after:row-start-1 after:row-end-2 after:col-start-1 after:col-end-2 after:break-words after:min-w-0",
      "after:w-full after:box-border after:typography-input-text"
    ],
    textareaClass: "input relative bg-clr-bg px-3 pt-2 pb-5 resize-none overflow-hidden row-start-1 row-end-2 col-start-1 col-end-2 focus-visible:outline-none",
    wordCounter: "absolute right-1 bottom-1 typography-textarea-wordcounter-text text-inherit"
  },
  variants: {
    labelInside: { true: { textareaClass: "pt-[34px]" } }
  }
}), iO = ({
  onChange: t,
  value: e = "",
  label: n,
  placeholder: r,
  name: o,
  id: s,
  helperText: i,
  errorText: a,
  disabled: l = !1,
  required: c = !1,
  error: u = !1,
  maxLength: d = 500
}) => {
  const p = e === "", h = !!n && p, { root: v, textareaClass: m, container: y, wordCounter: b } = UM({ labelInside: h }), w = s || (n == null ? void 0 : n.toLowerCase().replace(" ", "-")) || "";
  return /* @__PURE__ */ g("div", { className: v(), children: /* @__PURE__ */ g(
    Kc,
    {
      label: n,
      id: w,
      placeholderShown: p,
      disabled: l,
      error: u,
      required: c,
      helperText: i,
      errorText: a,
      children: /* @__PURE__ */ G("div", { className: y(), "data-value": e, children: [
        /* @__PURE__ */ g(
          "textarea",
          {
            name: o,
            placeholder: r || " ",
            className: m(),
            disabled: l,
            maxLength: d,
            onChange: (x) => t(x.currentTarget.value),
            value: e,
            id: w
          }
        ),
        /* @__PURE__ */ g("div", { className: b(), children: `${e.length} / ${d}` })
      ] })
    }
  ) });
}, qf = "absolute top-0 left-0 h-full w-full transition-opacity ease-in duration-200", HM = ae({
  slots: {
    root: "preflight block h-4 w-4 relative",
    iconAClass: qf,
    iconBClass: qf
  },
  variants: {
    showIconA: {
      false: {
        iconAClass: "opacity-0"
      },
      true: {
        iconBClass: "opacity-0"
      }
    }
  }
}), aO = ({ iconA: t, iconB: e, showIconA: n = !0 }) => {
  const { root: r, iconAClass: o, iconBClass: s } = HM({ showIconA: n });
  return /* @__PURE__ */ G("span", { className: r(), children: [
    /* @__PURE__ */ g(ge, { variant: t, className: o() }),
    /* @__PURE__ */ g(ge, { variant: e, className: s() })
  ] });
};
// @__NO_SIDE_EFFECTS__
function zM(t) {
  const e = /* @__PURE__ */ GM(t), n = f.forwardRef((r, o) => {
    const { children: s, ...i } = r, a = f.Children.toArray(s), l = a.find(YM);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? f.Children.count(c) > 1 ? f.Children.only(null) : f.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ g(e, { ...i, ref: o, children: f.isValidElement(c) ? f.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ g(e, { ...i, ref: o, children: s });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function GM(t) {
  const e = f.forwardRef((n, r) => {
    const { children: o, ...s } = n, i = f.isValidElement(o) ? XM(o) : void 0, a = te(i, r);
    if (f.isValidElement(o)) {
      const l = qM(s, o.props);
      return o.type !== f.Fragment && (l.ref = a), f.cloneElement(o, l);
    }
    return f.Children.count(o) > 1 ? f.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var ib = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function KM(t) {
  const e = ({ children: n }) => /* @__PURE__ */ g(Pe, { children: n });
  return e.displayName = `${t}.Slottable`, e.__radixId = ib, e;
}
function YM(t) {
  return f.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === ib;
}
function qM(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], s = e[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...a) => {
      const l = s(...a);
      return o(...a), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function XM(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var ZM = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], JM = ZM.reduce((t, e) => {
  const n = /* @__PURE__ */ zM(`Primitive.${e}`), r = f.forwardRef((o, s) => {
    const { asChild: i, ...a } = o, l = i ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ g(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {}), [Ti, lO] = je("Tooltip", [
  bi
]), Ri = bi(), ab = "TooltipProvider", QM = 700, hl = "tooltip.open", [eN, pu] = Ti(ab), lb = (t) => {
  const {
    __scopeTooltip: e,
    delayDuration: n = QM,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: s
  } = t, i = f.useRef(!0), a = f.useRef(!1), l = f.useRef(0);
  return f.useEffect(() => {
    const c = l.current;
    return () => window.clearTimeout(c);
  }, []), /* @__PURE__ */ g(
    eN,
    {
      scope: e,
      isOpenDelayedRef: i,
      delayDuration: n,
      onOpen: f.useCallback(() => {
        window.clearTimeout(l.current), i.current = !1;
      }, []),
      onClose: f.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => i.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: a,
      onPointerInTransitChange: f.useCallback((c) => {
        a.current = c;
      }, []),
      disableHoverableContent: o,
      children: s
    }
  );
};
lb.displayName = ab;
var co = "Tooltip", [tN, ko] = Ti(co), cb = (t) => {
  const {
    __scopeTooltip: e,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: s,
    disableHoverableContent: i,
    delayDuration: a
  } = t, l = pu(co, t.__scopeTooltip), c = Ri(e), [u, d] = f.useState(null), p = Je(), h = f.useRef(0), v = i ?? l.disableHoverableContent, m = a ?? l.delayDuration, y = f.useRef(!1), [b, w] = tt({
    prop: r,
    defaultProp: o ?? !1,
    onChange: (S) => {
      S ? (l.onOpen(), document.dispatchEvent(new CustomEvent(hl))) : l.onClose(), s == null || s(S);
    },
    caller: co
  }), x = f.useMemo(() => b ? y.current ? "delayed-open" : "instant-open" : "closed", [b]), E = f.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, y.current = !1, w(!0);
  }, [w]), C = f.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, w(!1);
  }, [w]), A = f.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      y.current = !0, w(!0), h.current = 0;
    }, m);
  }, [m, w]);
  return f.useEffect(() => () => {
    h.current && (window.clearTimeout(h.current), h.current = 0);
  }, []), /* @__PURE__ */ g(sy, { ...c, children: /* @__PURE__ */ g(
    tN,
    {
      scope: e,
      contentId: p,
      open: b,
      stateAttribute: x,
      trigger: u,
      onTriggerChange: d,
      onTriggerEnter: f.useCallback(() => {
        l.isOpenDelayedRef.current ? A() : E();
      }, [l.isOpenDelayedRef, A, E]),
      onTriggerLeave: f.useCallback(() => {
        v ? C() : (window.clearTimeout(h.current), h.current = 0);
      }, [C, v]),
      onOpen: E,
      onClose: C,
      disableHoverableContent: v,
      children: n
    }
  ) });
};
cb.displayName = co;
var ml = "TooltipTrigger", ub = f.forwardRef(
  (t, e) => {
    const { __scopeTooltip: n, ...r } = t, o = ko(ml, n), s = pu(ml, n), i = Ri(n), a = f.useRef(null), l = te(e, a, o.onTriggerChange), c = f.useRef(!1), u = f.useRef(!1), d = f.useCallback(() => c.current = !1, []);
    return f.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ g(iy, { asChild: !0, ...i, children: /* @__PURE__ */ g(
      JM.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: J(t.onPointerMove, (p) => {
          p.pointerType !== "touch" && !u.current && !s.isPointerInTransitRef.current && (o.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: J(t.onPointerLeave, () => {
          o.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: J(t.onPointerDown, () => {
          o.open && o.onClose(), c.current = !0, document.addEventListener("pointerup", d, { once: !0 });
        }),
        onFocus: J(t.onFocus, () => {
          c.current || o.onOpen();
        }),
        onBlur: J(t.onBlur, o.onClose),
        onClick: J(t.onClick, o.onClose)
      }
    ) });
  }
);
ub.displayName = ml;
var hu = "TooltipPortal", [nN, rN] = Ti(hu, {
  forceMount: void 0
}), db = (t) => {
  const { __scopeTooltip: e, forceMount: n, children: r, container: o } = t, s = ko(hu, e);
  return /* @__PURE__ */ g(nN, { scope: e, forceMount: n, children: /* @__PURE__ */ g(Ge, { present: n || s.open, children: /* @__PURE__ */ g(oi, { asChild: !0, container: o, children: r }) }) });
};
db.displayName = hu;
var ur = "TooltipContent", fb = f.forwardRef(
  (t, e) => {
    const n = rN(ur, t.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...s } = t, i = ko(ur, t.__scopeTooltip);
    return /* @__PURE__ */ g(Ge, { present: r || i.open, children: i.disableHoverableContent ? /* @__PURE__ */ g(pb, { side: o, ...s, ref: e }) : /* @__PURE__ */ g(oN, { side: o, ...s, ref: e }) });
  }
), oN = f.forwardRef((t, e) => {
  const n = ko(ur, t.__scopeTooltip), r = pu(ur, t.__scopeTooltip), o = f.useRef(null), s = te(e, o), [i, a] = f.useState(null), { trigger: l, onClose: c } = n, u = o.current, { onPointerInTransitChange: d } = r, p = f.useCallback(() => {
    a(null), d(!1);
  }, [d]), h = f.useCallback(
    (v, m) => {
      const y = v.currentTarget, b = { x: v.clientX, y: v.clientY }, w = cN(b, y.getBoundingClientRect()), x = uN(b, w), E = dN(m.getBoundingClientRect()), C = pN([...x, ...E]);
      a(C), d(!0);
    },
    [d]
  );
  return f.useEffect(() => () => p(), [p]), f.useEffect(() => {
    if (l && u) {
      const v = (y) => h(y, u), m = (y) => h(y, l);
      return l.addEventListener("pointerleave", v), u.addEventListener("pointerleave", m), () => {
        l.removeEventListener("pointerleave", v), u.removeEventListener("pointerleave", m);
      };
    }
  }, [l, u, h, p]), f.useEffect(() => {
    if (i) {
      const v = (m) => {
        const y = m.target, b = { x: m.clientX, y: m.clientY }, w = (l == null ? void 0 : l.contains(y)) || (u == null ? void 0 : u.contains(y)), x = !fN(b, i);
        w ? p() : x && (p(), c());
      };
      return document.addEventListener("pointermove", v), () => document.removeEventListener("pointermove", v);
    }
  }, [l, u, i, c, p]), /* @__PURE__ */ g(pb, { ...t, ref: s });
}), [sN, iN] = Ti(co, { isInside: !1 }), aN = /* @__PURE__ */ KM("TooltipContent"), pb = f.forwardRef(
  (t, e) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: s,
      onPointerDownOutside: i,
      ...a
    } = t, l = ko(ur, n), c = Ri(n), { onClose: u } = l;
    return f.useEffect(() => (document.addEventListener(hl, u), () => document.removeEventListener(hl, u)), [u]), f.useEffect(() => {
      if (l.trigger) {
        const d = (p) => {
          const h = p.target;
          h != null && h.contains(l.trigger) && u();
        };
        return window.addEventListener("scroll", d, { capture: !0 }), () => window.removeEventListener("scroll", d, { capture: !0 });
      }
    }, [l.trigger, u]), /* @__PURE__ */ g(
      ri,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: s,
        onPointerDownOutside: i,
        onFocusOutside: (d) => d.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ G(
          ay,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...a,
            ref: e,
            style: {
              ...a.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ g(aN, { children: r }),
              /* @__PURE__ */ g(sN, { scope: n, isInside: !0, children: /* @__PURE__ */ g(cD, { id: l.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
fb.displayName = ur;
var hb = "TooltipArrow", lN = f.forwardRef(
  (t, e) => {
    const { __scopeTooltip: n, ...r } = t, o = Ri(n);
    return iN(
      hb,
      n
    ).isInside ? null : /* @__PURE__ */ g(ly, { ...o, ...r, ref: e });
  }
);
lN.displayName = hb;
function cN(t, e) {
  const n = Math.abs(e.top - t.y), r = Math.abs(e.bottom - t.y), o = Math.abs(e.right - t.x), s = Math.abs(e.left - t.x);
  switch (Math.min(n, r, o, s)) {
    case s:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function uN(t, e, n = 5) {
  const r = [];
  switch (e) {
    case "top":
      r.push(
        { x: t.x - n, y: t.y + n },
        { x: t.x + n, y: t.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: t.x - n, y: t.y - n },
        { x: t.x + n, y: t.y - n }
      );
      break;
    case "left":
      r.push(
        { x: t.x + n, y: t.y - n },
        { x: t.x + n, y: t.y + n }
      );
      break;
    case "right":
      r.push(
        { x: t.x - n, y: t.y - n },
        { x: t.x - n, y: t.y + n }
      );
      break;
  }
  return r;
}
function dN(t) {
  const { top: e, right: n, bottom: r, left: o } = t;
  return [
    { x: o, y: e },
    { x: n, y: e },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function fN(t, e) {
  const { x: n, y: r } = t;
  let o = !1;
  for (let s = 0, i = e.length - 1; s < e.length; i = s++) {
    const a = e[s], l = e[i], c = a.x, u = a.y, d = l.x, p = l.y;
    u > r != p > r && n < (d - c) * (r - u) / (p - u) + c && (o = !o);
  }
  return o;
}
function pN(t) {
  const e = t.slice();
  return e.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), hN(e);
}
function hN(t) {
  if (t.length <= 1) return t.slice();
  const e = [];
  for (let r = 0; r < t.length; r++) {
    const o = t[r];
    for (; e.length >= 2; ) {
      const s = e[e.length - 1], i = e[e.length - 2];
      if ((s.x - i.x) * (o.y - i.y) >= (s.y - i.y) * (o.x - i.x)) e.pop();
      else break;
    }
    e.push(o);
  }
  e.pop();
  const n = [];
  for (let r = t.length - 1; r >= 0; r--) {
    const o = t[r];
    for (; n.length >= 2; ) {
      const s = n[n.length - 1], i = n[n.length - 2];
      if ((s.x - i.x) * (o.y - i.y) >= (s.y - i.y) * (o.x - i.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), e.length === 1 && n.length === 1 && e[0].x === n[0].x && e[0].y === n[0].y ? e : e.concat(n);
}
var mN = lb, gN = cb, vN = ub, yN = db, bN = fb;
const wN = ae({
  slots: {
    trigger: [
      "preflight select-text underline underline-offset-2 hover:decoration-2 rounded-sm text-inherit font-[inherit] [font-size:inherit]",
      "focus-visible:outline focus-visible:outline-1 focus-visible:outline-clr-primary focus-visible:no-underline"
      //focus
    ],
    contentContainer: [
      "preflight flex flex-row gap-4 justify-between bg-clr-bg border box-border border-clr-primary rounded p-4 text-clr-primary",
      "data-[state=delayed-open]:animate-fadeIn data-[state=closed]:animate-fadeOut",
      //animation
      "s:w-[calc(100vw-30px)] s:-translate-x-1 m:max-w-[350px] l:max-w-[450px] xl:max-w-[450px]"
    ],
    iconButton: "shrink-0 w-4 h-4",
    icon: "w-4 h-4"
  }
}), cO = ({ children: t, content: e, zIndex: n = 0 }) => {
  const r = Tl("s", "m"), o = M0("l"), [s, i] = de(!1), a = Se(null), { trigger: l, contentContainer: c, iconButton: u, icon: d } = wN(), p = (v) => {
    o ? v.preventDefault() : i(!0);
  }, h = (v) => {
    r || (v.target === a.current ? v.preventDefault() : i(!1));
  };
  return /* @__PURE__ */ g(mN, { children: /* @__PURE__ */ G(gN, { open: o ? void 0 : s, delayDuration: 50, children: [
    /* @__PURE__ */ g(vN, { className: l(), ref: a, onClick: p, type: "button", children: t }),
    /* @__PURE__ */ g(yN, { children: /* @__PURE__ */ G(
      bN,
      {
        sideOffset: 8,
        collisionPadding: 20,
        side: "bottom",
        align: "start",
        className: c(),
        onPointerDownOutside: h,
        style: { zIndex: n },
        children: [
          /* @__PURE__ */ g("div", { children: e }),
          r && /* @__PURE__ */ g(
            "button",
            {
              type: "button",
              className: u(),
              onClick: () => {
                i(!1);
              },
              children: /* @__PURE__ */ g(ge, { variant: "closer", className: d() })
            }
          )
        ]
      }
    ) })
  ] }) });
}, mb = {
  // PRIMARY
  "clr-primary": "#000000",
  // ON PRIMARY
  "clr-on-primary-high": "#FFFFFF",
  "clr-on-primary-low": "#B8B8B8",
  // ON BACKGROUND
  "clr-on-bg-high": "#0F0F0F",
  "clr-on-bg-mid": "#3F3E3E",
  "clr-on-bg-low": "#707275",
  "clr-on-bg-disabled": "#DDDDDD",
  // BACKGROUND
  "clr-bg": "#FEFEFE",
  "clr-bg-light": "#F8F8F8",
  // TECHNICAL
  "clr-error": "#A12027",
  "clr-error-bg": "#FDF2F2",
  "clr-alert": "#B35724",
  "clr-alert-bg": "#FDF6EC",
  "clr-success": "#228247",
  "clr-success-bg": "#F4F8F5",
  "clr-info": "#3B5EAE",
  "clr-info-bg": "#EFF2F9",
  // ADDITIONAL
  "clr-sale": "#BE181A",
  "clr-on-sale": "#FFFFFF",
  "clr-sustainable": "#86A596",
  // COMMON
  "clr-black": "#000000",
  "clr-white": "#FFFFFF"
}, gb = {
  // PRIMARY
  "clr-primary": "#FFFFFF",
  // ON PRIMARY
  "clr-on-primary-high": "#000000",
  "clr-on-primary-low": "#686868",
  // ON BACKGROUND
  "clr-on-bg-high": "#FFFFFF",
  "clr-on-bg-mid": "#DEDEDE",
  "clr-on-bg-low": "#9E9E9E",
  "clr-on-bg-disabled": "#696969",
  // BACKGROUND
  "clr-bg": "#303030",
  "clr-bg-light": "#363636",
  // TECHNICAL
  "clr-error": "#E37379",
  "clr-error-bg": "#382B2B",
  "clr-alert": "#CFA663",
  "clr-alert-bg": "#454135",
  "clr-success": "#35B666",
  "clr-success-bg": "#313F37",
  "clr-info": "#87B3D9",
  "clr-info-bg": "#3F4247",
  // ADDITIONAL
  "clr-sale": "#BE181A",
  "clr-on-sale": "#FFFFFF",
  "clr-sustainable": "#86A596",
  // COMMON
  "clr-black": "#000000",
  "clr-white": "#FFFFFF"
}, xN = {
  "clr-bg-modal": mb["clr-bg-light"]
}, CN = {
  "clr-bg-modal": gb["clr-bg-light"]
}, EN = { light: { ...mb, ...xN }, dark: { ...gb, ...CN } }, _t = {
  0.25: "0.0625rem",
  0.75: "0.1875rem",
  1.25: "0.3125rem",
  6.5: "1.625rem",
  11.5: "2.875rem",
  17.5: "4.375rem",
  35: "8.75rem",
  50: "12.5rem",
  75: "18.75rem",
  100: "25rem",
  150: "37.5rem"
}, uO = {
  corePlugins: {
    preflight: !1
  },
  future: {
    // for deactivating hover effects on touch devices
    // TODO: migrate to @custom-variant in v4
    hoverOnlyWhenSupported: !0
  },
  darkMode: ["class", '[data-mode="dark"]'],
  content: ["./index.html", "./src/**/*.{js,ts,jsx,tsx}", "./.storybook/*.html"],
  theme: {
    extend: {
      fontFamily: {
        bonprixRegular: ["bonprixRegular"],
        sourceSans3: ["sourceSans3"]
      },
      keyframes: {
        fadeIn: {
          from: { opacity: "0" },
          to: { opacity: "1" }
        },
        fadeOut: {
          from: { opacity: "1" },
          to: { opacity: "0" }
        },
        slideLeft: {
          from: { transform: "translateX(0)" },
          to: { transform: "translateX(-400px)" }
        },
        slideRight: {
          from: { transform: "translateX(-400px)" },
          to: { transform: "translateX(0)" }
        }
      },
      animation: {
        slideLeft: "slideLeft 300ms ease-out forwards",
        slideRight: "slideRight 300ms ease-out forwards",
        fadeIn: "fadeIn 300ms linear forwards",
        fadeOut: "fadeOut 300ms linear forwards"
      },
      gap: _t,
      height: _t,
      margin: _t,
      maxHeight: _t,
      maxWidth: _t,
      minHeight: _t,
      minWidth: _t,
      opacity: {
        32: "0.32"
      },
      padding: _t,
      width: _t,
      inset: {
        100: "25rem"
      },
      zIndex: {
        1: "1",
        2: "2"
      },
      colors: {
        "fixed-clr-on-bg-mid": EN.light["clr-on-bg-mid"]
      }
    },
    screens: {
      s: `${pe.s}px`,
      m: `${pe.m}px`,
      l: `${pe.l}px`,
      xl: `${pe.xl}px`,
      xxl: `${pe.xxl}px`,
      xxxl: `${pe.xxxl}px`
    },
    colors: {
      transparent: "transparent",
      current: "currentColor",
      inherit: "inherit",
      "clr-primary": "rgb(var(--color-primary))",
      "clr-on-primary-high": "rgb(var(--color-on-primary-high))",
      "clr-on-primary-low": "rgb(var(--color-on-primary-low))",
      "clr-on-bg-high": "rgb(var(--color-on-bg-high))",
      "clr-on-bg-mid": "rgb(var(--color-on-bg-mid))",
      "clr-on-bg-low": "rgb(var(--color-on-bg-low))",
      "clr-on-bg-disabled": "rgb(var(--color-on-bg-disabled))",
      "clr-bg": "rgb(var(--color-bg))",
      "clr-bg-light": "rgb(var(--color-bg-light))",
      "clr-error": "rgb(var(--color-error))",
      "clr-error-bg": "rgb(var(--color-error-bg))",
      "clr-alert": "rgb(var(--color-alert))",
      "clr-alert-bg": "rgb(var(--color-alert-bg))",
      "clr-success": "rgb(var(--color-success))",
      "clr-success-bg": "rgb(var(--color-success-bg))",
      "clr-info": "rgb(var(--color-info))",
      "clr-info-bg": "rgb(var(--color-info-bg))",
      "clr-sale": "rgb(var(--color-sale))",
      "clr-on-sale": "rgb(var(--color-on-sale))",
      "clr-disabled": "rgb(var(--color-disabled))",
      "clr-bg-disabled": "rgb(var(--color-bg-disabled))",
      "clr-sustainable": "rgb(var(--color-sustainable))",
      "clr-bg-disabled": "rgb(var(--color-bg-disabled))",
      "clr-black": "rgb(var(--color-black))",
      "clr-white": "rgb(var(--color-white))",
      "clr-bg-modal": "rgb(var(--color-bg-light))"
    }
  },
  important: !0
};
export {
  Aw as Accordion,
  NN as Alert,
  ON as Availability,
  VN as BenefitTag,
  ET as BottomSheet,
  $N as Breadcrumb,
  Pl as Button,
  FR as Carousel,
  WN as Checkbox,
  jR as CheckboxGroup,
  _l as Collapsible,
  jN as Container,
  ci as Dialog,
  H_ as Grid,
  ge as Icon,
  Tn as IconButton,
  G_ as Image,
  qN as Link,
  VP as List,
  XN as Logo,
  ZN as Modal,
  JN as Pagination,
  zN as PasswordField,
  QN as Price,
  Ck as RadioGroup,
  ww as Rating,
  tO as RemovedItemPlaceholder,
  zs as ScrollArea,
  YN as SearchField,
  fl as Select,
  Oy as Selection,
  Ei as SideSheet,
  Tw as Spinner,
  JD as StepNavi,
  oO as Switch,
  jM as Tabs,
  MN as TertiaryButton,
  KN as TextField,
  iO as Textarea,
  aO as ToggleIcon,
  cO as Tooltip,
  er as Typography,
  pe as breakpoints,
  uO as tailwindConfig,
  Tl as useBreakpointBetween,
  _N as useBreakpointCurrent,
  N0 as useBreakpointDown,
  M0 as useBreakpointUp,
  IN as useExperimentalBreakpointBetween,
  DN as useExperimentalBreakpointCurrent,
  kN as useExperimentalBreakpointDown,
  PN as useExperimentalBreakpointUp
};
//# sourceMappingURL=index.js.map
